(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.cW.aI === region.dN.aI)
	{
		return 'on line ' + region.cW.aI;
	}
	return 'on lines ' + region.cW.aI + ' through ' + region.dN.aI;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gG,
		impl.ih,
		impl.e3,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		ej: func(record.ej),
		cX: record.cX,
		cG: record.cG
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.ej;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cX;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.cG) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gG,
		impl.ih,
		impl.e3,
		function(sendToApp, initialModel) {
			var view = impl.ik;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gG,
		impl.ih,
		impl.e3,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.cO && impl.cO(sendToApp)
			var view = impl.ik;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fI);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.h5) && (_VirtualDom_doc.title = title = doc.h5);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.he;
	var onUrlRequest = impl.hf;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		cO: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.eE === next.eE
							&& curr.dZ === next.dZ
							&& curr.ez.a === next.ez.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		gG: function(flags)
		{
			return A3(impl.gG, flags, _Browser_getUrl(), key);
		},
		ik: impl.ik,
		ih: impl.ih,
		e3: impl.e3
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { gy: 'hidden', fW: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { gy: 'mozHidden', fW: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { gy: 'msHidden', fW: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { gy: 'webkitHidden', fW: 'webkitvisibilitychange' }
		: { gy: 'hidden', fW: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		eQ: _Browser_getScene(),
		il: {
			C: _Browser_window.pageXOffset,
			D: _Browser_window.pageYOffset,
			fe: _Browser_doc.documentElement.clientWidth,
			dW: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fe: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		dW: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			eQ: {
				fe: node.scrollWidth,
				dW: node.scrollHeight
			},
			il: {
				C: node.scrollLeft,
				D: node.scrollTop,
				fe: node.clientWidth,
				dW: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			eQ: _Browser_getScene(),
			il: {
				C: x,
				D: y,
				fe: _Browser_doc.documentElement.clientWidth,
				dW: _Browser_doc.documentElement.clientHeight
			},
			gk: {
				C: x + rect.left,
				D: y + rect.top,
				fe: rect.width,
				dW: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$Msg$LinkClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$UrlChanged = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.j) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.k);
		} else {
			var treeLen = builder.j * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.l) : builder.l;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.j);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.k);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{l: nodeList, j: (len / $elm$core$Array$branchFactor) | 0, k: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {aE: fragment, dZ: host, bq: path, ez: port_, eE: protocol, eG: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$Model = F4(
	function (key, page, header, time) {
		return {i: header, at: key, c: page, r: time};
	});
var $author$project$Main$NotFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$Tick = function (a) {
	return {$: 23, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$clearLocalStorage = _Platform_outgoingPort(
	'clearLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Type$Database$Database = function (answers) {
	return function (coders) {
		return function (codings) {
			return function (coding_answers) {
				return function (coding_frames) {
					return function (coding_questions) {
						return function (coding_questionnaries) {
							return function (events) {
								return function (input_types) {
									return function (places) {
										return function (questions) {
											return function (questionnaries) {
												return function (studies) {
													return function (test_subjects) {
														return function (users) {
															return {bL: answers, aZ: coders, f0: coding_answers, bT: coding_frames, f2: coding_questionnaries, dy: coding_questions, a$: codings, gm: events, d5: input_types, br: places, bs: questionnaries, hp: questions, hK: studies, aP: test_subjects, c6: users};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Type$Database$DatabaseView = function (answers) {
	return function (coders) {
		return function (codings) {
			return function (coding_answers) {
				return function (coding_frames) {
					return function (coding_questions) {
						return function (coding_questionnaries) {
							return function (events) {
								return function (input_types) {
									return function (places) {
										return function (questions) {
											return function (questionnaries) {
												return function (studies) {
													return function (test_subjects) {
														return function (users) {
															return {bL: answers, aZ: coders, f0: coding_answers, bT: coding_frames, f2: coding_questionnaries, dy: coding_questions, a$: codings, gm: events, d5: input_types, br: places, bs: questionnaries, hp: questions, hK: studies, aP: test_subjects, c6: users};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Type$Database$Answer = F4(
	function (question, test_subject, value, event) {
		return {as: event, eH: question, aO: test_subject, fb: value};
	});
var $author$project$Type$Database$AnswerView = F4(
	function (question, test_subject, value, event) {
		return {as: event, eH: question, aO: test_subject, fb: value};
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map2 = F3(
	function (func, _v0, _v1) {
		var genA = _v0;
		var genB = _v1;
		return function (seed0) {
			var _v2 = genA(seed0);
			var a = _v2.a;
			var seed1 = _v2.b;
			var _v3 = genB(seed1);
			var b = _v3.a;
			var seed2 = _v3.b;
			return _Utils_Tuple2(
				A2(func, a, b),
				seed2);
		};
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm_explorations$test$RoseTree$Rose = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm_explorations$test$Lazy$List$Cons = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm_explorations$test$Lazy$force = function (piece) {
	if (piece.$ === 1) {
		var a = piece.a;
		return a;
	} else {
		var thunk = piece.a;
		return thunk(0);
	}
};
var $elm_explorations$test$Lazy$Lazy = function (a) {
	return {$: 0, a: a};
};
var $elm_explorations$test$Lazy$lazy = function (thunk) {
	return $elm_explorations$test$Lazy$Lazy(thunk);
};
var $elm_explorations$test$Lazy$List$append = F2(
	function (list1, list2) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				var _v1 = $elm_explorations$test$Lazy$force(list1);
				if (!_v1.$) {
					return $elm_explorations$test$Lazy$force(list2);
				} else {
					var first = _v1.a;
					var rest = _v1.b;
					return A2(
						$elm_explorations$test$Lazy$List$Cons,
						first,
						A2($elm_explorations$test$Lazy$List$append, rest, list2));
				}
			});
	});
var $elm_explorations$test$Lazy$List$Nil = {$: 0};
var $elm_explorations$test$Lazy$List$map = F2(
	function (f, list) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				var _v1 = $elm_explorations$test$Lazy$force(list);
				if (!_v1.$) {
					return $elm_explorations$test$Lazy$List$Nil;
				} else {
					var first = _v1.a;
					var rest = _v1.b;
					return A2(
						$elm_explorations$test$Lazy$List$Cons,
						f(first),
						A2($elm_explorations$test$Lazy$List$map, f, rest));
				}
			});
	});
var $elm_explorations$test$Fuzz$map2RoseTree = F3(
	function (transform, rose1, rose2) {
		var root1 = rose1.a;
		var children1 = rose1.b;
		var root2 = rose2.a;
		var children2 = rose2.b;
		var shrink2 = A2(
			$elm_explorations$test$Lazy$List$map,
			function (subtree) {
				return A3($elm_explorations$test$Fuzz$map2RoseTree, transform, rose1, subtree);
			},
			children2);
		var shrink1 = A2(
			$elm_explorations$test$Lazy$List$map,
			function (subtree) {
				return A3($elm_explorations$test$Fuzz$map2RoseTree, transform, subtree, rose2);
			},
			children1);
		var root = A2(transform, root1, root2);
		return A2(
			$elm_explorations$test$RoseTree$Rose,
			root,
			A2($elm_explorations$test$Lazy$List$append, shrink1, shrink2));
	});
var $elm_explorations$test$Fuzz$map2 = F3(
	function (transform, fuzzA, fuzzB) {
		return A3(
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$Result$map2, $elm$random$Random$map2),
				$elm_explorations$test$Fuzz$map2RoseTree),
			transform,
			fuzzA,
			fuzzB);
	});
var $elm_explorations$test$Fuzz$andMap = $elm_explorations$test$Fuzz$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Type$IO$Decoder$attribute = F3(
	function (name, child, parent) {
		return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, name, child, parent);
	});
var $author$project$Type$IO$Encoder$ListEncoder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$IO$Encoder$SingleEncoder = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Type$IO$Encoder$listToSingle = function (l) {
	return function (x) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (y) {
					return y(x);
				},
				l));
	};
};
var $author$project$Type$IO$Encoder$attribute = F4(
	function (name, def, getter, parent) {
		var _v0 = _Utils_Tuple2(parent, def);
		if (_v0.a.$ === 1) {
			if (!_v0.b.$) {
				var pe = _v0.a.a;
				var de = _v0.b.a;
				return $author$project$Type$IO$Encoder$ListEncoder(
					_Utils_ap(
						_List_fromArray(
							[
								function (x) {
								return _Utils_Tuple2(
									name,
									de(
										getter(x)));
							}
							]),
						pe));
			} else {
				var pe = _v0.a.a;
				var de = _v0.b.a;
				return $author$project$Type$IO$Encoder$ListEncoder(
					_Utils_ap(
						_List_fromArray(
							[
								function (x) {
								return _Utils_Tuple2(
									name,
									A2(
										$author$project$Type$IO$Encoder$listToSingle,
										de,
										getter(x)));
							}
							]),
						pe));
			}
		} else {
			var pe = _v0.a.a;
			return $author$project$Type$IO$Encoder$SingleEncoder(pe);
		}
	});
var $author$project$Type$IO$Form$AttrMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Type$IO$Form$parseHeadTail = function (accessor) {
	var rest = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$join('.'),
			$elm$core$List$tail(
				A2($elm$core$String$split, '.', accessor))));
	var index = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, '.', accessor)));
	return _Utils_Tuple2(index, rest);
};
var $author$project$Type$IO$Form$attribute = F8(
	function (name, getter, childform, parentform, label, callback, kind, acc) {
		var newname = label + ('.' + name);
		var _v0 = $author$project$Type$IO$Form$parseHeadTail(acc);
		var head = _v0.a;
		var tail = _v0.b;
		return _Utils_eq(name, head) ? A4(
			childform,
			newname,
			A2(
				$elm$core$Basics$composeL,
				callback,
				$author$project$Type$IO$Form$AttrMsg(head)),
			getter(kind),
			tail) : A4(parentform, label, callback, kind, acc);
	});
var $author$project$Type$IO$Setter$AttributeMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Type$IO$Setter$ErrorMsg = {$: 18};
var $author$project$Type$IO$Setter$Mismatch = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Type$IO$Setter$updateWithLong = F5(
	function (getter, name, def, message, car) {
		if (message.$ === 6) {
			var searched = message.a;
			var msg_ = message.b;
			return _Utils_eq(name, searched) ? A2(
				def,
				msg_,
				getter(car)) : $elm$core$Result$Ok(
				getter(car));
		} else {
			return $elm$core$Result$Err(
				A2(
					$author$project$Type$IO$Setter$Mismatch,
					message,
					A2($author$project$Type$IO$Setter$AttributeMsg, name, $author$project$Type$IO$Setter$ErrorMsg)));
		}
	});
var $author$project$Type$IO$Setter$attribute = F6(
	function (name, getter, def, parent, msg, car) {
		return A3(
			$elm$core$Result$map2,
			F2(
				function (x, y) {
					return y(x);
				}),
			A5($author$project$Type$IO$Setter$updateWithLong, getter, name, def, msg, car),
			A2(parent, msg, car));
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Type$IO$ToString$parseHeadTail = function (accessor) {
	var rest = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$join('.'),
			$elm$core$List$tail(
				A2($elm$core$String$split, '.', accessor))));
	var index = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, '.', accessor)));
	return (accessor === '*') ? _Utils_Tuple2('*', '*') : _Utils_Tuple2(index, rest);
};
var $author$project$Type$IO$ToString$attribute = F4(
	function (name, def, getter, parent) {
		return F2(
			function (acc, value) {
				var _v0 = $author$project$Type$IO$ToString$parseHeadTail(acc);
				var head = _v0.a;
				var tail = _v0.b;
				return _Utils_eq(name, head) ? A2(
					def,
					tail,
					getter(value)) : ((acc === '*') ? A2(
					$elm$core$Result$map,
					function (x) {
						var _v1 = A2(parent, acc, value);
						if (!_v1.$) {
							var s = _v1.a;
							return _Utils_ap(x, s);
						} else {
							return x;
						}
					},
					A2(
						$elm$core$Result$map,
						function (x) {
							return name + (':' + (x + '\n'));
						},
						A2(
							def,
							'*',
							getter(value)))) : A2(parent, acc, value));
			});
	});
var $author$project$Type$IO$Viewer$attribute = F4(
	function (getter, parent, db, full) {
		return A2(
			$elm$core$Maybe$map,
			function (x) {
				return x(
					getter(full));
			},
			A2(parent, db, full));
	});
var $author$project$Type$IO$attribute = F4(
	function (name, def, getter, parent) {
		return {
			a6: A3($author$project$Type$IO$Decoder$attribute, name, def.a6, parent.a6),
			dK: parent.dK(def.dK),
			dM: A4($author$project$Type$IO$Encoder$attribute, name, def.dM, getter, parent.dM),
			dP: _Utils_ap(
				parent.dP,
				_List_fromArray(
					[name])),
			aD: A4($author$project$Type$IO$Form$attribute, name, getter, def.aD, parent.aD),
			aF: A2($elm_explorations$test$Fuzz$andMap, def.aF, parent.aF),
			e_: function (a) {
				return A3(
					$author$project$Type$IO$Decoder$attribute,
					name,
					def.e_(a),
					parent.e_(a));
			},
			h9: A4($author$project$Type$IO$ToString$attribute, name, def.h9, getter, parent.h9),
			c4: A4($author$project$Type$IO$Setter$attribute, name, getter, def.c4, parent.c4),
			fd: A2($author$project$Type$IO$Viewer$attribute, getter, parent.fd)
		};
	});
var $elm$random$Random$constant = function (value) {
	return function (seed) {
		return _Utils_Tuple2(value, seed);
	};
};
var $elm_explorations$test$Lazy$List$empty = $elm_explorations$test$Lazy$lazy(
	function (_v0) {
		return $elm_explorations$test$Lazy$List$Nil;
	});
var $elm_explorations$test$RoseTree$singleton = function (a) {
	return A2($elm_explorations$test$RoseTree$Rose, a, $elm_explorations$test$Lazy$List$empty);
};
var $elm_explorations$test$Fuzz$constant = function (x) {
	return $elm$core$Result$Ok(
		$elm$random$Random$constant(
			$elm_explorations$test$RoseTree$singleton(x)));
};
var $author$project$Type$IO$Decoder$entity = $elm$json$Json$Decode$succeed;
var $author$project$Type$IO$Encoder$entity = $author$project$Type$IO$Encoder$ListEncoder(_List_Nil);
var $author$project$Type$IO$Form$AttributeNotFound = 4;
var $author$project$Type$IO$Form$entity = F5(
	function (name, callback, kind, acc, f) {
		return $elm$core$Result$Err(4);
	});
var $author$project$Type$IO$Setter$entity = F3(
	function (toChange, msg, car) {
		return $elm$core$Result$Ok(toChange);
	});
var $author$project$Type$IO$ToString$NoSuchSubstruct = function (a) {
	return {$: 5, a: a};
};
var $author$project$Type$IO$ToString$entity = F3(
	function (_v0, name, _v1) {
		return $elm$core$Result$Err(
			$author$project$Type$IO$ToString$NoSuchSubstruct(name));
	});
var $author$project$Type$IO$Viewer$entity = F3(
	function (view, _v0, _v1) {
		return $elm$core$Maybe$Just(view);
	});
var $author$project$Type$IO$entity = F2(
	function (_new, view) {
		return {
			a6: $author$project$Type$IO$Decoder$entity(_new),
			dK: _new,
			dM: $author$project$Type$IO$Encoder$entity,
			dP: _List_Nil,
			aD: $author$project$Type$IO$Form$entity,
			aF: $elm_explorations$test$Fuzz$constant(_new),
			e_: function (a) {
				return $author$project$Type$IO$Decoder$entity(_new);
			},
			h9: $author$project$Type$IO$ToString$entity(_new),
			c4: $author$project$Type$IO$Setter$entity(_new),
			fd: $author$project$Type$IO$Viewer$entity(view)
		};
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $author$project$Type$IO$Internal$Id = $elm$core$Basics$identity;
var $author$project$Type$IO$Internal$box = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm_explorations$test$RoseTree$map = F2(
	function (f, _v0) {
		var a = _v0.a;
		var c = _v0.b;
		return A2(
			$elm_explorations$test$RoseTree$Rose,
			f(a),
			A2(
				$elm_explorations$test$Lazy$List$map,
				$elm_explorations$test$RoseTree$map(f),
				c));
	});
var $elm_explorations$test$Fuzz$Internal$map = F2(
	function (fn, fuzzer) {
		return A2(
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$Result$map, $elm$random$Random$map),
				$elm_explorations$test$RoseTree$map),
			fn,
			fuzzer);
	});
var $elm_explorations$test$Fuzz$map = $elm_explorations$test$Fuzz$Internal$map;
var $author$project$Type$IO$Decoder$reference = $author$project$Type$IO$Decoder$attribute;
var $author$project$Type$IO$Encoder$collapseEncoder = function (enc) {
	if (!enc.$) {
		var s = enc.a;
		return s;
	} else {
		var l = enc.a;
		return function (x) {
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$map,
					function (y) {
						return y(x);
					},
					l));
		};
	}
};
var $author$project$Type$IO$Internal$unbox = function (_v0) {
	var v = _v0;
	return v;
};
var $author$project$Type$IO$Encoder$reference = F4(
	function (name, getter, def, parent) {
		if (parent.$ === 1) {
			var pe = parent.a;
			return $author$project$Type$IO$Encoder$ListEncoder(
				A2(
					$elm$core$List$cons,
					function (x) {
						if (!def.$) {
							var e = def.a;
							return _Utils_Tuple2(
								name,
								e(
									$author$project$Type$IO$Internal$unbox(
										getter(x))));
						} else {
							var e = def.a;
							return _Utils_Tuple2(
								name,
								A2(
									$author$project$Type$IO$Encoder$collapseEncoder,
									$author$project$Type$IO$Encoder$ListEncoder(e),
									$author$project$Type$IO$Internal$unbox(
										getter(x))));
						}
					},
					pe));
		} else {
			var pe = parent.a;
			return $author$project$Type$IO$Encoder$SingleEncoder(pe);
		}
	});
var $author$project$Type$IO$Form$reference = F8(
	function (name, getter, childform, parentform, label, callback, kind, acc) {
		var newname = label + ('.' + name);
		var _v0 = $author$project$Type$IO$Form$parseHeadTail(acc);
		var head = _v0.a;
		var tail = _v0.b;
		return _Utils_eq(name, head) ? A4(
			childform,
			newname,
			A2(
				$elm$core$Basics$composeL,
				callback,
				$author$project$Type$IO$Form$AttrMsg(head)),
			$author$project$Type$IO$Internal$unbox(
				getter(kind)),
			tail) : A4(parentform, label, callback, kind, acc);
	});
var $author$project$Type$IO$Setter$reference = F6(
	function (name, getter, def, parent, msg, car) {
		var iddef = F2(
			function (msg_, car_) {
				return A2(
					$elm$core$Result$map,
					$author$project$Type$IO$Internal$box,
					A2(
						def,
						msg_,
						$author$project$Type$IO$Internal$unbox(car_)));
			});
		return A3(
			$elm$core$Result$map2,
			F2(
				function (x, y) {
					return y(x);
				}),
			A5($author$project$Type$IO$Setter$updateWithLong, getter, name, iddef, msg, car),
			A2(parent, msg, car));
	});
var $author$project$Type$IO$ToString$reference = F4(
	function (name, getter, def, parent) {
		return F2(
			function (acc, value) {
				var _v0 = $author$project$Type$IO$ToString$parseHeadTail(acc);
				var head = _v0.a;
				return _Utils_eq(name, head) ? A2(
					def,
					acc,
					$author$project$Type$IO$Internal$unbox(
						getter(value))) : ((acc === '*') ? A2(
					$elm$core$Result$map,
					function (x) {
						var _v1 = A2(parent, acc, value);
						if (!_v1.$) {
							var s = _v1.a;
							return _Utils_ap(x, s);
						} else {
							return x;
						}
					},
					A2(
						$elm$core$Result$map,
						function (x) {
							return name + (':' + (x + '\n'));
						},
						A2(
							def,
							'*',
							$author$project$Type$IO$Internal$unbox(
								getter(value))))) : A2(parent, acc, value));
			});
	});
var $author$project$Type$IO$Viewer$reference = F7(
	function (keygetter, dictgetter, foreigngetter, post, parent, db, full) {
		return function (x) {
			var _v0 = _Utils_Tuple2(
				x,
				A2(parent, db, full));
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var argument = _v0.a.a;
				var f = _v0.b.a;
				return $elm$core$Maybe$Just(
					f(argument));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(
			A2(
				$elm$core$Maybe$map,
				post,
				A2(
					foreigngetter,
					$author$project$Type$IO$Internal$unbox(
						keygetter(full)),
					dictgetter(db))));
	});
var $author$project$Type$IO$reference = F7(
	function (name, def, getter, lookup, foreigngetter, post, parent) {
		return {
			a6: A3(
				$author$project$Type$IO$Decoder$reference,
				name,
				A2($elm$json$Json$Decode$map, $author$project$Type$IO$Internal$box, def.a6),
				parent.a6),
			dK: parent.dK(
				$author$project$Type$IO$Internal$box(def.dK)),
			dM: A4($author$project$Type$IO$Encoder$reference, name, getter, def.dM, parent.dM),
			dP: _Utils_ap(
				parent.dP,
				_List_fromArray(
					[name])),
			aD: A4($author$project$Type$IO$Form$reference, name, getter, def.aD, parent.aD),
			aF: A2(
				$elm_explorations$test$Fuzz$andMap,
				A2($elm_explorations$test$Fuzz$map, $author$project$Type$IO$Internal$box, def.aF),
				parent.aF),
			e_: function (a) {
				return A3(
					$author$project$Type$IO$Decoder$reference,
					name,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Type$IO$Internal$box,
						def.e_(a)),
					parent.e_(a));
			},
			h9: A4($author$project$Type$IO$ToString$reference, name, getter, def.h9, parent.h9),
			c4: A4($author$project$Type$IO$Setter$reference, name, getter, def.c4, parent.c4),
			fd: A5($author$project$Type$IO$Viewer$reference, getter, lookup, foreigngetter, post, parent.fd)
		};
	});
var $elm$random$Random$andThen = F2(
	function (callback, _v0) {
		var genA = _v0;
		return function (seed) {
			var _v1 = genA(seed);
			var result = _v1.a;
			var newSeed = _v1.b;
			var _v2 = callback(result);
			var genB = _v2;
			return genB(newSeed);
		};
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm_explorations$test$Fuzz$asciiCharGenerator = A2(
	$elm$random$Random$map,
	$elm$core$Char$fromCode,
	A2($elm$random$Random$int, 32, 126));
var $elm_explorations$test$Fuzz$custom = F2(
	function (generator, shrinker) {
		var shrinkTree = function (a) {
			return A2(
				$elm_explorations$test$RoseTree$Rose,
				a,
				$elm_explorations$test$Lazy$lazy(
					function (_v0) {
						return $elm_explorations$test$Lazy$force(
							A2(
								$elm_explorations$test$Lazy$List$map,
								shrinkTree,
								shrinker(a)));
					}));
		};
		return $elm$core$Result$Ok(
			A2($elm$random$Random$map, shrinkTree, generator));
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$random$Random$float = F2(
	function (a, b) {
		return function (seed0) {
			var seed1 = $elm$random$Random$next(seed0);
			var range = $elm$core$Basics$abs(b - a);
			var n1 = $elm$random$Random$peel(seed1);
			var n0 = $elm$random$Random$peel(seed0);
			var lo = (134217727 & n1) * 1.0;
			var hi = (67108863 & n0) * 1.0;
			var val = ((hi * 134217728.0) + lo) / 9007199254740992.0;
			var scaled = (val * range) + a;
			return _Utils_Tuple2(
				scaled,
				$elm$random$Random$next(seed1));
		};
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm_explorations$test$MicroRandomExtra$frequency = F2(
	function (firstPair, restPairs) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, $elm$core$Basics$abs, $elm$core$Tuple$first),
				A2($elm$core$List$cons, firstPair, restPairs)));
		var pick = F3(
			function (_v0, restChoices, n) {
				pick:
				while (true) {
					var k = _v0.a;
					var g = _v0.b;
					if (_Utils_cmp(n, k) < 1) {
						return g;
					} else {
						if (!restChoices.b) {
							return g;
						} else {
							var next = restChoices.a;
							var rest = restChoices.b;
							var $temp$_v0 = next,
								$temp$restChoices = rest,
								$temp$n = n - k;
							_v0 = $temp$_v0;
							restChoices = $temp$restChoices;
							n = $temp$n;
							continue pick;
						}
					}
				}
			});
		return A2(
			$elm$random$Random$andThen,
			A2(pick, firstPair, restPairs),
			A2($elm$random$Random$float, 0, total));
	});
var $elm$core$String$fromList = _String_fromList;
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0;
		return function (seed) {
			return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var $elm_explorations$test$MicroRandomExtra$lengthString = F2(
	function (charGenerator, stringLength) {
		return A2(
			$elm$random$Random$map,
			$elm$core$String$fromList,
			A2($elm$random$Random$list, stringLength, charGenerator));
	});
var $elm_explorations$test$Lazy$List$cons = F2(
	function (a, list) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				return A2($elm_explorations$test$Lazy$List$Cons, a, list);
			});
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm_explorations$test$Shrink$seriesInt = F2(
	function (low, high) {
		if (_Utils_cmp(low, high) > -1) {
			return $elm_explorations$test$Lazy$List$empty;
		} else {
			if (_Utils_eq(low, high - 1)) {
				return A2($elm_explorations$test$Lazy$List$cons, low, $elm_explorations$test$Lazy$List$empty);
			} else {
				var low_ = low + (((high - low) / 2) | 0);
				return A2(
					$elm_explorations$test$Lazy$List$cons,
					low,
					A2($elm_explorations$test$Shrink$seriesInt, low_, high));
			}
		}
	});
var $elm_explorations$test$Shrink$atLeastInt = F2(
	function (min, n) {
		return ((n < 0) && (_Utils_cmp(n, min) > -1)) ? A2(
			$elm_explorations$test$Lazy$List$cons,
			-n,
			A2(
				$elm_explorations$test$Lazy$List$map,
				$elm$core$Basics$mul(-1),
				A2($elm_explorations$test$Shrink$seriesInt, 0, -n))) : A2(
			$elm_explorations$test$Shrink$seriesInt,
			A2($elm$core$Basics$max, 0, min),
			n);
	});
var $elm_explorations$test$Shrink$convert = F4(
	function (f, g, shrinker, b) {
		return A2(
			$elm_explorations$test$Lazy$List$map,
			f,
			shrinker(
				g(b)));
	});
var $elm_explorations$test$Shrink$atLeastChar = function (ch) {
	return A3(
		$elm_explorations$test$Shrink$convert,
		$elm$core$Char$fromCode,
		$elm$core$Char$toCode,
		$elm_explorations$test$Shrink$atLeastInt(
			$elm$core$Char$toCode(ch)));
};
var $elm_explorations$test$Shrink$character = $elm_explorations$test$Shrink$atLeastChar(
	$elm$core$Char$fromCode(32));
var $elm_explorations$test$Lazy$List$fromList = A2($elm$core$List$foldr, $elm_explorations$test$Lazy$List$cons, $elm_explorations$test$Lazy$List$empty);
var $elm_explorations$test$Lazy$List$flatten = function (list) {
	return $elm_explorations$test$Lazy$lazy(
		function (_v0) {
			var _v1 = $elm_explorations$test$Lazy$force(list);
			if (!_v1.$) {
				return $elm_explorations$test$Lazy$List$Nil;
			} else {
				var first = _v1.a;
				var rest = _v1.b;
				return $elm_explorations$test$Lazy$force(
					A2(
						$elm_explorations$test$Lazy$List$append,
						first,
						$elm_explorations$test$Lazy$List$flatten(rest)));
			}
		});
};
var $elm_explorations$test$Lazy$List$andThen = F2(
	function (f, list) {
		return $elm_explorations$test$Lazy$List$flatten(
			A2($elm_explorations$test$Lazy$List$map, f, list));
	});
var $elm_explorations$test$Lazy$List$drop = F2(
	function (n, list) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				if (n <= 0) {
					return $elm_explorations$test$Lazy$force(list);
				} else {
					var _v1 = $elm_explorations$test$Lazy$force(list);
					if (!_v1.$) {
						return $elm_explorations$test$Lazy$List$Nil;
					} else {
						var first = _v1.a;
						var rest = _v1.b;
						return $elm_explorations$test$Lazy$force(
							A2($elm_explorations$test$Lazy$List$drop, n - 1, rest));
					}
				}
			});
	});
var $elm_explorations$test$Lazy$List$isEmpty = function (list) {
	var _v0 = $elm_explorations$test$Lazy$force(list);
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $elm_explorations$test$Lazy$List$iterate = F2(
	function (f, a) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				return A2(
					$elm_explorations$test$Lazy$List$Cons,
					a,
					A2(
						$elm_explorations$test$Lazy$List$iterate,
						f,
						f(a)));
			});
	});
var $elm_explorations$test$Lazy$List$reduce = F3(
	function (reducer, b, list) {
		reduce:
		while (true) {
			var _v0 = $elm_explorations$test$Lazy$force(list);
			if (!_v0.$) {
				return b;
			} else {
				var first = _v0.a;
				var rest = _v0.b;
				var $temp$reducer = reducer,
					$temp$b = A2(reducer, first, b),
					$temp$list = rest;
				reducer = $temp$reducer;
				b = $temp$b;
				list = $temp$list;
				continue reduce;
			}
		}
	});
var $elm_explorations$test$Lazy$List$length = A2(
	$elm_explorations$test$Lazy$List$reduce,
	F2(
		function (_v0, n) {
			return n + 1;
		}),
	0);
var $elm_explorations$test$Lazy$List$take = F2(
	function (n, list) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				if (n <= 0) {
					return $elm_explorations$test$Lazy$List$Nil;
				} else {
					var _v1 = $elm_explorations$test$Lazy$force(list);
					if (!_v1.$) {
						return $elm_explorations$test$Lazy$List$Nil;
					} else {
						var first = _v1.a;
						var rest = _v1.b;
						return A2(
							$elm_explorations$test$Lazy$List$Cons,
							first,
							A2($elm_explorations$test$Lazy$List$take, n - 1, rest));
					}
				}
			});
	});
var $elm_explorations$test$Lazy$List$takeWhile = F2(
	function (predicate, list) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				var _v1 = $elm_explorations$test$Lazy$force(list);
				if (!_v1.$) {
					return $elm_explorations$test$Lazy$List$Nil;
				} else {
					var first = _v1.a;
					var rest = _v1.b;
					return predicate(first) ? A2(
						$elm_explorations$test$Lazy$List$Cons,
						first,
						A2($elm_explorations$test$Lazy$List$takeWhile, predicate, rest)) : $elm_explorations$test$Lazy$List$Nil;
				}
			});
	});
var $elm_explorations$test$Shrink$lazylist = F2(
	function (shrinker, l) {
		return $elm_explorations$test$Lazy$lazy(
			function (_v0) {
				var shrinkOneHelp = function (lst) {
					return $elm_explorations$test$Lazy$lazy(
						function (_v1) {
							var _v2 = $elm_explorations$test$Lazy$force(lst);
							if (!_v2.$) {
								return $elm_explorations$test$Lazy$force($elm_explorations$test$Lazy$List$empty);
							} else {
								var x = _v2.a;
								var xs = _v2.b;
								return $elm_explorations$test$Lazy$force(
									A2(
										$elm_explorations$test$Lazy$List$append,
										A2(
											$elm_explorations$test$Lazy$List$map,
											function (val) {
												return A2($elm_explorations$test$Lazy$List$cons, val, xs);
											},
											shrinker(x)),
										A2(
											$elm_explorations$test$Lazy$List$map,
											$elm_explorations$test$Lazy$List$cons(x),
											shrinkOneHelp(xs))));
							}
						});
				};
				var removes = F3(
					function (k_, n_, l_) {
						return $elm_explorations$test$Lazy$lazy(
							function (_v3) {
								if (_Utils_cmp(k_, n_) > 0) {
									return $elm_explorations$test$Lazy$force($elm_explorations$test$Lazy$List$empty);
								} else {
									if ($elm_explorations$test$Lazy$List$isEmpty(l_)) {
										return $elm_explorations$test$Lazy$force(
											A2($elm_explorations$test$Lazy$List$cons, $elm_explorations$test$Lazy$List$empty, $elm_explorations$test$Lazy$List$empty));
									} else {
										var rest = A2($elm_explorations$test$Lazy$List$drop, k_, l_);
										var first = A2($elm_explorations$test$Lazy$List$take, k_, l_);
										return $elm_explorations$test$Lazy$force(
											A2(
												$elm_explorations$test$Lazy$List$cons,
												rest,
												A2(
													$elm_explorations$test$Lazy$List$map,
													$elm_explorations$test$Lazy$List$append(first),
													A3(removes, k_, n_ - k_, rest))));
									}
								}
							});
					});
				var n = $elm_explorations$test$Lazy$List$length(l);
				return $elm_explorations$test$Lazy$force(
					A2(
						$elm_explorations$test$Lazy$List$append,
						A2(
							$elm_explorations$test$Lazy$List$andThen,
							function (k) {
								return A3(removes, k, n, l);
							},
							A2(
								$elm_explorations$test$Lazy$List$takeWhile,
								function (x) {
									return x > 0;
								},
								A2(
									$elm_explorations$test$Lazy$List$iterate,
									function (num) {
										return (num / 2) | 0;
									},
									n))),
						shrinkOneHelp(l)));
			});
	});
var $elm_explorations$test$Lazy$List$toList = function (list) {
	var _v0 = $elm_explorations$test$Lazy$force(list);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		var first = _v0.a;
		var rest = _v0.b;
		return A2(
			$elm$core$List$cons,
			first,
			$elm_explorations$test$Lazy$List$toList(rest));
	}
};
var $elm_explorations$test$Shrink$list = function (shrinker) {
	return A3(
		$elm_explorations$test$Shrink$convert,
		$elm_explorations$test$Lazy$List$toList,
		$elm_explorations$test$Lazy$List$fromList,
		$elm_explorations$test$Shrink$lazylist(shrinker));
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm_explorations$test$Shrink$string = A3(
	$elm_explorations$test$Shrink$convert,
	$elm$core$String$fromList,
	$elm$core$String$toList,
	$elm_explorations$test$Shrink$list($elm_explorations$test$Shrink$character));
var $elm_explorations$test$MicroRandomExtra$sample = function () {
	var find = F2(
		function (k, ys) {
			find:
			while (true) {
				if (!ys.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var z = ys.a;
					var zs = ys.b;
					if (!k) {
						return $elm$core$Maybe$Just(z);
					} else {
						var $temp$k = k - 1,
							$temp$ys = zs;
						k = $temp$k;
						ys = $temp$ys;
						continue find;
					}
				}
			}
		});
	return function (xs) {
		return A2(
			$elm$random$Random$map,
			function (i) {
				return A2(find, i, xs);
			},
			A2(
				$elm$random$Random$int,
				0,
				$elm$core$List$length(xs) - 1));
	};
}();
var $elm_explorations$test$Fuzz$whitespaceCharGenerator = A2(
	$elm$random$Random$map,
	$elm$core$Maybe$withDefault(' '),
	$elm_explorations$test$MicroRandomExtra$sample(
		_List_fromArray(
			[' ', '\t', '\n'])));
var $elm_explorations$test$Fuzz$string = function () {
	var whitespaceGenerator = A2(
		$elm$random$Random$andThen,
		$elm_explorations$test$MicroRandomExtra$lengthString($elm_explorations$test$Fuzz$whitespaceCharGenerator),
		A2($elm$random$Random$int, 1, 10));
	var asciiGenerator = A2(
		$elm$random$Random$andThen,
		$elm_explorations$test$MicroRandomExtra$lengthString($elm_explorations$test$Fuzz$asciiCharGenerator),
		A2(
			$elm_explorations$test$MicroRandomExtra$frequency,
			_Utils_Tuple2(
				3,
				A2($elm$random$Random$int, 1, 10)),
			_List_fromArray(
				[
					_Utils_Tuple2(
					0.2,
					$elm$random$Random$constant(0)),
					_Utils_Tuple2(
					1,
					A2($elm$random$Random$int, 11, 50)),
					_Utils_Tuple2(
					1,
					A2($elm$random$Random$int, 50, 1000))
				])));
	return A2(
		$elm_explorations$test$Fuzz$custom,
		A2(
			$elm_explorations$test$MicroRandomExtra$frequency,
			_Utils_Tuple2(9, asciiGenerator),
			_List_fromArray(
				[
					_Utils_Tuple2(1, whitespaceGenerator)
				])),
		$elm_explorations$test$Shrink$string);
}();
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Type$IO$Decoder$string = $elm$json$Json$Decode$string;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Type$IO$Encoder$string = $author$project$Type$IO$Encoder$SingleEncoder($elm$json$Json$Encode$string);
var $author$project$Type$IO$Form$StringMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$IO$Form$string = F5(
	function (name, callback, kind, label, f) {
		return $elm$core$Result$Ok(
			A2(
				f,
				kind,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, callback, $author$project$Type$IO$Form$StringMsg),
					$elm$core$Maybe$Just)));
	});
var $author$project$Type$IO$Setter$StringMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$IO$Setter$string = F2(
	function (msg, val) {
		if (msg.$ === 2) {
			var f = msg.a;
			return $elm$core$Result$Ok(f);
		} else {
			return $elm$core$Result$Err(
				A2(
					$author$project$Type$IO$Setter$Mismatch,
					msg,
					$author$project$Type$IO$Setter$StringMsg(val)));
		}
	});
var $author$project$Type$IO$ToString$string = F2(
	function (_v0, s) {
		return $elm$core$Result$Ok(s);
	});
var $author$project$Type$IO$Viewer$basic = F2(
	function (_v0, full) {
		return $elm$core$Maybe$Just(full);
	});
var $author$project$Type$IO$Viewer$string = $author$project$Type$IO$Viewer$basic;
var $author$project$Type$IO$string = {a6: $author$project$Type$IO$Decoder$string, dK: '', dM: $author$project$Type$IO$Encoder$string, dP: _List_Nil, aD: $author$project$Type$IO$Form$string, aF: $elm_explorations$test$Fuzz$string, e_: $elm$json$Json$Decode$succeed, h9: $author$project$Type$IO$ToString$string, c4: $author$project$Type$IO$Setter$string, fd: $author$project$Type$IO$Viewer$string};
var $author$project$Type$Database$answer = A7(
	$author$project$Type$IO$reference,
	'event',
	$author$project$Type$IO$string,
	function ($) {
		return $.as;
	},
	function ($) {
		return $.gm;
	},
	$elm$core$Dict$get,
	function ($) {
		return $.fb;
	},
	A4(
		$author$project$Type$IO$attribute,
		'value',
		$author$project$Type$IO$string,
		function ($) {
			return $.fb;
		},
		A7(
			$author$project$Type$IO$reference,
			'test_subject',
			$author$project$Type$IO$string,
			function ($) {
				return $.aO;
			},
			function ($) {
				return $.aP;
			},
			$elm$core$Dict$get,
			function ($) {
				return $.fb;
			},
			A7(
				$author$project$Type$IO$reference,
				'question',
				$author$project$Type$IO$string,
				function ($) {
					return $.eH;
				},
				function ($) {
					return $.hp;
				},
				$elm$core$Dict$get,
				function ($) {
					return $.fb;
				},
				A2($author$project$Type$IO$entity, $author$project$Type$Database$Answer, $author$project$Type$Database$AnswerView)))));
var $author$project$Type$Database$Coder = function (user) {
	return {c5: user};
};
var $author$project$Type$Database$CoderView = function (user) {
	return {c5: user};
};
var $author$project$Type$Database$coder = A7(
	$author$project$Type$IO$reference,
	'user',
	$author$project$Type$IO$string,
	function ($) {
		return $.c5;
	},
	function ($) {
		return $.c6;
	},
	$elm$core$Dict$get,
	function ($) {
		return $.fb;
	},
	A2($author$project$Type$IO$entity, $author$project$Type$Database$Coder, $author$project$Type$Database$CoderView));
var $author$project$Type$Database$Coding = function (coder) {
	return {du: coder};
};
var $author$project$Type$Database$CodingView = function (coder) {
	return {du: coder};
};
var $author$project$Type$Database$coding = A7(
	$author$project$Type$IO$reference,
	'coder',
	$author$project$Type$IO$string,
	function ($) {
		return $.du;
	},
	function ($) {
		return $.aZ;
	},
	$elm$core$Dict$get,
	function ($) {
		return $.fb;
	},
	A2($author$project$Type$IO$entity, $author$project$Type$Database$Coding, $author$project$Type$Database$CodingView));
var $author$project$Type$Database$CodingAnswer = F3(
	function (coding_question, answer, value) {
		return {E: answer, dx: coding_question, fb: value};
	});
var $author$project$Type$Database$CodingAnswerView = F3(
	function (coding_question, answer, value) {
		return {E: answer, dx: coding_question, fb: value};
	});
var $author$project$Type$Database$coding_answer = A4(
	$author$project$Type$IO$attribute,
	'value',
	$author$project$Type$IO$string,
	function ($) {
		return $.fb;
	},
	A7(
		$author$project$Type$IO$reference,
		'answer',
		$author$project$Type$IO$string,
		function ($) {
			return $.E;
		},
		function ($) {
			return $.bL;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A7(
			$author$project$Type$IO$reference,
			'coding_question',
			$author$project$Type$IO$string,
			function ($) {
				return $.dx;
			},
			function ($) {
				return $.dy;
			},
			$elm$core$Dict$get,
			function ($) {
				return $.fb;
			},
			A2($author$project$Type$IO$entity, $author$project$Type$Database$CodingAnswer, $author$project$Type$Database$CodingAnswerView))));
var $author$project$Type$Database$CodingFrame = F2(
	function (answer, coding) {
		return {E: answer, bR: coding};
	});
var $author$project$Type$Database$CodingFrameView = F2(
	function (answer, coding) {
		return {E: answer, bR: coding};
	});
var $author$project$Type$Database$coding_frame = A7(
	$author$project$Type$IO$reference,
	'coding',
	$author$project$Type$IO$string,
	function ($) {
		return $.bR;
	},
	function ($) {
		return $.a$;
	},
	$elm$core$Dict$get,
	function ($) {
		return $.fb;
	},
	A7(
		$author$project$Type$IO$reference,
		'answer',
		$author$project$Type$IO$string,
		function ($) {
			return $.E;
		},
		function ($) {
			return $.bL;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A2($author$project$Type$IO$entity, $author$project$Type$Database$CodingFrame, $author$project$Type$Database$CodingFrameView)));
var $author$project$Type$Database$CodingQuestion = F3(
	function (coding_questionary, text, input_type) {
		return {f1: coding_questionary, d4: input_type, hQ: text};
	});
var $author$project$Type$Database$CodingQuestionView = F3(
	function (coding_questionary, text, input_type) {
		return {f1: coding_questionary, d4: input_type, hQ: text};
	});
var $author$project$Type$Database$updateEmpty = F2(
	function (f, prev) {
		return _Utils_update(
			prev,
			{
				dK: f(prev.dK)
			});
	});
var $author$project$Type$Database$coding_question = A2(
	$author$project$Type$Database$updateEmpty,
	function (x) {
		return _Utils_update(
			x,
			{hQ: 'Unnamed Coding Question'});
	},
	A7(
		$author$project$Type$IO$reference,
		'input_type',
		$author$project$Type$IO$string,
		function ($) {
			return $.d4;
		},
		function ($) {
			return $.d5;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A4(
			$author$project$Type$IO$attribute,
			'text',
			$author$project$Type$IO$string,
			function ($) {
				return $.hQ;
			},
			A7(
				$author$project$Type$IO$reference,
				'coding_questionary',
				$author$project$Type$IO$string,
				function ($) {
					return $.f1;
				},
				function ($) {
					return $.f2;
				},
				$elm$core$Dict$get,
				function ($) {
					return $.fb;
				},
				A2($author$project$Type$IO$entity, $author$project$Type$Database$CodingQuestion, $author$project$Type$Database$CodingQuestionView)))));
var $author$project$Type$Database$CodingQuestionary = F2(
	function (question, enabled) {
		return {dL: enabled, eH: question};
	});
var $author$project$Type$Database$CodingQuestionaryView = F2(
	function (question, enabled) {
		return {dL: enabled, eH: question};
	});
var $elm_explorations$test$MicroRandomExtra$bool = A2(
	$elm$random$Random$map,
	$elm$core$Basics$eq(0),
	A2($elm$random$Random$int, 0, 1));
var $elm_explorations$test$Shrink$bool = function (b) {
	if (b) {
		return A2($elm_explorations$test$Lazy$List$cons, false, $elm_explorations$test$Lazy$List$empty);
	} else {
		return $elm_explorations$test$Lazy$List$empty;
	}
};
var $elm_explorations$test$Fuzz$bool = A2($elm_explorations$test$Fuzz$custom, $elm_explorations$test$MicroRandomExtra$bool, $elm_explorations$test$Shrink$bool);
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Type$IO$Decoder$bool = $elm$json$Json$Decode$bool;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Type$IO$Encoder$bool = $author$project$Type$IO$Encoder$SingleEncoder($elm$json$Json$Encode$bool);
var $author$project$Type$IO$Form$BoolMsg = function (a) {
	return {$: 3, a: a};
};
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Checked = 1;
var $aforemny$material_components_web_elm$Material$Checkbox$checked = 1;
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Indeterminate = 2;
var $aforemny$material_components_web_elm$Material$Checkbox$indeterminate = 2;
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Unchecked = 0;
var $aforemny$material_components_web_elm$Material$Checkbox$unchecked = 0;
var $author$project$Type$IO$Form$bool = F5(
	function (_v0, callback, kind, _v1, f) {
		var bool2state = function (state) {
			if (!state.$) {
				if (state.a) {
					return $aforemny$material_components_web_elm$Material$Checkbox$checked;
				} else {
					return $aforemny$material_components_web_elm$Material$Checkbox$unchecked;
				}
			} else {
				return $aforemny$material_components_web_elm$Material$Checkbox$indeterminate;
			}
		};
		return $elm$core$Result$Ok(
			A2(
				f,
				kind ? 'TRUE' : 'FALSE',
				function (x) {
					return callback(
						$author$project$Type$IO$Form$BoolMsg(
							$elm$core$Maybe$Just(x === 'TRUE')));
				}));
	});
var $author$project$Type$IO$Setter$BoolMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Type$IO$Setter$bool = F2(
	function (msg, val) {
		switch (msg.$) {
			case 4:
				var f = msg.a;
				return $elm$core$Result$Ok(
					f(val));
			case 5:
				var b = msg.a;
				return $elm$core$Result$Ok(b);
			default:
				return $elm$core$Result$Err(
					A2(
						$author$project$Type$IO$Setter$Mismatch,
						msg,
						$author$project$Type$IO$Setter$BoolMsg(val)));
		}
	});
var $author$project$Type$IO$ToString$bool = F2(
	function (_v0, b) {
		return $elm$core$Result$Ok(
			b ? 'TRUE' : 'FALSE');
	});
var $author$project$Type$IO$Viewer$bool = $author$project$Type$IO$Viewer$basic;
var $author$project$Type$IO$bool = {
	a6: $author$project$Type$IO$Decoder$bool,
	dK: false,
	dM: $author$project$Type$IO$Encoder$bool,
	dP: _List_Nil,
	aD: $author$project$Type$IO$Form$bool,
	aF: $elm_explorations$test$Fuzz$bool,
	e_: function (_v0) {
		return $author$project$Type$IO$Decoder$bool;
	},
	h9: $author$project$Type$IO$ToString$bool,
	c4: $author$project$Type$IO$Setter$bool,
	fd: $author$project$Type$IO$Viewer$bool
};
var $author$project$Type$Database$coding_questionary = A4(
	$author$project$Type$IO$attribute,
	'enabled',
	$author$project$Type$IO$bool,
	function ($) {
		return $.dL;
	},
	A7(
		$author$project$Type$IO$reference,
		'question',
		$author$project$Type$IO$string,
		function ($) {
			return $.eH;
		},
		function ($) {
			return $.hp;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A2($author$project$Type$IO$entity, $author$project$Type$Database$CodingQuestionary, $author$project$Type$Database$CodingQuestionaryView)));
var $author$project$Type$Database$Event = F4(
	function (place, date, study, name) {
		return {bZ: date, af: name, hl: place, cY: study};
	});
var $author$project$Type$Database$EventView = F4(
	function (place, date, study, name) {
		return {bZ: date, af: name, hl: place, cY: study};
	});
var $author$project$Type$Database$event = A2(
	$author$project$Type$Database$updateEmpty,
	function (x) {
		return _Utils_update(
			x,
			{af: 'Unnamed Event'});
	},
	A4(
		$author$project$Type$IO$attribute,
		'name',
		$author$project$Type$IO$string,
		function ($) {
			return $.af;
		},
		A7(
			$author$project$Type$IO$reference,
			'study',
			$author$project$Type$IO$string,
			function ($) {
				return $.cY;
			},
			function ($) {
				return $.hK;
			},
			$elm$core$Dict$get,
			function ($) {
				return $.fb;
			},
			A4(
				$author$project$Type$IO$attribute,
				'date',
				$author$project$Type$IO$string,
				function ($) {
					return $.bZ;
				},
				A7(
					$author$project$Type$IO$reference,
					'place',
					$author$project$Type$IO$string,
					function ($) {
						return $.hl;
					},
					function ($) {
						return $.br;
					},
					$elm$core$Dict$get,
					function ($) {
						return $.fb;
					},
					A2($author$project$Type$IO$entity, $author$project$Type$Database$Event, $author$project$Type$Database$EventView))))));
var $author$project$Type$Database$InputType$ShortAnswer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Database$InputType$List = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Database$InputType$LongAnswer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Database$InputType$ListConfig = F2(
	function (singleInput, choices) {
		return {ds: choices, eX: singleInput};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_explorations$test$Lazy$List$numbers = A2(
	$elm_explorations$test$Lazy$List$iterate,
	$elm$core$Basics$add(1),
	1);
var $elm_explorations$test$RoseTree$root = function (_v0) {
	var a = _v0.a;
	return a;
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_explorations$test$Fuzz$listShrinkRecurse = function (listOfTrees) {
	var shrinkOne = F2(
		function (prefix, aList) {
			if (!aList.b) {
				return $elm_explorations$test$Lazy$List$empty;
			} else {
				var _v4 = aList.a;
				var x = _v4.a;
				var shrunkenXs = _v4.b;
				var more = aList.b;
				return A2(
					$elm_explorations$test$Lazy$List$map,
					function (childTree) {
						return $elm_explorations$test$Fuzz$listShrinkRecurse(
							_Utils_ap(
								prefix,
								A2($elm$core$List$cons, childTree, more)));
					},
					shrunkenXs);
			}
		});
	var root = A2($elm$core$List$map, $elm_explorations$test$RoseTree$root, listOfTrees);
	var removeOne = F2(
		function (index, aList) {
			return A2(
				$elm$core$List$append,
				A2($elm$core$List$take, index, aList),
				A2($elm$core$List$drop, index + 1, aList));
		});
	var n = $elm$core$List$length(listOfTrees);
	var shortened = $elm_explorations$test$Lazy$lazy(
		function (_v2) {
			return $elm_explorations$test$Lazy$force(
				A2(
					$elm_explorations$test$Lazy$List$map,
					$elm_explorations$test$Fuzz$listShrinkRecurse,
					A2(
						$elm_explorations$test$Lazy$List$map,
						function (index) {
							return A2(removeOne, index, listOfTrees);
						},
						$elm_explorations$test$Lazy$List$fromList(
							A2($elm$core$List$range, 0, n - 1)))));
		});
	var shrunkenVals = $elm_explorations$test$Lazy$lazy(
		function (_v1) {
			return $elm_explorations$test$Lazy$force(
				A2(
					$elm_explorations$test$Lazy$List$andThen,
					function (i) {
						return A2(
							shrinkOne,
							A2($elm$core$List$take, i, listOfTrees),
							A2($elm$core$List$drop, i, listOfTrees));
					},
					A2(
						$elm_explorations$test$Lazy$List$take,
						n,
						A2(
							$elm_explorations$test$Lazy$List$map,
							function (i) {
								return i - 1;
							},
							$elm_explorations$test$Lazy$List$numbers))));
		});
	var dropSecondHalf = function (list_) {
		return $elm_explorations$test$Fuzz$listShrinkRecurse(
			A2(
				$elm$core$List$take,
				($elm$core$List$length(list_) / 2) | 0,
				list_));
	};
	var dropFirstHalf = function (list_) {
		return $elm_explorations$test$Fuzz$listShrinkRecurse(
			A2(
				$elm$core$List$drop,
				($elm$core$List$length(list_) / 2) | 0,
				list_));
	};
	var halved = (n >= 8) ? $elm_explorations$test$Lazy$lazy(
		function (_v0) {
			return $elm_explorations$test$Lazy$force(
				$elm_explorations$test$Lazy$List$fromList(
					_List_fromArray(
						[
							dropFirstHalf(listOfTrees),
							dropSecondHalf(listOfTrees)
						])));
		}) : $elm_explorations$test$Lazy$List$empty;
	return A2(
		$elm_explorations$test$RoseTree$Rose,
		root,
		A2(
			$elm_explorations$test$Lazy$List$append,
			halved,
			A2($elm_explorations$test$Lazy$List$append, shortened, shrunkenVals)));
};
var $elm_explorations$test$Fuzz$mapChildren = F2(
	function (fn, _v0) {
		var root = _v0.a;
		var children = _v0.b;
		return A2(
			$elm_explorations$test$RoseTree$Rose,
			root,
			fn(children));
	});
var $elm_explorations$test$Fuzz$listShrinkHelp = function (listOfTrees) {
	return A2(
		$elm_explorations$test$Fuzz$mapChildren,
		$elm_explorations$test$Lazy$List$cons(
			$elm_explorations$test$RoseTree$singleton(_List_Nil)),
		$elm_explorations$test$Fuzz$listShrinkRecurse(listOfTrees));
};
var $elm_explorations$test$Fuzz$list = function (fuzzer) {
	var genLength = A2(
		$elm_explorations$test$MicroRandomExtra$frequency,
		_Utils_Tuple2(
			1,
			$elm$random$Random$constant(0)),
		_List_fromArray(
			[
				_Utils_Tuple2(
				1,
				$elm$random$Random$constant(1)),
				_Utils_Tuple2(
				3,
				A2($elm$random$Random$int, 2, 10)),
				_Utils_Tuple2(
				2,
				A2($elm$random$Random$int, 10, 100)),
				_Utils_Tuple2(
				0.5,
				A2($elm$random$Random$int, 100, 400))
			]));
	return A2(
		$elm$core$Result$map,
		function (validFuzzer) {
			return A2(
				$elm$random$Random$map,
				$elm_explorations$test$Fuzz$listShrinkHelp,
				A2(
					$elm$random$Random$andThen,
					function (a) {
						return A2($elm$random$Random$list, a, validFuzzer);
					},
					genLength));
		},
		fuzzer);
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Type$IO$Decoder$list = $elm$json$Json$Decode$list;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Type$IO$Encoder$list = function (old) {
	return $author$project$Type$IO$Encoder$SingleEncoder(
		$elm$json$Json$Encode$list(
			$author$project$Type$IO$Encoder$collapseEncoder(old)));
};
var $author$project$Type$IO$Form$ListError = 1;
var $author$project$Type$IO$Form$ListMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Type$IO$Form$list = F6(
	function (old, name, callback, kind, acc, f) {
		var _v0 = $author$project$Type$IO$Form$parseHeadTail(acc);
		var parsedIndex = _v0.a;
		var rest = _v0.b;
		var _new = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, instance) {
					return A5(
						old,
						name,
						A2(
							$elm$core$Basics$composeL,
							callback,
							$author$project$Type$IO$Form$ListMsg(index)),
						instance,
						rest,
						f);
				}),
			kind);
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Result$Err(1),
			A2(
				$elm$core$Maybe$andThen,
				function (x) {
					return A2($elm_community$list_extra$List$Extra$getAt, x, _new);
				},
				$elm$core$String$toInt(parsedIndex)));
	});
var $author$project$Type$IO$Setter$IndexOutOfBounds = {$: 1};
var $author$project$Type$IO$Setter$ListUpdateMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Type$IO$Setter$list = F4(
	function (empty, old, msg, val) {
		list:
		while (true) {
			switch (msg.$) {
				case 9:
					var index = msg.a;
					var msg_ = msg.b;
					return A2(
						$elm$core$Result$map,
						function (x) {
							return A3($elm_community$list_extra$List$Extra$setAt, index, x, val);
						},
						A2(
							$elm$core$Result$andThen,
							old(msg_),
							A2(
								$elm$core$Result$fromMaybe,
								$author$project$Type$IO$Setter$IndexOutOfBounds,
								A2($elm_community$list_extra$List$Extra$getAt, index, val))));
				case 10:
					var msg_ = msg.a;
					var _v1 = A2(old, msg_, empty);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(
							A2(
								$elm$core$List$append,
								val,
								_List_fromArray(
									[value])));
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(err);
					}
				case 11:
					var index = msg.a;
					var msg_ = msg.b;
					if (_Utils_cmp(
						index,
						$elm$core$List$length(val)) > -1) {
						var $temp$empty = empty,
							$temp$old = old,
							$temp$msg = msg,
							$temp$val = _Utils_ap(
							val,
							_List_fromArray(
								[empty]));
						empty = $temp$empty;
						old = $temp$old;
						msg = $temp$msg;
						val = $temp$val;
						continue list;
					} else {
						var $temp$empty = empty,
							$temp$old = old,
							$temp$msg = A2($author$project$Type$IO$Setter$ListUpdateMsg, index, msg_),
							$temp$val = val;
						empty = $temp$empty;
						old = $temp$old;
						msg = $temp$msg;
						val = $temp$val;
						continue list;
					}
				default:
					return $elm$core$Result$Err(
						A2(
							$author$project$Type$IO$Setter$Mismatch,
							msg,
							A2($author$project$Type$IO$Setter$ListUpdateMsg, 0, $author$project$Type$IO$Setter$ErrorMsg)));
			}
		}
	});
var $author$project$Type$IO$ToString$IndexOutOfBounds = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$IO$ToString$NotAnInt = function (a) {
	return {$: 2, a: a};
};
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$Type$IO$ToString$l2s = function (l) {
	return '[ ' + (A2($elm$core$String$join, ', ', l) + ' ]');
};
var $author$project$Type$IO$ToString$list = F3(
	function (old, name, l) {
		var _v0 = $author$project$Type$IO$ToString$parseHeadTail(name);
		var head = _v0.a;
		var rest = _v0.b;
		if (name === '*') {
			return A2(
				$elm$core$Result$map,
				$author$project$Type$IO$ToString$l2s,
				$elm_community$result_extra$Result$Extra$combine(
					A2(
						$elm$core$List$map,
						old('*'),
						l)));
		} else {
			var _v1 = $elm$core$String$toInt(head);
			if (!_v1.$) {
				var index = _v1.a;
				var _v2 = A2($elm_community$list_extra$List$Extra$getAt, index, l);
				if (!_v2.$) {
					var value = _v2.a;
					return A2(old, rest, value);
				} else {
					return $elm$core$Result$Err(
						$author$project$Type$IO$ToString$IndexOutOfBounds(index));
				}
			} else {
				return $elm$core$Result$Err(
					$author$project$Type$IO$ToString$NotAnInt(head));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (!head.$) {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $author$project$Type$IO$Viewer$list = F3(
	function (old, db, full) {
		return $elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				$elm$core$List$map,
				old(db),
				full));
	});
var $author$project$Type$IO$list = function (old) {
	return {
		a6: $author$project$Type$IO$Decoder$list(old.a6),
		dK: _List_Nil,
		dM: $author$project$Type$IO$Encoder$list(old.dM),
		dP: _List_Nil,
		aD: $author$project$Type$IO$Form$list(old.aD),
		aF: $elm_explorations$test$Fuzz$list(old.aF),
		e_: function (a) {
			return $author$project$Type$IO$Decoder$list(
				old.e_(a));
		},
		h9: $author$project$Type$IO$ToString$list(old.h9),
		c4: A2($author$project$Type$IO$Setter$list, old.dK, old.c4),
		fd: $author$project$Type$IO$Viewer$list(old.fd)
	};
};
var $author$project$Type$Database$InputType$Box = 1;
var $author$project$Type$Database$InputType$Radio = 0;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm_explorations$test$Fuzz$Internal$combineValid = function (valids) {
	if (!valids.b) {
		return $elm$core$Result$Ok(_List_Nil);
	} else {
		if (!valids.a.$) {
			var x = valids.a.a;
			var rest = valids.b;
			return A2(
				$elm$core$Result$map,
				$elm$core$List$cons(x),
				$elm_explorations$test$Fuzz$Internal$combineValid(rest));
		} else {
			var reason = valids.a.a;
			return $elm$core$Result$Err(reason);
		}
	}
};
var $elm_explorations$test$Fuzz$extractValid = function (_v0) {
	var a = _v0.a;
	var valid = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (b) {
			return _Utils_Tuple2(a, b);
		},
		valid);
};
var $elm_explorations$test$Fuzz$invalid = function (reason) {
	return $elm$core$Result$Err(reason);
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm_explorations$test$Fuzz$frequency = function (aList) {
	if ($elm$core$List$isEmpty(aList)) {
		return $elm_explorations$test$Fuzz$invalid('You must provide at least one frequency pair.');
	} else {
		if (A2(
			$elm$core$List$any,
			function (_v0) {
				var weight = _v0.a;
				return weight < 0;
			},
			aList)) {
			return $elm_explorations$test$Fuzz$invalid('No frequency weights can be less than 0.');
		} else {
			if ($elm$core$List$sum(
				A2($elm$core$List$map, $elm$core$Tuple$first, aList)) <= 0) {
				return $elm_explorations$test$Fuzz$invalid('Frequency weights must sum to more than 0.');
			} else {
				var toRandom = function (validList) {
					if (!validList.b) {
						return $elm_explorations$test$Fuzz$invalid('You must provide at least one frequency pair.');
					} else {
						var first = validList.a;
						var rest = validList.b;
						return $elm$core$Result$Ok(
							A2($elm_explorations$test$MicroRandomExtra$frequency, first, rest));
					}
				};
				return A2(
					$elm$core$Result$andThen,
					toRandom,
					$elm_explorations$test$Fuzz$Internal$combineValid(
						A2($elm$core$List$map, $elm_explorations$test$Fuzz$extractValid, aList)));
			}
		}
	}
};
var $elm_explorations$test$Fuzz$oneOf = function (aList) {
	return $elm$core$List$isEmpty(aList) ? $elm_explorations$test$Fuzz$invalid('You must pass at least one Fuzzer to Fuzz.oneOf.') : $elm_explorations$test$Fuzz$frequency(
		A2(
			$elm$core$List$map,
			function (fuzzer) {
				return _Utils_Tuple2(1, fuzzer);
			},
			aList));
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Type$Database$InputType$singleInputTypeDecoder = function () {
	var helper = function (name) {
		switch (name) {
			case 'radio':
				return $elm$json$Json$Decode$succeed(0);
			case 'box':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('I need either radio or box, but i got' + name);
		}
	};
	return A2($elm$json$Json$Decode$andThen, helper, $elm$json$Json$Decode$string);
}();
var $author$project$Type$Database$InputType$singleInputTypeEncoder = $author$project$Type$IO$Encoder$SingleEncoder(
	function (value) {
		if (value === 1) {
			return $elm$json$Json$Encode$string('box');
		} else {
			return $elm$json$Json$Encode$string('radio');
		}
	});
var $author$project$Type$Database$InputType$singleInputTypeForm = F5(
	function (name, callback, kind, label, f) {
		if (kind === 1) {
			return $elm$core$Result$Ok(
				A2(
					f,
					'box',
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, callback, $author$project$Type$IO$Form$StringMsg),
						$elm$core$Maybe$Just)));
		} else {
			return $elm$core$Result$Ok(
				A2(
					f,
					'radio',
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, callback, $author$project$Type$IO$Form$StringMsg),
						$elm$core$Maybe$Just)));
		}
	});
var $author$project$Type$Database$InputType$singleInputTypeToString = F2(
	function (name, value) {
		if (value === 1) {
			return $elm$core$Result$Ok('box');
		} else {
			return $elm$core$Result$Ok('radio');
		}
	});
var $author$project$Type$IO$Setter$InvalidValue = {$: 3};
var $author$project$Type$Database$InputType$singleInputTypeUpdater = F2(
	function (msg, val) {
		_v0$2:
		while (true) {
			if (msg.$ === 2) {
				switch (msg.a) {
					case 'box':
						return $elm$core$Result$Ok(1);
					case 'radio':
						return $elm$core$Result$Ok(0);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Result$Err($author$project$Type$IO$Setter$InvalidValue);
	});
var $author$project$Type$Database$InputType$singleInputType = {
	a6: $author$project$Type$Database$InputType$singleInputTypeDecoder,
	dK: 1,
	dM: $author$project$Type$Database$InputType$singleInputTypeEncoder,
	dP: _List_Nil,
	aD: $author$project$Type$Database$InputType$singleInputTypeForm,
	aF: $elm_explorations$test$Fuzz$oneOf(
		_List_fromArray(
			[
				$elm_explorations$test$Fuzz$constant(1),
				$elm_explorations$test$Fuzz$constant(0)
			])),
	e_: function (_v0) {
		return $author$project$Type$Database$InputType$singleInputTypeDecoder;
	},
	h9: $author$project$Type$Database$InputType$singleInputTypeToString,
	c4: $author$project$Type$Database$InputType$singleInputTypeUpdater,
	fd: F2(
		function (_v1, full) {
			return $elm$core$Maybe$Just(full);
		})
};
var $author$project$Type$IO$Decoder$substruct = $author$project$Type$IO$Decoder$attribute;
var $author$project$Type$IO$Encoder$substruct = F4(
	function (name, struct, getter, old) {
		var _v0 = _Utils_Tuple2(old, struct);
		if (_v0.a.$ === 1) {
			if (!_v0.b.$) {
				var pe = _v0.a.a;
				var de = _v0.b.a;
				return $author$project$Type$IO$Encoder$ListEncoder(
					_Utils_ap(
						_List_fromArray(
							[
								function (x) {
								return _Utils_Tuple2(
									name,
									de(
										getter(x)));
							}
							]),
						pe));
			} else {
				var pe = _v0.a.a;
				var de = _v0.b.a;
				return $author$project$Type$IO$Encoder$ListEncoder(
					_Utils_ap(
						_List_fromArray(
							[
								function (x) {
								return _Utils_Tuple2(
									name,
									A2(
										$author$project$Type$IO$Encoder$listToSingle,
										de,
										getter(x)));
							}
							]),
						pe));
			}
		} else {
			var pe = _v0.a.a;
			return $author$project$Type$IO$Encoder$SingleEncoder(pe);
		}
	});
var $author$project$Type$IO$Form$substruct = F8(
	function (name, getter, childform, parentform, label, callback, kind, acc) {
		var newname = label + ('.' + name);
		var _v0 = $author$project$Type$IO$Form$parseHeadTail(acc);
		var head = _v0.a;
		var tail = _v0.b;
		return _Utils_eq(name, head) ? A4(
			childform,
			newname,
			A2(
				$elm$core$Basics$composeL,
				callback,
				$author$project$Type$IO$Form$AttrMsg(head)),
			getter(kind),
			tail) : A4(parentform, label, callback, kind, acc);
	});
var $author$project$Type$IO$Setter$substruct = $author$project$Type$IO$Setter$attribute;
var $author$project$Type$IO$ToString$substruct = F4(
	function (name, struct, getter, old) {
		return F2(
			function (acc, value) {
				var _v0 = $author$project$Type$IO$ToString$parseHeadTail(acc);
				var head = _v0.a;
				var tail = _v0.b;
				return (_Utils_eq(name, head) || (name === '*')) ? A2(
					struct,
					tail,
					getter(value)) : A2(old, acc, value);
			});
	});
var $author$project$Type$IO$Viewer$substruct = F3(
	function (getter, struct, old) {
		return F2(
			function (db, full) {
				var _v0 = _Utils_Tuple2(
					A2(old, db, full),
					A2(
						struct,
						db,
						getter(full)));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var f = _v0.a.a;
					var v = _v0.b.a;
					return $elm$core$Maybe$Just(
						f(v));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
	});
var $author$project$Type$IO$substruct = F4(
	function (name, struct, getter, old) {
		return {
			a6: A3($author$project$Type$IO$Decoder$substruct, name, struct.a6, old.a6),
			dK: old.dK(struct.dK),
			dM: A4($author$project$Type$IO$Encoder$substruct, name, struct.dM, getter, old.dM),
			dP: _Utils_ap(
				old.dP,
				A2(
					$elm$core$List$map,
					function (x) {
						return name + ('.' + x);
					},
					struct.dP)),
			aD: A4($author$project$Type$IO$Form$substruct, name, getter, struct.aD, old.aD),
			aF: A2($elm_explorations$test$Fuzz$andMap, struct.aF, old.aF),
			e_: function (a) {
				return A3(
					$author$project$Type$IO$Decoder$substruct,
					name,
					struct.e_(a),
					old.e_(a));
			},
			h9: A4($author$project$Type$IO$ToString$substruct, name, struct.h9, getter, old.h9),
			c4: A4($author$project$Type$IO$Setter$substruct, name, getter, struct.c4, old.c4),
			fd: A3($author$project$Type$IO$Viewer$substruct, getter, struct.fd, old.fd)
		};
	});
var $author$project$Type$Database$InputType$updateEmpty = F2(
	function (f, prev) {
		return _Utils_update(
			prev,
			{
				dK: f(prev.dK)
			});
	});
var $author$project$Type$Database$InputType$listConfig = A2(
	$author$project$Type$Database$InputType$updateEmpty,
	function (x) {
		return _Utils_update(
			x,
			{
				ds: _List_fromArray(
					['Unnamed Choice'])
			});
	},
	A4(
		$author$project$Type$IO$attribute,
		'choices',
		$author$project$Type$IO$list($author$project$Type$IO$string),
		function ($) {
			return $.ds;
		},
		A4(
			$author$project$Type$IO$substruct,
			'singleInput',
			$author$project$Type$Database$InputType$singleInputType,
			function ($) {
				return $.eX;
			},
			A2($author$project$Type$IO$entity, $author$project$Type$Database$InputType$ListConfig, $author$project$Type$Database$InputType$ListConfig))));
var $author$project$Type$Database$InputType$LongAnswerConfig = F7(
	function (label, placeholder, minLength, maxLength, pattern, rows, cols) {
		return {f3: cols, ea: label, bh: maxLength, bi: minLength, ex: pattern, hm: placeholder, hu: rows};
	});
var $elm_explorations$test$Shrink$int = function (n) {
	return (n < 0) ? A2(
		$elm_explorations$test$Lazy$List$cons,
		-n,
		A2(
			$elm_explorations$test$Lazy$List$map,
			$elm$core$Basics$mul(-1),
			A2($elm_explorations$test$Shrink$seriesInt, 0, -n))) : A2($elm_explorations$test$Shrink$seriesInt, 0, n);
};
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $elm_explorations$test$Fuzz$int = function () {
	var generator = A2(
		$elm_explorations$test$MicroRandomExtra$frequency,
		_Utils_Tuple2(
			3,
			A2($elm$random$Random$int, -50, 50)),
		_List_fromArray(
			[
				_Utils_Tuple2(
				0.2,
				$elm$random$Random$constant(0)),
				_Utils_Tuple2(
				1,
				A2($elm$random$Random$int, 0, $elm$random$Random$maxInt - $elm$random$Random$minInt)),
				_Utils_Tuple2(
				1,
				A2($elm$random$Random$int, $elm$random$Random$minInt - $elm$random$Random$maxInt, 0))
			]));
	return A2($elm_explorations$test$Fuzz$custom, generator, $elm_explorations$test$Shrink$int);
}();
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Type$IO$Decoder$int = $elm$json$Json$Decode$int;
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Type$IO$Encoder$int = $author$project$Type$IO$Encoder$SingleEncoder($elm$json$Json$Encode$int);
var $author$project$Type$IO$Form$IntMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$IO$Form$int = F5(
	function (name, callback, kind, label, f) {
		return $elm$core$Result$Ok(
			A2(
				f,
				$elm$core$String$fromInt(kind),
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, callback, $author$project$Type$IO$Form$IntMsg),
					$elm$core$String$toInt)));
	});
var $author$project$Type$IO$Setter$IntMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$IO$Setter$int = F2(
	function (msg, val) {
		switch (msg.$) {
			case 0:
				var f = msg.a;
				return $elm$core$Result$Ok(f);
			case 1:
				var f = msg.a;
				return $elm$core$Result$Ok(
					f(val));
			default:
				return $elm$core$Result$Err(
					A2(
						$author$project$Type$IO$Setter$Mismatch,
						msg,
						$author$project$Type$IO$Setter$IntMsg(val)));
		}
	});
var $author$project$Type$IO$ToString$int = F2(
	function (_v0, i) {
		return $elm$core$Result$Ok(
			$elm$core$String$fromInt(i));
	});
var $author$project$Type$IO$Viewer$int = $author$project$Type$IO$Viewer$basic;
var $author$project$Type$IO$int = {
	a6: $author$project$Type$IO$Decoder$int,
	dK: 0,
	dM: $author$project$Type$IO$Encoder$int,
	dP: _List_Nil,
	aD: $author$project$Type$IO$Form$int,
	aF: $elm_explorations$test$Fuzz$int,
	e_: function (_v0) {
		return $author$project$Type$IO$Decoder$int;
	},
	h9: $author$project$Type$IO$ToString$int,
	c4: $author$project$Type$IO$Setter$int,
	fd: $author$project$Type$IO$Viewer$int
};
var $elm_explorations$test$RoseTree$addChild = F2(
	function (child, _v0) {
		var a = _v0.a;
		var c = _v0.b;
		return A2(
			$elm_explorations$test$RoseTree$Rose,
			a,
			A2($elm_explorations$test$Lazy$List$cons, child, c));
	});
var $elm_explorations$test$MicroRandomExtra$oneIn = function (n) {
	return A2(
		$elm$random$Random$map,
		$elm$core$Basics$eq(1),
		A2($elm$random$Random$int, 1, n));
};
var $elm_explorations$test$Fuzz$maybe = function (fuzzer) {
	var toMaybe = F2(
		function (useNothing, tree) {
			return useNothing ? $elm_explorations$test$RoseTree$singleton($elm$core$Maybe$Nothing) : A2(
				$elm_explorations$test$RoseTree$addChild,
				$elm_explorations$test$RoseTree$singleton($elm$core$Maybe$Nothing),
				A2($elm_explorations$test$RoseTree$map, $elm$core$Maybe$Just, tree));
		});
	return A2(
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$map,
			$elm$random$Random$map2(toMaybe)),
		$elm_explorations$test$MicroRandomExtra$oneIn(4),
		fuzzer);
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Type$IO$Decoder$maybe = $elm$json$Json$Decode$nullable;
var $author$project$Type$IO$Encoder$maybe = function (old) {
	if (old.$ === 1) {
		var e = old.a;
		return $author$project$Type$IO$Encoder$SingleEncoder(
			function (x) {
				if (!x.$) {
					var v = x.a;
					return $elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							function (y) {
								return y(v);
							},
							e));
				} else {
					return $elm$json$Json$Encode$null;
				}
			});
	} else {
		var e = old.a;
		return $author$project$Type$IO$Encoder$SingleEncoder(
			function (x) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, e, x));
			});
	}
};
var $author$project$Type$IO$Form$MaybeMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$IO$Form$MaybeWasNothing = 0;
var $author$project$Type$IO$Form$maybe = F6(
	function (old, name, callback, kind, acc, f) {
		var _new = A2(
			$elm$core$Maybe$map,
			function (x) {
				return A5(
					old,
					name,
					A2($elm$core$Basics$composeL, callback, $author$project$Type$IO$Form$MaybeMsg),
					x,
					acc,
					f);
			},
			kind);
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Result$Err(0),
			_new);
	});
var $author$project$Type$IO$Setter$MaybeUpdateMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Type$IO$Setter$maybe = F4(
	function (empty, old, msg, val) {
		switch (msg.$) {
			case 7:
				if (!msg.a.$) {
					if (!val.$) {
						var v = val.a;
						var _v2 = A2(old, msg, v);
						if (!_v2.$) {
							var res = _v2.a;
							return $elm$core$Result$Ok(
								$elm$core$Maybe$Just(res));
						} else {
							var e = _v2.a;
							return $elm$core$Result$Err(e);
						}
					} else {
						return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
					}
				} else {
					var _v3 = msg.a;
					return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
				}
			case 8:
				if (!msg.a.$) {
					var msg_ = msg.a.a;
					return A2(
						$elm$core$Result$map,
						$elm$core$Maybe$Just,
						A2(old, msg_, empty));
				} else {
					var _v4 = msg.a;
					return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
				}
			default:
				return $elm$core$Result$Err(
					A2(
						$author$project$Type$IO$Setter$Mismatch,
						msg,
						$author$project$Type$IO$Setter$MaybeUpdateMsg($elm$core$Maybe$Nothing)));
		}
	});
var $author$project$Type$IO$ToString$maybe = F3(
	function (old, name, value) {
		if (!value.$) {
			var v = value.a;
			return A2(old, name, v);
		} else {
			return $elm$core$Result$Ok('Nothing');
		}
	});
var $author$project$Type$IO$Viewer$maybe = F3(
	function (old, db, full) {
		return A2(
			$elm$core$Maybe$map,
			old(db),
			full);
	});
var $author$project$Type$IO$maybe = function (old) {
	return {
		a6: $author$project$Type$IO$Decoder$maybe(old.a6),
		dK: $elm$core$Maybe$Nothing,
		dM: $author$project$Type$IO$Encoder$maybe(old.dM),
		dP: _List_Nil,
		aD: $author$project$Type$IO$Form$maybe(old.aD),
		aF: $elm_explorations$test$Fuzz$maybe(old.aF),
		e_: function (a) {
			return $author$project$Type$IO$Decoder$maybe(
				old.e_(a));
		},
		h9: $author$project$Type$IO$ToString$maybe(old.h9),
		c4: A2($author$project$Type$IO$Setter$maybe, old.dK, old.c4),
		fd: $author$project$Type$IO$Viewer$maybe(old.fd)
	};
};
var $author$project$Type$Database$InputType$longAnswerConfig = A4(
	$author$project$Type$IO$attribute,
	'cols',
	$author$project$Type$IO$maybe($author$project$Type$IO$int),
	function ($) {
		return $.f3;
	},
	A4(
		$author$project$Type$IO$attribute,
		'rows',
		$author$project$Type$IO$maybe($author$project$Type$IO$int),
		function ($) {
			return $.hu;
		},
		A4(
			$author$project$Type$IO$attribute,
			'pattern',
			$author$project$Type$IO$maybe($author$project$Type$IO$string),
			function ($) {
				return $.ex;
			},
			A4(
				$author$project$Type$IO$attribute,
				'maxLength',
				$author$project$Type$IO$maybe($author$project$Type$IO$int),
				function ($) {
					return $.bh;
				},
				A4(
					$author$project$Type$IO$attribute,
					'minLength',
					$author$project$Type$IO$maybe($author$project$Type$IO$int),
					function ($) {
						return $.bi;
					},
					A4(
						$author$project$Type$IO$attribute,
						'placeholder',
						$author$project$Type$IO$maybe($author$project$Type$IO$string),
						function ($) {
							return $.hm;
						},
						A4(
							$author$project$Type$IO$attribute,
							'label',
							$author$project$Type$IO$maybe($author$project$Type$IO$string),
							function ($) {
								return $.ea;
							},
							A2($author$project$Type$IO$entity, $author$project$Type$Database$InputType$LongAnswerConfig, $author$project$Type$Database$InputType$LongAnswerConfig))))))));
var $author$project$Type$Database$InputType$ShortAnswerConfig = F5(
	function (label, placeholder, minLength, maxLength, pattern) {
		return {ea: label, bh: maxLength, bi: minLength, ex: pattern, hm: placeholder};
	});
var $author$project$Type$Database$InputType$shortAnswerConfig = A4(
	$author$project$Type$IO$attribute,
	'pattern',
	$author$project$Type$IO$maybe($author$project$Type$IO$string),
	function ($) {
		return $.ex;
	},
	A4(
		$author$project$Type$IO$attribute,
		'maxLength',
		$author$project$Type$IO$maybe($author$project$Type$IO$int),
		function ($) {
			return $.bh;
		},
		A4(
			$author$project$Type$IO$attribute,
			'minLength',
			$author$project$Type$IO$maybe($author$project$Type$IO$int),
			function ($) {
				return $.bi;
			},
			A4(
				$author$project$Type$IO$attribute,
				'placeholder',
				$author$project$Type$IO$maybe($author$project$Type$IO$string),
				function ($) {
					return $.hm;
				},
				A4(
					$author$project$Type$IO$attribute,
					'label',
					$author$project$Type$IO$maybe($author$project$Type$IO$string),
					function ($) {
						return $.ea;
					},
					A2($author$project$Type$IO$entity, $author$project$Type$Database$InputType$ShortAnswerConfig, $author$project$Type$Database$InputType$ShortAnswerConfig))))));
var $author$project$Type$Database$InputType$inputTypeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Type$Database$InputType$LongAnswer, $author$project$Type$Database$InputType$longAnswerConfig.a6),
			A2($elm$json$Json$Decode$map, $author$project$Type$Database$InputType$ShortAnswer, $author$project$Type$Database$InputType$shortAnswerConfig.a6),
			A2($elm$json$Json$Decode$map, $author$project$Type$Database$InputType$List, $author$project$Type$Database$InputType$listConfig.a6)
		]));
var $author$project$Type$Database$InputType$inputTypeEncoder = $author$project$Type$IO$Encoder$SingleEncoder(
	function (value) {
		switch (value.$) {
			case 0:
				var v = value.a;
				return A2($author$project$Type$IO$Encoder$collapseEncoder, $author$project$Type$Database$InputType$shortAnswerConfig.dM, v);
			case 1:
				var v = value.a;
				return A2($author$project$Type$IO$Encoder$collapseEncoder, $author$project$Type$Database$InputType$longAnswerConfig.dM, v);
			default:
				var v = value.a;
				return A2($author$project$Type$IO$Encoder$collapseEncoder, $author$project$Type$Database$InputType$listConfig.dM, v);
		}
	});
var $author$project$Type$Database$InputType$inputTypeForm = F3(
	function (name, callback, kind) {
		switch (kind.$) {
			case 0:
				var v = kind.a;
				return A3($author$project$Type$Database$InputType$shortAnswerConfig.aD, name, callback, v);
			case 1:
				var v = kind.a;
				return A3($author$project$Type$Database$InputType$longAnswerConfig.aD, name, callback, v);
			default:
				var v = kind.a;
				return A3($author$project$Type$Database$InputType$listConfig.aD, name, callback, v);
		}
	});
var $author$project$Type$Database$InputType$inputTypeFuzzer = $elm_explorations$test$Fuzz$oneOf(
	_List_fromArray(
		[
			A2($elm_explorations$test$Fuzz$map, $author$project$Type$Database$InputType$ShortAnswer, $author$project$Type$Database$InputType$shortAnswerConfig.aF),
			A2($elm_explorations$test$Fuzz$map, $author$project$Type$Database$InputType$LongAnswer, $author$project$Type$Database$InputType$longAnswerConfig.aF),
			A2($elm_explorations$test$Fuzz$map, $author$project$Type$Database$InputType$List, $author$project$Type$Database$InputType$listConfig.aF)
		]));
var $author$project$Type$Database$InputType$inputTypeToString = F2(
	function (name, value) {
		switch (value.$) {
			case 0:
				var v = value.a;
				return A2($author$project$Type$Database$InputType$shortAnswerConfig.h9, name, v);
			case 1:
				var v = value.a;
				return A2($author$project$Type$Database$InputType$longAnswerConfig.h9, name, v);
			default:
				var v = value.a;
				return A2($author$project$Type$Database$InputType$listConfig.h9, name, v);
		}
	});
var $author$project$Type$IO$Setter$CustomError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Type$Database$InputType$inputTypeUpdater = F2(
	function (msg, val) {
		switch (msg.$) {
			case 19:
				var kind = msg.a;
				var mbMsg = msg.b;
				switch (kind) {
					case 'Short Answer':
						var _v2 = _Utils_Tuple2(val, mbMsg);
						if (!_v2.b.$) {
							if (!_v2.a.$) {
								var v = _v2.a.a;
								var msg_ = _v2.b.a;
								return A2(
									$elm$core$Result$map,
									$author$project$Type$Database$InputType$ShortAnswer,
									A2($author$project$Type$Database$InputType$shortAnswerConfig.c4, msg_, v));
							} else {
								var msg_ = _v2.b.a;
								return A2(
									$elm$core$Result$map,
									$author$project$Type$Database$InputType$ShortAnswer,
									A2($author$project$Type$Database$InputType$shortAnswerConfig.c4, msg_, $author$project$Type$Database$InputType$shortAnswerConfig.dK));
							}
						} else {
							if (!_v2.a.$) {
								var _v3 = _v2.b;
								return $elm$core$Result$Ok(val);
							} else {
								var _v4 = _v2.b;
								return $elm$core$Result$Ok(
									$author$project$Type$Database$InputType$ShortAnswer($author$project$Type$Database$InputType$shortAnswerConfig.dK));
							}
						}
					case 'Long Answer':
						var _v5 = _Utils_Tuple2(val, mbMsg);
						if (!_v5.b.$) {
							if (_v5.a.$ === 1) {
								var v = _v5.a.a;
								var msg_ = _v5.b.a;
								return A2(
									$elm$core$Result$map,
									$author$project$Type$Database$InputType$LongAnswer,
									A2($author$project$Type$Database$InputType$longAnswerConfig.c4, msg_, v));
							} else {
								var msg_ = _v5.b.a;
								return A2(
									$elm$core$Result$map,
									$author$project$Type$Database$InputType$LongAnswer,
									A2($author$project$Type$Database$InputType$longAnswerConfig.c4, msg_, $author$project$Type$Database$InputType$longAnswerConfig.dK));
							}
						} else {
							if (_v5.a.$ === 1) {
								var _v6 = _v5.b;
								return $elm$core$Result$Ok(val);
							} else {
								var _v7 = _v5.b;
								return $elm$core$Result$Ok(
									$author$project$Type$Database$InputType$LongAnswer($author$project$Type$Database$InputType$longAnswerConfig.dK));
							}
						}
					default:
						var s = kind;
						return $elm$core$Result$Err(
							$author$project$Type$IO$Setter$CustomError('Incorrect string: ' + s));
				}
			case 6:
				var name = msg.a;
				var msg_ = msg.b;
				switch (val.$) {
					case 0:
						var v = val.a;
						return A2(
							$elm$core$Result$map,
							$author$project$Type$Database$InputType$ShortAnswer,
							A2($author$project$Type$Database$InputType$shortAnswerConfig.c4, msg, v));
					case 1:
						var v = val.a;
						return A2(
							$elm$core$Result$map,
							$author$project$Type$Database$InputType$LongAnswer,
							A2($author$project$Type$Database$InputType$longAnswerConfig.c4, msg, v));
					default:
						var v = val.a;
						return A2(
							$elm$core$Result$map,
							$author$project$Type$Database$InputType$List,
							A2($author$project$Type$Database$InputType$listConfig.c4, msg, v));
				}
			default:
				return $elm$core$Result$Err(
					$author$project$Type$IO$Setter$CustomError('Tried to update an InputType without using Custom'));
		}
	});
var $author$project$Type$Database$InputType$input_type = {
	a6: $author$project$Type$Database$InputType$inputTypeDecoder,
	dK: $author$project$Type$Database$InputType$ShortAnswer($author$project$Type$Database$InputType$shortAnswerConfig.dK),
	dM: $author$project$Type$Database$InputType$inputTypeEncoder,
	dP: _List_Nil,
	aD: $author$project$Type$Database$InputType$inputTypeForm,
	aF: $author$project$Type$Database$InputType$inputTypeFuzzer,
	e_: function (_v0) {
		return $author$project$Type$Database$InputType$inputTypeDecoder;
	},
	h9: $author$project$Type$Database$InputType$inputTypeToString,
	c4: $author$project$Type$Database$InputType$inputTypeUpdater,
	fd: F2(
		function (_v1, full) {
			return $elm$core$Maybe$Just(full);
		})
};
var $author$project$Type$Database$Place = F3(
	function (name, latitude, longitude) {
		return {ed: latitude, ei: longitude, af: name};
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm_explorations$test$Lazy$List$singleton = function (a) {
	return A2($elm_explorations$test$Lazy$List$cons, a, $elm_explorations$test$Lazy$List$empty);
};
var $elm_explorations$test$Shrink$seriesFloat = F2(
	function (low, high) {
		if (_Utils_cmp(low, high - 0.0001) > -1) {
			return (high !== 0.000001) ? $elm_explorations$test$Lazy$List$singleton(low + 0.000001) : $elm_explorations$test$Lazy$List$empty;
		} else {
			var low_ = low + ((high - low) / 2);
			return A2(
				$elm_explorations$test$Lazy$List$cons,
				low,
				A2($elm_explorations$test$Shrink$seriesFloat, low_, high));
		}
	});
var $elm_explorations$test$Shrink$float = function (n) {
	return (n < 0) ? A2(
		$elm_explorations$test$Lazy$List$cons,
		-n,
		A2(
			$elm_explorations$test$Lazy$List$map,
			$elm$core$Basics$mul(-1),
			A2($elm_explorations$test$Shrink$seriesFloat, 0, -n))) : A2($elm_explorations$test$Shrink$seriesFloat, 0, n);
};
var $elm_explorations$test$Fuzz$float = function () {
	var generator = A2(
		$elm_explorations$test$MicroRandomExtra$frequency,
		_Utils_Tuple2(
			3,
			A2($elm$random$Random$float, -50, 50)),
		_List_fromArray(
			[
				_Utils_Tuple2(
				0.5,
				$elm$random$Random$constant(0)),
				_Utils_Tuple2(
				1,
				A2($elm$random$Random$float, -1, 1)),
				_Utils_Tuple2(
				1,
				A2($elm$random$Random$float, 0, $elm$random$Random$maxInt - $elm$random$Random$minInt)),
				_Utils_Tuple2(
				1,
				A2($elm$random$Random$float, $elm$random$Random$minInt - $elm$random$Random$maxInt, 0))
			]));
	return A2($elm_explorations$test$Fuzz$custom, generator, $elm_explorations$test$Shrink$float);
}();
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Type$IO$Decoder$float = $elm$json$Json$Decode$float;
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Type$IO$Encoder$float = $author$project$Type$IO$Encoder$SingleEncoder($elm$json$Json$Encode$float);
var $author$project$Type$IO$Form$FloatMsg = function (a) {
	return {$: 2, a: a};
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Type$IO$Form$float = F5(
	function (name, callback, kind, label, f) {
		return $elm$core$Result$Ok(
			A2(
				f,
				$elm$core$String$fromFloat(kind),
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, callback, $author$project$Type$IO$Form$FloatMsg),
					$elm$core$String$toFloat)));
	});
var $author$project$Type$IO$Setter$FloatMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$IO$Setter$float = F2(
	function (msg, val) {
		if (msg.$ === 3) {
			var f = msg.a;
			return $elm$core$Result$Ok(f);
		} else {
			return $elm$core$Result$Err(
				A2(
					$author$project$Type$IO$Setter$Mismatch,
					msg,
					$author$project$Type$IO$Setter$FloatMsg(val)));
		}
	});
var $author$project$Type$IO$ToString$float = F2(
	function (_v0, f) {
		return $elm$core$Result$Ok(
			$elm$core$String$fromFloat(f));
	});
var $author$project$Type$IO$Viewer$float = $author$project$Type$IO$Viewer$basic;
var $author$project$Type$IO$float = {
	a6: $author$project$Type$IO$Decoder$float,
	dK: 0,
	dM: $author$project$Type$IO$Encoder$float,
	dP: _List_Nil,
	aD: $author$project$Type$IO$Form$float,
	aF: $elm_explorations$test$Fuzz$float,
	e_: function (_v0) {
		return $author$project$Type$IO$Decoder$float;
	},
	h9: $author$project$Type$IO$ToString$float,
	c4: $author$project$Type$IO$Setter$float,
	fd: $author$project$Type$IO$Viewer$float
};
var $author$project$Type$Database$place = A2(
	$author$project$Type$Database$updateEmpty,
	function (x) {
		return _Utils_update(
			x,
			{af: 'Unnamed Place'});
	},
	A4(
		$author$project$Type$IO$attribute,
		'longitude',
		$author$project$Type$IO$float,
		function ($) {
			return $.ei;
		},
		A4(
			$author$project$Type$IO$attribute,
			'latitude',
			$author$project$Type$IO$float,
			function ($) {
				return $.ed;
			},
			A4(
				$author$project$Type$IO$attribute,
				'name',
				$author$project$Type$IO$string,
				function ($) {
					return $.af;
				},
				A2($author$project$Type$IO$entity, $author$project$Type$Database$Place, $author$project$Type$Database$Place)))));
var $author$project$Type$Database$Question = F4(
	function (questionary, index, text, input_type) {
		return {gF: index, d4: input_type, eI: questionary, hQ: text};
	});
var $author$project$Type$Database$QuestionView = F4(
	function (questionary, index, text, input_type) {
		return {gF: index, d4: input_type, eI: questionary, hQ: text};
	});
var $author$project$Type$Database$question = A2(
	$author$project$Type$Database$updateEmpty,
	function (x) {
		return _Utils_update(
			x,
			{hQ: 'Unnamed Question'});
	},
	A7(
		$author$project$Type$IO$reference,
		'input_type',
		$author$project$Type$IO$string,
		function ($) {
			return $.d4;
		},
		function ($) {
			return $.d5;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A4(
			$author$project$Type$IO$attribute,
			'text',
			$author$project$Type$IO$string,
			function ($) {
				return $.hQ;
			},
			A4(
				$author$project$Type$IO$attribute,
				'index',
				$author$project$Type$IO$int,
				function ($) {
					return $.gF;
				},
				A7(
					$author$project$Type$IO$reference,
					'questionary',
					$author$project$Type$IO$string,
					function ($) {
						return $.eI;
					},
					function ($) {
						return $.bs;
					},
					$elm$core$Dict$get,
					function ($) {
						return $.fb;
					},
					A2($author$project$Type$IO$entity, $author$project$Type$Database$Question, $author$project$Type$Database$QuestionView))))));
var $author$project$Type$Database$Questionary = F2(
	function (name, study) {
		return {af: name, cY: study};
	});
var $author$project$Type$Database$QuestionaryView = F2(
	function (name, study) {
		return {af: name, cY: study};
	});
var $author$project$Type$Database$questionary = A2(
	$author$project$Type$Database$updateEmpty,
	function (x) {
		return _Utils_update(
			x,
			{af: 'Unnamed Questionary '});
	},
	A7(
		$author$project$Type$IO$reference,
		'study',
		$author$project$Type$IO$string,
		function ($) {
			return $.cY;
		},
		function ($) {
			return $.hK;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A4(
			$author$project$Type$IO$attribute,
			'name',
			$author$project$Type$IO$string,
			function ($) {
				return $.af;
			},
			A2($author$project$Type$IO$entity, $author$project$Type$Database$Questionary, $author$project$Type$Database$QuestionaryView))));
var $author$project$Type$Database$Study = F3(
	function (name, description, leader) {
		return {a7: description, aH: leader, af: name};
	});
var $author$project$Type$Database$StudyView = F3(
	function (name, description, leader) {
		return {a7: description, aH: leader, af: name};
	});
var $author$project$Type$Database$study = A2(
	$author$project$Type$Database$updateEmpty,
	function (x) {
		return _Utils_update(
			x,
			{af: 'Unnamed Study '});
	},
	A7(
		$author$project$Type$IO$reference,
		'leader',
		$author$project$Type$IO$string,
		function ($) {
			return $.aH;
		},
		function ($) {
			return $.c6;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A4(
			$author$project$Type$IO$attribute,
			'description',
			$author$project$Type$IO$string,
			function ($) {
				return $.a7;
			},
			A4(
				$author$project$Type$IO$attribute,
				'name',
				$author$project$Type$IO$string,
				function ($) {
					return $.af;
				},
				A2($author$project$Type$IO$entity, $author$project$Type$Database$Study, $author$project$Type$Database$StudyView)))));
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $author$project$Type$IO$Decoder$decodeDictFromTuples = F2(
	function (keyDecoder, tuples) {
		if (!tuples.b) {
			return $elm$json$Json$Decode$succeed($elm$core$Dict$empty);
		} else {
			var _v1 = tuples.a;
			var strKey = _v1.a;
			var value = _v1.b;
			var rest = tuples.b;
			var _v2 = A2(
				$elm$json$Json$Decode$decodeString,
				keyDecoder(strKey),
				strKey);
			if (!_v2.$) {
				var key = _v2.a;
				return A2(
					$elm$json$Json$Decode$andThen,
					A2(
						$elm$core$Basics$composeR,
						A2($elm$core$Dict$insert, key, value),
						$elm$json$Json$Decode$succeed),
					A2($author$project$Type$IO$Decoder$decodeDictFromTuples, keyDecoder, rest));
			} else {
				var error = _v2.a;
				var _v3 = A2(
					$elm$json$Json$Decode$decodeString,
					keyDecoder(strKey),
					'{}');
				if (!_v3.$) {
					var key = _v3.a;
					return A2(
						$elm$json$Json$Decode$andThen,
						A2(
							$elm$core$Basics$composeR,
							A2($elm$core$Dict$insert, key, value),
							$elm$json$Json$Decode$succeed),
						A2($author$project$Type$IO$Decoder$decodeDictFromTuples, keyDecoder, rest));
				} else {
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(error));
				}
			}
		}
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $author$project$Type$IO$Decoder$dict = F2(
	function (key, value) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$author$project$Type$IO$Decoder$decodeDictFromTuples(key),
			$elm$json$Json$Decode$keyValuePairs(value));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Type$IO$Encoder$getMaybeOut = function (mb) {
	if (mb.a.$ === 1) {
		var _v1 = mb.a;
		return $elm$core$Maybe$Nothing;
	} else {
		var a = mb.a.a;
		var b = mb.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(a, b));
	}
};
var $author$project$Type$IO$Encoder$dict = F2(
	function (keys, values) {
		return $author$project$Type$IO$Encoder$SingleEncoder(
			function (x) {
				return $elm$json$Json$Encode$object(
					A2(
						$elm$core$List$filterMap,
						$author$project$Type$IO$Encoder$getMaybeOut,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var a = _v0.a;
								var b = _v0.b;
								return _Utils_Tuple2(
									keys(a),
									A2($author$project$Type$IO$Encoder$collapseEncoder, values, b));
							},
							$elm$core$Dict$toList(x))));
			});
	});
var $author$project$Type$IO$Form$DictMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Type$IO$Form$KeyError = 2;
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Type$IO$Form$dict = F7(
	function (keySerializer, old, name, callback, kind, acc, f) {
		var _v0 = $author$project$Type$IO$Form$parseHeadTail(acc);
		var parsedkey = _v0.a;
		var rest = _v0.b;
		var _new = A2(
			$elm$core$Dict$map,
			F2(
				function (key, instance) {
					return A5(
						old,
						name,
						A2(
							$elm$core$Basics$composeL,
							callback,
							$author$project$Type$IO$Form$DictMsg(
								keySerializer(key))),
						instance,
						rest,
						f);
				}),
			kind);
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Result$Err(2),
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (x) {
						return A2($elm$core$Dict$get, x, _new);
					},
					A2(
						$elm$core$List$filter,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function (y) {
										return _Utils_eq(y, parsedkey);
									},
									keySerializer(x)));
						},
						$elm$core$Dict$keys(_new)))));
	});
var $author$project$Type$IO$Setter$DictKeyMsg = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Type$IO$Setter$KeyAlreadyPresent = {$: 4};
var $author$project$Type$IO$Setter$KeyError = {$: 2};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $author$project$Type$IO$Setter$dict = F7(
	function (emptyKey, emptyValue, keySerializer, keys, values, msg, val) {
		switch (msg.$) {
			case 12:
				var parsedkey = msg.a;
				var msg_ = msg.b;
				return A2(
					$elm$core$Result$map,
					function (x) {
						return A2($elm$core$Dict$union, x, val);
					},
					A2(
						$elm$core$Result$map,
						$elm$core$Dict$fromList,
						$elm_community$result_extra$Result$Extra$combine(
							A2(
								$elm$core$List$map,
								function (_v2) {
									var x = _v2.a;
									var y = _v2.b;
									if (!y.$) {
										var value = y.a;
										return $elm$core$Result$Ok(
											_Utils_Tuple2(x, value));
									} else {
										var err = y.a;
										return $elm$core$Result$Err(err);
									}
								},
								A2(
									$elm$core$List$map,
									function (_v1) {
										var x = _v1.a;
										var y = _v1.b;
										return _Utils_Tuple2(
											x,
											A2(
												$elm$core$Result$andThen,
												values(msg_),
												y));
									},
									A2(
										$elm$core$List$map,
										function (x) {
											return _Utils_Tuple2(
												x,
												A2(
													$elm$core$Result$fromMaybe,
													$author$project$Type$IO$Setter$KeyError,
													A2($elm$core$Dict$get, x, val)));
										},
										A2(
											$elm$core$List$filter,
											function (x) {
												return A2(
													$elm$core$Maybe$withDefault,
													false,
													A2(
														$elm$core$Maybe$map,
														function (y) {
															return _Utils_eq(y, parsedkey);
														},
														keySerializer(x)));
											},
											$elm$core$Dict$keys(val))))))));
			case 13:
				var keymsg_ = msg.a;
				var valuemsg_ = msg.b;
				var _v4 = _Utils_Tuple2(
					A2(keys, keymsg_, emptyKey),
					A2(values, valuemsg_, emptyValue));
				if (_v4.a.$ === 1) {
					var err = _v4.a.a;
					return $elm$core$Result$Err(err);
				} else {
					if (_v4.b.$ === 1) {
						var err = _v4.b.a;
						return $elm$core$Result$Err(err);
					} else {
						var key = _v4.a.a;
						var value = _v4.b.a;
						return A2($elm$core$Dict$member, key, val) ? $elm$core$Result$Err($author$project$Type$IO$Setter$KeyAlreadyPresent) : $elm$core$Result$Ok(
							A3($elm$core$Dict$insert, key, value, val));
					}
				}
			default:
				return $elm$core$Result$Err(
					A2(
						$author$project$Type$IO$Setter$Mismatch,
						msg,
						A2($author$project$Type$IO$Setter$DictKeyMsg, '', $author$project$Type$IO$Setter$ErrorMsg)));
		}
	});
var $author$project$Type$IO$ToString$NoSuchKey = function (a) {
	return {$: 3, a: a};
};
var $author$project$Type$IO$ToString$NoSuchValue = {$: 4};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Type$IO$ToString$dict = F4(
	function (keys, values, name, dictionary) {
		var _v0 = $author$project$Type$IO$ToString$parseHeadTail(name);
		var head = _v0.a;
		var rest = _v0.b;
		var lkey = A2(
			$elm$core$List$filter,
			function (x) {
				return A2(
					$elm$core$Result$withDefault,
					false,
					A2(
						$elm$core$Result$map,
						function (y) {
							return _Utils_eq(y, head);
						},
						A2(keys, rest, x)));
			},
			$elm$core$Dict$keys(dictionary));
		var _v1 = $elm$core$List$head(lkey);
		if (!_v1.$) {
			var key = _v1.a;
			var _v2 = A2($elm$core$Dict$get, key, dictionary);
			if (!_v2.$) {
				var value = _v2.a;
				return A2(values, rest, value);
			} else {
				return $elm$core$Result$Err($author$project$Type$IO$ToString$NoSuchValue);
			}
		} else {
			return $elm$core$Result$Err(
				$author$project$Type$IO$ToString$NoSuchKey(head));
		}
	});
var $author$project$Type$IO$Viewer$dict = F4(
	function (keys, values, db, full) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Dict$fromList,
			$elm_community$maybe_extra$Maybe$Extra$combine(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var k = _v1.a;
						var v = _v1.b;
						var _v2 = _Utils_Tuple2(k, v);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var k1 = _v2.a.a;
							var v1 = _v2.b.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(k1, v1));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					A2(
						$elm$core$List$map,
						function (_v0) {
							var k = _v0.a;
							var v = _v0.b;
							return _Utils_Tuple2(
								A2(keys, db, k),
								A2(values, db, v));
						},
						$elm$core$Dict$toList(full)))));
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_explorations$test$Fuzz$tuple = function (_v0) {
	var fuzzerA = _v0.a;
	var fuzzerB = _v0.b;
	return A3(
		$elm_explorations$test$Fuzz$map2,
		F2(
			function (a, b) {
				return _Utils_Tuple2(a, b);
			}),
		fuzzerA,
		fuzzerB);
};
var $author$project$Type$IO$dict = F2(
	function (keys, values) {
		return {
			a6: A2($author$project$Type$IO$Decoder$dict, keys.e_, values.a6),
			dK: $elm$core$Dict$empty,
			dM: A2(
				$author$project$Type$IO$Encoder$dict,
				function (x) {
					return $elm$core$Result$toMaybe(
						A2(keys.h9, '', x));
				},
				values.dM),
			dP: _List_Nil,
			aD: A2(
				$author$project$Type$IO$Form$dict,
				function (x) {
					return $elm$core$Result$toMaybe(
						A2(keys.h9, '', x));
				},
				values.aD),
			aF: A2(
				$elm_explorations$test$Fuzz$map,
				$elm$core$Dict$fromList,
				$elm_explorations$test$Fuzz$list(
					$elm_explorations$test$Fuzz$tuple(
						_Utils_Tuple2(keys.aF, values.aF)))),
			e_: function (a) {
				return A2(
					$author$project$Type$IO$Decoder$dict,
					keys.e_,
					values.e_(a));
			},
			h9: A2($author$project$Type$IO$ToString$dict, keys.h9, values.h9),
			c4: A5(
				$author$project$Type$IO$Setter$dict,
				keys.dK,
				values.dK,
				function (x) {
					return $elm$core$Result$toMaybe(
						A2(keys.h9, '', x));
				},
				keys.c4,
				values.c4),
			fd: A2($author$project$Type$IO$Viewer$dict, keys.fd, values.fd)
		};
	});
var $author$project$Type$Database$Timestamp = F6(
	function (creator, created, modified, accessed, deleted, value) {
		return {fm: accessed, f8: created, a5: creator, b_: deleted, gW: modified, fb: value};
	});
var $author$project$Type$Database$TimestampView = F6(
	function (creator, created, modified, accessed, deleted, value) {
		return {fm: accessed, f8: created, a5: creator, b_: deleted, gW: modified, fb: value};
	});
var $author$project$Type$Database$timestamp = function (other) {
	var t = A4(
		$author$project$Type$IO$substruct,
		'value',
		other,
		function ($) {
			return $.fb;
		},
		A4(
			$author$project$Type$IO$attribute,
			'deleted',
			$author$project$Type$IO$maybe($author$project$Type$IO$int),
			function ($) {
				return $.b_;
			},
			A4(
				$author$project$Type$IO$attribute,
				'accessed',
				$author$project$Type$IO$int,
				function ($) {
					return $.fm;
				},
				A4(
					$author$project$Type$IO$attribute,
					'modified',
					$author$project$Type$IO$int,
					function ($) {
						return $.gW;
					},
					A4(
						$author$project$Type$IO$attribute,
						'created',
						$author$project$Type$IO$int,
						function ($) {
							return $.f8;
						},
						A7(
							$author$project$Type$IO$reference,
							'creator',
							$author$project$Type$IO$string,
							function ($) {
								return $.a5;
							},
							function ($) {
								return $.c6;
							},
							$elm$core$Dict$get,
							function ($) {
								return $.fb;
							},
							A2($author$project$Type$IO$entity, $author$project$Type$Database$Timestamp, $author$project$Type$Database$TimestampView)))))));
	return t;
};
var $author$project$Type$Database$table = function (kind) {
	return A2(
		$author$project$Type$IO$dict,
		$author$project$Type$IO$string,
		$author$project$Type$Database$timestamp(kind));
};
var $author$project$Type$Database$TestSubject = F3(
	function (id, event, infos) {
		return {as: event, S: id, ck: infos};
	});
var $author$project$Type$Database$TestSubjectView = F3(
	function (id, event, infos) {
		return {as: event, S: id, ck: infos};
	});
var $author$project$Type$Database$test_subject = A4(
	$author$project$Type$IO$attribute,
	'infos',
	A2($author$project$Type$IO$dict, $author$project$Type$IO$string, $author$project$Type$IO$string),
	function ($) {
		return $.ck;
	},
	A7(
		$author$project$Type$IO$reference,
		'event',
		$author$project$Type$IO$string,
		function ($) {
			return $.as;
		},
		function ($) {
			return $.gm;
		},
		$elm$core$Dict$get,
		function ($) {
			return $.fb;
		},
		A4(
			$author$project$Type$IO$attribute,
			'id',
			$author$project$Type$IO$string,
			function ($) {
				return $.S;
			},
			A2($author$project$Type$IO$entity, $author$project$Type$Database$TestSubject, $author$project$Type$Database$TestSubjectView))));
var $author$project$Type$Database$User = F3(
	function (name, email, last_login) {
		return {dJ: email, ec: last_login, af: name};
	});
var $author$project$Type$Database$user = A4(
	$author$project$Type$IO$attribute,
	'last_login',
	$author$project$Type$IO$int,
	function ($) {
		return $.ec;
	},
	A4(
		$author$project$Type$IO$attribute,
		'email',
		$author$project$Type$IO$maybe($author$project$Type$IO$string),
		function ($) {
			return $.dJ;
		},
		A4(
			$author$project$Type$IO$attribute,
			'name',
			$author$project$Type$IO$maybe($author$project$Type$IO$string),
			function ($) {
				return $.af;
			},
			A2($author$project$Type$IO$entity, $author$project$Type$Database$User, $author$project$Type$Database$User))));
var $author$project$Type$Database$database = A4(
	$author$project$Type$IO$substruct,
	'users',
	$author$project$Type$Database$table($author$project$Type$Database$user),
	function ($) {
		return $.c6;
	},
	A4(
		$author$project$Type$IO$substruct,
		'test_subjects',
		$author$project$Type$Database$table($author$project$Type$Database$test_subject),
		function ($) {
			return $.aP;
		},
		A4(
			$author$project$Type$IO$substruct,
			'studies',
			$author$project$Type$Database$table($author$project$Type$Database$study),
			function ($) {
				return $.hK;
			},
			A4(
				$author$project$Type$IO$substruct,
				'questionnaries',
				$author$project$Type$Database$table($author$project$Type$Database$questionary),
				function ($) {
					return $.bs;
				},
				A4(
					$author$project$Type$IO$substruct,
					'questions',
					$author$project$Type$Database$table($author$project$Type$Database$question),
					function ($) {
						return $.hp;
					},
					A4(
						$author$project$Type$IO$substruct,
						'places',
						$author$project$Type$Database$table($author$project$Type$Database$place),
						function ($) {
							return $.br;
						},
						A4(
							$author$project$Type$IO$substruct,
							'input_types',
							$author$project$Type$Database$table($author$project$Type$Database$InputType$input_type),
							function ($) {
								return $.d5;
							},
							A4(
								$author$project$Type$IO$substruct,
								'events',
								$author$project$Type$Database$table($author$project$Type$Database$event),
								function ($) {
									return $.gm;
								},
								A4(
									$author$project$Type$IO$substruct,
									'coding_questionnaries',
									$author$project$Type$Database$table($author$project$Type$Database$coding_questionary),
									function ($) {
										return $.f2;
									},
									A4(
										$author$project$Type$IO$substruct,
										'coding_questions',
										$author$project$Type$Database$table($author$project$Type$Database$coding_question),
										function ($) {
											return $.dy;
										},
										A4(
											$author$project$Type$IO$substruct,
											'coding_frames',
											$author$project$Type$Database$table($author$project$Type$Database$coding_frame),
											function ($) {
												return $.bT;
											},
											A4(
												$author$project$Type$IO$substruct,
												'coding_answers',
												$author$project$Type$Database$table($author$project$Type$Database$coding_answer),
												function ($) {
													return $.f0;
												},
												A4(
													$author$project$Type$IO$substruct,
													'codings',
													$author$project$Type$Database$table($author$project$Type$Database$coding),
													function ($) {
														return $.a$;
													},
													A4(
														$author$project$Type$IO$substruct,
														'coders',
														$author$project$Type$Database$table($author$project$Type$Database$coder),
														function ($) {
															return $.aZ;
														},
														A4(
															$author$project$Type$IO$substruct,
															'answers',
															$author$project$Type$Database$table($author$project$Type$Database$answer),
															function ($) {
																return $.bL;
															},
															A2($author$project$Type$IO$entity, $author$project$Type$Database$Database, $author$project$Type$Database$DatabaseView))))))))))))))));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $aforemny$material_components_web_elm$Material$Snackbar$MessageId = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$Queue = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$initialQueue = {ad: _List_Nil, aJ: 0};
var $author$project$Viewer$header = {R: false, bj: '', bt: $aforemny$material_components_web_elm$Material$Snackbar$initialQueue};
var $author$project$Session$Session = F4(
	function (timeAppStarted, windowSize, user, db) {
		return {u: db, h4: timeAppStarted, c5: user, fh: windowSize};
	});
var $author$project$Type$Database$UserType = {$: 10};
var $author$project$Type$Database$TypeMatching$keys = F2(
	function (kind, db) {
		var g = $elm$core$Dict$keys;
		switch (kind.$) {
			case 0:
				return g(db.bL);
			case 1:
				return g(db.aZ);
			case 2:
				return g(db.a$);
			case 3:
				return g(db.f0);
			case 4:
				return g(db.bT);
			case 5:
				return g(db.dy);
			case 6:
				return g(db.f2);
			case 11:
				return g(db.gm);
			case 7:
				return g(db.hp);
			case 8:
				return g(db.bs);
			case 9:
				return g(db.hK);
			case 10:
				return g(db.c6);
			case 12:
				return g(db.aP);
			default:
				return g(db.d5);
		}
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Session$init = function (flags) {
	var posixTime = $elm$time$Time$millisToPosix(flags.h4);
	var db = A2($elm$json$Json$Decode$decodeValue, $author$project$Type$Database$database.a6, flags.u);
	if (!db.$) {
		var storage = db.a;
		var user = function (x) {
			var _v1 = $elm$core$List$length(x);
			if (_v1 === 1) {
				return $elm$core$List$head(x);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(
			A2($author$project$Type$Database$TypeMatching$keys, $author$project$Type$Database$UserType, storage));
		return A4($author$project$Session$Session, posixTime, flags.fh, $elm$core$Maybe$Nothing, storage);
	} else {
		return A4($author$project$Session$Session, posixTime, flags.fh, $elm$core$Maybe$Nothing, $author$project$Type$Database$database.dK);
	}
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Main$extractSession = function (model) {
	var getSession = function (_v1) {
		var x = _v1;
		return x.hB;
	};
	var _v0 = model.c;
	switch (_v0.$) {
		case 0:
			var session = _v0.a;
			return session;
		case 2:
			var m = _v0.a;
			return getSession(m);
		case 1:
			var m = _v0.a;
			return getSession(m);
		case 5:
			var m = _v0.a;
			return getSession(m);
		case 3:
			var m = _v0.a;
			return getSession(m);
		case 4:
			var m = _v0.a;
			return getSession(m);
		case 6:
			var m = _v0.a;
			return getSession(m);
		case 7:
			var m = _v0.a;
			return getSession(m);
		case 8:
			var m = _v0.a;
			return getSession(m);
		case 9:
			var m = _v0.a;
			return getSession(m);
		case 10:
			var m = _v0.a;
			return getSession(m);
		case 11:
			var m = _v0.a;
			return getSession(m);
		default:
			var m = _v0.a;
			return getSession(m);
	}
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {Z: frag, ah: params, V: unvisited, fb: value, am: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.V;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.fb);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.fb);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.bq),
					$elm$url$Url$Parser$prepareQuery(url.eG),
					url.aE,
					$elm$core$Basics$identity)));
	});
var $author$project$Main$Admin = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$Answer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$Code = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$CodingQuestion = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$Event = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$EventOverview = 1;
var $author$project$Msg$EventPeople = 2;
var $author$project$Msg$EventSettings = 0;
var $author$project$Main$PageOne = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$PageWithSubpage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Question = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$Questionary = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$Study = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$Top = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$User = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Questionary$Fokus = F2(
	function (activeQuestion, titleFocused) {
		return {bE: activeQuestion, bz: titleFocused};
	});
var $author$project$Page$Questionary$defaultFokus = A2($author$project$Page$Questionary$Fokus, $elm$core$Maybe$Nothing, false);
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.am;
			var unvisited = _v0.V;
			var params = _v0.ah;
			var frag = _v0.Z;
			var value = _v0.fb;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $author$project$Page$Page = $elm$core$Basics$identity;
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$mapPageMsg = F3(
	function (model, map, _v0) {
		var page = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					c: map(page)
				}),
			A2($elm$core$Platform$Cmd$map, page.e6, effect));
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Page$Admin$Model = F3(
	function (subpage, textfield, error) {
		return {b3: error, e1: subpage, e5: textfield};
	});
var $author$project$Page$Admin$init = function (x) {
	return A3($author$project$Page$Admin$Model, x, '', $elm$core$Maybe$Nothing);
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Type$IO$Setter$ArrayUpdateIndexMsg = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Type$IO$Setter$BoolUpdateMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Type$IO$Setter$ResultErrMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Type$IO$Setter$ResultOkMsg = function (a) {
	return {$: 15, a: a};
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Type$IO$form2update = function (fmsg) {
	switch (fmsg.$) {
		case 0:
			if (fmsg.a.$ === 1) {
				var _v1 = fmsg.a;
				return $elm$core$Maybe$Nothing;
			} else {
				var val = fmsg.a.a;
				return $elm$core$Maybe$Just(
					$author$project$Type$IO$Setter$IntMsg(val));
			}
		case 1:
			if (fmsg.a.$ === 1) {
				var _v2 = fmsg.a;
				return $elm$core$Maybe$Nothing;
			} else {
				var val = fmsg.a.a;
				return $elm$core$Maybe$Just(
					$author$project$Type$IO$Setter$StringMsg(val));
			}
		case 2:
			if (fmsg.a.$ === 1) {
				var _v3 = fmsg.a;
				return $elm$core$Maybe$Nothing;
			} else {
				var val = fmsg.a.a;
				return $elm$core$Maybe$Just(
					$author$project$Type$IO$Setter$FloatMsg(val));
			}
		case 3:
			return $elm$core$Maybe$Just(
				$author$project$Type$IO$Setter$BoolUpdateMsg($elm$core$Basics$not));
		case 5:
			var index = fmsg.a;
			var msg = fmsg.b;
			var _v4 = $author$project$Type$IO$form2update(msg);
			if (!_v4.$) {
				var msg_ = _v4.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Type$IO$Setter$ListUpdateMsg, index, msg_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 8:
			var index = fmsg.a;
			var msg = fmsg.b;
			var _v5 = $author$project$Type$IO$form2update(msg);
			if (!_v5.$) {
				var msg_ = _v5.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Type$IO$Setter$ArrayUpdateIndexMsg, index, msg_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 4:
			var msg = fmsg.a;
			return $elm$core$Maybe$Just(
				$author$project$Type$IO$Setter$MaybeUpdateMsg(
					$author$project$Type$IO$form2update(msg)));
		case 6:
			var key = fmsg.a;
			var msg = fmsg.b;
			var _v6 = _Utils_Tuple2(
				$author$project$Type$IO$form2update(msg),
				key);
			if ((!_v6.a.$) && (!_v6.b.$)) {
				var msg_ = _v6.a.a;
				var key_ = _v6.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Type$IO$Setter$DictKeyMsg, key_, msg_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 7:
			var state = fmsg.a;
			var msg = fmsg.b;
			var _v7 = _Utils_Tuple2(
				state,
				$author$project$Type$IO$form2update(msg));
			_v7$2:
			while (true) {
				if (!_v7.a) {
					if (!_v7.b.$) {
						var _v8 = _v7.a;
						var val = _v7.b.a;
						return $elm$core$Maybe$Just(
							$author$project$Type$IO$Setter$ResultErrMsg(val));
					} else {
						break _v7$2;
					}
				} else {
					if (!_v7.b.$) {
						var _v9 = _v7.a;
						var val = _v7.b.a;
						return $elm$core$Maybe$Just(
							$author$project$Type$IO$Setter$ResultOkMsg(val));
					} else {
						break _v7$2;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		default:
			var name = fmsg.a;
			var msg = fmsg.b;
			var _v10 = $author$project$Type$IO$form2update(msg);
			if (!_v10.$) {
				var val = _v10.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Type$IO$Setter$AttributeMsg, name, val));
			} else {
				return $elm$core$Maybe$Nothing;
			}
	}
};
var $author$project$Type$Database$TypeMatching$New = function (a) {
	return {$: 0, a: a};
};
var $author$project$Type$Database$TypeMatching$dispatchDb = F4(
	function (dt, id, kind, db) {
		var g = F3(
			function (table, def, update) {
				var config = $author$project$Type$Database$timestamp(def).dK;
				return A2(
					update,
					db,
					function () {
						if (!dt.$) {
							var u = dt.a;
							return A3(
								$elm$core$Dict$insert,
								$author$project$Type$IO$Internal$unbox(id),
								_Utils_update(
									config,
									{a5: u}),
								table);
						} else {
							return A2(
								$elm$core$Dict$remove,
								$author$project$Type$IO$Internal$unbox(id),
								table);
						}
					}());
			});
		switch (kind.$) {
			case 0:
				return A3(
					g,
					db.bL,
					$author$project$Type$Database$answer,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{bL: x});
						}));
			case 1:
				return A3(
					g,
					db.aZ,
					$author$project$Type$Database$coder,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{aZ: x});
						}));
			case 2:
				return A3(
					g,
					db.a$,
					$author$project$Type$Database$coding,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{a$: x});
						}));
			case 3:
				return A3(
					g,
					db.f0,
					$author$project$Type$Database$coding_answer,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{f0: x});
						}));
			case 4:
				return A3(
					g,
					db.bT,
					$author$project$Type$Database$coding_frame,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{bT: x});
						}));
			case 5:
				return A3(
					g,
					db.dy,
					$author$project$Type$Database$coding_question,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{dy: x});
						}));
			case 6:
				return A3(
					g,
					db.f2,
					$author$project$Type$Database$coding_questionary,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{f2: x});
						}));
			case 11:
				return A3(
					g,
					db.gm,
					$author$project$Type$Database$event,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{gm: x});
						}));
			case 7:
				return A3(
					g,
					db.hp,
					$author$project$Type$Database$question,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{hp: x});
						}));
			case 8:
				return A3(
					g,
					db.bs,
					$author$project$Type$Database$questionary,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{bs: x});
						}));
			case 9:
				return A3(
					g,
					db.hK,
					$author$project$Type$Database$study,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{hK: x});
						}));
			case 10:
				return A3(
					g,
					db.c6,
					$author$project$Type$Database$user,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{c6: x});
						}));
			case 12:
				return A3(
					g,
					db.aP,
					$author$project$Type$Database$test_subject,
					F2(
						function (t, x) {
							return _Utils_update(
								t,
								{aP: x});
						}));
			default:
				var it = kind.a;
				switch (it) {
					case 0:
						return A3(
							g,
							db.d5,
							$author$project$Type$Database$InputType$input_type,
							F2(
								function (t, x) {
									return _Utils_update(
										t,
										{d5: x});
								}));
					case 1:
						return A3(
							g,
							db.d5,
							_Utils_update(
								$author$project$Type$Database$InputType$input_type,
								{
									dK: $author$project$Type$Database$InputType$LongAnswer($author$project$Type$Database$InputType$longAnswerConfig.dK)
								}),
							F2(
								function (t, x) {
									return _Utils_update(
										t,
										{d5: x});
								}));
					default:
						return A3(
							g,
							db.d5,
							_Utils_update(
								$author$project$Type$Database$InputType$input_type,
								{
									dK: $author$project$Type$Database$InputType$List($author$project$Type$Database$InputType$listConfig.dK)
								}),
							F2(
								function (t, x) {
									return _Utils_update(
										t,
										{d5: x});
								}));
				}
		}
	});
var $author$project$Type$Database$TypeMatching$new = F4(
	function (id, kind, u, db) {
		return A4(
			$author$project$Type$Database$TypeMatching$dispatchDb,
			$author$project$Type$Database$TypeMatching$New(u),
			id,
			kind,
			db);
	});
var $author$project$Type$IO$encode = $author$project$Type$IO$Encoder$collapseEncoder;
var $author$project$Type$IO$Setter$toString = function (msg) {
	switch (msg.$) {
		case 0:
			var v = msg.a;
			return '(int) ' + $elm$core$String$fromInt(v);
		case 1:
			return '(int) updating';
		case 2:
			var s = msg.a;
			return '(string) ' + s;
		case 3:
			var f = msg.a;
			return '(float) ' + $elm$core$String$fromFloat(f);
		case 6:
			var a = msg.a;
			var msg_ = msg.b;
			return a + ('->' + $author$project$Type$IO$Setter$toString(msg_));
		case 7:
			if (!msg.a.$) {
				var msg_ = msg.a.a;
				return 'Just (update) ->' + $author$project$Type$IO$Setter$toString(msg_);
			} else {
				var _v1 = msg.a;
				return 'Nothing (update)';
			}
		case 8:
			if (!msg.a.$) {
				var msg_ = msg.a.a;
				return 'Just (set) ->' + $author$project$Type$IO$Setter$toString(msg_);
			} else {
				var _v2 = msg.a;
				return 'Nothing (set)';
			}
		case 19:
			if (!msg.b.$) {
				var name = msg.a;
				var msg_ = msg.b.a;
				return name + (' (custom) ->' + $author$project$Type$IO$Setter$toString(msg_));
			} else {
				var name = msg.a;
				var _v3 = msg.b;
				return name + ' (custom)';
			}
		case 5:
			var b = msg.a;
			return '(bool) ' + (b ? 'TRUE' : 'FALSE');
		default:
			return 'Yet undeclared!';
	}
};
var $author$project$Type$IO$Setter$errToString = function (err) {
	switch (err.$) {
		case 0:
			var got = err.a;
			var expect = err.b;
			return 'The change message didn\'t match up the structure: Got \"' + ($author$project$Type$IO$Setter$toString(got) + ('\" but expected ' + ($author$project$Type$IO$Setter$toString(expect) + '!')));
		case 1:
			return 'The index was out of the bounds!';
		case 2:
			return 'Didn\'t find this key in my dict!';
		case 3:
			return 'Cannot update this type with this value.';
		case 4:
			return 'Cannot create new value here. There is already a value on this key';
		default:
			var s = err.a;
			return s;
	}
};
var $author$project$Ports$toDb = _Platform_outgoingPort('toDb', $elm$core$Basics$identity);
var $author$project$Page$Admin$updateDb = F2(
	function (f, _v0) {
		var model = _v0;
		var _v1 = f(model.hB.u);
		if (!_v1.$) {
			var val = _v1.a;
			var oldsession = model.hB;
			var newsession = _Utils_update(
				oldsession,
				{u: val});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{hB: newsession}),
				$author$project$Ports$toDb(
					A2($author$project$Type$IO$encode, $author$project$Type$Database$database.dM, val)));
		} else {
			var err = _v1.a;
			var oldmodel = model.c;
			var newmodel = _Utils_update(
				oldmodel,
				{
					b3: $elm$core$Maybe$Just(
						$author$project$Type$IO$Setter$errToString(err))
				});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{c: newmodel}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Admin$update = F2(
	function (message, _v0) {
		var model = _v0;
		if (message.$ === 7) {
			var msg = message.a;
			switch (msg.$) {
				case 0:
					var msg_ = msg.a;
					var _v3 = $author$project$Type$IO$form2update(msg_);
					if (!_v3.$) {
						var dbmsg = _v3.a;
						return A2(
							$author$project$Page$Admin$updateDb,
							$author$project$Type$Database$database.c4(dbmsg),
							model);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 1:
					var dbmsg = msg.a;
					if (!dbmsg.$) {
						var kind = dbmsg.a;
						var index = dbmsg.b;
						var oldsession = model.hB;
						var newsession = _Utils_update(
							oldsession,
							{
								u: A4(
									$author$project$Type$Database$TypeMatching$new,
									$author$project$Type$IO$Internal$box(index),
									kind,
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Type$IO$Internal$box(''),
										model.hB.c5),
									model.hB.u)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{hB: newsession}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				default:
					var val = msg.a;
					var oldmodel = model.c;
					var newmodel = _Utils_update(
						oldmodel,
						{e5: val});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c: newmodel}),
						$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Viewer$detailsConfig = {
	fn: _List_Nil,
	fI: function (_v0) {
		return _List_Nil;
	},
	hz: $elm$core$Maybe$Nothing,
	h5: '',
	id: false,
	c5: $elm$core$Maybe$Nothing
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Msg$CRUD = function (a) {
	return {$: 17, a: a};
};
var $author$project$Msg$Create = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Msg$Form = function (a) {
	return {$: 18, a: a};
};
var $aforemny$material_components_web_elm$Material$Button$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Button$config = {bF: _List_Nil, b$: false, aC: false, aG: $elm$core$Maybe$Nothing, d0: $elm$core$Maybe$Nothing, cp: $elm$core$Maybe$Nothing, cz: $elm$core$Maybe$Nothing, c$: $elm$core$Maybe$Nothing, aS: true, bA: false};
var $author$project$Type$Database$TypeMatching$fields = function (kind) {
	switch (kind.$) {
		case 0:
			return $author$project$Type$Database$answer.dP;
		case 1:
			return $author$project$Type$Database$coder.dP;
		case 2:
			return $author$project$Type$Database$coding.dP;
		case 3:
			return $author$project$Type$Database$coding_answer.dP;
		case 4:
			return $author$project$Type$Database$coding_frame.dP;
		case 5:
			return $author$project$Type$Database$coding_question.dP;
		case 6:
			return $author$project$Type$Database$coding_questionary.dP;
		case 11:
			return $author$project$Type$Database$event.dP;
		case 7:
			return $author$project$Type$Database$question.dP;
		case 8:
			return $author$project$Type$Database$questionary.dP;
		case 9:
			return $author$project$Type$Database$study.dP;
		case 10:
			return $author$project$Type$Database$user.dP;
		case 12:
			return $author$project$Type$Database$test_subject.dP;
		default:
			return $author$project$Type$Database$InputType$input_type.dP;
	}
};
var $author$project$Type$IO$Form$NotFound = 5;
var $author$project$Type$Database$TypeMatching$toStringPlural = function (kind) {
	switch (kind.$) {
		case 0:
			return 'answers';
		case 1:
			return 'coders';
		case 2:
			return 'codings';
		case 3:
			return 'coding_answers';
		case 4:
			return 'coding_frames';
		case 5:
			return 'coding_questions';
		case 6:
			return 'coding_questionnaries';
		case 11:
			return 'events';
		case 7:
			return 'questions';
		case 8:
			return 'questionnaries';
		case 9:
			return 'studies';
		case 10:
			return 'users';
		case 12:
			return 'test_subjects';
		default:
			return 'input_types';
	}
};
var $author$project$Type$Database$TypeMatching$forms = F5(
	function (id, kind, acc, db, f) {
		var m = function (x) {
			return $author$project$Msg$Form(
				A2(
					$author$project$Type$IO$Form$AttrMsg,
					$author$project$Type$Database$TypeMatching$toStringPlural(kind),
					A2(
						$author$project$Type$IO$Form$DictMsg,
						$elm$core$Maybe$Just(id),
						A2($author$project$Type$IO$Form$AttrMsg, 'value', x))));
		};
		var g = F2(
			function (def, table) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Result$Err(5),
					A2(
						$elm$core$Maybe$map,
						function (x) {
							return A5(def.aD, id, m, x.fb, acc, f);
						},
						A2($elm$core$Dict$get, id, table)));
			});
		switch (kind.$) {
			case 0:
				return A2(g, $author$project$Type$Database$answer, db.bL);
			case 1:
				return A2(g, $author$project$Type$Database$coder, db.aZ);
			case 2:
				return A2(g, $author$project$Type$Database$coding, db.a$);
			case 3:
				return A2(g, $author$project$Type$Database$coding_answer, db.f0);
			case 4:
				return A2(g, $author$project$Type$Database$coding_frame, db.bT);
			case 5:
				return A2(g, $author$project$Type$Database$coding_question, db.dy);
			case 6:
				return A2(g, $author$project$Type$Database$coding_questionary, db.f2);
			case 11:
				return A2(g, $author$project$Type$Database$event, db.gm);
			case 7:
				return A2(g, $author$project$Type$Database$question, db.hp);
			case 8:
				return A2(g, $author$project$Type$Database$questionary, db.bs);
			case 9:
				return A2(g, $author$project$Type$Database$study, db.hK);
			case 10:
				return A2(g, $author$project$Type$Database$user, db.c6);
			case 12:
				return A2(g, $author$project$Type$Database$test_subject, db.aP);
			default:
				return A2(g, $author$project$Type$Database$InputType$input_type, db.d5);
		}
	});
var $aforemny$material_components_web_elm$Material$Button$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cz: $elm$core$Maybe$Just(onClick)
			});
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $aforemny$material_components_web_elm$Material$Button$Text = 0;
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $aforemny$material_components_web_elm$Material$Button$clickHandler = function (_v0) {
	var onClick = _v0.cz;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $aforemny$material_components_web_elm$Material$Button$denseCs = function (_v0) {
	var dense = _v0.b$;
	return dense ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-button--dense')) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $aforemny$material_components_web_elm$Material$Button$disabledAttr = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$disabled(disabled));
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $aforemny$material_components_web_elm$Material$Button$hrefAttr = function (_v0) {
	var href = _v0.aG;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, href);
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $aforemny$material_components_web_elm$Material$Button$labelElt = function (label) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-button__label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $aforemny$material_components_web_elm$Material$Button$iconElt = function (_v0) {
	var config_ = _v0;
	return A2(
		$elm$core$Maybe$map,
		$elm$html$Html$map($elm$core$Basics$never),
		function () {
			var _v1 = config_.d0;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var node = _v1.a.a.bk;
					var attributes = _v1.a.a.bM;
					var nodes = _v1.a.a.bl;
					return $elm$core$Maybe$Just(
						A2(
							node,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('mdc-button__icon'),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
									attributes)),
							nodes));
				} else {
					var node = _v1.a.a.bk;
					var attributes = _v1.a.a.bM;
					var nodes = _v1.a.a.bl;
					return $elm$core$Maybe$Just(
						A2(
							node,
							A2(
								$elm$core$List$cons,
								$elm$svg$Svg$Attributes$class('mdc-button__icon'),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
									attributes)),
							nodes));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}());
};
var $aforemny$material_components_web_elm$Material$Button$leadingIconElt = function (config_) {
	var trailingIcon = config_.bA;
	return (!trailingIcon) ? $aforemny$material_components_web_elm$Material$Button$iconElt(config_) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Menu$closeHandler = function (_v0) {
	var onClose = _v0.bo;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('MDCMenuSurface:close'),
			$elm$json$Json$Decode$succeed),
		onClose);
};
var $aforemny$material_components_web_elm$Material$List$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$List$config = {bF: _List_Nil, bN: false, b$: false, bd: true, bu: true, c2: false, ij: false, dd: false};
var $aforemny$material_components_web_elm$Material$List$Item$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$List$avatarListCs = function (_v0) {
	var avatarList = _v0.bN;
	return avatarList ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-deprecated-list--avatar-list')) : $elm$core$Maybe$Nothing;
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $aforemny$material_components_web_elm$Material$List$clickHandler = function (listItems) {
	var getOnClick = function (listItem_) {
		switch (listItem_.$) {
			case 0:
				var onClick = listItem_.b.cz;
				return $elm$core$Maybe$Just(onClick);
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var nthOnClick = function (index) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			$elm$core$List$head(
				A2(
					$elm$core$List$drop,
					index,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2($elm$core$List$map, getOnClick, listItems)))));
	};
	var mergedClickHandler = A2(
		$elm$json$Json$Decode$andThen,
		function (index) {
			var _v0 = nthOnClick(index);
			if (!_v0.$) {
				var msg_ = _v0.a;
				return $elm$json$Json$Decode$succeed(msg_);
			} else {
				return $elm$json$Json$Decode$fail('');
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['detail', 'index']),
			$elm$json$Json$Decode$int));
	return $elm$core$Maybe$Just(
		A2($elm$html$Html$Events$on, 'MDCList:action', mergedClickHandler));
};
var $aforemny$material_components_web_elm$Material$List$denseCs = function (_v0) {
	var dense = _v0.b$;
	return dense ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-deprecated-list--dense')) : $elm$core$Maybe$Nothing;
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $aforemny$material_components_web_elm$Material$List$interactiveProp = function (_v0) {
	var interactive = _v0.bd;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'interactive',
			$elm$json$Json$Encode$bool(interactive)));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $aforemny$material_components_web_elm$Material$List$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-deprecated-list'));
var $aforemny$material_components_web_elm$Material$List$selectedIndexProp = function (listItems) {
	var selectedIndex = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, listItem_) {
					switch (listItem_.$) {
						case 0:
							var selection = listItem_.b.hA;
							return (!_Utils_eq(selection, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(index) : $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				}),
			A2(
				$elm$core$List$filter,
				function (listItem_) {
					switch (listItem_.$) {
						case 0:
							return true;
						case 1:
							return false;
						default:
							return false;
					}
				},
				listItems)));
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'selectedIndex',
			A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, selectedIndex)));
};
var $aforemny$material_components_web_elm$Material$List$twoLineCs = function (_v0) {
	var twoLine = _v0.c2;
	return twoLine ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-deprecated-list--two-line')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$wrapFocusProp = function (_v0) {
	var wrapFocus = _v0.dd;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'wrapFocus',
			$elm$json$Json$Encode$bool(wrapFocus)));
};
var $aforemny$material_components_web_elm$Material$List$list = F3(
	function (config_, firstListItem, remainingListItems) {
		var ripples = config_.bu;
		var interactive = config_.bd;
		var additionalAttributes = config_.bF;
		var listItems = A2($elm$core$List$cons, firstListItem, remainingListItems);
		return A3(
			$elm$html$Html$node,
			'mdc-list',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$List$rootCs,
							$aforemny$material_components_web_elm$Material$List$denseCs(config_),
							$aforemny$material_components_web_elm$Material$List$avatarListCs(config_),
							$aforemny$material_components_web_elm$Material$List$twoLineCs(config_),
							$aforemny$material_components_web_elm$Material$List$wrapFocusProp(config_),
							$aforemny$material_components_web_elm$Material$List$clickHandler(listItems),
							$aforemny$material_components_web_elm$Material$List$selectedIndexProp(listItems),
							$aforemny$material_components_web_elm$Material$List$interactiveProp(config_)
						])),
				additionalAttributes),
			A2(
				$elm$core$List$map,
				function (listItem_) {
					switch (listItem_.$) {
						case 0:
							var node = listItem_.a;
							var config__ = listItem_.b;
							return node(
								_Utils_update(
									config__,
									{bu: ripples && interactive}));
						case 1:
							var node = listItem_.a;
							return node;
						default:
							var node = listItem_.a;
							return node;
					}
				},
				listItems));
	});
var $aforemny$material_components_web_elm$Material$Menu$openProp = function (_v0) {
	var open = _v0.cB;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'open',
			$elm$json$Json$Encode$bool(open)));
};
var $aforemny$material_components_web_elm$Material$Menu$quickOpenProp = function (_v0) {
	var quickOpen = _v0.cJ;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'quickOpen',
			$elm$json$Json$Encode$bool(quickOpen)));
};
var $aforemny$material_components_web_elm$Material$Menu$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-menu mdc-menu-surface'));
var $aforemny$material_components_web_elm$Material$List$setRipples = F2(
	function (ripples, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bu: ripples});
	});
var $aforemny$material_components_web_elm$Material$List$setWrapFocus = F2(
	function (wrapFocus, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{dd: wrapFocus});
	});
var $aforemny$material_components_web_elm$Material$Menu$menu = F3(
	function (config_, firstListItem, remainingListItems) {
		var additionalAttributes = config_.bF;
		return A3(
			$elm$html$Html$node,
			'mdc-menu',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Menu$rootCs,
							$aforemny$material_components_web_elm$Material$Menu$openProp(config_),
							$aforemny$material_components_web_elm$Material$Menu$quickOpenProp(config_),
							$aforemny$material_components_web_elm$Material$Menu$closeHandler(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					A3(
					$aforemny$material_components_web_elm$Material$List$list,
					A2(
						$aforemny$material_components_web_elm$Material$List$setWrapFocus,
						true,
						A2($aforemny$material_components_web_elm$Material$List$setRipples, false, $aforemny$material_components_web_elm$Material$List$config)),
					firstListItem,
					remainingListItems)
				]));
	});
var $aforemny$material_components_web_elm$Material$Button$rippleElt = $elm$core$Maybe$Just(
	A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-button__ripple')
			]),
		_List_Nil));
var $aforemny$material_components_web_elm$Material$Button$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-button'));
var $aforemny$material_components_web_elm$Material$Button$tabIndexProp = function (_v0) {
	var disabled = _v0.aC;
	return disabled ? $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'tabIndex',
			$elm$json$Json$Encode$int(-1))) : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'tabIndex',
			$elm$json$Json$Encode$int(0)));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $aforemny$material_components_web_elm$Material$Button$targetAttr = function (_v0) {
	var href = _v0.aG;
	var target = _v0.c$;
	return (!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? A2($elm$core$Maybe$map, $elm$html$Html$Attributes$target, target) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$touchCs = function (_v0) {
	var touch = _v0.aS;
	return touch ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-button--touch')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$touchElt = function (_v0) {
	var touch = _v0.aS;
	return touch ? $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-button__touch')
				]),
			_List_Nil)) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$trailingIconElt = function (config_) {
	var trailingIcon = config_.bA;
	return trailingIcon ? $aforemny$material_components_web_elm$Material$Button$iconElt(config_) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Button$variantCs = function (variant) {
	switch (variant) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-button--raised'));
		case 2:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-button--unelevated'));
		default:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-button--outlined'));
	}
};
var $aforemny$material_components_web_elm$Material$Button$button = F3(
	function (variant, config_, label) {
		var innerConfig = config_;
		var additionalAttributes = innerConfig.bF;
		var touch = innerConfig.aS;
		var href = innerConfig.aG;
		var disabled = innerConfig.aC;
		var wrapTouch = function (node) {
			return touch ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-touch-target-wrapper')
					]),
				_List_fromArray(
					[node])) : node;
		};
		var wrapMenu = function (node) {
			var _v0 = innerConfig.cp;
			if (_v0.$ === 1) {
				return node;
			} else {
				var _v1 = _v0.a;
				var menuConfig = _v1.a;
				var firstListItem = _v1.b;
				var remainingListItems = _v1.c;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mdc-menu-surface--anchor')
						]),
					_List_fromArray(
						[
							node,
							A3($aforemny$material_components_web_elm$Material$Menu$menu, menuConfig, firstListItem, remainingListItems)
						]));
			}
		};
		return wrapMenu(
			wrapTouch(
				A3(
					$elm$html$Html$node,
					'mdc-button',
					_List_Nil,
					_List_fromArray(
						[
							A2(
							((!_Utils_eq(href, $elm$core$Maybe$Nothing)) && (!disabled)) ? $elm$html$Html$a : $elm$html$Html$button,
							_Utils_ap(
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$aforemny$material_components_web_elm$Material$Button$rootCs,
											$aforemny$material_components_web_elm$Material$Button$variantCs(variant),
											$aforemny$material_components_web_elm$Material$Button$denseCs(config_),
											$aforemny$material_components_web_elm$Material$Button$touchCs(config_),
											$aforemny$material_components_web_elm$Material$Button$disabledAttr(config_),
											$aforemny$material_components_web_elm$Material$Button$tabIndexProp(config_),
											$aforemny$material_components_web_elm$Material$Button$hrefAttr(config_),
											$aforemny$material_components_web_elm$Material$Button$targetAttr(config_),
											$aforemny$material_components_web_elm$Material$Button$clickHandler(config_)
										])),
								additionalAttributes),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$Button$rippleElt,
										$aforemny$material_components_web_elm$Material$Button$leadingIconElt(config_),
										$aforemny$material_components_web_elm$Material$Button$labelElt(label),
										$aforemny$material_components_web_elm$Material$Button$trailingIconElt(config_),
										$aforemny$material_components_web_elm$Material$Button$touchElt(config_)
									])))
						]))));
	});
var $aforemny$material_components_web_elm$Material$Button$text = F2(
	function (config_, label) {
		return A3($aforemny$material_components_web_elm$Material$Button$button, 0, config_, label);
	});
var $aforemny$material_components_web_elm$Material$TextField$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$TextField$config = {bF: _List_Nil, aC: false, b2: false, ba: false, ea: $elm$core$Maybe$Nothing, ee: $elm$core$Maybe$Nothing, ac: $elm$core$Maybe$Nothing, bh: $elm$core$Maybe$Nothing, ae: $elm$core$Maybe$Nothing, bi: $elm$core$Maybe$Nothing, cy: $elm$core$Maybe$Nothing, cA: $elm$core$Maybe$Nothing, ex: $elm$core$Maybe$Nothing, hm: $elm$core$Maybe$Nothing, cF: $elm$core$Maybe$Nothing, cL: false, aM: $elm$core$Maybe$Nothing, cZ: $elm$core$Maybe$Nothing, bA: $elm$core$Maybe$Nothing, c3: $elm$core$Maybe$Nothing, c7: true, fb: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$TextField$disabledCs = function (_v0) {
	var disabled = _v0.aC;
	return disabled ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--disabled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$disabledProp = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$TextField$endAlignedCs = function (_v0) {
	var endAligned = _v0.b2;
	return endAligned ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--end-aligned')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$filledCs = function (outlined_) {
	return (!outlined_) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--filled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$foucClassNamesProp = $elm$core$Maybe$Just(
	A2(
		$elm$html$Html$Attributes$property,
		'foucClassNames',
		A2(
			$elm$json$Json$Encode$list,
			$elm$json$Json$Encode$string,
			_List_fromArray(
				['mdc-text-field--label-floating']))));
var $aforemny$material_components_web_elm$Material$TextField$fullwidthCs = function (_v0) {
	var fullwidth = _v0.ba;
	return fullwidth ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--fullwidth')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$ariaLabelAttr = function (_v0) {
	var fullwidth = _v0.ba;
	var placeholder = _v0.hm;
	var label = _v0.ea;
	return fullwidth ? A2(
		$elm$core$Maybe$map,
		$elm$html$Html$Attributes$attribute('aria-label'),
		label) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $aforemny$material_components_web_elm$Material$TextField$changeHandler = function (_v0) {
	var onChange = _v0.cy;
	return A2(
		$elm$core$Maybe$map,
		function (f) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, f, $elm$html$Html$Events$targetValue));
		},
		onChange);
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $aforemny$material_components_web_elm$Material$TextField$inputCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field__input'));
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $aforemny$material_components_web_elm$Material$TextField$inputHandler = function (_v0) {
	var onInput = _v0.cA;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, onInput);
};
var $aforemny$material_components_web_elm$Material$TextField$maxLengthAttr = function (_v0) {
	var maxLength = _v0.bh;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('maxLength'),
			$elm$core$String$fromInt),
		maxLength);
};
var $aforemny$material_components_web_elm$Material$TextField$minLengthAttr = function (_v0) {
	var minLength = _v0.bi;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('minLength'),
			$elm$core$String$fromInt),
		minLength);
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $aforemny$material_components_web_elm$Material$TextField$placeholderAttr = function (_v0) {
	var placeholder = _v0.hm;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$placeholder, placeholder);
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $aforemny$material_components_web_elm$Material$TextField$typeAttr = function (_v0) {
	var type_ = _v0.c3;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$type_, type_);
};
var $aforemny$material_components_web_elm$Material$TextField$inputElt = function (config_) {
	return A2(
		$elm$html$Html$input,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$inputCs,
					$aforemny$material_components_web_elm$Material$TextField$typeAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$ariaLabelAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$placeholderAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$inputHandler(config_),
					$aforemny$material_components_web_elm$Material$TextField$changeHandler(config_),
					$aforemny$material_components_web_elm$Material$TextField$minLengthAttr(config_),
					$aforemny$material_components_web_elm$Material$TextField$maxLengthAttr(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$TextField$labelElt = function (_v0) {
	var label = _v0.ea;
	var value = _v0.fb;
	var fullwidth = _v0.ba;
	var floatingLabelFloatAboveCs = 'mdc-floating-label--float-above';
	var floatingLabelCs = 'mdc-floating-label';
	var _v1 = _Utils_Tuple2(fullwidth, label);
	if ((!_v1.a) && (!_v1.b.$)) {
		var str = _v1.b.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					(A2($elm$core$Maybe$withDefault, '', value) !== '') ? $elm$html$Html$Attributes$class(floatingLabelCs + (' ' + floatingLabelFloatAboveCs)) : $elm$html$Html$Attributes$class(floatingLabelCs),
					A2(
					$elm$html$Html$Attributes$property,
					'foucClassNames',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						_List_fromArray(
							[floatingLabelFloatAboveCs])))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextField$labelFloatingCs = function (_v0) {
	var label = _v0.ea;
	var value = _v0.fb;
	var fullwidth = _v0.ba;
	return ((!fullwidth) && ((!_Utils_eq(label, $elm$core$Maybe$Nothing)) && (A2($elm$core$Maybe$withDefault, '', value) !== ''))) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--label-floating')) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $aforemny$material_components_web_elm$Material$TextField$iconElt = F2(
	function (modifierCs, icon_) {
		if (icon_.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			if (!icon_.a.$) {
				var node = icon_.a.a.bk;
				var attributes = icon_.a.a.bM;
				var nodes = icon_.a.a.bl;
				var onInteraction = icon_.a.a.es;
				var disabled = icon_.a.a.aC;
				return A2(
					node,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('mdc-text-field__icon'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(modifierCs),
							function () {
								if (!onInteraction.$) {
									var msg = onInteraction.a;
									return (!disabled) ? A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(0),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(msg),
												A2(
													$elm$core$List$cons,
													A2(
														$elm$html$Html$Events$on,
														'keydown',
														A2(
															$elm$json$Json$Decode$andThen,
															function (keyCode) {
																return (keyCode === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
															},
															$elm$html$Html$Events$keyCode)),
													attributes)))) : A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(-1),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											attributes));
								} else {
									return attributes;
								}
							}())),
					nodes);
			} else {
				var node = icon_.a.a.bk;
				var attributes = icon_.a.a.bM;
				var nodes = icon_.a.a.bl;
				var onInteraction = icon_.a.a.es;
				var disabled = icon_.a.a.aC;
				return A2(
					node,
					A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$class('mdc-text-field__icon'),
						A2(
							$elm$core$List$cons,
							$elm$svg$Svg$Attributes$class(modifierCs),
							function () {
								if (!onInteraction.$) {
									var msg = onInteraction.a;
									return (!disabled) ? A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(0),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(msg),
												A2(
													$elm$core$List$cons,
													A2(
														$elm$html$Html$Events$on,
														'keydown',
														A2(
															$elm$json$Json$Decode$andThen,
															function (keyCode) {
																return (keyCode === 13) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
															},
															$elm$html$Html$Events$keyCode)),
													attributes)))) : A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$tabindex(-1),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
											attributes));
								} else {
									return attributes;
								}
							}())),
					nodes);
			}
		}
	});
var $aforemny$material_components_web_elm$Material$TextField$leadingIconElt = function (_v0) {
	var leadingIcon = _v0.ee;
	return A2($aforemny$material_components_web_elm$Material$TextField$iconElt, 'mdc-text-field__icon--leading', leadingIcon);
};
var $aforemny$material_components_web_elm$Material$TextField$lineRippleElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-line-ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$maxLengthProp = function (_v0) {
	var maxLength = _v0.bh;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'maxLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, maxLength))));
};
var $aforemny$material_components_web_elm$Material$TextField$maxProp = function (_v0) {
	var max = _v0.ac;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'max',
			$elm$json$Json$Encode$string(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, max)))));
};
var $aforemny$material_components_web_elm$Material$TextField$minLengthProp = function (_v0) {
	var minLength = _v0.bi;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'minLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, minLength))));
};
var $aforemny$material_components_web_elm$Material$TextField$minProp = function (_v0) {
	var min = _v0.ae;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'min',
			$elm$json$Json$Encode$string(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, min)))));
};
var $aforemny$material_components_web_elm$Material$TextField$noLabelCs = function (_v0) {
	var label = _v0.ea;
	return _Utils_eq(label, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--no-label')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineLeadingElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__leading')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineNotchElt = function (config_) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline__notch')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextField$labelElt(config_)
			]));
};
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineTrailingElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__trailing')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$notchedOutlineElt = function (config_) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextField$notchedOutlineLeadingElt,
				$aforemny$material_components_web_elm$Material$TextField$notchedOutlineNotchElt(config_),
				$aforemny$material_components_web_elm$Material$TextField$notchedOutlineTrailingElt
			]));
};
var $aforemny$material_components_web_elm$Material$TextField$outlinedCs = function (outlined_) {
	return outlined_ ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--outlined')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$patternProp = function (_v0) {
	var pattern = _v0.ex;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'pattern',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, pattern))));
};
var $aforemny$material_components_web_elm$Material$TextField$prefixCs = $elm$html$Html$Attributes$class('mdc-text-field__affix mdc-text-field__affix--prefix');
var $aforemny$material_components_web_elm$Material$TextField$prefixElt = function (_v0) {
	var prefix = _v0.cF;
	if (!prefix.$) {
		var prefixStr = prefix.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TextField$prefixCs]),
			_List_fromArray(
				[
					$elm$html$Html$text(prefixStr)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextField$requiredProp = function (_v0) {
	var required = _v0.cL;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'required',
			$elm$json$Json$Encode$bool(required)));
};
var $aforemny$material_components_web_elm$Material$TextField$rippleElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-text-field__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextField$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field'));
var $aforemny$material_components_web_elm$Material$TextField$stepProp = function (_v0) {
	var step = _v0.aM;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'step',
			$elm$json$Json$Encode$string(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, step)))));
};
var $aforemny$material_components_web_elm$Material$TextField$suffixCs = $elm$html$Html$Attributes$class('mdc-text-field__affix mdc-text-field__affix--suffix');
var $aforemny$material_components_web_elm$Material$TextField$suffixElt = function (_v0) {
	var suffix = _v0.cZ;
	if (!suffix.$) {
		var suffixStr = suffix.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TextField$suffixCs]),
			_List_fromArray(
				[
					$elm$html$Html$text(suffixStr)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextField$trailingIconElt = function (_v0) {
	var trailingIcon = _v0.bA;
	return A2($aforemny$material_components_web_elm$Material$TextField$iconElt, 'mdc-text-field__icon--trailing', trailingIcon);
};
var $aforemny$material_components_web_elm$Material$TextField$validProp = function (_v0) {
	var valid = _v0.c7;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'valid',
			$elm$json$Json$Encode$bool(valid)));
};
var $aforemny$material_components_web_elm$Material$TextField$valueProp = function (_v0) {
	var value = _v0.fb;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$property('value'),
			$elm$json$Json$Encode$string),
		value);
};
var $aforemny$material_components_web_elm$Material$TextField$withLeadingIconCs = function (_v0) {
	var leadingIcon = _v0.ee;
	return (!_Utils_eq(leadingIcon, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--with-leading-icon')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$withTrailingIconCs = function (_v0) {
	var trailingIcon = _v0.bA;
	return (!_Utils_eq(trailingIcon, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--with-trailing-icon')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextField$textField = F2(
	function (outlined_, config_) {
		var additionalAttributes = config_.bF;
		var fullwidth = config_.ba;
		return A3(
			$elm$html$Html$node,
			'mdc-text-field',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TextField$rootCs,
							$aforemny$material_components_web_elm$Material$TextField$noLabelCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$filledCs(outlined_),
							$aforemny$material_components_web_elm$Material$TextField$outlinedCs(outlined_),
							$aforemny$material_components_web_elm$Material$TextField$fullwidthCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$labelFloatingCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$foucClassNamesProp,
							$aforemny$material_components_web_elm$Material$TextField$disabledCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$withLeadingIconCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$withTrailingIconCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$endAlignedCs(config_),
							$aforemny$material_components_web_elm$Material$TextField$valueProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$disabledProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$requiredProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$validProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$patternProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$minLengthProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$maxLengthProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$minProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$maxProp(config_),
							$aforemny$material_components_web_elm$Material$TextField$stepProp(config_)
						])),
				additionalAttributes),
			outlined_ ? _List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$leadingIconElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$prefixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$inputElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$suffixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$notchedOutlineElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$trailingIconElt(config_)
				]) : _List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextField$rippleElt,
					$aforemny$material_components_web_elm$Material$TextField$leadingIconElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$prefixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$inputElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$suffixElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$labelElt(config_),
					$aforemny$material_components_web_elm$Material$TextField$lineRippleElt,
					$aforemny$material_components_web_elm$Material$TextField$trailingIconElt(config_)
				]));
	});
var $aforemny$material_components_web_elm$Material$TextField$filled = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$TextField$textField, false, config_);
};
var $aforemny$material_components_web_elm$Material$TextField$setLabel = F2(
	function (label, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{ea: label});
	});
var $aforemny$material_components_web_elm$Material$TextField$setOnInput = F2(
	function (onInput, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cA: $elm$core$Maybe$Just(onInput)
			});
	});
var $aforemny$material_components_web_elm$Material$TextField$setValue = F2(
	function (value, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fb: value});
	});
var $author$project$Viewer$textForm = F3(
	function (label, value, callback) {
		return $aforemny$material_components_web_elm$Material$TextField$filled(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setLabel,
				label,
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setOnInput,
					callback,
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setValue,
						$elm$core$Maybe$Just(value),
						$aforemny$material_components_web_elm$Material$TextField$config))));
	});
var $author$project$Page$Admin$edit = F3(
	function (db, kind, id) {
		var msg = function (x) {
			return $author$project$Msg$Form(
				A2(
					$author$project$Type$IO$Form$AttrMsg,
					$author$project$Type$Database$TypeMatching$toStringPlural(kind),
					A2(
						$author$project$Type$IO$Form$DictMsg,
						$elm$core$Maybe$Just(id),
						A2($author$project$Type$IO$Form$AttrMsg, 'value', x))));
		};
		return A2(
			$elm$core$List$map,
			$elm$html$Html$div(_List_Nil),
			A2(
				$elm$core$List$map,
				function (x) {
					var _v0 = A5(
						$author$project$Type$Database$TypeMatching$forms,
						id,
						kind,
						x,
						db,
						$author$project$Viewer$textForm(
							$elm$core$Maybe$Just(x)));
					if (!_v0.$) {
						var form = _v0.a;
						return _List_fromArray(
							[
								form,
								A2(
								$aforemny$material_components_web_elm$Material$Button$text,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setOnClick,
									$author$project$Msg$Form(
										A2(
											$author$project$Type$IO$Form$AttrMsg,
											$author$project$Type$Database$TypeMatching$toStringPlural(kind),
											A2(
												$author$project$Type$IO$Form$DictMsg,
												$elm$core$Maybe$Just(id),
												A2(
													$author$project$Type$IO$Form$AttrMsg,
													'value',
													A2(
														$author$project$Type$IO$Form$AttrMsg,
														x,
														$author$project$Type$IO$Form$StringMsg(
															$elm$core$Maybe$Just('Value'))))))),
									$aforemny$material_components_web_elm$Material$Button$config),
								'SetValue!'),
								function () {
								var _v1 = A2(
									$author$project$Type$Database$database.h9,
									$author$project$Type$Database$TypeMatching$toStringPlural(kind) + ('.' + (id + ('.value.' + x))),
									db);
								if (!_v1.$) {
									var v = _v1.a;
									return $elm$html$Html$text(v);
								} else {
									switch (_v1.a.$) {
										case 1:
											var index = _v1.a.a;
											return $elm$html$Html$text(
												'IndexOutOfBounds: ' + $elm$core$String$fromInt(index));
										case 0:
											var _v2 = _v1.a;
											return $elm$html$Html$text('Not Found');
										case 2:
											var name = _v1.a.a;
											return $elm$html$Html$text('Not an Int: ' + name);
										case 3:
											var key = _v1.a.a;
											return $elm$html$Html$text('No such key: ' + key);
										case 5:
											var name = _v1.a.a;
											return $elm$html$Html$text('No such substruct: ' + name);
										default:
											var _v3 = _v1.a;
											return $elm$html$Html$text('No such value');
									}
								}
							}(),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$elm$html$Html$text,
									$author$project$Type$Database$TypeMatching$fields(kind)))
							]);
					} else {
						return _List_fromArray(
							[
								$elm$html$Html$text('ID not found'),
								A2(
								$aforemny$material_components_web_elm$Material$Button$text,
								A2(
									$aforemny$material_components_web_elm$Material$Button$setOnClick,
									$author$project$Msg$CRUD(
										A3($author$project$Msg$Create, kind, id, _List_Nil)),
									$aforemny$material_components_web_elm$Material$Button$config),
								'Create!')
							]);
					}
				},
				$author$project$Type$Database$TypeMatching$fields(kind)));
	});
var $rluiten$stringdistance$StringDistance$maxl = F2(
	function (xs, ys) {
		return (_Utils_cmp(
			$elm$core$List$length(xs),
			$elm$core$List$length(ys)) > 0) ? xs : ys;
	});
var $rluiten$stringdistance$StringDistance$lcsLimit_ = F4(
	function (offset, maxLookAhead, xs_, ys_) {
		if (_Utils_cmp(offset, maxLookAhead) > 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(xs_, ys_);
			if (_v0.a.b && _v0.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs = _v1.b;
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys = _v2.b;
				return _Utils_eq(x, y) ? A2(
					$elm$core$List$cons,
					x,
					A4($rluiten$stringdistance$StringDistance$lcsLimit_, 0, maxLookAhead, xs, ys)) : A2(
					$rluiten$stringdistance$StringDistance$maxl,
					A4($rluiten$stringdistance$StringDistance$lcsLimit_, offset + 1, maxLookAhead, xs_, ys),
					A4($rluiten$stringdistance$StringDistance$lcsLimit_, offset + 1, maxLookAhead, xs, ys_));
			} else {
				return _List_Nil;
			}
		}
	});
var $rluiten$stringdistance$StringDistance$lcsLimit = $rluiten$stringdistance$StringDistance$lcsLimit_(0);
var $rluiten$stringdistance$StringDistance$sift3Distance = F2(
	function (s1, s2) {
		var s2Len = $elm$core$String$length(s2);
		var s1Len = $elm$core$String$length(s1);
		var lcs_ = $rluiten$stringdistance$StringDistance$lcsLimit(5);
		if (!s1Len) {
			return s2Len;
		} else {
			if (!s2Len) {
				return s1Len;
			} else {
				var common = A2(
					lcs_,
					$elm$core$String$toList(s1),
					$elm$core$String$toList(s2));
				return ((s1Len + s2Len) / 2) - $elm$core$List$length(common);
			}
		}
	});
var $author$project$Page$Admin$smartFilter = F2(
	function (first, second) {
		var diff = $elm$core$Basics$abs(
			$elm$core$String$length(first) - $elm$core$String$length(second));
		return (A2($rluiten$stringdistance$StringDistance$sift3Distance, first, second) - diff) <= 0;
	});
var $author$project$Page$Admin$filterKeys = F3(
	function (query, kind, db) {
		if (!query.$) {
			var q = query.a;
			return A2(
				$elm$core$List$filter,
				$author$project$Page$Admin$smartFilter(q),
				A2($author$project$Type$Database$TypeMatching$keys, kind, db));
		} else {
			return A2($author$project$Type$Database$TypeMatching$keys, kind, db);
		}
	});
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$p = _VirtualDom_node('p');
var $aforemny$material_components_web_elm$Material$DataTable$Cell = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$DataTable$cell = F2(
	function (attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$DataTable$Cell(
			{bM: attributes, bl: nodes, bm: false});
	});
var $aforemny$material_components_web_elm$Material$DataTable$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$DataTable$config = {bF: _List_Nil, ea: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$DataTable$ariaLabelAttr = function (_v0) {
	var label = _v0.ea;
	return A2(
		$elm$core$Maybe$map,
		$elm$html$Html$Attributes$attribute('aria-label'),
		label);
};
var $aforemny$material_components_web_elm$Material$Checkbox$Internal$Config = $elm$core$Basics$identity;
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $aforemny$material_components_web_elm$Material$Checkbox$backgroundElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-checkbox__background')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('mdc-checkbox__checkmark'),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('mdc-checkbox__checkmark-path'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$d('M1.73,12.91 8.1,19.28 22.79,4.59')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-checkbox__mixedmark')
				]),
			_List_Nil)
		]));
var $aforemny$material_components_web_elm$Material$Checkbox$checkedProp = function (_v0) {
	var state = _v0.bx;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'checked',
			$elm$json$Json$Encode$bool(
				_Utils_eq(
					state,
					$elm$core$Maybe$Just(1)))));
};
var $aforemny$material_components_web_elm$Material$Checkbox$disabledProp = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$Checkbox$indeterminateProp = function (_v0) {
	var state = _v0.bx;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'indeterminate',
			$elm$json$Json$Encode$bool(
				_Utils_eq(
					state,
					$elm$core$Maybe$Just(2)))));
};
var $aforemny$material_components_web_elm$Material$Checkbox$changeHandler = function (_v0) {
	var onChange = _v0.cy;
	return A2(
		$elm$core$Maybe$map,
		function (msg) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				$elm$json$Json$Decode$succeed(msg));
		},
		onChange);
};
var $aforemny$material_components_web_elm$Material$Checkbox$nativeControlElt = function (config_) {
	return A2(
		$elm$html$Html$input,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$elm$html$Html$Attributes$type_('checkbox')),
					$elm$core$Maybe$Just(
					$elm$html$Html$Attributes$class('mdc-checkbox__native-control')),
					$aforemny$material_components_web_elm$Material$Checkbox$checkedProp(config_),
					$aforemny$material_components_web_elm$Material$Checkbox$indeterminateProp(config_),
					$aforemny$material_components_web_elm$Material$Checkbox$changeHandler(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$Checkbox$rippleElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-checkbox__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Checkbox$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-checkbox'));
var $aforemny$material_components_web_elm$Material$Checkbox$touchCs = function (_v0) {
	var touch = _v0.aS;
	return touch ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-checkbox--touch')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Checkbox$checkbox = function (config_) {
	var touch = config_.aS;
	var additionalAttributes = config_.bF;
	var wrapTouch = function (node) {
		return touch ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-touch-target-wrapper')
				]),
			_List_fromArray(
				[node])) : node;
	};
	return wrapTouch(
		A3(
			$elm$html$Html$node,
			'mdc-checkbox',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Checkbox$rootCs,
							$aforemny$material_components_web_elm$Material$Checkbox$touchCs(config_),
							$aforemny$material_components_web_elm$Material$Checkbox$checkedProp(config_),
							$aforemny$material_components_web_elm$Material$Checkbox$indeterminateProp(config_),
							$aforemny$material_components_web_elm$Material$Checkbox$disabledProp(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$nativeControlElt(config_),
					$aforemny$material_components_web_elm$Material$Checkbox$backgroundElt,
					$aforemny$material_components_web_elm$Material$Checkbox$rippleElt
				])));
};
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCellCheckboxCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__cell--checkbox'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCellCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__cell'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCellNumericCs = function (numeric) {
	return numeric ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-data-table__cell--numeric')) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $aforemny$material_components_web_elm$Material$DataTable$bodyCell = function (cell_) {
	if (!cell_.$) {
		var numeric = cell_.a.bm;
		var attributes = cell_.a.bM;
		var nodes = cell_.a.bl;
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$DataTable$dataTableCellCs,
							$aforemny$material_components_web_elm$Material$DataTable$dataTableCellNumericCs(numeric)
						])),
				attributes),
			nodes);
	} else {
		var attributes = cell_.a.bM;
		var config_ = cell_.a.bW;
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$DataTable$dataTableCellCs, $aforemny$material_components_web_elm$Material$DataTable$dataTableCellCheckboxCs])),
				attributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					function () {
						var config__ = config_;
						return _Utils_update(
							config__,
							{
								bF: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('mdc-data-table__row-checkbox'),
									config__.bF)
							});
					}())
				]));
	}
};
var $aforemny$material_components_web_elm$Material$DataTable$dataTableRowCs = $elm$html$Html$Attributes$class('mdc-data-table__row');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $aforemny$material_components_web_elm$Material$DataTable$bodyRow = function (_v0) {
	var attributes = _v0.bM;
	var nodes = _v0.bl;
	return A2(
		$elm$html$Html$tr,
		A2($elm$core$List$cons, $aforemny$material_components_web_elm$Material$DataTable$dataTableRowCs, attributes),
		A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$bodyCell, nodes));
};
var $aforemny$material_components_web_elm$Material$DataTable$dataTableContentCs = $elm$html$Html$Attributes$class('mdc-data-table__content');
var $aforemny$material_components_web_elm$Material$DataTable$dataTableCs = $elm$html$Html$Attributes$class('mdc-data-table');
var $aforemny$material_components_web_elm$Material$DataTable$dataTableTableCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__table'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderRowCs = $elm$html$Html$Attributes$class('mdc-data-table__header-row');
var $aforemny$material_components_web_elm$Material$DataTable$colScopeAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'scope', 'col'));
var $aforemny$material_components_web_elm$Material$DataTable$columnHeaderRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'columnheader'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCheckboxCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__header-cell--checkbox'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-data-table__header-cell'));
var $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellNumericCs = function (numeric) {
	return numeric ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-data-table__header-cell--numeric')) : $elm$core$Maybe$Nothing;
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $aforemny$material_components_web_elm$Material$DataTable$headerCell = function (cell_) {
	if (!cell_.$) {
		var numeric = cell_.a.bm;
		var attributes = cell_.a.bM;
		var nodes = cell_.a.bl;
		return A2(
			$elm$html$Html$th,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCs,
							$aforemny$material_components_web_elm$Material$DataTable$columnHeaderRoleAttr,
							$aforemny$material_components_web_elm$Material$DataTable$colScopeAttr,
							$aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellNumericCs(numeric)
						])),
				attributes),
			nodes);
	} else {
		var attributes = cell_.a.bM;
		var config_ = cell_.a.bW;
		return A2(
			$elm$html$Html$th,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCs, $aforemny$material_components_web_elm$Material$DataTable$columnHeaderRoleAttr, $aforemny$material_components_web_elm$Material$DataTable$colScopeAttr, $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderCellCheckboxCs])),
				attributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Checkbox$checkbox(
					function () {
						var config__ = config_;
						return _Utils_update(
							config__,
							{
								bF: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('mdc-data-table__row-checkbox'),
									config__.bF)
							});
					}())
				]));
	}
};
var $aforemny$material_components_web_elm$Material$DataTable$headerRow = function (_v0) {
	var attributes = _v0.bM;
	var nodes = _v0.bl;
	return A2(
		$elm$html$Html$tr,
		A2($elm$core$List$cons, $aforemny$material_components_web_elm$Material$DataTable$dataTableHeaderRowCs, attributes),
		A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$headerCell, nodes));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $aforemny$material_components_web_elm$Material$DataTable$dataTable = F2(
	function (config_, _v0) {
		var additionalAttributes = config_.bF;
		var thead = _v0.h2;
		var tbody = _v0.hO;
		return A3(
			$elm$html$Html$node,
			'mdc-data-table',
			A2($elm$core$List$cons, $aforemny$material_components_web_elm$Material$DataTable$dataTableCs, additionalAttributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$aforemny$material_components_web_elm$Material$DataTable$dataTableTableCs,
								$aforemny$material_components_web_elm$Material$DataTable$ariaLabelAttr(config_)
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$headerRow, thead)),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[$aforemny$material_components_web_elm$Material$DataTable$dataTableContentCs]),
							A2($elm$core$List$map, $aforemny$material_components_web_elm$Material$DataTable$bodyRow, tbody))
						]))
				]));
	});
var $author$project$Type$Database$TypeMatching$getField = F4(
	function (id, fname, kind, db) {
		return $elm$core$Result$toMaybe(
			A2(
				$author$project$Type$Database$database.h9,
				$author$project$Type$Database$TypeMatching$toStringPlural(kind) + ('.' + (id + ('.value.' + fname))),
				db));
	});
var $aforemny$material_components_web_elm$Material$DataTable$Row = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$DataTable$row = F2(
	function (attributes, nodes) {
		return {bM: attributes, bl: nodes};
	});
var $elm$core$String$cons = _String_cons;
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $author$project$Page$Admin$toTable = F3(
	function (keys, kind, db) {
		var values = A2(
			$elm$core$List$map,
			function (id) {
				return A2(
					$elm$core$List$cons,
					id,
					A2(
						$elm$core$List$map,
						function (fname) {
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								A4($author$project$Type$Database$TypeMatching$getField, id, fname, kind, db));
						},
						$author$project$Type$Database$TypeMatching$fields(kind)));
			},
			keys);
		var headers = A2(
			$elm$core$List$map,
			$elm_community$string_extra$String$Extra$toSentenceCase,
			A2(
				$elm$core$List$cons,
				'ID',
				$author$project$Type$Database$TypeMatching$fields(kind)));
		return A2(
			$aforemny$material_components_web_elm$Material$DataTable$dataTable,
			$aforemny$material_components_web_elm$Material$DataTable$config,
			{
				hO: A2(
					$elm$core$List$map,
					function (row) {
						return A2(
							$aforemny$material_components_web_elm$Material$DataTable$row,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (x) {
									return A2(
										$aforemny$material_components_web_elm$Material$DataTable$cell,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(x)
											]));
								},
								row));
					},
					values),
				h2: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$DataTable$row,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (x) {
								return A2(
									$aforemny$material_components_web_elm$Material$DataTable$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(x)
										]));
							},
							headers))
					])
			});
	});
var $author$project$Page$Admin$toTitle = function (_v0) {
	return 'Admin';
};
var $author$project$Msg$Admin = function (a) {
	return {$: 7, a: a};
};
var $author$project$Type$Database$TypeMatching$toString = function (kind) {
	switch (kind.$) {
		case 0:
			return 'answer';
		case 1:
			return 'coder';
		case 2:
			return 'coding';
		case 3:
			return 'coding_answer';
		case 4:
			return 'coding_frame';
		case 5:
			return 'coding_question';
		case 6:
			return 'coding_questionary';
		case 11:
			return 'event';
		case 7:
			return 'question';
		case 8:
			return 'questionary';
		case 9:
			return 'study';
		case 10:
			return 'user';
		case 12:
			return 'test_subject';
		default:
			return 'input_type';
	}
};
var $author$project$Type$Database$AnswerType = {$: 0};
var $author$project$Type$Database$CoderType = {$: 1};
var $author$project$Type$Database$CodingAnswerType = {$: 3};
var $author$project$Type$Database$CodingFrameType = {$: 4};
var $author$project$Type$Database$CodingQuestionType = {$: 5};
var $author$project$Type$Database$CodingQuestionaryType = {$: 6};
var $author$project$Type$Database$CodingType = {$: 2};
var $author$project$Type$Database$EventType = {$: 11};
var $author$project$Type$Database$InputTypeType = function (a) {
	return {$: 13, a: a};
};
var $author$project$Type$Database$ListKind = 2;
var $author$project$Type$Database$LongKind = 1;
var $author$project$Type$Database$QuestionType = {$: 7};
var $author$project$Type$Database$QuestionaryType = {$: 8};
var $author$project$Type$Database$ShortKind = 0;
var $author$project$Type$Database$StudyType = {$: 9};
var $author$project$Type$Database$TypeMatching$types = _List_fromArray(
	[
		$author$project$Type$Database$AnswerType,
		$author$project$Type$Database$CoderType,
		$author$project$Type$Database$CodingType,
		$author$project$Type$Database$CodingAnswerType,
		$author$project$Type$Database$CodingFrameType,
		$author$project$Type$Database$CodingQuestionType,
		$author$project$Type$Database$CodingQuestionaryType,
		$author$project$Type$Database$EventType,
		$author$project$Type$Database$QuestionType,
		$author$project$Type$Database$QuestionaryType,
		$author$project$Type$Database$StudyType,
		$author$project$Type$Database$UserType,
		$author$project$Type$Database$InputTypeType(0),
		$author$project$Type$Database$InputTypeType(2),
		$author$project$Type$Database$InputTypeType(1)
	]);
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Page$Admin$viewSummary = F2(
	function (kind, keys) {
		var asString = $author$project$Type$Database$TypeMatching$toString(kind);
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Table: ' + (asString + ': ')),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							'/admin/' + $author$project$Type$Database$TypeMatching$toString(kind))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Type$Database$TypeMatching$toString(kind))
						])),
					$elm$html$Html$text(
					'Found ' + ($elm$core$String$fromInt(
						$elm$core$List$length(keys)) + ' entries!'))
				]));
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Page$Admin$toBullet = F2(
	function (path, name) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/admin/' + (path + ('/' + name)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$Page$Admin$viewTable = F3(
	function (path, name, keys) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Found ' + ($elm$core$String$fromInt(
						$elm$core$List$length(keys)) + (' ' + (name + 's!')))),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Page$Admin$toBullet(path),
						keys))
				]));
	});
var $author$project$Msg$AdminDb = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Admin$viewValue = F3(
	function (id, kind, db) {
		var results = A2(
			$elm$core$List$filter,
			$elm$core$String$startsWith(id),
			A2($author$project$Type$Database$TypeMatching$keys, kind, db));
		return ($elm$core$List$length(results) > 0) ? A3(
			$author$project$Page$Admin$viewTable,
			$author$project$Type$Database$TypeMatching$toString(kind),
			$author$project$Type$Database$TypeMatching$toString(kind),
			results) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No result found! Create One?'),
					A2(
					$aforemny$material_components_web_elm$Material$Button$text,
					A2(
						$aforemny$material_components_web_elm$Material$Button$setOnClick,
						$author$project$Msg$AdminDb(
							A3($author$project$Msg$Create, kind, id, _List_Nil)),
						$aforemny$material_components_web_elm$Material$Button$config),
					'Create!')
				]));
	});
var $author$project$Page$Admin$viewTables = function (_v0) {
	var model = _v0;
	var db = model.hB.u;
	var _v1 = model.c.e1;
	switch (_v1.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Database overview:'),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (x) {
								return A2(
									$author$project$Page$Admin$viewSummary,
									x,
									A2($author$project$Type$Database$TypeMatching$keys, x, db));
							},
							$author$project$Type$Database$TypeMatching$types))
					]));
		case 1:
			var kind = _v1.a;
			var id = _v1.b;
			return A2(
				$elm$html$Html$map,
				$author$project$Msg$Admin,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!id.$) {
								var strid = id.a;
								return A3($author$project$Page$Admin$viewValue, strid, kind, db);
							} else {
								return A3(
									$author$project$Page$Admin$viewTable,
									$author$project$Type$Database$TypeMatching$toString(kind),
									$author$project$Type$Database$TypeMatching$toString(kind),
									A2($author$project$Type$Database$TypeMatching$keys, kind, db));
							}
						}()
						])));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Edit me')
					]));
	}
};
var $author$project$Page$Admin$view = function (_v0) {
	var model = _v0;
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Admin Panel')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('content')
							]),
						function () {
							var _v2 = model.c.e1;
							switch (_v2.$) {
								case 0:
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('This is a page that can handle sbpaths in its routing.')
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (_v3) {
													var x = _v3.a;
													return $elm$html$Html$text(x);
												},
												$elm$core$Dict$toList(model.hB.u.c6))),
											$author$project$Page$Admin$viewTables(model)
										]);
								case 1:
									var kind = _v2.a;
									var id = _v2.b;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Querying ' + A2($elm$core$Maybe$withDefault, '', id))
												])),
											A3(
											$author$project$Page$Admin$toTable,
											A3($author$project$Page$Admin$filterKeys, id, kind, model.hB.u),
											kind,
											model.hB.u)
										]);
								default:
									var kind = _v2.a;
									var id = _v2.b;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											A3($author$project$Page$Admin$edit, model.hB.u, kind, id)),
											A2(
											$elm$core$Maybe$withDefault,
											A2($elm$html$Html$div, _List_Nil, _List_Nil),
											A2(
												$elm$core$Maybe$map,
												function (x) {
													return A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Error: ' + x)
															]));
												},
												model.c.b3))
										]);
							}
						}())
					]);
			},
			hz: function () {
				var _v4 = model.c.e1;
				if (_v4.$ === 1) {
					var id = _v4.b;
					return $elm$core$Maybe$Just(
						A2($elm$core$Maybe$withDefault, '', id));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			h5: $author$project$Page$Admin$toTitle(model.c)
		});
};
var $author$project$Page$Admin$page = F2(
	function (session, table) {
		var model = {
			c: $author$project$Page$Admin$init(table),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $elm$core$Basics$identity,
			ih: $author$project$Page$Admin$update,
			ik: $author$project$Page$Admin$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Answer$update = F2(
	function (message, _v0) {
		var model = _v0;
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Left = 0;
var $mdgriffith$elm_ui$Element$alignLeft = $mdgriffith$elm_ui$Internal$Model$AlignX(0);
var $mdgriffith$elm_ui$Internal$Model$Right = 2;
var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
var $mdgriffith$elm_ui$Internal$Style$classes = {fl: 'a', fp: 'atv', fs: 'ab', ft: 'cx', fu: 'cy', fv: 'acb', fw: 'accx', fx: 'accy', fy: 'acr', di: 'al', dj: 'ar', fz: 'at', bI: 'ah', bJ: 'av', fB: 's', fG: 'bh', fH: 'b', fJ: 'w7', fL: 'bd', fM: 'bdt', aV: 'bn', fN: 'bs', aW: 'cpe', fY: 'cp', fZ: 'cpx', f_: 'cpy', O: 'c', a1: 'ctr', a2: 'cb', a3: 'ccx', P: 'ccy', aB: 'cl', a4: 'cr', f6: 'ct', f9: 'cptr', ga: 'ctxt', gs: 'fcs', dR: 'focus-within', gu: 'fs', gw: 'g', cb: 'hbh', cc: 'hc', dX: 'he', cd: 'hf', dY: 'hfp', gz: 'hv', gC: 'ic', gE: 'fr', bc: 'lbl', gH: 'iml', gI: 'imlf', gJ: 'imlp', gK: 'implw', gL: 'it', gO: 'i', eg: 'lnk', au: 'nb', ep: 'notxt', hb: 'ol', hd: 'or', ag: 'oq', hj: 'oh', c: 'pg', ew: 'p', hk: 'ppe', ht: 'ui', eM: 'r', hv: 'sb', hw: 'sbx', hx: 'sby', hy: 'sbt', hD: 'e', hE: 'cap', hF: 'sev', hJ: 'sk', hQ: 't', hR: 'tc', hS: 'w8', hT: 'w2', hU: 'w9', hV: 'tj', by: 'tja', hW: 'tl', hX: 'w3', hY: 'w5', hZ: 'w4', h_: 'tr', h$: 'w6', h0: 'w1', h1: 'tun', e9: 'ts', al: 'clr', ig: 'u', c9: 'wc', ff: 'we', da: 'wf', fg: 'wfp', de: 'wrp'};
var $mdgriffith$elm_ui$Internal$Model$Generic = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.O);
var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gw);
var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.c);
var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ew);
var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.eM);
var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hD);
var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Model$rowClass;
		case 1:
			return $mdgriffith$elm_ui$Internal$Model$columnClass;
		case 2:
			return $mdgriffith$elm_ui$Internal$Model$singleClass;
		case 3:
			return $mdgriffith$elm_ui$Internal$Model$gridClass;
		case 4:
			return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
		default:
			return $mdgriffith$elm_ui$Internal$Model$pageClass;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addChildren = F2(
	function (existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(behind, existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(existing, inFront);
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					behind,
					_Utils_ap(existing, inFront));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3(
	function (key, existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(
					existing,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						inFront));
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					_Utils_ap(
						existing,
						A2(
							$elm$core$List$map,
							function (x) {
								return _Utils_Tuple2(key, x);
							},
							inFront)));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
	return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
};
var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
	switch (x.$) {
		case 0:
			var px = x.a;
			return $elm$core$String$fromInt(px) + 'px';
		case 1:
			return 'auto';
		case 2:
			var i = x.a;
			return $elm$core$String$fromInt(i) + 'fr';
		case 3:
			var min = x.a;
			var len = x.b;
			return 'min' + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
		default:
			var max = x.a;
			var len = x.b;
			return 'max' + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$Basics$round = _Basics_round;
var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(x * 255));
};
var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'mv-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			return $elm$core$Maybe$Just(
				'tfrm-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
	switch (style.$) {
		case 13:
			var name = style.a;
			return name;
		case 12:
			var name = style.a;
			var o = style.b;
			return name;
		case 0:
			var _class = style.a;
			return _class;
		case 1:
			var name = style.a;
			return name;
		case 2:
			var i = style.a;
			return 'font-size-' + $elm$core$String$fromInt(i);
		case 3:
			var _class = style.a;
			return _class;
		case 4:
			var _class = style.a;
			return _class;
		case 5:
			var cls = style.a;
			var x = style.b;
			var y = style.c;
			return cls;
		case 7:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 6:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 8:
			var template = style.a;
			return 'grid-rows-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.hu)) + ('-cols-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.dA)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.hG.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.hG.b)))))));
		case 9:
			var pos = style.a;
			return 'gp grid-pos-' + ($elm$core$String$fromInt(pos.eM) + ('-' + ($elm$core$String$fromInt(pos.dz) + ('-' + ($elm$core$String$fromInt(pos.fe) + ('-' + $elm$core$String$fromInt(pos.dW)))))));
		case 11:
			var selector = style.a;
			var subStyle = style.b;
			var name = function () {
				switch (selector) {
					case 0:
						return 'fs';
					case 1:
						return 'hv';
					default:
						return 'act';
				}
			}();
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (sty) {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
						if (_v1 === '') {
							return '';
						} else {
							var styleName = _v1;
							return styleName + ('-' + name);
						}
					},
					subStyle));
		default:
			var x = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$mdgriffith$elm_ui$Internal$Model$transformClass(x));
	}
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2(
	function (style, nevermind) {
		var cache = nevermind.a;
		var existing = nevermind.b;
		var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
		return A2($elm$core$Set$member, styleName, cache) ? nevermind : _Utils_Tuple2(
			A2($elm$core$Set$insert, styleName, cache),
			A2($elm$core$List$cons, style, existing));
	});
var $mdgriffith$elm_ui$Internal$Model$Property = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Style = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
	return '.' + c;
};
var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(red * 255)) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(green * 255))) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(blue * 255))) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))));
};
var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					shadow.cl ? $elm$core$Maybe$Just('inset') : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.b.a) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.b.b) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.ao) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.B) + 'px'),
					$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Internal$Model$formatColor(shadow.bV))
				])));
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dR) + ':focus-within',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.fK),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.fD),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										ao: shadow.ao,
										bV: shadow.bV,
										cl: false,
										b: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.b)),
										B: shadow.B
									}));
						},
						focus.hC),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					]))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + ':focus .focusable, ') + (($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + '.focusable:focus, ') + ('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + ' .focusable-thumb'))),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.fK),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.fD),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										ao: shadow.ao,
										bV: shadow.bV,
										cl: false,
										b: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.b)),
										B: shadow.B
									}));
						},
						focus.hC),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					])))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$AllChildren = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Style$Child = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Class = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Descriptor = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Left = 3;
var $mdgriffith$elm_ui$Internal$Style$Prop = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Right = 2;
var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Supports = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
var $mdgriffith$elm_ui$Internal$Style$Top = 0;
var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f6);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a2);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a4);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aB);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a3);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.P);
	}
};
var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fz);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fs);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dj);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.di);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ft);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fu);
	}
};
var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
	var createDescription = function (alignment) {
		var _v0 = values(alignment);
		var content = _v0.a;
		var indiv = _v0.b;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$contentName(alignment),
				content),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						indiv)
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray(
	[
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cb),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fG),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hy),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hQ),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.da),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'auto !important')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cc),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.da),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fg),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c9),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
			])),
		$mdgriffith$elm_ui$Internal$Style$describeAlignment(
		function (alignment) {
			switch (alignment) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
							]));
				case 1:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
							]));
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
							]));
				case 3:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							]));
				case 4:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
							]));
				default:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
									]))
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
							]));
			}
		})
	]);
var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
	var createDescription = function (alignment) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						values(alignment))
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$Above = 0;
var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
var $mdgriffith$elm_ui$Internal$Style$Below = 1;
var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
var $mdgriffith$elm_ui$Internal$Style$Within = 4;
var $mdgriffith$elm_ui$Internal$Style$locations = function () {
	var loc = 0;
	var _v0 = function () {
		switch (loc) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 0;
			case 3:
				return 0;
			case 4:
				return 0;
			default:
				return 0;
		}
	}();
	return _List_fromArray(
		[0, 1, 2, 3, 4, 5]);
}();
var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		'html,body',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		_Utils_ap(
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
			_Utils_ap(
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hD),
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gC))),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-height', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.da),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + ':focus',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'outline', 'none')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ht),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gE),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.au),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.au),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hD),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				$mdgriffith$elm_ui$Internal$Style$Batch(
				function (fn) {
					return A2($elm$core$List$map, fn, $mdgriffith$elm_ui$Internal$Style$locations);
				}(
					function (loc) {
						switch (loc) {
							case 0:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fl),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.da),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
												])),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fH),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												]))
										]));
							case 2:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hd),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hb),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'right', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 4:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gE),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							default:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fG),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
						}
					}))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'resize', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'box-sizing', 'border-box'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-size', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-family', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'inherit'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.de),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-wrap', 'wrap')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ep),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-moz-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-webkit-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-ms-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'user-select', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'pointer')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ga),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hk),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aW),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.al),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ag),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gz, $mdgriffith$elm_ui$Internal$Style$classes.al)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gz, $mdgriffith$elm_ui$Internal$Style$classes.ag)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gs, $mdgriffith$elm_ui$Internal$Style$classes.al)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.gs, $mdgriffith$elm_ui$Internal$Style$classes.ag)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.fp, $mdgriffith$elm_ui$Internal$Style$classes.al)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.fp, $mdgriffith$elm_ui$Internal$Style$classes.ag)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.e9),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Prop,
						'transition',
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (x) {
									return x + ' 160ms';
								},
								_List_fromArray(
									['transform', 'opacity', 'filter', 'background-color', 'color', 'font-size']))))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hw),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hx),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.O),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fY),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fZ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.f_),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', 'auto')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aV),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fL),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dashed')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fM),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dotted')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fN),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hQ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gL),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1.05'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background', 'transparent'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'inherit')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hD),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0%'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ff),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eg),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dY),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.da),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a1),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fy,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fw,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ft),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-left', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fw,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ft),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-right', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fw,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fu),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fw + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fy + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.fw)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_Nil);
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_Nil);
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hF),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bc),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'baseline')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.O),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0px'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', 'min-content'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dX),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.da),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fg),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c9),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fv,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fx,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fu),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fx,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fu),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.fx,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fu),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fx + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.fv + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.fx)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a1),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hF),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gw),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', '-ms-grid'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'.gp',
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Supports,
						_Utils_Tuple2('display', 'grid'),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$gridAlignments(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
										]);
								case 1:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
										]);
								case 2:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
										]);
								case 3:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
										]);
								case 4:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
										]);
								default:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
										]);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.c),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB + ':first-child'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.fB + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.fB))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.fB + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.fB))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gH),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background-color', 'transparent')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gK),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gJ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gI),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'transparent')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ew),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-wrap', 'break-word'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cb),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fG),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ew),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::after',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::before',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hD),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ff),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gE),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fG),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fl),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hd),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hb),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hQ),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.O),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-flex')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gw),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left')
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.hidden',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h0),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '100')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hT),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '200')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '300')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hZ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '400')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hY),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '500')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h$),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '600')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fJ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '700')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hS),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '800')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hU),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '900')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gO),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'italic')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ig),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ig),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hJ)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h1),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'normal')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hV),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.by),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify-all')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hR),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'center')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.h_),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'right')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hW),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'left')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.modal',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none')
					]))
			]))
	]);
var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + _var,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\"'))
				])),
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + (_var + '-off'),
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\" 0'))
				]))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.border-' + $elm$core$String$fromInt(x),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'border-width',
							$elm$core$String$fromInt(x) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 6)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 8, 32)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.p-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'padding',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 24)),
			_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'small-caps')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp-off',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'normal')
					]))
			]),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('zero'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('onum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('liga'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('dlig'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('ordn'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('tnum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('afrc'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('frac')
		]));
var $mdgriffith$elm_ui$Internal$Style$explainer = '\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .' + ($mdgriffith$elm_ui$Internal$Style$classes.fB + (' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .' + ($mdgriffith$elm_ui$Internal$Style$classes.fB + ' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n')));
var $mdgriffith$elm_ui$Internal$Style$inputTextReset = '\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$sliderReset = '\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$thumbReset = '\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n';
var $mdgriffith$elm_ui$Internal$Style$trackReset = '\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$overrides = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + (' { flex-basis: auto !important; } ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eM) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.a1) + (' { flex-basis: auto !important; }}' + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2(
	function (selector, closing) {
		return {aY: closing, o: _List_Nil, U: _List_Nil, K: selector};
	});
var $mdgriffith$elm_ui$Internal$Style$renderRules = F2(
	function (_v0, rulesToRender) {
		var parent = _v0;
		var generateIntermediates = F2(
			function (rule, rendered) {
				switch (rule.$) {
					case 0:
						var name = rule.a;
						var val = rule.b;
						return _Utils_update(
							rendered,
							{
								U: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(name, val),
									rendered.U)
							});
					case 3:
						var _v2 = rule.a;
						var prop = _v2.a;
						var value = _v2.b;
						var props = rule.b;
						return _Utils_update(
							rendered,
							{
								o: A2(
									$elm$core$List$cons,
									{aY: '\n}', o: _List_Nil, U: props, K: '@supports (' + (prop + (':' + (value + (') {' + parent.K))))},
									rendered.o)
							});
					case 5:
						var selector = rule.a;
						var adjRules = rule.b;
						return _Utils_update(
							rendered,
							{
								o: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.K + (' + ' + selector), ''),
										adjRules),
									rendered.o)
							});
					case 1:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								o: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.K + (' > ' + child), ''),
										childRules),
									rendered.o)
							});
					case 2:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								o: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.K + (' ' + child), ''),
										childRules),
									rendered.o)
							});
					case 4:
						var descriptor = rule.a;
						var descriptorRules = rule.b;
						return _Utils_update(
							rendered,
							{
								o: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2(
											$mdgriffith$elm_ui$Internal$Style$emptyIntermediate,
											_Utils_ap(parent.K, descriptor),
											''),
										descriptorRules),
									rendered.o)
							});
					default:
						var batched = rule.a;
						return _Utils_update(
							rendered,
							{
								o: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.K, ''),
										batched),
									rendered.o)
							});
				}
			});
		return A3($elm$core$List$foldr, generateIntermediates, parent, rulesToRender);
	});
var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
	var renderValues = function (values) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return x + (':' + (y + ';'));
				},
				values));
	};
	var renderClass = function (rule) {
		var _v2 = rule.U;
		if (!_v2.b) {
			return '';
		} else {
			return rule.K + ('{' + (renderValues(rule.U) + (rule.aY + '}')));
		}
	};
	var renderIntermediate = function (_v0) {
		var rule = _v0;
		return _Utils_ap(
			renderClass(rule),
			$elm$core$String$concat(
				A2($elm$core$List$map, renderIntermediate, rule.o)));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			renderIntermediate,
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v1, existing) {
						var name = _v1.a;
						var styleRules = _v1.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$mdgriffith$elm_ui$Internal$Style$renderRules,
								A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, name, ''),
								styleRules),
							existing);
					}),
				_List_Nil,
				styleClasses)));
};
var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap(
	$mdgriffith$elm_ui$Internal$Style$overrides,
	$mdgriffith$elm_ui$Internal$Style$renderCompact(
		_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
	var _v0 = opts.gU;
	switch (_v0) {
		case 0:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$virtual_dom$VirtualDom$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
							]))
					]));
		case 1:
			return $elm$virtual_dom$VirtualDom$text('');
		default:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'elm-ui-static-rules',
				_List_fromArray(
					[
						A2(
						$elm$virtual_dom$VirtualDom$property,
						'rules',
						$elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
					]),
				_List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
	switch (font.$) {
		case 0:
			return 'serif';
		case 1:
			return 'sans-serif';
		case 2:
			return 'monospace';
		case 3:
			var name = font.a;
			return '\"' + (name + '\"');
		case 4:
			var name = font.a;
			var url = font.b;
			return '\"' + (name + '\"');
		default:
			var name = font.a.af;
			return '\"' + (name + '\"');
	}
};
var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return name === 'smcp';
		case 1:
			var name = _var.a;
			return false;
		default:
			var name = _var.a;
			var index = _var.b;
			return (name === 'smcp') && (index === 1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.fc);
	} else {
		return false;
	}
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $mdgriffith$elm_ui$Internal$Model$renderProps = F3(
	function (force, _v0, existing) {
		var key = _v0.a;
		var val = _v0.b;
		return force ? (existing + ('\n  ' + (key + (': ' + (val + ' !important;'))))) : (existing + ('\n  ' + (key + (': ' + (val + ';')))));
	});
var $mdgriffith$elm_ui$Internal$Model$renderStyle = F4(
	function (options, maybePseudo, selector, props) {
		if (maybePseudo.$ === 1) {
			return _List_fromArray(
				[
					selector + ('{' + (A3(
					$elm$core$List$foldl,
					$mdgriffith$elm_ui$Internal$Model$renderProps(false),
					'',
					props) + '\n}'))
				]);
		} else {
			var pseudo = maybePseudo.a;
			switch (pseudo) {
				case 1:
					var _v2 = options.gz;
					switch (_v2) {
						case 0:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									selector + ('-hv {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(true),
									'',
									props) + '\n}'))
								]);
						default:
							return _List_fromArray(
								[
									selector + ('-hv:hover {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(false),
									'',
									props) + '\n}'))
								]);
					}
				case 0:
					var renderedProps = A3(
						$elm$core$List$foldl,
						$mdgriffith$elm_ui$Internal$Model$renderProps(false),
						'',
						props);
					return _List_fromArray(
						[
							selector + ('-fs:focus {' + (renderedProps + '\n}')),
							('.' + ($mdgriffith$elm_ui$Internal$Style$classes.fB + (':focus ' + (selector + '-fs  {')))) + (renderedProps + '\n}'),
							(selector + '-fs:focus-within {') + (renderedProps + '\n}'),
							('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fB) + (' .focusable-thumb' + (selector + '-fs {')))) + (renderedProps + '\n}')
						]);
				default:
					return _List_fromArray(
						[
							selector + ('-act:active {' + (A3(
							$elm$core$List$foldl,
							$mdgriffith$elm_ui$Internal$Model$renderProps(false),
							'',
							props) + '\n}'))
						]);
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return '\"' + (name + '\"');
		case 1:
			var name = _var.a;
			return '\"' + (name + '\" 0');
		default:
			var name = _var.a;
			var index = _var.b;
			return '\"' + (name + ('\" ' + $elm$core$String$fromInt(index)));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$renderVariant, font.fc)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'translate3d(' + ($elm$core$String$fromFloat(x) + ('px, ' + ($elm$core$String$fromFloat(y) + ('px, ' + ($elm$core$String$fromFloat(z) + 'px)'))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			var translate = 'translate3d(' + ($elm$core$String$fromFloat(tx) + ('px, ' + ($elm$core$String$fromFloat(ty) + ('px, ' + ($elm$core$String$fromFloat(tz) + 'px)')))));
			var scale = 'scale3d(' + ($elm$core$String$fromFloat(sx) + (', ' + ($elm$core$String$fromFloat(sy) + (', ' + ($elm$core$String$fromFloat(sz) + ')')))));
			var rotate = 'rotate3d(' + ($elm$core$String$fromFloat(ox) + (', ' + ($elm$core$String$fromFloat(oy) + (', ' + ($elm$core$String$fromFloat(oz) + (', ' + ($elm$core$String$fromFloat(angle) + 'rad)')))))));
			return $elm$core$Maybe$Just(translate + (' ' + (scale + (' ' + rotate))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3(
	function (options, rule, maybePseudo) {
		switch (rule.$) {
			case 0:
				var selector = rule.a;
				var props = rule.b;
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, selector, props);
			case 13:
				var name = rule.a;
				var prop = rule.b;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, 'box-shadow', prop)
						]));
			case 12:
				var name = rule.a;
				var transparency = rule.b;
				var opacity = A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, 1, 1 - transparency));
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'opacity',
							$elm$core$String$fromFloat(opacity))
						]));
			case 2:
				var i = rule.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			case 1:
				var name = rule.a;
				var typefaces = rule.b;
				var features = A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
				var families = _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-family',
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'font-feature-settings', features),
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-variant',
						A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? 'small-caps' : 'normal')
					]);
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, '.' + name, families);
			case 3:
				var _class = rule.a;
				var prop = rule.b;
				var val = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, prop, val)
						]));
			case 4:
				var _class = rule.a;
				var prop = rule.b;
				var color = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							prop,
							$mdgriffith$elm_ui$Internal$Model$formatColor(color))
						]));
			case 5:
				var cls = rule.a;
				var x = rule.b;
				var y = rule.c;
				var yPx = $elm$core$String$fromInt(y) + 'px';
				var xPx = $elm$core$String$fromInt(x) + 'px';
				var single = '.' + $mdgriffith$elm_ui$Internal$Style$classes.hD;
				var row = '.' + $mdgriffith$elm_ui$Internal$Style$classes.eM;
				var wrappedRow = '.' + ($mdgriffith$elm_ui$Internal$Style$classes.de + row);
				var right = '.' + $mdgriffith$elm_ui$Internal$Style$classes.dj;
				var paragraph = '.' + $mdgriffith$elm_ui$Internal$Style$classes.ew;
				var page = '.' + $mdgriffith$elm_ui$Internal$Style$classes.c;
				var left = '.' + $mdgriffith$elm_ui$Internal$Style$classes.di;
				var halfY = $elm$core$String$fromFloat(y / 2) + 'px';
				var halfX = $elm$core$String$fromFloat(x / 2) + 'px';
				var column = '.' + $mdgriffith$elm_ui$Internal$Style$classes.O;
				var _class = '.' + cls;
				var any = '.' + $mdgriffith$elm_ui$Internal$Style$classes.fB;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (row + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (wrappedRow + (' > ' + any)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin', halfY + (' ' + halfX))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (column + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_Utils_ap(_class, paragraph),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							'textarea' + (any + _class),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)')),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'height',
									'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::after'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-top',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::before'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-bottom',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								]))
						]));
			case 7:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'padding',
							$elm$core$String$fromFloat(top) + ('px ' + ($elm$core$String$fromFloat(right) + ('px ' + ($elm$core$String$fromFloat(bottom) + ('px ' + ($elm$core$String$fromFloat(left) + 'px')))))))
						]));
			case 6:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'border-width',
							$elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px')))))))
						]));
			case 8:
				var template = rule.a;
				var toGridLengthHelper = F3(
					function (minimum, maximum, x) {
						toGridLengthHelper:
						while (true) {
							switch (x.$) {
								case 0:
									var px = x.a;
									return $elm$core$String$fromInt(px) + 'px';
								case 1:
									var _v2 = _Utils_Tuple2(minimum, maximum);
									if (_v2.a.$ === 1) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.a;
											var _v4 = _v2.b;
											return 'max-content';
										} else {
											var _v6 = _v2.a;
											var maxSize = _v2.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v2.b.$ === 1) {
											var minSize = _v2.a.a;
											var _v5 = _v2.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + 'max-content)'));
										} else {
											var minSize = _v2.a.a;
											var maxSize = _v2.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 2:
									var i = x.a;
									var _v7 = _Utils_Tuple2(minimum, maximum);
									if (_v7.a.$ === 1) {
										if (_v7.b.$ === 1) {
											var _v8 = _v7.a;
											var _v9 = _v7.b;
											return $elm$core$String$fromInt(i) + 'fr';
										} else {
											var _v11 = _v7.a;
											var maxSize = _v7.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v7.b.$ === 1) {
											var minSize = _v7.a.a;
											var _v10 = _v7.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(i) + ('fr' + 'fr)'))));
										} else {
											var minSize = _v7.a.a;
											var maxSize = _v7.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 3:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = $elm$core$Maybe$Just(m),
										$temp$maximum = maximum,
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
								default:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = minimum,
										$temp$maximum = $elm$core$Maybe$Just(m),
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
							}
						}
					});
				var toGridLength = function (x) {
					return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
				};
				var xSpacing = toGridLength(template.hG.a);
				var ySpacing = toGridLength(template.hG.b);
				var rows = function (x) {
					return 'grid-template-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.hu)));
				var msRows = function (x) {
					return '-ms-grid-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.dA)));
				var msColumns = function (x) {
					return '-ms-grid-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.dA)));
				var gapY = 'grid-row-gap:' + (toGridLength(template.hG.b) + ';');
				var gapX = 'grid-column-gap:' + (toGridLength(template.hG.a) + ';');
				var columns = function (x) {
					return 'grid-template-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.dA)));
				var _class = '.grid-rows-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.hu)) + ('-cols-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.dA)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.hG.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.hG.b)))))));
				var modernGrid = _class + ('{' + (columns + (rows + (gapX + (gapY + '}')))));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msColumns + (msRows + '}')));
				return _List_fromArray(
					[base, supports]);
			case 9:
				var position = rule.a;
				var msPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'-ms-grid-row: ' + ($elm$core$String$fromInt(position.eM) + ';'),
							'-ms-grid-row-span: ' + ($elm$core$String$fromInt(position.dW) + ';'),
							'-ms-grid-column: ' + ($elm$core$String$fromInt(position.dz) + ';'),
							'-ms-grid-column-span: ' + ($elm$core$String$fromInt(position.fe) + ';')
						]));
				var modernPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'grid-row: ' + ($elm$core$String$fromInt(position.eM) + (' / ' + ($elm$core$String$fromInt(position.eM + position.dW) + ';'))),
							'grid-column: ' + ($elm$core$String$fromInt(position.dz) + (' / ' + ($elm$core$String$fromInt(position.dz + position.fe) + ';')))
						]));
				var _class = '.grid-pos-' + ($elm$core$String$fromInt(position.eM) + ('-' + ($elm$core$String$fromInt(position.dz) + ('-' + ($elm$core$String$fromInt(position.fe) + ('-' + $elm$core$String$fromInt(position.dW)))))));
				var modernGrid = _class + ('{' + (modernPosition + '}'));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msPosition + '}'));
				return _List_fromArray(
					[base, supports]);
			case 11:
				var _class = rule.a;
				var styles = rule.b;
				var renderPseudoRule = function (style) {
					return A3(
						$mdgriffith$elm_ui$Internal$Model$renderStyleRule,
						options,
						style,
						$elm$core$Maybe$Just(_class));
				};
				return A2($elm$core$List$concatMap, renderPseudoRule, styles);
			default:
				var transform = rule.a;
				var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
				var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				var _v12 = _Utils_Tuple2(_class, val);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var cls = _v12.a.a;
					var v = _v12.b.a;
					return A4(
						$mdgriffith$elm_ui$Internal$Model$renderStyle,
						options,
						maybePseudo,
						'.' + cls,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Model$Property, 'transform', v)
							]));
				} else {
					return _List_Nil;
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2(
	function (options, stylesheet) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (style) {
					var styled = A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Internal$Model$getStyleName(style),
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, styled));
				},
				stylesheet));
	});
var $mdgriffith$elm_ui$Internal$Model$bracket = F2(
	function (selector, rules) {
		var renderPair = function (_v0) {
			var name = _v0.a;
			var val = _v0.b;
			return name + (': ' + (val + ';'));
		};
		return selector + (' {' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, renderPair, rules)) + '}'));
	});
var $mdgriffith$elm_ui$Internal$Model$fontRule = F3(
	function (name, modifier, _v0) {
		var parentAdj = _v0.a;
		var textAdjustment = _v0.b;
		return _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + (', ' + ('.' + (name + (' .' + modifier))))))), parentAdj),
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.hQ + (', .' + (name + (' .' + (modifier + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.hQ)))))))))), textAdjustment)
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3(
	function (fontToAdjust, _v0, otherFontName) {
		var full = _v0.a;
		var capital = _v0.b;
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.hE, capital),
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.gu, full)));
	});
var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2(
	function (fontToAdjust, otherFontName) {
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.hE + (', ' + ('.' + (name + (' .' + $mdgriffith$elm_ui$Internal$Style$classes.hE))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('line-height', '1')
						])),
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.hE + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.hQ + (', .' + (name + (' .' + ($mdgriffith$elm_ui$Internal$Style$classes.hE + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.hQ)))))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('vertical-align', '0'),
							_Utils_Tuple2('line-height', '1')
						]))
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$adjust = F3(
	function (size, height, vertical) {
		return {dW: height / size, B: size, ij: vertical};
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
	var lines = _List_fromArray(
		[adjustment.fU, adjustment.fE, adjustment.gc, adjustment.gR]);
	var lineHeight = 1.5;
	var normalDescender = (lineHeight - 1) / 2;
	var oldMiddle = lineHeight / 2;
	var descender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.gc,
		$elm$core$List$minimum(lines));
	var newBaseline = A2(
		$elm$core$Maybe$withDefault,
		adjustment.fE,
		$elm$core$List$minimum(
			A2(
				$elm$core$List$filter,
				function (x) {
					return !_Utils_eq(x, descender);
				},
				lines)));
	var base = lineHeight;
	var ascender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.fU,
		$elm$core$List$maximum(lines));
	var capitalSize = 1 / (ascender - newBaseline);
	var capitalVertical = 1 - ascender;
	var fullSize = 1 / (ascender - descender);
	var fullVertical = 1 - ascender;
	var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
	var newFullMiddle = ((ascender - descender) / 2) + descender;
	return {
		fU: A3($mdgriffith$elm_ui$Internal$Model$adjust, capitalSize, ascender - newBaseline, capitalVertical),
		dS: A3($mdgriffith$elm_ui$Internal$Model$adjust, fullSize, ascender - descender, fullVertical)
	};
};
var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
	return _Utils_Tuple2(
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'block')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'inline-block'),
				_Utils_Tuple2(
				'line-height',
				$elm$core$String$fromFloat(converted.dW)),
				_Utils_Tuple2(
				'vertical-align',
				$elm$core$String$fromFloat(converted.ij) + 'em'),
				_Utils_Tuple2(
				'font-size',
				$elm$core$String$fromFloat(converted.B) + 'em')
			]));
};
var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (face, found) {
				if (found.$ === 1) {
					if (face.$ === 5) {
						var _with = face.a;
						var _v2 = _with.fr;
						if (_v2.$ === 1) {
							return found;
						} else {
							var adjustment = _v2.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.dS;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))),
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.fU;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
						}
					} else {
						return found;
					}
				} else {
					return found;
				}
			}),
		$elm$core$Maybe$Nothing,
		typefaces);
};
var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
	var withImport = function (font) {
		if (font.$ === 4) {
			var url = font.b;
			return $elm$core$Maybe$Just('@import url(\'' + (url + '\');'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var fontImports = function (_v2) {
		var name = _v2.a;
		var typefaces = _v2.b;
		var imports = A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$filterMap, withImport, typefaces));
		return imports;
	};
	var allNames = A2($elm$core$List$map, $elm$core$Tuple$first, rules);
	var fontAdjustments = function (_v1) {
		var name = _v1.a;
		var typefaces = _v1.b;
		var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
		if (_v0.$ === 1) {
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name),
					allNames));
		} else {
			var adjustment = _v0.a;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment),
					allNames));
		}
	};
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontImports, rules)),
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontAdjustments, rules)));
};
var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
	if (rule.$ === 1) {
		var name = rule.a;
		var typefaces = rule.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(name, typefaces));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2(
	function (options, stylesheet) {
		var combine = F2(
			function (style, rendered) {
				return {
					bv: _Utils_ap(
						rendered.bv,
						A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing)),
					aR: function () {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
						if (_v1.$ === 1) {
							return rendered.aR;
						} else {
							var topLevel = _v1.a;
							return A2($elm$core$List$cons, topLevel, rendered.aR);
						}
					}()
				};
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			combine,
			{bv: _List_Nil, aR: _List_Nil},
			stylesheet);
		var topLevel = _v0.aR;
		var rules = _v0.bv;
		return _Utils_ap(
			$mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel),
			$elm$core$String$concat(rules));
	});
var $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2(
	function (options, styleSheet) {
		var _v0 = options.gU;
		switch (_v0) {
			case 0:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			case 1:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			default:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'elm-ui-rules',
					_List_fromArray(
						[
							A2(
							$elm$virtual_dom$VirtualDom$property,
							'rules',
							A2($mdgriffith$elm_ui$Internal$Model$encodeStyles, options, styleSheet))
						]),
					_List_Nil);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.gs)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'static-stylesheet',
				$mdgriffith$elm_ui$Internal$Model$staticRoot(opts)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
				children)) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
			children);
	});
var $mdgriffith$elm_ui$Internal$Model$embedWith = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.gs)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Internal$Model$staticRoot(opts),
			A2($elm$core$List$cons, dynamicStyleSheet, children)) : A2($elm$core$List$cons, dynamicStyleSheet, children);
	});
var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $mdgriffith$elm_ui$Internal$Flag$present = F2(
	function (myFlag, _v0) {
		var fieldOne = _v0.a;
		var fieldTwo = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return _Utils_eq(first & fieldOne, first);
		} else {
			var second = myFlag.a;
			return _Utils_eq(second & fieldTwo, second);
		}
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $elm$html$Html$u = _VirtualDom_node('u');
var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
var $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6(
	function (has, node, attributes, children, embedMode, parentContext) {
		var createNode = F2(
			function (nodeName, attrs) {
				if (children.$ === 1) {
					var keyed = children.a;
					return A3(
						$elm$virtual_dom$VirtualDom$keyedNode,
						nodeName,
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return keyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, false, opts, styles, keyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, true, opts, styles, keyed);
							}
						}());
				} else {
					var unkeyed = children.a;
					return A2(
						function () {
							switch (nodeName) {
								case 'div':
									return $elm$html$Html$div;
								case 'p':
									return $elm$html$Html$p;
								default:
									return $elm$virtual_dom$VirtualDom$node(nodeName);
							}
						}(),
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return unkeyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, false, opts, styles, unkeyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, true, opts, styles, unkeyed);
							}
						}());
				}
			});
		var html = function () {
			switch (node.$) {
				case 0:
					return A2(createNode, 'div', attributes);
				case 1:
					var nodeName = node.a;
					return A2(createNode, nodeName, attributes);
				default:
					var nodeName = node.a;
					var internal = node.b;
					return A3(
						$elm$virtual_dom$VirtualDom$node,
						nodeName,
						attributes,
						_List_fromArray(
							[
								A2(
								createNode,
								internal,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.hD))
									]))
							]));
			}
		}();
		switch (parentContext) {
			case 0:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fB, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.a1, $mdgriffith$elm_ui$Internal$Style$classes.P, $mdgriffith$elm_ui$Internal$Style$classes.fy])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerX, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fB, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.a1, $mdgriffith$elm_ui$Internal$Style$classes.P, $mdgriffith$elm_ui$Internal$Style$classes.fw])))
						]),
					_List_fromArray(
						[html])) : html));
			case 1:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerY, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fB, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.a1, $mdgriffith$elm_ui$Internal$Style$classes.fx])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.fB, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.a1, $mdgriffith$elm_ui$Internal$Style$classes.fv])))
						]),
					_List_fromArray(
						[html])) : html));
			default:
				return html;
		}
	});
var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.hQ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.c9 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.cc)))));
var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.fB + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.hQ + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.da + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.cd)))));
var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$createElement = F3(
	function (context, children, rendered) {
		var gatherKeyed = F2(
			function (_v8, _v9) {
				var key = _v8.a;
				var child = _v8.b;
				var htmls = _v9.a;
				var existingStyles = _v9.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.gA, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.e0 : _Utils_ap(styled.e0, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.gA, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.e0 : _Utils_ap(styled.e0, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		var gather = F2(
			function (child, _v6) {
				var htmls = _v6.a;
				var existingStyles = _v6.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.gA, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.e0 : _Utils_ap(styled.e0, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.gA, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.e0 : _Utils_ap(styled.e0, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		if (children.$ === 1) {
			var keyedChildren = children.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				gatherKeyed,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				keyedChildren);
			var keyed = _v1.a;
			var styles = _v1.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.e0 : _Utils_ap(rendered.e0, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered._,
						rendered.bk,
						rendered.bM,
						$mdgriffith$elm_ui$Internal$Model$Keyed(
							A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.fX)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						gA: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered._,
							rendered.bk,
							rendered.bM,
							$mdgriffith$elm_ui$Internal$Model$Keyed(
								A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.fX))),
						e0: allStyles
					});
			}
		} else {
			var unkeyedChildren = children.a;
			var _v3 = A3(
				$elm$core$List$foldr,
				gather,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				unkeyedChildren);
			var unkeyed = _v3.a;
			var styles = _v3.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.e0 : _Utils_ap(rendered.e0, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered._,
						rendered.bk,
						rendered.bM,
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.fX)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						gA: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered._,
							rendered.bk,
							rendered.bM,
							$mdgriffith$elm_ui$Internal$Model$Unkeyed(
								A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.fX))),
						e0: allStyles
					});
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Single = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $mdgriffith$elm_ui$Internal$Flag$add = F2(
	function (myFlag, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, first | one, two);
		} else {
			var second = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, one, second | two);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2(
	function (location, elem) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					function () {
						switch (location) {
							case 0:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.au, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.fl]));
							case 1:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.au, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.fH]));
							case 2:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.au, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.hd]));
							case 3:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.au, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.hb]));
							case 4:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.au, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.gE]));
							default:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.au, $mdgriffith$elm_ui$Internal$Style$classes.hD, $mdgriffith$elm_ui$Internal$Style$classes.fG]));
						}
					}())
				]),
			_List_fromArray(
				[
					function () {
					switch (elem.$) {
						case 3:
							return $elm$virtual_dom$VirtualDom$text('');
						case 2:
							var str = elem.a;
							return $mdgriffith$elm_ui$Internal$Model$textElement(str);
						case 0:
							var html = elem.a;
							return html($mdgriffith$elm_ui$Internal$Model$asEl);
						default:
							var styled = elem.a;
							return A2(styled.gA, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
					}
				}()
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3(
	function (location, elem, existing) {
		var nearby = A2($mdgriffith$elm_ui$Internal$Model$nearbyElement, location, elem);
		switch (existing.$) {
			case 0:
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						_List_fromArray(
							[nearby]));
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						_List_fromArray(
							[nearby]));
				}
			case 1:
				var existingBehind = existing.a;
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						A2($elm$core$List$cons, nearby, existingBehind));
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						_List_fromArray(
							[nearby]));
				}
			case 2:
				var existingInFront = existing.a;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						_List_fromArray(
							[nearby]),
						existingInFront);
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						A2($elm$core$List$cons, nearby, existingInFront));
				}
			default:
				var existingBehind = existing.a;
				var existingInFront = existing.b;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						A2($elm$core$List$cons, nearby, existingBehind),
						existingInFront);
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						A2($elm$core$List$cons, nearby, existingInFront));
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Embedded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addNodeName = F2(
	function (newNode, old) {
		switch (old.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
			case 1:
				var name = old.a;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, name, newNode);
			default:
				var x = old.a;
				var y = old.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, x, y);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.di);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dj);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.bI + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ft);
	}
};
var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.bJ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fz);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.bJ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fs);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.bJ + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fu);
	}
};
var $mdgriffith$elm_ui$Internal$Model$FullTransform = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2(
	function (transform, component) {
		switch (transform.$) {
			case 0:
				switch (component.$) {
					case 0:
						var x = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, 0, 0));
					case 1:
						var y = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, y, 0));
					case 2:
						var z = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, 0, z));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var xyz = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							xyz,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			case 1:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(newX, y, z));
					case 1:
						var newY = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, newY, z));
					case 2:
						var newZ = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, y, newZ));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var scale = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							scale,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			default:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				var scaled = transform.b;
				var origin = transform.c;
				var angle = transform.d;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(newX, y, z),
							scaled,
							origin,
							angle);
					case 1:
						var newY = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, newY, z),
							scaled,
							origin,
							angle);
					case 2:
						var newZ = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, y, newZ),
							scaled,
							origin,
							angle);
					case 3:
						var newMove = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, newMove, scaled, origin, angle);
					case 4:
						var newOrigin = component.a;
						var newAngle = component.b;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, scaled, newOrigin, newAngle);
					default:
						var newScale = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, newScale, origin, angle);
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
var $mdgriffith$elm_ui$Internal$Flag$merge = F2(
	function (_v0, _v1) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v1.a;
		var four = _v1.b;
		return A2($mdgriffith$elm_ui$Internal$Flag$Field, one | three, two | four);
	});
var $mdgriffith$elm_ui$Internal$Flag$none = A2($mdgriffith$elm_ui$Internal$Flag$Field, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
	switch (h.$) {
		case 0:
			var px = h.a;
			var val = $elm$core$String$fromInt(px);
			var name = 'height-px-' + val;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.dX + (' ' + name),
				_List_fromArray(
					[
						A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height', val + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.cc,
				_List_Nil);
		case 2:
			var portion = h.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.cd,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.dY + (' height-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.fB + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.O + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'height-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = h.a;
			var len = h.b;
			var cls = 'min-height-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-height',
				$elm$core$String$fromInt(minSize) + 'px !important');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = h.a;
			var len = h.b;
			var cls = 'max-height-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-height',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
	switch (w.$) {
		case 0:
			var px = w.a;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.ff + (' width-px-' + $elm$core$String$fromInt(px)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						'width-px-' + $elm$core$String$fromInt(px),
						'width',
						$elm$core$String$fromInt(px) + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.c9,
				_List_Nil);
		case 2:
			var portion = w.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.da,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.fg + (' width-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.fB + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.eM + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'width-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = w.a;
			var len = w.b;
			var cls = 'min-width-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-width',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = w.a;
			var len = w.b;
			var cls = 'max-width-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-width',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
var $mdgriffith$elm_ui$Internal$Model$skippable = F2(
	function (flag, style) {
		if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
			if (style.$ === 3) {
				var val = style.c;
				switch (val) {
					case '0px':
						return true;
					case '1px':
						return true;
					case '2px':
						return true;
					case '3px':
						return true;
					case '4px':
						return true;
					case '5px':
						return true;
					case '6px':
						return true;
					default:
						return false;
				}
			} else {
				return false;
			}
		} else {
			switch (style.$) {
				case 2:
					var i = style.a;
					return (i >= 8) && (i <= 32);
				case 7:
					var name = style.a;
					var t = style.b;
					var r = style.c;
					var b = style.d;
					var l = style.e;
					return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
				default:
					return false;
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8(
	function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
		gatherAttrRecursive:
		while (true) {
			if (!elementAttrs.b) {
				var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				if (_v1.$ === 1) {
					return {
						bM: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes),
							attrs),
						fX: children,
						_: has,
						bk: node,
						e0: styles
					};
				} else {
					var _class = _v1.a;
					return {
						bM: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes + (' ' + _class)),
							attrs),
						fX: children,
						_: has,
						bk: node,
						e0: A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$Transform(transform),
							styles)
					};
				}
			} else {
				var attribute = elementAttrs.a;
				var remaining = elementAttrs.b;
				switch (attribute.$) {
					case 0:
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 3:
						var flag = attribute.a;
						var exactClassName = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = exactClassName + (' ' + classes),
								$temp$node = node,
								$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					case 1:
						var actualAttribute = attribute.a;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = A2($elm$core$List$cons, actualAttribute, attrs),
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 4:
						var flag = attribute.a;
						var style = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							if (A2($mdgriffith$elm_ui$Internal$Model$skippable, flag, style)) {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							} else {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = A2($elm$core$List$cons, style, styles),
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							}
						}
					case 10:
						var flag = attribute.a;
						var component = attribute.b;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
							$temp$transform = A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, transform, component),
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 7:
						var width = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$width, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (width.$) {
								case 0:
									var px = width.a;
									var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.ff + (' width-px-' + $elm$core$String$fromInt(px))) + (' ' + classes),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3(
											$mdgriffith$elm_ui$Internal$Model$Single,
											'width-px-' + $elm$core$String$fromInt(px),
											'width',
											$elm$core$String$fromInt(px) + 'px'),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.c9),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$widthContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = width.a;
									if (portion === 1) {
										var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.da),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.fg + (' width-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.fB + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.eM + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'width-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
									var addToFlags = _v4.a;
									var newClass = _v4.b;
									var newStyles = _v4.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 8:
						var height = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$height, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (height.$) {
								case 0:
									var px = height.a;
									var val = $elm$core$String$fromInt(px) + 'px';
									var name = 'height-px-' + val;
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.dX + (' ' + (name + (' ' + classes))),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height ', val),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.cc + (' ' + classes),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$heightContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = height.a;
									if (portion === 1) {
										var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.cd + (' ' + classes),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.dY + (' height-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.fB + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.O + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'height-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
									var addToFlags = _v6.a;
									var newClass = _v6.b;
									var newStyles = _v6.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 2:
						var description = attribute.a;
						switch (description.$) {
							case 0:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'main', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 1:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'nav', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 2:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'footer', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 3:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'aside', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 4:
								var i = description.a;
								if (i <= 1) {
									var $temp$classes = classes,
										$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h1', node),
										$temp$has = has,
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								} else {
									if (i < 7) {
										var $temp$classes = classes,
											$temp$node = A2(
											$mdgriffith$elm_ui$Internal$Model$addNodeName,
											'h' + $elm$core$String$fromInt(i),
											node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes,
											$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h6', node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								}
							case 9:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 8:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'role', 'button'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 5:
								var label = description.a;
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-label', label),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 6:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'polite'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							default:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'assertive'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
						}
					case 9:
						var location = attribute.a;
						var elem = attribute.b;
						var newStyles = function () {
							switch (elem.$) {
								case 3:
									return styles;
								case 2:
									var str = elem.a;
									return styles;
								case 0:
									var html = elem.a;
									return styles;
								default:
									var styled = elem.a;
									return _Utils_ap(styles, styled.e0);
							}
						}();
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = newStyles,
							$temp$attrs = attrs,
							$temp$children = A3($mdgriffith$elm_ui$Internal$Model$addNearbyElement, location, elem, children),
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 6:
						var x = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (x) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerX, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					default:
						var y = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (y) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerY, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
				}
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Untransformed = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
var $mdgriffith$elm_ui$Internal$Model$element = F4(
	function (context, node, attributes, children) {
		return A3(
			$mdgriffith$elm_ui$Internal$Model$createElement,
			context,
			children,
			A8(
				$mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive,
				$mdgriffith$elm_ui$Internal$Model$contextClasses(context),
				node,
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Model$untransformed,
				_List_Nil,
				_List_Nil,
				$mdgriffith$elm_ui$Internal$Model$NoNearbyChildren,
				$elm$core$List$reverse(attributes)));
	});
var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		$elm$html$Html$Attributes$class(cls));
};
var $mdgriffith$elm_ui$Internal$Model$Content = {$: 1};
var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
var $mdgriffith$elm_ui$Element$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.f6 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.aB)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Page$Answer$demoContent = _List_fromArray(
	[
		$elm$html$Html$Attributes$id('demo-content'),
		A2($elm$html$Html$Attributes$style, 'height', '100%'),
		A2($elm$html$Html$Attributes$style, '-webkit-box-sizing', 'border-box'),
		A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
		A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
		A2($elm$html$Html$Attributes$style, 'padding-left', '16px'),
		A2($elm$html$Html$Attributes$style, 'padding-right', '16px'),
		A2($elm$html$Html$Attributes$style, 'padding-bottom', '100px'),
		A2($elm$html$Html$Attributes$style, 'width', '100%'),
		A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
		A2($elm$html$Html$Attributes$style, 'display', '-ms-flexbox'),
		A2($elm$html$Html$Attributes$style, 'display', 'flex'),
		A2($elm$html$Html$Attributes$style, '-ms-flex-direction', 'column'),
		A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
		A2($elm$html$Html$Attributes$style, '-ms-flex-align', 'center'),
		A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
		A2($elm$html$Html$Attributes$style, '-ms-flex-pack', 'start'),
		A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-start')
	]);
var $mdgriffith$elm_ui$Element$el = F2(
	function (attrs, child) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[child])));
	});
var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
var $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Unstyled, $elm$core$Basics$always);
var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
var $mdgriffith$elm_ui$Internal$Model$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
	fD: $elm$core$Maybe$Nothing,
	fK: $elm$core$Maybe$Nothing,
	hC: $elm$core$Maybe$Just(
		{
			ao: 0,
			bV: A4($mdgriffith$elm_ui$Internal$Model$Rgba, 155 / 255, 203 / 255, 1, 1),
			b: _Utils_Tuple2(0, 0),
			B: 3
		})
};
var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
	var combine = F2(
		function (opt, record) {
			switch (opt.$) {
				case 0:
					var hoverable = opt.a;
					var _v4 = record.gz;
					if (_v4.$ === 1) {
						return _Utils_update(
							record,
							{
								gz: $elm$core$Maybe$Just(hoverable)
							});
					} else {
						return record;
					}
				case 1:
					var focusStyle = opt.a;
					var _v5 = record.gs;
					if (_v5.$ === 1) {
						return _Utils_update(
							record,
							{
								gs: $elm$core$Maybe$Just(focusStyle)
							});
					} else {
						return record;
					}
				default:
					var renderMode = opt.a;
					var _v6 = record.gU;
					if (_v6.$ === 1) {
						return _Utils_update(
							record,
							{
								gU: $elm$core$Maybe$Just(renderMode)
							});
					} else {
						return record;
					}
			}
		});
	var andFinally = function (record) {
		return {
			gs: function () {
				var _v0 = record.gs;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
				} else {
					var focusable = _v0.a;
					return focusable;
				}
			}(),
			gz: function () {
				var _v1 = record.gz;
				if (_v1.$ === 1) {
					return 1;
				} else {
					var hoverable = _v1.a;
					return hoverable;
				}
			}(),
			gU: function () {
				var _v2 = record.gU;
				if (_v2.$ === 1) {
					return 0;
				} else {
					var actualMode = _v2.a;
					return actualMode;
				}
			}()
		};
	};
	return andFinally(
		A3(
			$elm$core$List$foldr,
			combine,
			{gs: $elm$core$Maybe$Nothing, gz: $elm$core$Maybe$Nothing, gU: $elm$core$Maybe$Nothing},
			options));
};
var $mdgriffith$elm_ui$Internal$Model$toHtml = F2(
	function (mode, el) {
		switch (el.$) {
			case 0:
				var html = el.a;
				return html($mdgriffith$elm_ui$Internal$Model$asEl);
			case 1:
				var styles = el.a.e0;
				var html = el.a.gA;
				return A2(
					html,
					mode(styles),
					$mdgriffith$elm_ui$Internal$Model$asEl);
			case 2:
				var text = el.a;
				return $mdgriffith$elm_ui$Internal$Model$textElement(text);
			default:
				return $mdgriffith$elm_ui$Internal$Model$textElement('');
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderRoot = F3(
	function (optionList, attributes, child) {
		var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
		var embedStyle = function () {
			var _v0 = options.gU;
			if (_v0 === 1) {
				return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
			} else {
				return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Internal$Model$toHtml,
			embedStyle,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				attributes,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[child]))));
	});
var $mdgriffith$elm_ui$Internal$Model$Colored = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$FontFamily = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$SansSerif = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$StyleClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
};
var $elm$core$String$toLower = _String_toLower;
var $elm$core$String$words = _String_words;
var $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2(
	function (font, current) {
		return _Utils_ap(
			current,
			function () {
				switch (font.$) {
					case 0:
						return 'serif';
					case 1:
						return 'sans-serif';
					case 2:
						return 'monospace';
					case 3:
						var name = font.a;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					case 4:
						var name = font.a;
						var url = font.b;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					default:
						var name = font.a.af;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
				}
			}());
	});
var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
	var families = _List_fromArray(
		[
			$mdgriffith$elm_ui$Internal$Model$Typeface('Open Sans'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Helvetica'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Verdana'),
			$mdgriffith$elm_ui$Internal$Model$SansSerif
		]);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$bgColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0)),
				'background-color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1)),
				'color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontSize,
			$mdgriffith$elm_ui$Internal$Model$FontSize(20)),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontFamily,
			A2(
				$mdgriffith$elm_ui$Internal$Model$FontFamily,
				A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'font-', families),
				families))
		]);
}();
var $mdgriffith$elm_ui$Element$layoutWith = F3(
	function (_v0, attrs, child) {
		var options = _v0.hi;
		return A3(
			$mdgriffith$elm_ui$Internal$Model$renderRoot,
			options,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[$mdgriffith$elm_ui$Internal$Style$classes.ht, $mdgriffith$elm_ui$Internal$Style$classes.fB, $mdgriffith$elm_ui$Internal$Style$classes.hD]))),
				_Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)),
			child);
	});
var $mdgriffith$elm_ui$Element$layout = $mdgriffith$elm_ui$Element$layoutWith(
	{hi: _List_Nil});
var $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5(
	function (a, b, c, d, e) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
var $mdgriffith$elm_ui$Element$padding = function (x) {
	var f = x;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$padding,
		A5(
			$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
			'p-' + $elm$core$String$fromInt(x),
			f,
			f,
			f,
			f));
};
var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
var $aforemny$material_components_web_elm$Material$Button$Raised = 1;
var $aforemny$material_components_web_elm$Material$Button$raised = F2(
	function (config_, label) {
		return A3($aforemny$material_components_web_elm$Material$Button$button, 1, config_, label);
	});
var $author$project$Msg$Access = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Msg$CreateRandom = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Msg$Update = function (a) {
	return {$: 2, a: a};
};
var $author$project$Type$Database$TypeMatching$setField = function (_v0) {
	var kind = _v0.d9;
	var attribute = _v0.dk;
	var setter = _v0.eV;
	var id = _v0.S;
	var value = _v0.fb;
	return $author$project$Msg$CRUD(
		$author$project$Msg$Update(
			A2(
				$author$project$Type$IO$Setter$AttributeMsg,
				$author$project$Type$Database$TypeMatching$toStringPlural(kind),
				A2(
					$author$project$Type$IO$Setter$DictKeyMsg,
					$author$project$Type$IO$Internal$unbox(id),
					A2(
						$author$project$Type$IO$Setter$AttributeMsg,
						'value',
						A2(
							$author$project$Type$IO$Setter$AttributeMsg,
							attribute,
							setter(value)))))));
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Page$Answer$relatedData = F2(
	function (db, model) {
		var questions = A2(
			$elm$core$List$map,
			function (_v17) {
				var id = _v17.a;
				var val = _v17.b;
				return _Utils_Tuple2(
					$author$project$Type$IO$Internal$box(id),
					val.fb);
			},
			A2(
				$elm$core$List$sortBy,
				function (_v16) {
					var val = _v16.b;
					return val.fb.gF;
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (_v15, val) {
								return A2(
									$elm$core$Dict$member,
									$author$project$Type$IO$Internal$unbox(val.fb.d4),
									db.d5);
							}),
						A2(
							$elm$core$Dict$filter,
							F2(
								function (_v14, val) {
									return _Utils_eq(
										val.fb.eI,
										$author$project$Type$IO$Internal$box(model.eI));
								}),
							db.hp)))));
		var qids = A2(
			$elm$core$List$map,
			function (_v13) {
				var x = _v13.a;
				return x;
			},
			questions);
		var getMsg = F2(
			function (id, answer) {
				if (!answer.$) {
					var _v12 = answer.a;
					var aid = _v12.a;
					return $elm$core$Maybe$Just(
						$author$project$Msg$CRUD(
							A2(
								$author$project$Msg$Access,
								$author$project$Type$Database$AnswerType,
								$author$project$Type$IO$Internal$unbox(aid))));
				} else {
					return A2(
						$elm$core$Maybe$map,
						function (qid) {
							return $author$project$Msg$CRUD(
								A2(
									$author$project$Msg$CreateRandom,
									$author$project$Type$Database$AnswerType,
									_List_fromArray(
										[
											function (answerid) {
											return $author$project$Type$Database$TypeMatching$setField(
												{
													dk: 'question',
													S: $author$project$Type$IO$Internal$box(answerid),
													d9: $author$project$Type$Database$AnswerType,
													eV: $author$project$Type$IO$Setter$StringMsg,
													fb: $author$project$Type$IO$Internal$unbox(qid)
												});
										},
											function (answerid) {
											return $author$project$Type$Database$TypeMatching$setField(
												{
													dk: 'event',
													S: $author$project$Type$IO$Internal$box(answerid),
													d9: $author$project$Type$Database$AnswerType,
													eV: $author$project$Type$IO$Setter$StringMsg,
													fb: model.as
												});
										},
											function (answerid) {
											return $author$project$Type$Database$TypeMatching$setField(
												{
													dk: 'test_subject',
													S: $author$project$Type$IO$Internal$box(answerid),
													d9: $author$project$Type$Database$AnswerType,
													eV: $author$project$Type$IO$Setter$StringMsg,
													fb: model.aO
												});
										}
										])));
						},
						id);
				}
			});
		var answers = A2(
			$elm$core$List$map,
			function (_v10) {
				var a = _v10.a;
				var b = _v10.b;
				return _Utils_Tuple2(
					$author$project$Type$IO$Internal$box(a),
					b);
			},
			A2(
				$elm$core$List$sortBy,
				function (_v9) {
					var val = _v9.b;
					return val.fm;
				},
				A2(
					$elm$core$List$filterMap,
					$elm_community$list_extra$List$Extra$last,
					A2(
						$elm$core$List$map,
						$elm$core$List$sortBy(
							function (_v8) {
								var val = _v8.b;
								return val.f8;
							}),
						A2(
							$elm$core$List$map,
							$elm$core$Dict$toList,
							A2(
								$elm$core$List$map,
								$elm$core$Dict$filter(
									F2(
										function (_v7, val) {
											return _Utils_eq(
												val.fb.aO,
												$author$project$Type$IO$Internal$box(model.aO));
										})),
								A2(
									$elm$core$List$map,
									$elm$core$Dict$filter(
										F2(
											function (_v6, val) {
												return _Utils_eq(
													val.fb.as,
													$author$project$Type$IO$Internal$box(model.as));
											})),
									A2(
										$elm$core$List$map,
										function (qid) {
											return A2(
												$elm$core$Dict$filter,
												F2(
													function (_v5, val) {
														return _Utils_eq(val.fb.eH, qid);
													}),
												db.bL);
										},
										qids))))))));
		var qids_present = A2(
			$elm$core$List$map,
			function (_v4) {
				var val = _v4.b;
				return val.fb.eH;
			},
			answers);
		var qids_missing = A2(
			$elm$core$List$filter,
			function (id) {
				return !A2($elm$core$List$member, id, qids_present);
			},
			qids);
		var currentQuestion = function () {
			var _v3 = $elm_community$list_extra$List$Extra$last(qids_present);
			if (!_v3.$) {
				var qid = _v3.a;
				return $elm$core$Maybe$Just(qid);
			} else {
				return $elm$core$List$head(qids_missing);
			}
		}();
		var curID = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($elm_community$list_extra$List$Extra$elemIndex, x, qids);
			},
			currentQuestion);
		var nextID = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($elm_community$list_extra$List$Extra$getAt, x + 1, qids);
			},
			curID);
		var prevID = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($elm_community$list_extra$List$Extra$getAt, x - 1, qids);
			},
			curID);
		var answerFromId = function (id) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$map,
					function (_v2) {
						var aid = _v2.a;
						var val = _v2.b;
						return _Utils_Tuple2(aid, val.fb);
					},
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var val = _v1.b;
							return _Utils_eq(
								$elm$core$Maybe$Just(val.fb.eH),
								id);
						},
						answers)));
		};
		var currentAnswer = answerFromId(currentQuestion);
		var nextAnswer = answerFromId(nextID);
		var prevAnswer = answerFromId(prevID);
		return {
			bL: A2(
				$elm$core$List$map,
				function (_v0) {
					var id = _v0.a;
					var val = _v0.b;
					return _Utils_Tuple2(id, val.fb);
				},
				answers),
			bX: currentAnswer,
			bY: currentQuestion,
			cu: A2(getMsg, nextID, nextAnswer),
			cH: A2(getMsg, prevID, prevAnswer),
			eF: qids_missing,
			hp: questions
		};
	});
var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
var $mdgriffith$elm_ui$Element$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.aB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.P)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$text = function (content) {
	return $mdgriffith$elm_ui$Internal$Model$Text(content);
};
var $author$project$Page$Answer$toTitle = function (_v0) {
	return 'Home ⧽ Answer';
};
var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
var $mdgriffith$elm_ui$Element$Keyed$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.f6 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.aB)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Keyed(children));
	});
var $aforemny$material_components_web_elm$Material$TextArea$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$TextArea$config = {bF: _List_Nil, f3: $elm$core$Maybe$Nothing, aC: false, ba: false, ea: $elm$core$Maybe$Nothing, bh: $elm$core$Maybe$Nothing, bi: $elm$core$Maybe$Nothing, cy: $elm$core$Maybe$Nothing, cA: $elm$core$Maybe$Nothing, hm: $elm$core$Maybe$Nothing, cL: false, hu: $elm$core$Maybe$Nothing, c7: true, fb: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$TextArea$disabledCs = function (_v0) {
	var disabled = _v0.aC;
	return disabled ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--disabled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$disabledProp = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$TextArea$fullwidthCs = function (_v0) {
	var fullwidth = _v0.ba;
	return fullwidth ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--fullwidth')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$ariaLabelAttr = function (_v0) {
	var fullwidth = _v0.ba;
	var placeholder = _v0.hm;
	var label = _v0.ea;
	return fullwidth ? A2(
		$elm$core$Maybe$map,
		$elm$html$Html$Attributes$attribute('aria-label'),
		label) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$changeHandler = function (_v0) {
	var onChange = _v0.cy;
	return A2(
		$elm$core$Maybe$map,
		function (f) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, f, $elm$html$Html$Events$targetValue));
		},
		onChange);
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $aforemny$material_components_web_elm$Material$TextArea$colsAttr = function (_v0) {
	var cols = _v0.f3;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$cols, cols);
};
var $aforemny$material_components_web_elm$Material$TextArea$inputCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field__input'));
var $aforemny$material_components_web_elm$Material$TextArea$inputHandler = function (_v0) {
	var onInput = _v0.cA;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, onInput);
};
var $aforemny$material_components_web_elm$Material$TextArea$maxLengthAttr = function (_v0) {
	var maxLength = _v0.bh;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('maxLength'),
			$elm$core$String$fromInt),
		maxLength);
};
var $aforemny$material_components_web_elm$Material$TextArea$minLengthAttr = function (_v0) {
	var minLength = _v0.bi;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('minLength'),
			$elm$core$String$fromInt),
		minLength);
};
var $aforemny$material_components_web_elm$Material$TextArea$placeholderAttr = function (_v0) {
	var placeholder = _v0.hm;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$placeholder, placeholder);
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $aforemny$material_components_web_elm$Material$TextArea$rowsAttr = function (_v0) {
	var rows = _v0.hu;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$rows, rows);
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $aforemny$material_components_web_elm$Material$TextArea$inputElt = function (config_) {
	return A2(
		$elm$html$Html$textarea,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextArea$inputCs,
					$aforemny$material_components_web_elm$Material$TextArea$ariaLabelAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$rowsAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$colsAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$placeholderAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$inputHandler(config_),
					$aforemny$material_components_web_elm$Material$TextArea$changeHandler(config_),
					$aforemny$material_components_web_elm$Material$TextArea$minLengthAttr(config_),
					$aforemny$material_components_web_elm$Material$TextArea$maxLengthAttr(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$TextArea$maxLengthProp = function (_v0) {
	var maxLength = _v0.bh;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'maxLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, maxLength))));
};
var $aforemny$material_components_web_elm$Material$TextArea$minLengthProp = function (_v0) {
	var minLength = _v0.bi;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'minLength',
			$elm$json$Json$Encode$int(
				A2($elm$core$Maybe$withDefault, -1, minLength))));
};
var $aforemny$material_components_web_elm$Material$TextArea$noLabelCs = function (_v0) {
	var label = _v0.ea;
	return _Utils_eq(label, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--no-label')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineLeadingElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__leading')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextArea$labelElt = function (_v0) {
	var label = _v0.ea;
	var value = _v0.fb;
	var floatingLabelFloatAboveCs = 'mdc-floating-label--float-above';
	var floatingLabelCs = 'mdc-floating-label';
	if (!label.$) {
		var str = label.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					(A2($elm$core$Maybe$withDefault, '', value) !== '') ? $elm$html$Html$Attributes$class(floatingLabelCs + (' ' + floatingLabelFloatAboveCs)) : $elm$html$Html$Attributes$class(floatingLabelCs),
					A2(
					$elm$html$Html$Attributes$property,
					'foucClassNames',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						_List_fromArray(
							[floatingLabelFloatAboveCs])))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineNotchElt = function (config_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline__notch')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextArea$labelElt(config_)
			]));
};
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineTrailingElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-notched-outline__trailing')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$TextArea$notchedOutlineElt = function (config_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-notched-outline')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineLeadingElt,
				$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineNotchElt(config_),
				$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineTrailingElt
			]));
};
var $aforemny$material_components_web_elm$Material$TextArea$outlinedCs = function (outlined_) {
	return outlined_ ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-text-field--outlined')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TextArea$requiredProp = function (_v0) {
	var required = _v0.cL;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'required',
			$elm$json$Json$Encode$bool(required)));
};
var $aforemny$material_components_web_elm$Material$TextArea$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-text-field mdc-text-field--textarea'));
var $aforemny$material_components_web_elm$Material$TextArea$validProp = function (_v0) {
	var valid = _v0.c7;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'valid',
			$elm$json$Json$Encode$bool(valid)));
};
var $aforemny$material_components_web_elm$Material$TextArea$valueProp = function (_v0) {
	var value = _v0.fb;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$property('value'),
			$elm$json$Json$Encode$string),
		value);
};
var $aforemny$material_components_web_elm$Material$TextArea$textArea = F2(
	function (outlined_, config_) {
		var additionalAttributes = config_.bF;
		var fullwidth = config_.ba;
		return A3(
			$elm$html$Html$node,
			'mdc-text-field',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TextArea$rootCs,
							$aforemny$material_components_web_elm$Material$TextArea$noLabelCs(config_),
							$aforemny$material_components_web_elm$Material$TextArea$outlinedCs(outlined_),
							$aforemny$material_components_web_elm$Material$TextArea$fullwidthCs(config_),
							$aforemny$material_components_web_elm$Material$TextArea$disabledCs(config_),
							$aforemny$material_components_web_elm$Material$TextArea$valueProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$disabledProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$requiredProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$validProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$minLengthProp(config_),
							$aforemny$material_components_web_elm$Material$TextArea$maxLengthProp(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TextArea$inputElt(config_),
					$aforemny$material_components_web_elm$Material$TextArea$notchedOutlineElt(config_)
				]));
	});
var $aforemny$material_components_web_elm$Material$TextArea$filled = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$TextArea$textArea, false, config_);
};
var $mdgriffith$elm_ui$Internal$Model$Empty = {$: 3};
var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Paragraph = {$: 9};
var $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
var $mdgriffith$elm_ui$Internal$Model$spacingName = F2(
	function (x, y) {
		return 'spacing-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y)));
	});
var $mdgriffith$elm_ui$Element$spacing = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$spacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
			A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, x),
			x,
			x));
};
var $mdgriffith$elm_ui$Element$paragraph = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asParagraph,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$spacing(5),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Keyed$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.aB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.P)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Keyed(children));
	});
var $aforemny$material_components_web_elm$Material$TextArea$setCols = F2(
	function (cols, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{f3: cols});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setLabel = F2(
	function (label, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{ea: label});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setOnInput = F2(
	function (onInput, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cA: $elm$core$Maybe$Just(onInput)
			});
	});
var $aforemny$material_components_web_elm$Material$TextField$setPlaceholder = F2(
	function (placeholder, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hm: placeholder});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setRows = F2(
	function (rows, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hu: rows});
	});
var $aforemny$material_components_web_elm$Material$TextArea$setValue = F2(
	function (value, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fb: value});
	});
var $mdgriffith$elm_ui$Element$Font$size = function (i) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontSize,
		$mdgriffith$elm_ui$Internal$Model$FontSize(i));
};
var $author$project$Page$Answer$viewQuestion = F5(
	function (db, qid, question, mbAnswer, model) {
		var mbvalue = A2(
			$elm$core$Maybe$map,
			function (_v3) {
				var val = _v3.b;
				return val.fb;
			},
			mbAnswer);
		var mbit = A2(
			$elm$core$Maybe$map,
			function (x) {
				return x.fb;
			},
			A2(
				$elm$core$Dict$get,
				$author$project$Type$IO$Internal$unbox(question.d4),
				db.d5));
		var mbid = A2(
			$elm$core$Maybe$map,
			function (_v2) {
				var id = _v2.a;
				return id;
			},
			mbAnswer);
		var tonInput = function () {
			if (!mbid.$) {
				var answer_id = mbid.a;
				return function (x) {
					return $author$project$Type$Database$TypeMatching$setField(
						{dk: 'value', S: answer_id, d9: $author$project$Type$Database$AnswerType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
				};
			} else {
				return function (x) {
					return $author$project$Msg$CRUD(
						A2(
							$author$project$Msg$CreateRandom,
							$author$project$Type$Database$AnswerType,
							_List_fromArray(
								[
									function (answerid) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'question',
											S: $author$project$Type$IO$Internal$box(answerid),
											d9: $author$project$Type$Database$AnswerType,
											eV: $author$project$Type$IO$Setter$StringMsg,
											fb: $author$project$Type$IO$Internal$unbox(qid)
										});
								},
									function (answerid) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'event',
											S: $author$project$Type$IO$Internal$box(answerid),
											d9: $author$project$Type$Database$AnswerType,
											eV: $author$project$Type$IO$Setter$StringMsg,
											fb: model.as
										});
								},
									function (answerid) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'test_subject',
											S: $author$project$Type$IO$Internal$box(answerid),
											d9: $author$project$Type$Database$AnswerType,
											eV: $author$project$Type$IO$Setter$StringMsg,
											fb: model.aO
										});
								},
									function (answerid) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'value',
											S: $author$project$Type$IO$Internal$box(answerid),
											d9: $author$project$Type$Database$AnswerType,
											eV: $author$project$Type$IO$Setter$StringMsg,
											fb: x
										});
								}
								])));
				};
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$Keyed$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$padding(32)
								]),
							A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$size(32)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(question.hQ)
									]))))),
					_Utils_Tuple2(
					'edit',
					A2(
						$mdgriffith$elm_ui$Element$Keyed$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'padleft',
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$none)),
								_Utils_Tuple2(
								$author$project$Type$IO$Internal$unbox(qid),
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
										]),
									A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$centerY,
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
											]),
										function () {
											if (mbit.$ === 1) {
												return $mdgriffith$elm_ui$Element$html(
													$elm$html$Html$text('Undefined input type'));
											} else {
												switch (mbit.a.$) {
													case 0:
														var s = mbit.a.a;
														return $mdgriffith$elm_ui$Element$html(
															$aforemny$material_components_web_elm$Material$TextField$filled(
																A2(
																	$aforemny$material_components_web_elm$Material$TextField$setOnInput,
																	tonInput,
																	A2(
																		$aforemny$material_components_web_elm$Material$TextField$setPlaceholder,
																		s.hm,
																		A2(
																			$aforemny$material_components_web_elm$Material$TextField$setValue,
																			mbvalue,
																			A2($aforemny$material_components_web_elm$Material$TextField$setLabel, s.ea, $aforemny$material_components_web_elm$Material$TextField$config))))));
													case 1:
														var l = mbit.a.a;
														return $mdgriffith$elm_ui$Element$html(
															$aforemny$material_components_web_elm$Material$TextArea$filled(
																A2(
																	$aforemny$material_components_web_elm$Material$TextArea$setCols,
																	l.f3,
																	A2(
																		$aforemny$material_components_web_elm$Material$TextArea$setRows,
																		l.hu,
																		A2(
																			$aforemny$material_components_web_elm$Material$TextArea$setOnInput,
																			tonInput,
																			A2(
																				$aforemny$material_components_web_elm$Material$TextArea$setValue,
																				mbvalue,
																				A2($aforemny$material_components_web_elm$Material$TextArea$setLabel, l.ea, $aforemny$material_components_web_elm$Material$TextArea$config)))))));
													default:
														return $mdgriffith$elm_ui$Element$text('List Answer');
												}
											}
										}()))),
								_Utils_Tuple2(
								'padright',
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$none))
							])))
				]));
	});
var $author$project$Page$Answer$view = function (_v0) {
	var model = _v0;
	var viewportHeight = model.hB.fh.dW;
	var db = model.hB.u;
	var infos = A2($author$project$Page$Answer$relatedData, db, model.c);
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				return _List_fromArray(
					[
						function () {
						var _v2 = infos.bY;
						if (!_v2.$) {
							var qid = _v2.a;
							var _v3 = A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(qid),
								$elm$core$Dict$fromList(
									A2(
										$elm$core$List$map,
										function (_v4) {
											var a = _v4.a;
											var b = _v4.b;
											return _Utils_Tuple2(
												$author$project$Type$IO$Internal$unbox(a),
												b);
										},
										infos.hp)));
							if (!_v3.$) {
								var question = _v3.a;
								return A2(
									$mdgriffith$elm_ui$Element$layout,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$height(
											$mdgriffith$elm_ui$Element$px(viewportHeight - 48)),
											$mdgriffith$elm_ui$Element$padding(24)
										]),
									A2(
										$mdgriffith$elm_ui$Element$column,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
														$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
													]),
												A5($author$project$Page$Answer$viewQuestion, db, qid, question, infos.bX, model.c)),
												A2(
												$mdgriffith$elm_ui$Element$row,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$alignBottom,
														$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
													]),
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[$mdgriffith$elm_ui$Element$alignLeft]),
														$mdgriffith$elm_ui$Element$html(
															function () {
																var _v5 = infos.cH;
																if (!_v5.$) {
																	var prev = _v5.a;
																	return A2(
																		$aforemny$material_components_web_elm$Material$Button$raised,
																		A2($aforemny$material_components_web_elm$Material$Button$setOnClick, prev, $aforemny$material_components_web_elm$Material$Button$config),
																		'Previous');
																} else {
																	return $elm$html$Html$text('');
																}
															}())),
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$centerX,
																$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
															]),
														$mdgriffith$elm_ui$Element$text('')),
														A2(
														$mdgriffith$elm_ui$Element$el,
														_List_fromArray(
															[$mdgriffith$elm_ui$Element$alignRight]),
														$mdgriffith$elm_ui$Element$html(
															function () {
																var _v6 = infos.cu;
																if (!_v6.$) {
																	var next = _v6.a;
																	return A2(
																		$aforemny$material_components_web_elm$Material$Button$raised,
																		A2($aforemny$material_components_web_elm$Material$Button$setOnClick, next, $aforemny$material_components_web_elm$Material$Button$config),
																		'Next');
																} else {
																	return $elm$html$Html$text('');
																}
															}()))
													]))
											])));
							} else {
								return $elm$html$Html$text('Question not found');
							}
						} else {
							return A2(
								$elm$html$Html$div,
								$author$project$Page$Answer$demoContent,
								_List_fromArray(
									[
										$elm$html$Html$text('Nothing to do!')
									]));
						}
					}()
					]);
			},
			h5: $author$project$Page$Answer$toTitle(model.c),
			c5: model.hB.c5
		});
};
var $author$project$Page$Answer$page = F2(
	function (session, init) {
		var model = {c: init, hB: session, e3: $elm$core$Platform$Sub$none, e6: $elm$core$Basics$identity, ih: $author$project$Page$Answer$update, ik: $author$project$Page$Answer$view};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Code$CodingAnswerTemplate = F8(
	function (answerId, answer, questionId, question, coding_questionId, coding_question, input_typeId, input_type) {
		return {E: answer, bK: answerId, dx: coding_question, bU: coding_questionId, d4: input_type, gM: input_typeId, eH: question, ho: questionId};
	});
var $author$project$Page$Code$Model = F7(
	function (id, templates, answer, current, currentEmpty, previous, next) {
		return {E: answer, dB: current, dC: currentEmpty, S: id, cu: next, cH: previous, hP: templates};
	});
var $author$project$Page$Code$init = F2(
	function (id, db) {
		var question2codingQuestionary = function (_v40) {
			var qid = _v40.a;
			var value = _v40.b;
			return A2(
				$elm$core$List$map,
				function (_v39) {
					var cid = _v39.a;
					var other = _v39.b;
					return _Utils_Tuple2(
						$author$project$Type$IO$Internal$box(cid),
						other);
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (cid, cq) {
								return _Utils_eq(cq.fb.eH, qid);
							}),
						db.f2)));
		};
		var codingQuestionary2codingQuestion = function (_v38) {
			var qid = _v38.a;
			var value = _v38.b;
			return A2(
				$elm$core$List$map,
				function (_v37) {
					var cid = _v37.a;
					var other = _v37.b;
					return _Utils_Tuple2(
						$author$project$Type$IO$Internal$box(cid),
						other);
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (cid, cq) {
								return _Utils_eq(cq.fb.f1, qid);
							}),
						db.dy)));
		};
		var codingQuestion2input_type = function (_v36) {
			var qid = _v36.a;
			var value = _v36.b;
			return A2(
				$elm$core$List$map,
				function (_v35) {
					var itid = _v35.a;
					var other = _v35.b;
					return _Utils_Tuple2(
						$author$project$Type$IO$Internal$box(itid),
						other);
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (itid, it) {
								return _Utils_eq(
									value.fb.d4,
									$author$project$Type$IO$Internal$box(itid));
							}),
						db.d5)));
		};
		var answers = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$elm$core$Dict$toList,
				A2(
					$elm$core$List$map,
					function (_v34) {
						var eid = _v34.a;
						var event = _v34.b;
						return A2(
							$elm$core$Dict$filter,
							F2(
								function (aid, answer) {
									return _Utils_eq(answer.fb.as, eid);
								}),
							db.bL);
					},
					A2(
						$elm$core$List$map,
						function (_v33) {
							var eid = _v33.a;
							var event = _v33.b;
							return _Utils_Tuple2(
								$author$project$Type$IO$Internal$box(eid),
								event);
						},
						$elm$core$Dict$toList(
							A2(
								$elm$core$Dict$filter,
								F2(
									function (eid, event) {
										return _Utils_eq(event.fb.cY, id);
									}),
								db.gm))))));
		var all_coding_answers = A2(
			$elm$core$List$map,
			function (_v31) {
				var answer = _v31.a;
				var question = _v31.b;
				var _v32 = _v31.c;
				var coding_question = _v32.a;
				var input_type = _v32.b;
				return {E: answer, dx: coding_question, d4: input_type, eH: question};
			},
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (_v29) {
						var a = _v29.a;
						var q = _v29.b;
						var _v30 = _v29.c;
						var c = _v30.a;
						var cl = _v30.b;
						return A2(
							$elm$core$List$map,
							function (cs) {
								return _Utils_Tuple3(
									a,
									q,
									_Utils_Tuple2(c, cs));
							},
							cl);
					},
					A2(
						$elm$core$List$map,
						function (_v28) {
							var a = _v28.a;
							var q = _v28.b;
							var c = _v28.c;
							return _Utils_Tuple3(
								a,
								q,
								_Utils_Tuple2(
									c,
									codingQuestion2input_type(c)));
						},
						A2(
							$elm$core$List$map,
							function (_v27) {
								var a = _v27.a;
								var b = _v27.b;
								var c = _v27.c;
								return _Utils_Tuple3(a, b, c);
							},
							$elm$core$List$concat(
								A2(
									$elm$core$List$map,
									function (_v26) {
										var answer = _v26.a;
										var question = _v26.b;
										var codingQuestions = _v26.c;
										return A2(
											$elm$core$List$map,
											function (codingQuestion) {
												return _Utils_Tuple3(answer, question, codingQuestion);
											},
											codingQuestions);
									},
									A2(
										$elm$core$List$map,
										function (_v25) {
											var answer = _v25.a;
											var question = _v25.b;
											var questionary = _v25.c;
											return _Utils_Tuple3(
												answer,
												question,
												codingQuestionary2codingQuestion(questionary));
										},
										$elm$core$List$concat(
											A2(
												$elm$core$List$map,
												function (_v24) {
													var answer = _v24.a;
													var question = _v24.b;
													var codingQuestionnaries = _v24.c;
													return A2(
														$elm$core$List$map,
														function (codingQuestionary) {
															return _Utils_Tuple3(answer, question, codingQuestionary);
														},
														codingQuestionnaries);
												},
												A2(
													$elm$core$List$map,
													function (_v23) {
														var answer = _v23.a;
														var question = _v23.b;
														return _Utils_Tuple3(
															answer,
															question,
															question2codingQuestionary(question));
													},
													A2(
														$elm$core$List$map,
														function (_v21) {
															var a = _v21.a;
															var _v22 = _v21.b;
															var b = _v22.a;
															var c = _v22.b;
															return _Utils_Tuple2(
																a,
																_Utils_Tuple2(
																	$author$project$Type$IO$Internal$box(b),
																	c));
														},
														$elm$core$List$concat(
															A2(
																$elm$core$List$map,
																function (_v20) {
																	var answer = _v20.a;
																	var questions = _v20.b;
																	return A2(
																		$elm$core$List$map,
																		function (question) {
																			return _Utils_Tuple2(answer, question);
																		},
																		questions);
																},
																A2(
																	$elm$core$List$map,
																	function (_v19) {
																		var answer = _v19.a;
																		var questiondict = _v19.b;
																		return _Utils_Tuple2(
																			answer,
																			$elm$core$Dict$toList(questiondict));
																	},
																	A2(
																		$elm$core$List$map,
																		function (_v18) {
																			var answer_id = _v18.a;
																			var answer = _v18.b;
																			return _Utils_Tuple2(
																				_Utils_Tuple2(
																					$author$project$Type$IO$Internal$box(answer_id),
																					answer),
																				A2(
																					$elm$core$Dict$filter,
																					F2(
																						function (question_id, question) {
																							return _Utils_eq(
																								answer.fb.eH,
																								$author$project$Type$IO$Internal$box(question_id));
																						}),
																					db.hp));
																		},
																		answers))))))))))))))));
		var all_relevant_keys = A2(
			$elm$core$List$map,
			function (_v15) {
				var _v16 = _v15.a;
				var aid = _v16.a;
				var _v17 = _v15.b;
				var cqid = _v17.a;
				return _Utils_Tuple2(aid, cqid);
			},
			A2(
				$elm$core$List$map,
				function (_v14) {
					var answer = _v14.E;
					var coding_question = _v14.dx;
					return _Utils_Tuple2(answer, coding_question);
				},
				all_coding_answers));
		var present_coding_answers = A2(
			$elm$core$List$map,
			function (_v13) {
				var cai = _v13.a;
				var cav = _v13.b;
				return _Utils_Tuple2(
					$author$project$Type$IO$Internal$box(cai),
					cav);
			},
			A2(
				$elm$core$List$sortBy,
				function (_v12) {
					var cav = _v12.b;
					return cav.fm;
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (cai, cav) {
								return A2(
									$elm$core$List$member,
									_Utils_Tuple2(cav.fb.E, cav.fb.dx),
									all_relevant_keys);
							}),
						db.f0))));
		var currentAnswer = $elm_community$list_extra$List$Extra$last(present_coding_answers);
		var history = A2(
			$elm$core$List$sortBy,
			function (_v11) {
				var cav = _v11.b;
				return cav.f8;
			},
			present_coding_answers);
		var curID = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($elm_community$list_extra$List$Extra$elemIndex, x, history);
			},
			currentAnswer);
		var next = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($elm_community$list_extra$List$Extra$getAt, x + 1, history);
			},
			curID);
		var previous = A2(
			$elm$core$Maybe$andThen,
			function (x) {
				return A2($elm_community$list_extra$List$Extra$getAt, x - 1, history);
			},
			curID);
		var qids_missing = A2(
			$elm$core$List$filter,
			function (_v9) {
				var answerid = _v9.a;
				var coding_questionid = _v9.b;
				return !A2(
					$elm$core$List$member,
					_Utils_Tuple2(answerid, coding_questionid),
					A2(
						$elm$core$List$map,
						function (_v10) {
							var ca = _v10.b;
							return _Utils_Tuple2(ca.fb.E, ca.fb.dx);
						},
						present_coding_answers));
			},
			all_relevant_keys);
		var getMsg = function (answer) {
			if (!answer.$) {
				var _v6 = answer.a;
				var aid = _v6.a;
				return $elm$core$Maybe$Just(
					$author$project$Msg$CRUD(
						A2(
							$author$project$Msg$Access,
							$author$project$Type$Database$CodingAnswerType,
							$author$project$Type$IO$Internal$unbox(aid))));
			} else {
				var _v7 = $elm$core$List$head(qids_missing);
				if (!_v7.$) {
					var _v8 = _v7.a;
					var answerid = _v8.a;
					var coding_questionid = _v8.b;
					return $elm$core$Maybe$Just(
						$author$project$Msg$CRUD(
							A2(
								$author$project$Msg$CreateRandom,
								$author$project$Type$Database$CodingAnswerType,
								_List_fromArray(
									[
										function (canswerid) {
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'answer',
												S: $author$project$Type$IO$Internal$box(canswerid),
												d9: $author$project$Type$Database$CodingAnswerType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(answerid)
											});
									},
										function (canswerid) {
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'coding_question',
												S: $author$project$Type$IO$Internal$box(canswerid),
												d9: $author$project$Type$Database$CodingAnswerType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(coding_questionid)
											});
									}
									]))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		};
		var templates = A2(
			$elm$core$List$map,
			function (_v4) {
				var answer = _v4.E;
				var question = _v4.eH;
				var coding_question = _v4.dx;
				var input_type = _v4.d4;
				return A8($author$project$Page$Code$CodingAnswerTemplate, answer.a, answer.b, question.a, question.b, coding_question.a, coding_question.b, input_type.a, input_type.b);
			},
			all_coding_answers);
		var currentQuestion = function () {
			if (!currentAnswer.$) {
				var _v1 = currentAnswer.a;
				var caid = _v1.a;
				var cav = _v1.b;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v3) {
							var answerId = _v3.bK;
							return _Utils_eq(answerId, cav.fb.E);
						},
						A2(
							$elm$core$List$filter,
							function (_v2) {
								var coding_questionId = _v2.bU;
								return _Utils_eq(coding_questionId, cav.fb.dx);
							},
							templates)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A7(
			$author$project$Page$Code$Model,
			id,
			templates,
			currentAnswer,
			currentQuestion,
			$elm$core$List$head(qids_missing),
			getMsg(previous),
			getMsg(next));
	});
var $author$project$Page$Code$update = F2(
	function (message, _v0) {
		var model = _v0;
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Code$demoContent = _List_fromArray(
	[
		$elm$html$Html$Attributes$id('demo-content'),
		A2($elm$html$Html$Attributes$style, 'height', '100%'),
		A2($elm$html$Html$Attributes$style, '-webkit-box-sizing', 'border-box'),
		A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
		A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
		A2($elm$html$Html$Attributes$style, 'padding-left', '16px'),
		A2($elm$html$Html$Attributes$style, 'padding-right', '16px'),
		A2($elm$html$Html$Attributes$style, 'padding-bottom', '100px'),
		A2($elm$html$Html$Attributes$style, 'width', '100%'),
		A2($elm$html$Html$Attributes$style, 'overflow', 'auto'),
		A2($elm$html$Html$Attributes$style, 'display', '-ms-flexbox'),
		A2($elm$html$Html$Attributes$style, 'display', 'flex'),
		A2($elm$html$Html$Attributes$style, '-ms-flex-direction', 'column'),
		A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
		A2($elm$html$Html$Attributes$style, '-ms-flex-align', 'center'),
		A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
		A2($elm$html$Html$Attributes$style, '-ms-flex-pack', 'start'),
		A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-start')
	]);
var $author$project$Page$Code$toTitle = function (_v0) {
	return 'Home ⧽ Answer';
};
var $author$project$Page$Code$viewCodingQuestion = F7(
	function (db, qid, tquestion, mbAnswer, anid, model, answer) {
		var question = tquestion.fb;
		var mbvalue = A2(
			$elm$core$Maybe$map,
			function (_v3) {
				var val = _v3.b;
				return val.fb.fb;
			},
			mbAnswer);
		var mbit = A2(
			$elm$core$Maybe$map,
			function (x) {
				return x.fb;
			},
			A2(
				$elm$core$Dict$get,
				$author$project$Type$IO$Internal$unbox(question.d4),
				db.d5));
		var mbid = A2(
			$elm$core$Maybe$map,
			function (_v2) {
				var id = _v2.a;
				return id;
			},
			mbAnswer);
		var tonInput = function () {
			if (!mbid.$) {
				var answer_id = mbid.a;
				return function (x) {
					return $author$project$Type$Database$TypeMatching$setField(
						{dk: 'value', S: answer_id, d9: $author$project$Type$Database$CodingAnswerType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
				};
			} else {
				return function (x) {
					return $author$project$Msg$CRUD(
						A2(
							$author$project$Msg$CreateRandom,
							$author$project$Type$Database$CodingAnswerType,
							_List_fromArray(
								[
									function (answerid) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'coding_question',
											S: $author$project$Type$IO$Internal$box(answerid),
											d9: $author$project$Type$Database$CodingAnswerType,
											eV: $author$project$Type$IO$Setter$StringMsg,
											fb: $author$project$Type$IO$Internal$unbox(qid)
										});
								},
									function (answerid) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'answer',
											S: $author$project$Type$IO$Internal$box(answerid),
											d9: $author$project$Type$Database$CodingAnswerType,
											eV: $author$project$Type$IO$Setter$StringMsg,
											fb: $author$project$Type$IO$Internal$unbox(anid)
										});
								},
									function (answerid) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'value',
											S: $author$project$Type$IO$Internal$box(answerid),
											d9: $author$project$Type$Database$AnswerType,
											eV: $author$project$Type$IO$Setter$StringMsg,
											fb: x
										});
								}
								])));
				};
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$Keyed$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$padding(32)
								]),
							A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$size(32)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(question.hQ)
									]))))),
					_Utils_Tuple2(
					'answer',
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$padding(32)
								]),
							A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Font$size(32)
									]),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(answer.fb.fb)
									]))))),
					_Utils_Tuple2(
					'edit',
					A2(
						$mdgriffith$elm_ui$Element$Keyed$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'padleft',
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$none)),
								_Utils_Tuple2(
								$author$project$Type$IO$Internal$unbox(qid),
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
										]),
									A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$centerY,
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
											]),
										function () {
											if (mbit.$ === 1) {
												return $mdgriffith$elm_ui$Element$html(
													$elm$html$Html$text('Undefined input type'));
											} else {
												switch (mbit.a.$) {
													case 0:
														var s = mbit.a.a;
														return $mdgriffith$elm_ui$Element$html(
															$aforemny$material_components_web_elm$Material$TextField$filled(
																A2(
																	$aforemny$material_components_web_elm$Material$TextField$setOnInput,
																	tonInput,
																	A2(
																		$aforemny$material_components_web_elm$Material$TextField$setPlaceholder,
																		s.hm,
																		A2(
																			$aforemny$material_components_web_elm$Material$TextField$setValue,
																			mbvalue,
																			A2($aforemny$material_components_web_elm$Material$TextField$setLabel, s.ea, $aforemny$material_components_web_elm$Material$TextField$config))))));
													case 1:
														var l = mbit.a.a;
														return $mdgriffith$elm_ui$Element$html(
															$aforemny$material_components_web_elm$Material$TextArea$filled(
																A2(
																	$aforemny$material_components_web_elm$Material$TextArea$setCols,
																	l.f3,
																	A2(
																		$aforemny$material_components_web_elm$Material$TextArea$setRows,
																		l.hu,
																		A2(
																			$aforemny$material_components_web_elm$Material$TextArea$setOnInput,
																			tonInput,
																			A2(
																				$aforemny$material_components_web_elm$Material$TextArea$setValue,
																				mbvalue,
																				A2($aforemny$material_components_web_elm$Material$TextArea$setLabel, l.ea, $aforemny$material_components_web_elm$Material$TextArea$config)))))));
													default:
														return $mdgriffith$elm_ui$Element$text('List Answer');
												}
											}
										}()))),
								_Utils_Tuple2(
								'padright',
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									$mdgriffith$elm_ui$Element$none))
							])))
				]));
	});
var $author$project$Page$Code$view = function (_v0) {
	var pageM = _v0;
	var session = pageM.hB;
	var viewportHeight = session.fh.dW;
	var model = pageM.c;
	var db = session.u;
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				return _List_fromArray(
					[
						function () {
						var _v2 = model.dB;
						if (!_v2.$) {
							var current = _v2.a;
							return A2(
								$mdgriffith$elm_ui$Element$layout,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$height(
										$mdgriffith$elm_ui$Element$px(viewportHeight - 48)),
										$mdgriffith$elm_ui$Element$padding(24)
									]),
								A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
												]),
											A7($author$project$Page$Code$viewCodingQuestion, db, current.bU, current.dx, model.E, current.bK, model, current.E)),
											A2(
											$mdgriffith$elm_ui$Element$row,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$alignBottom,
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
												]),
											_List_fromArray(
												[
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[$mdgriffith$elm_ui$Element$alignLeft]),
													$mdgriffith$elm_ui$Element$html(
														function () {
															var _v3 = model.cH;
															if (!_v3.$) {
																var prev = _v3.a;
																return A2(
																	$aforemny$material_components_web_elm$Material$Button$raised,
																	A2($aforemny$material_components_web_elm$Material$Button$setOnClick, prev, $aforemny$material_components_web_elm$Material$Button$config),
																	'Previous');
															} else {
																return $elm$html$Html$text('');
															}
														}())),
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$centerX,
															$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
														]),
													$mdgriffith$elm_ui$Element$text('')),
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[$mdgriffith$elm_ui$Element$alignRight]),
													$mdgriffith$elm_ui$Element$html(
														function () {
															var _v4 = model.cu;
															if (!_v4.$) {
																var next = _v4.a;
																return A2(
																	$aforemny$material_components_web_elm$Material$Button$raised,
																	A2($aforemny$material_components_web_elm$Material$Button$setOnClick, next, $aforemny$material_components_web_elm$Material$Button$config),
																	'Next');
															} else {
																return $elm$html$Html$text('');
															}
														}()))
												]))
										])));
						} else {
							var _v5 = model.dC;
							if (!_v5.$) {
								var _v6 = _v5.a;
								var answerid = _v6.a;
								var coding_questionid = _v6.b;
								var mbcoding_question = A2(
									$elm$core$Dict$get,
									$author$project$Type$IO$Internal$unbox(coding_questionid),
									db.dy);
								var mbinput_type = A2(
									$elm$core$Maybe$map,
									function (x) {
										return A2(
											$elm$core$Dict$get,
											$author$project$Type$IO$Internal$unbox(x.fb.d4),
											db.d5);
									},
									mbcoding_question);
								var mbanswer = A2(
									$elm$core$Dict$get,
									$author$project$Type$IO$Internal$unbox(answerid),
									db.bL);
								var _v7 = _Utils_Tuple3(mbinput_type, mbanswer, mbcoding_question);
								if (((!_v7.a.$) && (!_v7.b.$)) && (!_v7.c.$)) {
									var input_type = _v7.a.a;
									var answer = _v7.b.a;
									var coding_question = _v7.c.a;
									return A2(
										$mdgriffith$elm_ui$Element$layout,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$height(
												$mdgriffith$elm_ui$Element$px(viewportHeight - 48)),
												$mdgriffith$elm_ui$Element$padding(24)
											]),
										A2(
											$mdgriffith$elm_ui$Element$column,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
												]),
											_List_fromArray(
												[
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
															$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
														]),
													A7($author$project$Page$Code$viewCodingQuestion, db, coding_questionid, coding_question, $elm$core$Maybe$Nothing, answerid, model, answer)),
													A2(
													$mdgriffith$elm_ui$Element$row,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$alignBottom,
															$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
														]),
													_List_fromArray(
														[
															A2(
															$mdgriffith$elm_ui$Element$el,
															_List_fromArray(
																[$mdgriffith$elm_ui$Element$alignLeft]),
															$mdgriffith$elm_ui$Element$html(
																function () {
																	var _v8 = model.cH;
																	if (!_v8.$) {
																		var prev = _v8.a;
																		return A2(
																			$aforemny$material_components_web_elm$Material$Button$raised,
																			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, prev, $aforemny$material_components_web_elm$Material$Button$config),
																			'Previous');
																	} else {
																		return $elm$html$Html$text('');
																	}
																}())),
															A2(
															$mdgriffith$elm_ui$Element$el,
															_List_fromArray(
																[
																	$mdgriffith$elm_ui$Element$centerX,
																	$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
																]),
															$mdgriffith$elm_ui$Element$text('')),
															A2(
															$mdgriffith$elm_ui$Element$el,
															_List_fromArray(
																[$mdgriffith$elm_ui$Element$alignRight]),
															$mdgriffith$elm_ui$Element$html(
																function () {
																	var _v9 = model.cu;
																	if (!_v9.$) {
																		var next = _v9.a;
																		return A2(
																			$aforemny$material_components_web_elm$Material$Button$raised,
																			A2($aforemny$material_components_web_elm$Material$Button$setOnClick, next, $aforemny$material_components_web_elm$Material$Button$config),
																			'Next');
																	} else {
																		return $elm$html$Html$text('');
																	}
																}()))
														]))
												])));
								} else {
									return $elm$html$Html$text('I failed to start.');
								}
							} else {
								return A2(
									$elm$html$Html$div,
									$author$project$Page$Code$demoContent,
									_List_fromArray(
										[
											$elm$html$Html$text('Nothing to do!')
										]));
							}
						}
					}()
					]);
			},
			h5: $author$project$Page$Code$toTitle(model),
			c5: session.c5
		});
};
var $author$project$Page$Code$page = F2(
	function (session, id) {
		var model = {
			c: A2($author$project$Page$Code$init, id, session.u),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $elm$core$Basics$identity,
			ih: $author$project$Page$Code$update,
			ik: $author$project$Page$Code$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$CodingQuestion$Model = F5(
	function (id, question, _short, _long, list) {
		return {S: id, aa: list, ab: _long, eH: question, ak: _short};
	});
var $author$project$Page$CodingQuestion$init = F2(
	function (db, id) {
		var q = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fb;
			},
			A2(
				$elm$core$Dict$get,
				$author$project$Type$IO$Internal$unbox(id),
				db.dy));
		var it_id = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.d4;
			},
			q);
		var it = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.d4;
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Type$Database$coding_question.fd(db),
				q));
		var emptyModel = A5(
			$author$project$Page$CodingQuestion$Model,
			id,
			A2(
				$elm$core$Dict$get,
				$author$project$Type$IO$Internal$unbox(id),
				db.dy),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(it, it_id);
		if (!_v0.a.$) {
			switch (_v0.a.a.$) {
				case 0:
					var a = _v0.b;
					return _Utils_update(
						emptyModel,
						{ak: a});
				case 1:
					var a = _v0.b;
					return _Utils_update(
						emptyModel,
						{ab: a});
				default:
					var a = _v0.b;
					return _Utils_update(
						emptyModel,
						{aa: a});
			}
		} else {
			return emptyModel;
		}
	});
var $author$project$Page$CodingQuestion$update = F2(
	function (message, _v0) {
		var model = _v0;
		var updatePage = function (x) {
			return _Utils_update(
				model,
				{c: x});
		};
		var oldmodel = model.c;
		var setInputTypeDb = function (it) {
			var oldsession = model.hB;
			var olddb = oldsession.u;
			var newdb = function (n) {
				return _Utils_update(
					oldsession,
					{u: n});
			};
			var newq = function (n) {
				return newdb(
					_Utils_update(
						olddb,
						{hp: n}));
			};
			return newq(
				A3(
					$elm$core$Dict$update,
					$author$project$Type$IO$Internal$unbox(oldmodel.S),
					$elm$core$Maybe$map(
						function (i) {
							var oldvalue = i.fb;
							var newvalue = function (n) {
								return _Utils_update(
									i,
									{fb: n});
							};
							var newquestion = _Utils_update(
								oldvalue,
								{d4: it});
							return newvalue(newquestion);
						}),
					model.hB.u.hp));
		};
		if (message.$ === 12) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $aforemny$material_components_web_elm$Material$LayoutGrid$cell = F2(
	function (attributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-layout-grid__cell'),
				attributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$Typography$headline5 = $elm$html$Html$Attributes$class('mdc-typography--headline5');
var $aforemny$material_components_web_elm$Material$LayoutGrid$inner = F2(
	function (attributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-layout-grid__inner'),
				attributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid = F2(
	function (attributes, nodes) {
		return A3(
			$elm$html$Html$node,
			'mdc-layout-grid',
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-layout-grid'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					attributes)),
			nodes);
	});
var $author$project$Page$CodingQuestion$relatedData = F2(
	function (id, db) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Type$IO$Internal$unbox(id),
			db.dy);
		if (!_v0.$) {
			var timestampedQuestion = _v0.a;
			var question = timestampedQuestion.fb;
			var coding_questions = A2(
				$elm$core$List$map,
				function (_v2) {
					var x = _v2.a;
					var y = _v2.b;
					return _Utils_Tuple2(
						$author$project$Type$IO$Internal$box(x),
						y.fb);
				},
				A2(
					$elm$core$List$filter,
					function (_v1) {
						var y = _v1.b;
						return _Utils_eq(y.fb.eH, id);
					},
					$elm$core$Dict$toList(db.f2)));
			return $elm$core$Maybe$Just(
				{
					f8: $elm$time$Time$millisToPosix(timestampedQuestion.f8),
					a5: _Utils_Tuple2(
						timestampedQuestion.a5,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(timestampedQuestion.a5),
								db.c6))),
					S: id,
					d4: _Utils_Tuple2(
						question.d4,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.d4;
							},
							A2($author$project$Type$Database$coding_question.fd, db, question))),
					hQ: question.hQ,
					fa: $elm$time$Time$millisToPosix(timestampedQuestion.gW)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$CodingQuestion$toTitle = function (_v0) {
	return 'Home ⧽ Question';
};
var $aforemny$material_components_web_elm$Material$Typography$typography = $elm$html$Html$Attributes$class('mdc-typography');
var $aforemny$material_components_web_elm$Material$FormField$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$FormField$config = {bF: _List_Nil, bH: false, b6: $elm$core$Maybe$Nothing, ea: $elm$core$Maybe$Nothing, cz: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$Radio$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Radio$config = {bF: _List_Nil, aX: false, aC: false, cy: $elm$core$Maybe$Nothing, aS: true};
var $aforemny$material_components_web_elm$Material$FormField$alignEndCs = function (_v0) {
	var alignEnd = _v0.bH;
	return alignEnd ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-form-field--align-end')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$FormField$clickHandler = function (_v0) {
	var onClick = _v0.cz;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $aforemny$material_components_web_elm$Material$FormField$forAttr = function (_v0) {
	var _for = _v0.b6;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$for, _for);
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $aforemny$material_components_web_elm$Material$FormField$labelElt = function (config_) {
	var label = config_.ea;
	return A2(
		$elm$html$Html$label,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$FormField$forAttr(config_),
					$aforemny$material_components_web_elm$Material$FormField$clickHandler(config_)
				])),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($elm$core$Maybe$withDefault, '', label))
			]));
};
var $aforemny$material_components_web_elm$Material$FormField$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-form-field'));
var $aforemny$material_components_web_elm$Material$FormField$formField = F2(
	function (config_, nodes) {
		var additionalAttributes = config_.bF;
		return A3(
			$elm$html$Html$node,
			'mdc-form-field',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$FormField$rootCs,
							$aforemny$material_components_web_elm$Material$FormField$alignEndCs(config_)
						])),
				additionalAttributes),
			_Utils_ap(
				nodes,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$FormField$labelElt(config_)
					])));
	});
var $aforemny$material_components_web_elm$Material$Radio$innerCircleElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-radio__inner-circle')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Radio$outerCircleElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-radio__outer-circle')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Radio$backgroundElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-radio__background')
		]),
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$Radio$outerCircleElt, $aforemny$material_components_web_elm$Material$Radio$innerCircleElt]));
var $aforemny$material_components_web_elm$Material$Radio$checkedProp = function (_v0) {
	var checked = _v0.aX;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'checked',
			$elm$json$Json$Encode$bool(checked)));
};
var $aforemny$material_components_web_elm$Material$Radio$disabledProp = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$Radio$changeHandler = function (_v0) {
	var checked = _v0.aX;
	var onChange = _v0.cy;
	return A2(
		$elm$core$Maybe$map,
		function (msg) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				$elm$json$Json$Decode$succeed(msg));
		},
		onChange);
};
var $aforemny$material_components_web_elm$Material$Radio$nativeControlCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-radio__native-control'));
var $aforemny$material_components_web_elm$Material$Radio$radioTypeAttr = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$type_('radio'));
var $aforemny$material_components_web_elm$Material$Radio$nativeControlElt = function (config_) {
	return A2(
		$elm$html$Html$input,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Radio$nativeControlCs,
					$aforemny$material_components_web_elm$Material$Radio$radioTypeAttr,
					$aforemny$material_components_web_elm$Material$Radio$checkedProp(config_),
					$aforemny$material_components_web_elm$Material$Radio$changeHandler(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$Radio$rippleElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-radio__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Radio$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-radio'));
var $aforemny$material_components_web_elm$Material$Radio$touchCs = function (_v0) {
	var touch = _v0.aS;
	return touch ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-radio--touch')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Radio$radio = function (config_) {
	var touch = config_.aS;
	var additionalAttributes = config_.bF;
	var wrapTouch = function (node) {
		return touch ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-touch-target-wrapper')
				]),
			_List_fromArray(
				[node])) : node;
	};
	return wrapTouch(
		A3(
			$elm$html$Html$node,
			'mdc-radio',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Radio$rootCs,
							$aforemny$material_components_web_elm$Material$Radio$touchCs(config_),
							$aforemny$material_components_web_elm$Material$Radio$checkedProp(config_),
							$aforemny$material_components_web_elm$Material$Radio$disabledProp(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Radio$nativeControlElt(config_),
					$aforemny$material_components_web_elm$Material$Radio$backgroundElt,
					$aforemny$material_components_web_elm$Material$Radio$rippleElt
				])));
};
var $aforemny$material_components_web_elm$Material$Radio$setChecked = F2(
	function (checked, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{aX: checked});
	});
var $aforemny$material_components_web_elm$Material$FormField$setFor = F2(
	function (_for, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{b6: _for});
	});
var $aforemny$material_components_web_elm$Material$FormField$setLabel = F2(
	function (label, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{ea: label});
	});
var $aforemny$material_components_web_elm$Material$Radio$setOnChange = F2(
	function (onChange, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cy: $elm$core$Maybe$Just(onChange)
			});
	});
var $aforemny$material_components_web_elm$Material$FormField$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cz: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Page$CodingQuestion$viewInputTypeSelection = F2(
	function (model, _v0) {
		var id = _v0.a;
		return A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[x]));
			},
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$FormField$formField,
					A2(
						$aforemny$material_components_web_elm$Material$FormField$setOnClick,
						function () {
							var _v1 = model.ak;
							if (!_v1.$) {
								var _short = _v1.a;
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'input_type',
										S: model.S,
										d9: $author$project$Type$Database$CodingQuestionType,
										eV: $author$project$Type$IO$Setter$StringMsg,
										fb: $author$project$Type$IO$Internal$unbox(_short)
									});
							} else {
								return $author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$InputTypeType(0),
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$CodingQuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
											}
											])));
							}
						}(),
						A2(
							$aforemny$material_components_web_elm$Material$FormField$setFor,
							$elm$core$Maybe$Just('1'),
							A2(
								$aforemny$material_components_web_elm$Material$FormField$setLabel,
								$elm$core$Maybe$Just('Short Answer'),
								$aforemny$material_components_web_elm$Material$FormField$config))),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Radio$radio(
							A2(
								$aforemny$material_components_web_elm$Material$Radio$setOnChange,
								function () {
									var _v2 = model.ak;
									if (!_v2.$) {
										var _short = _v2.a;
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'input_type',
												S: model.S,
												d9: $author$project$Type$Database$CodingQuestionType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(_short)
											});
									} else {
										return $author$project$Msg$CRUD(
											A2(
												$author$project$Msg$CreateRandom,
												$author$project$Type$Database$InputTypeType(0),
												_List_fromArray(
													[
														function (x) {
														return $author$project$Type$Database$TypeMatching$setField(
															{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$CodingQuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
													}
													])));
									}
								}(),
								A2(
									$aforemny$material_components_web_elm$Material$Radio$setChecked,
									_Utils_eq(
										model.ak,
										$elm$core$Maybe$Just(id)),
									$aforemny$material_components_web_elm$Material$Radio$config)))
						])),
					A2(
					$aforemny$material_components_web_elm$Material$FormField$formField,
					A2(
						$aforemny$material_components_web_elm$Material$FormField$setOnClick,
						function () {
							var _v3 = model.ab;
							if (!_v3.$) {
								var _long = _v3.a;
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'input_type',
										S: model.S,
										d9: $author$project$Type$Database$CodingQuestionType,
										eV: $author$project$Type$IO$Setter$StringMsg,
										fb: $author$project$Type$IO$Internal$unbox(_long)
									});
							} else {
								return $author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$InputTypeType(1),
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$CodingQuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
											}
											])));
							}
						}(),
						A2(
							$aforemny$material_components_web_elm$Material$FormField$setFor,
							$elm$core$Maybe$Just('2'),
							A2(
								$aforemny$material_components_web_elm$Material$FormField$setLabel,
								$elm$core$Maybe$Just('Long Answer'),
								$aforemny$material_components_web_elm$Material$FormField$config))),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Radio$radio(
							A2(
								$aforemny$material_components_web_elm$Material$Radio$setOnChange,
								function () {
									var _v4 = model.ab;
									if (!_v4.$) {
										var _long = _v4.a;
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'input_type',
												S: model.S,
												d9: $author$project$Type$Database$CodingQuestionType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(_long)
											});
									} else {
										return $author$project$Msg$CRUD(
											A2(
												$author$project$Msg$CreateRandom,
												$author$project$Type$Database$InputTypeType(1),
												_List_fromArray(
													[
														function (x) {
														return $author$project$Type$Database$TypeMatching$setField(
															{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$CodingQuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
													}
													])));
									}
								}(),
								A2(
									$aforemny$material_components_web_elm$Material$Radio$setChecked,
									_Utils_eq(
										model.ab,
										$elm$core$Maybe$Just(id)),
									$aforemny$material_components_web_elm$Material$Radio$config)))
						])),
					A2(
					$aforemny$material_components_web_elm$Material$FormField$formField,
					A2(
						$aforemny$material_components_web_elm$Material$FormField$setOnClick,
						function () {
							var _v5 = model.aa;
							if (!_v5.$) {
								var list = _v5.a;
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'input_type',
										S: model.S,
										d9: $author$project$Type$Database$CodingQuestionType,
										eV: $author$project$Type$IO$Setter$StringMsg,
										fb: $author$project$Type$IO$Internal$unbox(list)
									});
							} else {
								return $author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$InputTypeType(2),
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$CodingQuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
											}
											])));
							}
						}(),
						A2(
							$aforemny$material_components_web_elm$Material$FormField$setFor,
							$elm$core$Maybe$Just('3'),
							A2(
								$aforemny$material_components_web_elm$Material$FormField$setLabel,
								$elm$core$Maybe$Just('Multiple Choice'),
								$aforemny$material_components_web_elm$Material$FormField$config))),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Radio$radio(
							A2(
								$aforemny$material_components_web_elm$Material$Radio$setOnChange,
								function () {
									var _v6 = model.aa;
									if (!_v6.$) {
										var list = _v6.a;
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'input_type',
												S: model.S,
												d9: $author$project$Type$Database$CodingQuestionType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(list)
											});
									} else {
										return $author$project$Msg$CRUD(
											A2(
												$author$project$Msg$CreateRandom,
												$author$project$Type$Database$InputTypeType(2),
												_List_fromArray(
													[
														function (x) {
														return $author$project$Type$Database$TypeMatching$setField(
															{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$CodingQuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
													}
													])));
									}
								}(),
								A2(
									$aforemny$material_components_web_elm$Material$Radio$setChecked,
									_Utils_eq(
										model.aa,
										$elm$core$Maybe$Just(id)),
									$aforemny$material_components_web_elm$Material$Radio$config)))
						]))
				]));
	});
var $author$project$Type$IO$Setter$MaybeSetMsg = function (a) {
	return {$: 8, a: a};
};
var $aforemny$material_components_web_elm$Material$Slider$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Slider$config = {bF: _List_Nil, aC: false, ap: false, a8: false, ac: 100, ae: 0, cA: $elm$core$Maybe$Nothing, aM: 1, fb: 0};
var $aforemny$material_components_web_elm$Material$Slider$setOnInput = F2(
	function (onInput, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cA: $elm$core$Maybe$Just(onInput)
			});
	});
var $aforemny$material_components_web_elm$Material$Slider$setValue = F2(
	function (value, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{fb: value});
	});
var $aforemny$material_components_web_elm$Material$Slider$ariaValueMaxAttr = function (_v0) {
	var max = _v0.ac;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$attribute,
			'aria-valuemax',
			$elm$core$String$fromFloat(max)));
};
var $aforemny$material_components_web_elm$Material$Slider$ariaValueMinAttr = function (_v0) {
	var min = _v0.ae;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$attribute,
			'aria-valuemin',
			$elm$core$String$fromFloat(min)));
};
var $aforemny$material_components_web_elm$Material$Slider$ariaValuenowAttr = function (_v0) {
	var value = _v0.fb;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$attribute,
			'aria-valuenow',
			$elm$core$String$fromFloat(value)));
};
var $aforemny$material_components_web_elm$Material$Slider$changeHandler = function (_v0) {
	var onInput = _v0.cA;
	return A2(
		$elm$core$Maybe$map,
		function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'MDCSlider:input',
				A2(
					$elm$json$Json$Decode$map,
					handler,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['detail', 'value']),
						$elm$json$Json$Decode$float)));
		},
		onInput);
};
var $aforemny$material_components_web_elm$Material$Slider$disabledProp = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$Slider$discreteCs = function (_v0) {
	var discrete = _v0.ap;
	return discrete ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-slider--discrete')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Slider$displayMarkersCs = function (_v0) {
	var discrete = _v0.ap;
	var displayMarkers = _v0.a8;
	return (discrete && displayMarkers) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-slider--tick-marks')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Slider$inputCs = $elm$html$Html$Attributes$class('mdc-slider__input');
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $aforemny$material_components_web_elm$Material$Slider$maxAttr = function (_v0) {
	var max = _v0.ac;
	return $elm$html$Html$Attributes$max(
		$elm$core$String$fromFloat(max));
};
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $aforemny$material_components_web_elm$Material$Slider$minAttr = function (_v0) {
	var min = _v0.ae;
	return $elm$html$Html$Attributes$min(
		$elm$core$String$fromFloat(min));
};
var $aforemny$material_components_web_elm$Material$Slider$rangeTypeAttr = $elm$html$Html$Attributes$type_('range');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $aforemny$material_components_web_elm$Material$Slider$stepAttr = function (_v0) {
	var step = _v0.aM;
	return $elm$html$Html$Attributes$step(
		$elm$core$String$fromFloat(step));
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $aforemny$material_components_web_elm$Material$Slider$valueAttr = function (_v0) {
	var min = _v0.ae;
	var max = _v0.ac;
	var value = _v0.fb;
	var normalizedValue = (_Utils_cmp(min, max) < 0) ? A3($elm$core$Basics$clamp, min, max, value) : min;
	return A2(
		$elm$html$Html$Attributes$attribute,
		'value',
		$elm$core$String$fromFloat(normalizedValue));
};
var $aforemny$material_components_web_elm$Material$Slider$inputElt = function (config_) {
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Slider$inputCs,
				$aforemny$material_components_web_elm$Material$Slider$rangeTypeAttr,
				$aforemny$material_components_web_elm$Material$Slider$minAttr(config_),
				$aforemny$material_components_web_elm$Material$Slider$maxAttr(config_),
				$aforemny$material_components_web_elm$Material$Slider$valueAttr(config_),
				$aforemny$material_components_web_elm$Material$Slider$stepAttr(config_)
			]),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$Slider$maxProp = function (_v0) {
	var max = _v0.ac;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'max',
			$elm$json$Json$Encode$float(max)));
};
var $aforemny$material_components_web_elm$Material$Slider$minProp = function (_v0) {
	var min = _v0.ae;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'min',
			$elm$json$Json$Encode$float(min)));
};
var $aforemny$material_components_web_elm$Material$Slider$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-slider'));
var $aforemny$material_components_web_elm$Material$Slider$sliderRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'slider'));
var $aforemny$material_components_web_elm$Material$Slider$stepProp = function (_v0) {
	var step = _v0.aM;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'step',
			$elm$json$Json$Encode$float(step)));
};
var $aforemny$material_components_web_elm$Material$Slider$thumbKnobElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-slider__thumb-knob')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Slider$ariaHidden = A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true');
var $aforemny$material_components_web_elm$Material$Slider$valueIndicatorTextElt = function (_v0) {
	var value = _v0.fb;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-slider__value-indicator-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromFloat(value))
			]));
};
var $aforemny$material_components_web_elm$Material$Slider$valueIndicatorElt = function (config_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-slider__value-indicator')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Slider$valueIndicatorTextElt(config_)
			]));
};
var $aforemny$material_components_web_elm$Material$Slider$valueIndicatorContainerElt = function (config_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-slider__value-indicator-container'),
				$aforemny$material_components_web_elm$Material$Slider$ariaHidden
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Slider$valueIndicatorElt(config_)
			]));
};
var $aforemny$material_components_web_elm$Material$Slider$thumbElt = function (config_) {
	var discrete = config_.ap;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-slider__thumb')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					discrete ? _List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Slider$valueIndicatorContainerElt(config_)
					]) : _List_Nil,
					_List_fromArray(
					[$aforemny$material_components_web_elm$Material$Slider$thumbKnobElt])
				])));
};
var $aforemny$material_components_web_elm$Material$Slider$tickMarkElt = function (isActive) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				isActive ? 'mdc-slider__tick-mark--active' : 'mdc-slider__tick-mark--inactive')
			]),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$Slider$tickMarksElt = function (config_) {
	var step = config_.aM;
	var min = config_.ae;
	var max = config_.ac;
	var value = config_.fb;
	var n = $elm$core$Basics$ceiling(
		(max - min) / A2($elm$core$Basics$max, 1, step));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-slider__tick-marks')
			]),
		A2(
			$elm$core$List$map,
			function (k) {
				return $aforemny$material_components_web_elm$Material$Slider$tickMarkElt(
					_Utils_cmp(value, min + (k * n)) < 1);
			},
			A2($elm$core$List$range, 0, n)));
};
var $aforemny$material_components_web_elm$Material$Slider$trackActiveElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-slider__track--active')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Slider$trackActiveFillElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-slider__track--active_fill')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Slider$trackInactiveElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-slider__track--inactive')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Slider$trackElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-slider__track')
		]),
	_List_fromArray(
		[$aforemny$material_components_web_elm$Material$Slider$trackInactiveElt, $aforemny$material_components_web_elm$Material$Slider$trackActiveElt, $aforemny$material_components_web_elm$Material$Slider$trackActiveFillElt]));
var $aforemny$material_components_web_elm$Material$Slider$valueProp = function (_v0) {
	var value = _v0.fb;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'value',
			$elm$json$Json$Encode$float(value)));
};
var $aforemny$material_components_web_elm$Material$Slider$slider = function (config_) {
	var additionalAttributes = config_.bF;
	var discrete = config_.ap;
	var displayMarkers = config_.a8;
	return A3(
		$elm$html$Html$node,
		'mdc-slider',
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Slider$rootCs,
						$aforemny$material_components_web_elm$Material$Slider$discreteCs(config_),
						$aforemny$material_components_web_elm$Material$Slider$displayMarkersCs(config_),
						$aforemny$material_components_web_elm$Material$Slider$sliderRoleAttr,
						$aforemny$material_components_web_elm$Material$Slider$valueProp(config_),
						$aforemny$material_components_web_elm$Material$Slider$minProp(config_),
						$aforemny$material_components_web_elm$Material$Slider$maxProp(config_),
						$aforemny$material_components_web_elm$Material$Slider$stepProp(config_),
						$aforemny$material_components_web_elm$Material$Slider$disabledProp(config_),
						$aforemny$material_components_web_elm$Material$Slider$ariaValueMinAttr(config_),
						$aforemny$material_components_web_elm$Material$Slider$ariaValueMaxAttr(config_),
						$aforemny$material_components_web_elm$Material$Slider$ariaValuenowAttr(config_),
						$aforemny$material_components_web_elm$Material$Slider$changeHandler(config_)
					])),
			additionalAttributes),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Slider$inputElt(config_),
						$aforemny$material_components_web_elm$Material$Slider$trackElt
					]),
					(discrete && displayMarkers) ? _List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Slider$tickMarksElt(config_)
					]) : _List_Nil,
					_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Slider$thumbElt(config_)
					])
				])));
};
var $author$project$Page$CodingQuestion$viewSettings = F4(
	function (db, id, model, _v0) {
		var itid = _v0.a;
		var mbit = _v0.b;
		var umessage = F3(
			function (attribute, setter, value) {
				return $author$project$Msg$CRUD(
					$author$project$Msg$Update(
						A2(
							$author$project$Type$IO$Setter$AttributeMsg,
							'questions',
							A2(
								$author$project$Type$IO$Setter$DictKeyMsg,
								$author$project$Type$IO$Internal$unbox(id),
								A2(
									$author$project$Type$IO$Setter$AttributeMsg,
									'value',
									A2(
										$author$project$Type$IO$Setter$AttributeMsg,
										'input_type',
										A2(
											$author$project$Type$IO$Setter$AttributeMsg,
											attribute,
											setter(value))))))));
			});
		var moreInfo = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Result$toMaybe,
				A2(
					$elm$core$Maybe$map,
					$author$project$Type$Database$InputType$input_type.h9('*'),
					mbit)));
		if (_Utils_eq(
			model.ak,
			$elm$core$Maybe$Just(itid))) {
			var _v1 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fb;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (x) {
						return A2(
							$elm$core$Dict$get,
							$author$project$Type$IO$Internal$unbox(x),
							db.d5);
					},
					model.ak));
			if ((!_v1.$) && (!_v1.a.$)) {
				var _short = _v1.a.a;
				return _List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$TextField$filled(
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							function (x) {
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'label',
										S: itid,
										d9: $author$project$Type$Database$InputTypeType(0),
										eV: function (p) {
											return $author$project$Type$IO$Setter$MaybeSetMsg(
												$elm$core$Maybe$Just(
													$author$project$Type$IO$Setter$StringMsg(p)));
										},
										fb: x
									});
							},
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								_short.ea,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('Set the label'),
									$aforemny$material_components_web_elm$Material$TextField$config)))),
						$aforemny$material_components_web_elm$Material$TextField$filled(
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							function (x) {
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'placeholder',
										S: itid,
										d9: $author$project$Type$Database$InputTypeType(0),
										eV: function (p) {
											return $author$project$Type$IO$Setter$MaybeSetMsg(
												$elm$core$Maybe$Just(
													$author$project$Type$IO$Setter$StringMsg(p)));
										},
										fb: x
									});
							},
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								_short.hm,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('Set the placeholder'),
									$aforemny$material_components_web_elm$Material$TextField$config)))),
						$aforemny$material_components_web_elm$Material$TextField$filled(
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							function (x) {
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'pattern',
										S: itid,
										d9: $author$project$Type$Database$InputTypeType(0),
										eV: function (p) {
											return $author$project$Type$IO$Setter$MaybeSetMsg(
												$elm$core$Maybe$Just(
													$author$project$Type$IO$Setter$StringMsg(p)));
										},
										fb: x
									});
							},
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								_short.ex,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('Set the pattern'),
									$aforemny$material_components_web_elm$Material$TextField$config)))),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Min Length: ' + A2(
									$elm$core$Maybe$withDefault,
									'0',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, _short.bi))),
								$aforemny$material_components_web_elm$Material$Slider$slider(
								A2(
									$aforemny$material_components_web_elm$Material$Slider$setOnInput,
									function (x) {
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'minLength',
												S: itid,
												d9: $author$project$Type$Database$InputTypeType(0),
												eV: function (p) {
													return $author$project$Type$IO$Setter$MaybeSetMsg(
														$elm$core$Maybe$Just(
															$author$project$Type$IO$Setter$IntMsg(
																$elm$core$Basics$round(p))));
												},
												fb: x
											});
									},
									function (x) {
										var _v2 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _short.bi);
										if (!_v2.$) {
											var length = _v2.a;
											return A2($aforemny$material_components_web_elm$Material$Slider$setValue, length, x);
										} else {
											return x;
										}
									}($aforemny$material_components_web_elm$Material$Slider$config)))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Max Length: ' + A2(
									$elm$core$Maybe$withDefault,
									'100',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, _short.bh))),
								$aforemny$material_components_web_elm$Material$Slider$slider(
								A2(
									$aforemny$material_components_web_elm$Material$Slider$setOnInput,
									function (x) {
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'maxLength',
												S: itid,
												d9: $author$project$Type$Database$InputTypeType(0),
												eV: function (p) {
													return $author$project$Type$IO$Setter$MaybeSetMsg(
														$elm$core$Maybe$Just(
															$author$project$Type$IO$Setter$IntMsg(
																$elm$core$Basics$round(p))));
												},
												fb: x
											});
									},
									function (x) {
										var _v3 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _short.bh);
										if (!_v3.$) {
											var length = _v3.a;
											return A2($aforemny$material_components_web_elm$Material$Slider$setValue, length, x);
										} else {
											return x;
										}
									}($aforemny$material_components_web_elm$Material$Slider$config)))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text('No Config found')
					]);
			}
		} else {
			if (_Utils_eq(
				model.ab,
				$elm$core$Maybe$Just(itid))) {
				var _v4 = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.fb;
					},
					A2(
						$elm$core$Maybe$andThen,
						function (x) {
							return A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(x),
								db.d5);
						},
						model.ab));
				if ((!_v4.$) && (_v4.a.$ === 1)) {
					var _long = _v4.a.a;
					return _List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TextField$filled(
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								function (x) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'label',
											S: itid,
											d9: $author$project$Type$Database$InputTypeType(0),
											eV: function (p) {
												return $author$project$Type$IO$Setter$MaybeSetMsg(
													$elm$core$Maybe$Just(
														$author$project$Type$IO$Setter$StringMsg(p)));
											},
											fb: x
										});
								},
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									_long.ea,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Set the label'),
										$aforemny$material_components_web_elm$Material$TextField$config)))),
							$aforemny$material_components_web_elm$Material$TextField$filled(
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								function (x) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'placeholder',
											S: itid,
											d9: $author$project$Type$Database$InputTypeType(0),
											eV: function (p) {
												return $author$project$Type$IO$Setter$MaybeSetMsg(
													$elm$core$Maybe$Just(
														$author$project$Type$IO$Setter$StringMsg(p)));
											},
											fb: x
										});
								},
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									_long.hm,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Set the placeholder'),
										$aforemny$material_components_web_elm$Material$TextField$config)))),
							$aforemny$material_components_web_elm$Material$TextField$filled(
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								function (x) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'pattern',
											S: itid,
											d9: $author$project$Type$Database$InputTypeType(0),
											eV: function (p) {
												return $author$project$Type$IO$Setter$MaybeSetMsg(
													$elm$core$Maybe$Just(
														$author$project$Type$IO$Setter$StringMsg(p)));
											},
											fb: x
										});
								},
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									_long.ex,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Set the pattern'),
										$aforemny$material_components_web_elm$Material$TextField$config)))),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Min Length: ' + A2(
										$elm$core$Maybe$withDefault,
										'0',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, _long.bi))),
									$aforemny$material_components_web_elm$Material$Slider$slider(
									A2(
										$aforemny$material_components_web_elm$Material$Slider$setOnInput,
										function (x) {
											return $author$project$Type$Database$TypeMatching$setField(
												{
													dk: 'minLength',
													S: itid,
													d9: $author$project$Type$Database$InputTypeType(0),
													eV: function (p) {
														return $author$project$Type$IO$Setter$MaybeSetMsg(
															$elm$core$Maybe$Just(
																$author$project$Type$IO$Setter$IntMsg(
																	$elm$core$Basics$round(p))));
													},
													fb: x
												});
										},
										function (x) {
											var _v5 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _long.bi);
											if (!_v5.$) {
												var length = _v5.a;
												return A2($aforemny$material_components_web_elm$Material$Slider$setValue, length, x);
											} else {
												return x;
											}
										}($aforemny$material_components_web_elm$Material$Slider$config)))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Max Length: ' + A2(
										$elm$core$Maybe$withDefault,
										'100',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, _long.bh))),
									$aforemny$material_components_web_elm$Material$Slider$slider(
									A2(
										$aforemny$material_components_web_elm$Material$Slider$setOnInput,
										function (x) {
											return $author$project$Type$Database$TypeMatching$setField(
												{
													dk: 'maxLength',
													S: itid,
													d9: $author$project$Type$Database$InputTypeType(0),
													eV: function (p) {
														return $author$project$Type$IO$Setter$MaybeSetMsg(
															$elm$core$Maybe$Just(
																$author$project$Type$IO$Setter$IntMsg(
																	$elm$core$Basics$round(p))));
													},
													fb: x
												});
										},
										function (x) {
											var _v6 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _long.bh);
											if (!_v6.$) {
												var length = _v6.a;
												return A2($aforemny$material_components_web_elm$Material$Slider$setValue, length, x);
											} else {
												return x;
											}
										}($aforemny$material_components_web_elm$Material$Slider$config)))
								]))
						]);
				} else {
					return _List_fromArray(
						[
							$elm$html$Html$text('No Config found')
						]);
				}
			} else {
				if (_Utils_eq(
					model.aa,
					$elm$core$Maybe$Just(itid))) {
					var _v7 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fb;
						},
						A2(
							$elm$core$Maybe$andThen,
							function (x) {
								return A2(
									$elm$core$Dict$get,
									$author$project$Type$IO$Internal$unbox(x),
									db.d5);
							},
							model.aa));
					if ((!_v7.$) && (_v7.a.$ === 2)) {
						var list = _v7.a.a;
						return _List_fromArray(
							[
								$elm$html$Html$text('Boxes or Radio?'),
								A2(
								$aforemny$material_components_web_elm$Material$FormField$formField,
								A2(
									$aforemny$material_components_web_elm$Material$FormField$setLabel,
									$elm$core$Maybe$Just('Radio Button'),
									$aforemny$material_components_web_elm$Material$FormField$config),
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$Radio$radio($aforemny$material_components_web_elm$Material$Radio$config)
									])),
								A2(
								$aforemny$material_components_web_elm$Material$FormField$formField,
								A2(
									$aforemny$material_components_web_elm$Material$FormField$setLabel,
									$elm$core$Maybe$Just('Checkbox'),
									$aforemny$material_components_web_elm$Material$FormField$config),
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$Radio$radio($aforemny$material_components_web_elm$Material$Radio$config)
									]))
							]);
					} else {
						return _List_fromArray(
							[
								$elm$html$Html$text('No Config found')
							]);
					}
				} else {
					return _List_fromArray(
						[
							$elm$html$Html$text('You have not selected an Input type yet.')
						]);
				}
			}
		}
	});
var $author$project$Page$CodingQuestion$view = function (_v0) {
	var model = _v0;
	var db = model.hB.u;
	var mbInfos = A2($author$project$Page$CodingQuestion$relatedData, model.c.S, db);
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				return _List_fromArray(
					[
						function () {
						if (!mbInfos.$) {
							var infos = mbInfos.a;
							return A2(
								$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
								_List_fromArray(
									[$aforemny$material_components_web_elm$Material$Typography$typography]),
								_List_fromArray(
									[
										A2(
										$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_Nil,
												_Utils_ap(
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h1,
															_List_fromArray(
																[$aforemny$material_components_web_elm$Material$Typography$headline5]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Question')
																])),
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Text: ')
																])),
															$aforemny$material_components_web_elm$Material$TextField$filled(
															A2(
																$aforemny$material_components_web_elm$Material$TextField$setOnInput,
																function (x) {
																	return $author$project$Type$Database$TypeMatching$setField(
																		{dk: 'text', S: model.c.S, d9: $author$project$Type$Database$CodingQuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
																},
																A2(
																	$aforemny$material_components_web_elm$Material$TextField$setValue,
																	$elm$core$Maybe$Just(infos.hQ),
																	A2(
																		$aforemny$material_components_web_elm$Material$TextField$setLabel,
																		$elm$core$Maybe$Just('Coding Question text'),
																		$aforemny$material_components_web_elm$Material$TextField$config))))
														]),
													A2($author$project$Page$CodingQuestion$viewInputTypeSelection, model.c, infos.d4))),
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_Nil,
												A4($author$project$Page$CodingQuestion$viewSettings, model.hB.u, model.c.S, model.c, infos.d4))
											]))
									]));
						} else {
							return $elm$html$Html$text('got No Infos');
						}
					}()
					]);
			},
			h5: $author$project$Page$CodingQuestion$toTitle(model.c),
			c5: model.hB.c5
		});
};
var $author$project$Page$CodingQuestion$page = F2(
	function (session, id) {
		var model = {
			c: A2($author$project$Page$CodingQuestion$init, session.u, id),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $elm$core$Basics$identity,
			ih: $author$project$Page$CodingQuestion$update,
			ik: $author$project$Page$CodingQuestion$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Event$Model = F3(
	function (page, id, nameFocus) {
		return {S: id, en: nameFocus, c: page};
	});
var $author$project$Page$Event$init = F2(
	function (page_, id) {
		return A2($author$project$Page$Event$Model, page_, id);
	});
var $author$project$Page$Event$update = F2(
	function (message, _v0) {
		var model = _v0;
		if (message.$ === 10) {
			var msg = message.a;
			switch (msg.$) {
				case 0:
					var msg_ = msg.a;
					if (!msg_) {
						var old_page = model.c;
						var new_page = _Utils_update(
							old_page,
							{en: true});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{c: new_page}),
							$elm$core$Platform$Cmd$none);
					} else {
						var old_page = model.c;
						var new_page = _Utils_update(
							old_page,
							{en: false});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{c: new_page}),
							$elm$core$Platform$Cmd$none);
					}
				case 1:
					var questionary = msg.a.eI;
					var test_subject = msg.a.aO;
					var event = msg.a.as;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Msg$Event = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$EventNameEdit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$Follow = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Msg$FollowSubpage = F4(
	function (a, b, c, d) {
		return {$: 20, a: a, b: b, c: c, d: d};
	});
var $author$project$Msg$GetFocus = 0;
var $author$project$Msg$LooseFocus = 1;
var $author$project$Type$Database$TestSubjectType = {$: 12};
var $aforemny$material_components_web_elm$Material$Button$Internal$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$Button$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$Button$Internal$Icon(
			{bM: attributes, bk: node, bl: nodes});
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $aforemny$material_components_web_elm$Material$Button$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$Button$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $author$project$Page$Event$relatedData = F2(
	function (id, db) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Type$IO$Internal$unbox(id),
			db.gm);
		if (!_v0.$) {
			var timestampedEvent = _v0.a;
			var event = timestampedEvent.fb;
			return $elm$core$Maybe$Just(
				{
					f8: $elm$time$Time$millisToPosix(timestampedEvent.f8),
					a5: _Utils_Tuple2(
						timestampedEvent.a5,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(timestampedEvent.a5),
								db.c6))),
					S: id,
					cn: event.hl,
					af: event.af,
					bs: A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapFirst($author$project$Type$IO$Internal$box),
						$elm$core$Dict$toList(
							A2(
								$elm$core$Dict$map,
								F2(
									function (x, y) {
										return y.fb;
									}),
								A2(
									$elm$core$Dict$filter,
									F2(
										function (x, y) {
											return _Utils_eq(y.fb.cY, event.cY);
										}),
									db.bs)))),
					cY: _Utils_Tuple2(
						event.cY,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(event.cY),
								db.hK))),
					aP: A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapFirst($author$project$Type$IO$Internal$box),
						$elm$core$Dict$toList(
							A2(
								$elm$core$Dict$map,
								F2(
									function (x, y) {
										return y.fb;
									}),
								A2(
									$elm$core$Dict$filter,
									F2(
										function (x, y) {
											return _Utils_eq(y.fb.as, id);
										}),
									db.aP)))),
					fa: $elm$time$Time$millisToPosix(timestampedEvent.gW)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $aforemny$material_components_web_elm$Material$Button$setIcon = F2(
	function (icon_, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{d0: icon_});
	});
var $aforemny$material_components_web_elm$Material$LayoutGrid$spanDesktop = function (n) {
	return $elm$html$Html$Attributes$class(
		'mdc-layout-grid__cell--span-' + ($elm$core$String$fromInt(n) + '-desktop'));
};
var $aforemny$material_components_web_elm$Material$LayoutGrid$span8Desktop = $aforemny$material_components_web_elm$Material$LayoutGrid$spanDesktop(8);
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $aforemny$material_components_web_elm$Material$TextField$outlined = function (config_) {
	return A2($aforemny$material_components_web_elm$Material$TextField$textField, true, config_);
};
var $aforemny$material_components_web_elm$Material$TextField$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bF: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$TextField$setOnChange = F2(
	function (onChange, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cy: $elm$core$Maybe$Just(onChange)
			});
	});
var $author$project$Viewer$EditableText$text = F3(
	function (c, attributes, value) {
		return c.fp ? $aforemny$material_components_web_elm$Material$TextField$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onBlur(
						c.gb('')),
					attributes),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setLabel,
					$elm$core$Maybe$Nothing,
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setOnChange,
						c.gb,
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							c.fT,
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								$elm$core$Maybe$Just(value),
								$aforemny$material_components_web_elm$Material$TextField$config)))))) : A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onClick(c.fo),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onBlur(
						c.gb('')),
					attributes)),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Page$Event$toTitle = function (model) {
	return 'Home ⧽ Event';
};
var $elm$core$String$toUpper = _String_toUpper;
var $aforemny$material_components_web_elm$Material$Button$Unelevated = 2;
var $aforemny$material_components_web_elm$Material$Button$unelevated = F2(
	function (config_, label) {
		return A3($aforemny$material_components_web_elm$Material$Button$button, 2, config_, label);
	});
var $aforemny$material_components_web_elm$Material$List$Item$config = {bF: _List_Nil, aC: false, aG: $elm$core$Maybe$Nothing, bd: false, cz: $elm$core$Maybe$Nothing, bu: false, hA: $elm$core$Maybe$Nothing, c$: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$List$Item$graphic = F2(
	function (additionalAttributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-deprecated-list-item__graphic'),
				additionalAttributes),
			nodes);
	});
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $gdamjan$elm_identicon$Identicon$mirror = $elm$core$Tuple$mapFirst(
	$elm$core$Basics$sub(4));
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $gdamjan$elm_identicon$Identicon$pixel = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromInt(y)),
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromInt(x)),
				$elm$svg$Svg$Attributes$width('1'),
				$elm$svg$Svg$Attributes$height('1')
			]),
		_List_Nil);
};
var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $gdamjan$elm_identicon$Identicon$toCoordinates = function (i) {
	var y = A2($elm$core$Basics$modBy, 5, i);
	var x = $elm$core$Basics$floor(i / 5);
	return _Utils_Tuple2(x, y);
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $gdamjan$elm_identicon$Identicon$custom = F4(
	function (hasher, colorer, size, string) {
		var hash = hasher(string);
		var pixels = A2(
			$elm$core$List$map,
			$gdamjan$elm_identicon$Identicon$pixel,
			function (l) {
				return A2(
					$elm$core$List$append,
					l,
					A2($elm$core$List$map, $gdamjan$elm_identicon$Identicon$mirror, l));
			}(
				A2(
					$elm$core$List$map,
					$gdamjan$elm_identicon$Identicon$toCoordinates,
					A2(
						$elm$core$List$filter,
						function (i) {
							return !A2($elm$core$Basics$modBy, 2, hash >> i);
						},
						A2($elm$core$List$range, 0, 14)))));
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 5 5'),
					$elm$svg$Svg$Attributes$fill(
					$avh4$elm_color$Color$toCssString(
						colorer(string))),
					$elm$svg$Svg$Attributes$height(size),
					$elm$svg$Svg$Attributes$width(size),
					$elm$svg$Svg$Attributes$shapeRendering('crispEdges')
				]),
			pixels);
	});
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, alpha);
	});
var $avh4$elm_color$Color$hsl = F3(
	function (h, s, l) {
		return A4($avh4$elm_color$Color$hsla, h, s, l, 1.0);
	});
var $gdamjan$elm_identicon$Identicon$color = function (hash) {
	var hue = A2($elm$core$Basics$modBy, 100, hash) / 100;
	return A3($avh4$elm_color$Color$hsl, hue, 0.5, 0.7);
};
var $gdamjan$elm_identicon$Identicon$defaultHash = function () {
	var step = function (b) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$add(b),
			A2(
				$elm$core$Basics$composeR,
				function (x) {
					return x + (10 << x);
				},
				function (x) {
					return x ^ (6 >> x);
				}));
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toList,
		A2(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$List$foldr,
				A2($elm$core$Basics$composeR, $elm$core$Char$toCode, step),
				0),
			A2(
				$elm$core$Basics$composeR,
				function (x) {
					return x + (3 << x);
				},
				A2(
					$elm$core$Basics$composeR,
					function (x) {
						return x ^ (11 >> x);
					},
					function (x) {
						return x + (15 << x);
					}))));
}();
var $gdamjan$elm_identicon$Identicon$defaultColor = A2($elm$core$Basics$composeL, $gdamjan$elm_identicon$Identicon$color, $gdamjan$elm_identicon$Identicon$defaultHash);
var $gdamjan$elm_identicon$Identicon$identicon = A2($gdamjan$elm_identicon$Identicon$custom, $gdamjan$elm_identicon$Identicon$defaultHash, $gdamjan$elm_identicon$Identicon$defaultColor);
var $aforemny$material_components_web_elm$Material$List$Item$Internal$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $aforemny$material_components_web_elm$Material$List$Item$Internal$Activated = 1;
var $aforemny$material_components_web_elm$Material$List$Item$activatedCs = function (_v0) {
	var selection = _v0.hA;
	return _Utils_eq(
		selection,
		$elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-deprecated-list-item--activated')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$ariaSelectedAttr = function (_v0) {
	var selection = _v0.hA;
	return (!_Utils_eq(selection, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
		A2($elm$html$Html$Attributes$attribute, 'aria-selected', 'true')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$disabledCs = function (_v0) {
	var disabled = _v0.aC;
	return disabled ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-deprecated-list-item--disabled')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$hrefAttr = function (_v0) {
	var href = _v0.aG;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, href);
};
var $aforemny$material_components_web_elm$Material$List$Item$interactiveProp = function (_v0) {
	var interactive = _v0.bd;
	return A2(
		$elm$html$Html$Attributes$property,
		'interactive',
		$elm$json$Json$Encode$bool(interactive));
};
var $aforemny$material_components_web_elm$Material$List$Item$listItemCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-deprecated-list-item'));
var $aforemny$material_components_web_elm$Material$List$Item$rippleElt = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-deprecated-list-item__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$List$Item$ripplesProp = function (_v0) {
	var ripples = _v0.bu;
	return A2(
		$elm$html$Html$Attributes$property,
		'ripples',
		$elm$json$Json$Encode$bool(ripples));
};
var $aforemny$material_components_web_elm$Material$List$Item$Internal$Selected = 0;
var $aforemny$material_components_web_elm$Material$List$Item$selectedCs = function (_v0) {
	var selection = _v0.hA;
	return _Utils_eq(
		selection,
		$elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-deprecated-list-item--selected')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$targetAttr = function (_v0) {
	var href = _v0.aG;
	var target = _v0.c$;
	return (!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? A2($elm$core$Maybe$map, $elm$html$Html$Attributes$target, target) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Item$listItemView = F2(
	function (config_, nodes) {
		var additionalAttributes = config_.bF;
		var href = config_.aG;
		return A2(
			F2(
				function (attributes, nodes_) {
					return A3(
						$elm$html$Html$node,
						'mdc-list-item',
						_Utils_ap(
							_List_fromArray(
								[
									$aforemny$material_components_web_elm$Material$List$Item$ripplesProp(config_),
									$aforemny$material_components_web_elm$Material$List$Item$interactiveProp(config_)
								]),
							(!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? _List_Nil : attributes),
						(!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? _List_fromArray(
							[
								A2($elm$html$Html$a, attributes, nodes_)
							]) : nodes_);
				}),
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$List$Item$listItemCs,
							$aforemny$material_components_web_elm$Material$List$Item$hrefAttr(config_),
							$aforemny$material_components_web_elm$Material$List$Item$targetAttr(config_),
							$aforemny$material_components_web_elm$Material$List$Item$disabledCs(config_),
							$aforemny$material_components_web_elm$Material$List$Item$selectedCs(config_),
							$aforemny$material_components_web_elm$Material$List$Item$activatedCs(config_),
							$aforemny$material_components_web_elm$Material$List$Item$ariaSelectedAttr(config_)
						])),
				additionalAttributes),
			A2($elm$core$List$cons, $aforemny$material_components_web_elm$Material$List$Item$rippleElt, nodes));
	});
var $aforemny$material_components_web_elm$Material$List$Item$listItem = F2(
	function (config_, nodes) {
		return A2(
			$aforemny$material_components_web_elm$Material$List$Item$Internal$ListItem,
			function (config__) {
				return A2($aforemny$material_components_web_elm$Material$List$Item$listItemView, config__, nodes);
			},
			config_);
	});
var $aforemny$material_components_web_elm$Material$List$Item$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cz: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Page$Event$viewList = F3(
	function (elements, onClick, nameGetter) {
		var mlist = A2(
			$elm$core$List$map,
			function (_v1) {
				var x = _v1.a;
				var y = _v1.b;
				return A2(
					$aforemny$material_components_web_elm$Material$List$Item$listItem,
					A2(
						$aforemny$material_components_web_elm$Material$List$Item$setOnClick,
						onClick(
							$author$project$Type$IO$Internal$unbox(x)),
						$aforemny$material_components_web_elm$Material$List$Item$config),
					_List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$List$Item$graphic,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$gdamjan$elm_identicon$Identicon$identicon,
									'100%',
									$author$project$Type$IO$Internal$unbox(x))
								])),
							$elm$html$Html$text(
							nameGetter(
								_Utils_Tuple2(x, y)))
						]));
			},
			elements);
		if (mlist.b) {
			var f = mlist.a;
			var r = mlist.b;
			return A3($aforemny$material_components_web_elm$Material$List$list, $aforemny$material_components_web_elm$Material$List$config, f, r);
		} else {
			return A3(
				$aforemny$material_components_web_elm$Material$List$list,
				$aforemny$material_components_web_elm$Material$List$config,
				A2(
					$aforemny$material_components_web_elm$Material$List$Item$listItem,
					$aforemny$material_components_web_elm$Material$List$Item$config,
					_List_fromArray(
						[
							$elm$html$Html$text('Nothing here, create one?')
						])),
				_List_Nil);
		}
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Page$Event$viewTable = F4(
	function (db, questionnaries, test_subjects, event_id) {
		return A2(
			$aforemny$material_components_web_elm$Material$DataTable$dataTable,
			$aforemny$material_components_web_elm$Material$DataTable$config,
			{
				hO: A2(
					$elm$core$List$map,
					function (_v0) {
						var test_subject_id = _v0.a;
						var test_subject_value = _v0.b;
						return A2(
							$aforemny$material_components_web_elm$Material$DataTable$row,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$aforemny$material_components_web_elm$Material$DataTable$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$toUpper(
												A2(
													$elm$core$String$left,
													4,
													$author$project$Type$IO$Internal$unbox(test_subject_id))))
										])),
								A2(
									$elm$core$List$map,
									function (_v1) {
										var questionary_id = _v1.a;
										var questionary_value = _v1.b;
										return A2(
											$aforemny$material_components_web_elm$Material$DataTable$cell,
											_List_Nil,
											_List_fromArray(
												[
													function () {
													var questions = $elm$core$Dict$toList(
														A2(
															$elm$core$Dict$filter,
															F2(
																function (question_id, question_table) {
																	return _Utils_eq(question_table.fb.eI, questionary_id);
																}),
															db.hp));
													var q_ids = A2(
														$elm$core$List$map,
														function (_v2) {
															var qid = _v2.a;
															return qid;
														},
														questions);
													var answers = $elm$core$Dict$toList(
														A2(
															$elm$core$Dict$filter,
															F2(
																function (answer_id, answer_table) {
																	return _Utils_eq(answer_table.fb.aO, test_subject_id);
																}),
															A2(
																$elm$core$Dict$filter,
																F2(
																	function (answer_id, answer_table) {
																		return A2(
																			$elm$core$List$member,
																			$author$project$Type$IO$Internal$unbox(answer_table.fb.eH),
																			q_ids);
																	}),
																db.bL)));
													return A2(
														$aforemny$material_components_web_elm$Material$Button$unelevated,
														A2(
															$aforemny$material_components_web_elm$Material$Button$setOnClick,
															A4(
																$author$project$Msg$FollowSubpage,
																$author$project$Type$Database$EventType,
																$author$project$Type$IO$Internal$unbox(event_id),
																_List_fromArray(
																	['answer']),
																_List_fromArray(
																	[
																		A2(
																		$elm$url$Url$Builder$string,
																		'qid',
																		$author$project$Type$IO$Internal$unbox(questionary_id)),
																		A2(
																		$elm$url$Url$Builder$string,
																		'tsid',
																		$author$project$Type$IO$Internal$unbox(test_subject_id))
																	])),
															$aforemny$material_components_web_elm$Material$Button$config),
														$elm$core$String$fromInt(
															$elm$core$List$length(answers)) + ('/' + $elm$core$String$fromInt(
															$elm$core$List$length(questions))));
												}()
												]));
									},
									questionnaries)));
					},
					test_subjects),
				h2: _List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$DataTable$row,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$aforemny$material_components_web_elm$Material$DataTable$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Subject')
									])),
							A2(
								$elm$core$List$map,
								function (_v3) {
									var x = _v3.a;
									var y = _v3.b;
									return A2(
										$aforemny$material_components_web_elm$Material$DataTable$cell,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(y.af)
											]));
								},
								questionnaries)))
					])
			});
	});
var $author$project$Page$Event$view = function (_v0) {
	var model = _v0;
	var econf = {
		fo: $author$project$Msg$Event(
			$author$project$Msg$EventNameEdit(0)),
		fp: model.c.en,
		fT: function (z) {
			return $author$project$Type$Database$TypeMatching$setField(
				{dk: 'name', S: model.c.S, d9: $author$project$Type$Database$EventType, eV: $author$project$Type$IO$Setter$StringMsg, fb: z});
		},
		gb: function (_v6) {
			return $author$project$Msg$Event(
				$author$project$Msg$EventNameEdit(1));
		}
	};
	var db = model.hB.u;
	var mbInfos = A2($author$project$Page$Event$relatedData, model.c.S, db);
	if (!mbInfos.$) {
		var infos = mbInfos.a;
		return _Utils_update(
			$author$project$Viewer$detailsConfig,
			{
				fn: _List_fromArray(
					[
						_Utils_Tuple2(
						'settings',
						A4(
							$author$project$Msg$FollowSubpage,
							$author$project$Type$Database$EventType,
							$author$project$Type$IO$Internal$unbox(infos.S),
							_List_fromArray(
								['settings']),
							_List_Nil))
					]),
				fI: function (_v2) {
					return _List_fromArray(
						[
							function () {
							var _v3 = model.c.c;
							switch (_v3) {
								case 0:
									return $elm$html$Html$text('Settings:');
								case 2:
									return A2(
										$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
										_List_fromArray(
											[$aforemny$material_components_web_elm$Material$Typography$typography]),
										_List_fromArray(
											[
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
														_List_fromArray(
															[$aforemny$material_components_web_elm$Material$LayoutGrid$span8Desktop]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h1,
																_List_fromArray(
																	[$aforemny$material_components_web_elm$Material$Typography$headline5]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Test Subjects')
																	])),
																A3(
																$author$project$Page$Event$viewList,
																infos.aP,
																$author$project$Msg$Follow($author$project$Type$Database$TestSubjectType),
																function (_v4) {
																	var x = _v4.a;
																	return $elm$core$String$toUpper(
																		A2(
																			$elm$core$String$left,
																			4,
																			$author$project$Type$IO$Internal$unbox(x)));
																}),
																A2(
																$aforemny$material_components_web_elm$Material$Button$unelevated,
																A2(
																	$aforemny$material_components_web_elm$Material$Button$setOnClick,
																	$author$project$Msg$CRUD(
																		A2(
																			$author$project$Msg$CreateRandom,
																			$author$project$Type$Database$TestSubjectType,
																			_List_fromArray(
																				[
																					function (x) {
																					return $author$project$Type$Database$TypeMatching$setField(
																						{
																							dk: 'event',
																							S: $author$project$Type$IO$Internal$box(x),
																							d9: $author$project$Type$Database$TestSubjectType,
																							eV: $author$project$Type$IO$Setter$StringMsg,
																							fb: $author$project$Type$IO$Internal$unbox(infos.S)
																						});
																				}
																				]))),
																	A2(
																		$aforemny$material_components_web_elm$Material$Button$setIcon,
																		$elm$core$Maybe$Just(
																			$aforemny$material_components_web_elm$Material$Button$icon('add')),
																		$aforemny$material_components_web_elm$Material$Button$config)),
																'Add')
															]))
													]))
											]));
								default:
									return A2(
										$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
										_List_fromArray(
											[$aforemny$material_components_web_elm$Material$Typography$typography]),
										_List_fromArray(
											[
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h1,
																_List_fromArray(
																	[$aforemny$material_components_web_elm$Material$Typography$headline5]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Viewer$EditableText$text,
																		econf,
																		_List_Nil,
																		A2(
																			$elm$core$Maybe$withDefault,
																			'',
																			A2(
																				$elm$core$Maybe$map,
																				function (x) {
																					return x.fb.af;
																				},
																				A2(
																					$elm$core$Dict$get,
																					$author$project$Type$IO$Internal$unbox(model.c.S),
																					db.gm))))
																	])),
																A2(
																$elm$html$Html$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		'Location:' + $author$project$Type$IO$Internal$unbox(infos.cn))
																	])),
																A2(
																$elm$html$Html$p,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$aforemny$material_components_web_elm$Material$Button$unelevated,
																		A2(
																			$aforemny$material_components_web_elm$Material$Button$setOnClick,
																			$author$project$Msg$CRUD(
																				A2(
																					$author$project$Msg$CreateRandom,
																					$author$project$Type$Database$TestSubjectType,
																					_List_fromArray(
																						[
																							function (x) {
																							return $author$project$Type$Database$TypeMatching$setField(
																								{
																									dk: 'event',
																									S: $author$project$Type$IO$Internal$box(x),
																									d9: $author$project$Type$Database$TestSubjectType,
																									eV: $author$project$Type$IO$Setter$StringMsg,
																									fb: $author$project$Type$IO$Internal$unbox(infos.S)
																								});
																						}
																						]))),
																			A2(
																				$aforemny$material_components_web_elm$Material$Button$setIcon,
																				$elm$core$Maybe$Just(
																					$aforemny$material_components_web_elm$Material$Button$icon('add')),
																				$aforemny$material_components_web_elm$Material$Button$config)),
																		'Add Subjects')
																	]))
															])),
														A2(
														$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
														_List_Nil,
														_List_fromArray(
															[
																A4($author$project$Page$Event$viewTable, db, infos.bs, infos.aP, infos.S)
															]))
													]))
											]));
							}
						}()
						]);
				},
				h5: infos.af,
				c5: model.hB.c5
			});
	} else {
		return _Utils_update(
			$author$project$Viewer$detailsConfig,
			{
				fI: function (_v5) {
					return _List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$Typography$headline5]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'Event not Found: ' + $author$project$Type$IO$Internal$unbox(model.c.S))
														]))
												]))
										]))
								]))
						]);
				},
				h5: $author$project$Page$Event$toTitle(model.c),
				c5: model.hB.c5
			});
	}
};
var $author$project$Page$Event$page = F4(
	function (session, subpage, id, focus) {
		var model = {
			c: A3($author$project$Page$Event$init, subpage, id, focus),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $elm$core$Basics$identity,
			ih: $author$project$Page$Event$update,
			ik: $author$project$Page$Event$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Msg$PageOne = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$PageOne$init = {};
var $author$project$Page$liftupdate = F3(
	function (uf, msg, _v0) {
		var model = _v0;
		var _v1 = A2(uf, msg, model.c);
		var newModel = _v1.a;
		var effect = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{c: newModel}),
			effect);
	});
var $author$project$Page$PageOne$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$PageOne$toTitle = 'Page One';
var $author$project$Page$PageOne$view = function (model) {
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v0) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('elm-spa-boilerplate - Page One')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('A beautiful, completely empty page in your application.')
							]))
					]);
			},
			h5: $author$project$Page$PageOne$toTitle
		});
};
var $author$project$Page$PageOne$page = function (session) {
	var model = {
		c: $author$project$Page$PageOne$init,
		hB: session,
		e3: $elm$core$Platform$Sub$none,
		e6: $author$project$Msg$PageOne,
		ih: $author$project$Page$liftupdate($author$project$Page$PageOne$update),
		ik: $author$project$Page$PageOne$view
	};
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Msg$PageWithSubpage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$PageWithSubpage$Model = function (subpage) {
	return {e1: subpage};
};
var $author$project$Page$PageWithSubpage$init = function (subpage) {
	return $author$project$Page$PageWithSubpage$Model(subpage);
};
var $author$project$Page$PageWithSubpage$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$PageWithSubpage$toTitle = function (model) {
	return 'Page With Subpage - ' + model.e1;
};
var $author$project$Page$PageWithSubpage$view = function (_v0) {
	var model = _v0;
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('elm-spa-boilerplate - Page With Subpage')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This is a page that can handle subpaths in its routing.')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The current subpath is : /' + model.c.e1)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The subpath could be anything, or a specific type, like a string or integer. You can have many levels of subpaths if you wanted!')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' This demo accepts a single level subpath that can be any string. For example, '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/pagewithsubpage/xyz')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('/pagewithsubpage/xyz')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/pagewithsubpage/a-wonderful-subpath')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('click here to go to a subpath')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/pagewithsubpage/i-love-elm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('click here to go to another subpath')
											]))
									]))
							]))
					]);
			},
			h5: $author$project$Page$PageWithSubpage$toTitle(model.c)
		});
};
var $author$project$Page$PageWithSubpage$page = F2(
	function (session, subpage) {
		var model = {
			c: $author$project$Page$PageWithSubpage$init(subpage),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $author$project$Msg$PageWithSubpage,
			ih: $author$project$Page$liftupdate($author$project$Page$PageWithSubpage$update),
			ik: $author$project$Page$PageWithSubpage$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Question$Model = F8(
	function (id, question, _short, _long, list, codingQuestionaryID, codingQuestionary, codingQuestions) {
		return {bS: codingQuestionary, a_: codingQuestionaryID, dv: codingQuestions, S: id, aa: list, ab: _long, eH: question, ak: _short};
	});
var $author$project$Page$Question$init = F2(
	function (db, id) {
		var q = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fb;
			},
			A2(
				$elm$core$Dict$get,
				$author$project$Type$IO$Internal$unbox(id),
				db.hp));
		var it_id = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.d4;
			},
			q);
		var it = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.d4;
			},
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Type$Database$question.fd(db),
				q));
		var coding_questionary = $elm$core$List$head(
			A2(
				$elm$core$List$sortBy,
				function (_v1) {
					var cqid = _v1.a;
					var cq = _v1.b;
					return cq.f8;
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (cqid, cq) {
								return _Utils_eq(cq.fb.eH, id);
							}),
						db.f2))));
		var cid = A2($elm$core$Maybe$map, $elm$core$Tuple$first, coding_questionary);
		var coding_questions = $elm$core$Dict$toList(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (cqqid, cqq) {
						return _Utils_eq(
							$elm$core$Maybe$Just(cqq.fb.f1),
							A2($elm$core$Maybe$map, $author$project$Type$IO$Internal$box, cid));
					}),
				db.dy));
		var emptyModel = A8(
			$author$project$Page$Question$Model,
			id,
			A2(
				$elm$core$Dict$get,
				$author$project$Type$IO$Internal$unbox(id),
				db.hp),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			A2($elm$core$Maybe$map, $author$project$Type$IO$Internal$box, cid),
			A2($elm$core$Maybe$map, $elm$core$Tuple$second, coding_questionary),
			coding_questions);
		var _v0 = _Utils_Tuple2(it, it_id);
		if (!_v0.a.$) {
			switch (_v0.a.a.$) {
				case 0:
					var a = _v0.b;
					return _Utils_update(
						emptyModel,
						{ak: a});
				case 1:
					var a = _v0.b;
					return _Utils_update(
						emptyModel,
						{ab: a});
				default:
					var a = _v0.b;
					return _Utils_update(
						emptyModel,
						{aa: a});
			}
		} else {
			return emptyModel;
		}
	});
var $author$project$Page$Question$update = F2(
	function (message, _v0) {
		var model = _v0;
		var updatePage = function (x) {
			return _Utils_update(
				model,
				{c: x});
		};
		var oldmodel = model.c;
		var setInputTypeDb = function (it) {
			var oldsession = model.hB;
			var olddb = oldsession.u;
			var newdb = function (n) {
				return _Utils_update(
					oldsession,
					{u: n});
			};
			var newq = function (n) {
				return newdb(
					_Utils_update(
						olddb,
						{hp: n}));
			};
			return newq(
				A3(
					$elm$core$Dict$update,
					$author$project$Type$IO$Internal$unbox(oldmodel.S),
					$elm$core$Maybe$map(
						function (i) {
							var oldvalue = i.fb;
							var newvalue = function (n) {
								return _Utils_update(
									i,
									{fb: n});
							};
							var newquestion = _Utils_update(
								oldvalue,
								{d4: it});
							return newvalue(newquestion);
						}),
					model.hB.u.hp));
		};
		if (message.$ === 12) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Question$relatedData = F2(
	function (id, db) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Type$IO$Internal$unbox(id),
			db.hp);
		if (!_v0.$) {
			var timestampedQuestion = _v0.a;
			var question = timestampedQuestion.fb;
			var coding_questions = A2(
				$elm$core$List$filter,
				function (_v1) {
					var y = _v1.b;
					return _Utils_eq(y.eH, id);
				},
				A2(
					$elm$core$List$map,
					function (_v2) {
						var x = _v2.a;
						var y = _v2.b;
						return _Utils_Tuple2(x, y.fb);
					},
					$elm$core$Dict$toList(db.f2)));
			return $elm$core$Maybe$Just(
				{
					f8: $elm$time$Time$millisToPosix(timestampedQuestion.f8),
					a5: _Utils_Tuple2(
						timestampedQuestion.a5,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(timestampedQuestion.a5),
								db.c6))),
					S: id,
					d4: _Utils_Tuple2(
						question.d4,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.d4;
							},
							A2($author$project$Type$Database$question.fd, db, question))),
					hQ: question.hQ,
					fa: $elm$time$Time$millisToPosix(timestampedQuestion.gW)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Question$toTitle = function (_v0) {
	return 'Home ⧽ Question';
};
var $aforemny$material_components_web_elm$Material$Switch$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Switch$config = {bF: _List_Nil, aX: false, aC: false, cy: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$Switch$setChecked = F2(
	function (checked, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{aX: checked});
	});
var $aforemny$material_components_web_elm$Material$Switch$setOnChange = F2(
	function (onChange, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cy: $elm$core$Maybe$Just(onChange)
			});
	});
var $aforemny$material_components_web_elm$Material$Switch$checkedProp = function (_v0) {
	var checked = _v0.aX;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'checked',
			$elm$json$Json$Encode$bool(checked)));
};
var $aforemny$material_components_web_elm$Material$Switch$disabledProp = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'disabled',
			$elm$json$Json$Encode$bool(disabled)));
};
var $aforemny$material_components_web_elm$Material$Switch$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-switch'));
var $aforemny$material_components_web_elm$Material$Switch$changeHandler = function (_v0) {
	var onChange = _v0.cy;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('change'),
			$elm$json$Json$Decode$succeed),
		onChange);
};
var $aforemny$material_components_web_elm$Material$Switch$checkboxTypeAttr = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$type_('checkbox'));
var $aforemny$material_components_web_elm$Material$Switch$nativeControlCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-switch__native-control'));
var $aforemny$material_components_web_elm$Material$Switch$switchRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'switch'));
var $aforemny$material_components_web_elm$Material$Switch$nativeControlElt = function (config_) {
	return A2(
		$elm$html$Html$input,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Switch$nativeControlCs,
					$aforemny$material_components_web_elm$Material$Switch$checkboxTypeAttr,
					$aforemny$material_components_web_elm$Material$Switch$switchRoleAttr,
					$aforemny$material_components_web_elm$Material$Switch$checkedProp(config_),
					$aforemny$material_components_web_elm$Material$Switch$changeHandler(config_)
				])),
		_List_Nil);
};
var $aforemny$material_components_web_elm$Material$Switch$thumbElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-switch__thumb')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Switch$thumbUnderlayElt = function (config_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-switch__thumb-underlay')
			]),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Switch$thumbElt,
				$aforemny$material_components_web_elm$Material$Switch$nativeControlElt(config_)
			]));
};
var $aforemny$material_components_web_elm$Material$Switch$trackElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-switch__track')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Switch$switch = function (config_) {
	var additionalAttributes = config_.bF;
	return A3(
		$elm$html$Html$node,
		'mdc-switch',
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Switch$rootCs,
						$aforemny$material_components_web_elm$Material$Switch$checkedProp(config_),
						$aforemny$material_components_web_elm$Material$Switch$disabledProp(config_)
					])),
			additionalAttributes),
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Switch$trackElt,
				$aforemny$material_components_web_elm$Material$Switch$thumbUnderlayElt(config_)
			]));
};
var $author$project$Page$Question$viewCodingQuestion = function (_v0) {
	var id = _v0.a;
	var cquestion = _v0.b;
	return A2(
		$aforemny$material_components_web_elm$Material$List$Item$listItem,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$setOnClick,
			A2($author$project$Msg$Follow, $author$project$Type$Database$CodingQuestionType, id),
			$aforemny$material_components_web_elm$Material$List$Item$config),
		_List_fromArray(
			[
				$elm$html$Html$text(cquestion.fb.hQ)
			]));
};
var $author$project$Page$Question$viewCodingQuestions = function (model) {
	var enabled = function () {
		var _v4 = model.bS;
		if (!_v4.$) {
			var cq = _v4.a;
			return cq.fb.dL;
		} else {
			return false;
		}
	}();
	return _List_fromArray(
		[
			A2(
			$aforemny$material_components_web_elm$Material$FormField$formField,
			A2(
				$aforemny$material_components_web_elm$Material$FormField$setLabel,
				$elm$core$Maybe$Just('Enable Coding'),
				$aforemny$material_components_web_elm$Material$FormField$config),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Switch$switch(
					A2(
						$aforemny$material_components_web_elm$Material$Switch$setOnChange,
						function () {
							var _v0 = _Utils_Tuple2(model.a_, model.bS);
							if ((!_v0.a.$) && (!_v0.b.$)) {
								var cqid = _v0.a.a;
								var cq = _v0.b.a;
								return $author$project$Type$Database$TypeMatching$setField(
									{dk: 'enabled', S: cqid, d9: $author$project$Type$Database$CodingQuestionaryType, eV: $author$project$Type$IO$Setter$BoolMsg, fb: !cq.fb.dL});
							} else {
								return $author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$CodingQuestionaryType,
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{
														dk: 'question',
														S: $author$project$Type$IO$Internal$box(x),
														d9: $author$project$Type$Database$CodingQuestionaryType,
														eV: $author$project$Type$IO$Setter$StringMsg,
														fb: $author$project$Type$IO$Internal$unbox(model.S)
													});
											},
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{
														dk: 'enabled',
														S: $author$project$Type$IO$Internal$box(x),
														d9: $author$project$Type$Database$CodingQuestionaryType,
														eV: $author$project$Type$IO$Setter$BoolMsg,
														fb: true
													});
											}
											])));
							}
						}(),
						A2($aforemny$material_components_web_elm$Material$Switch$setChecked, enabled, $aforemny$material_components_web_elm$Material$Switch$config)))
				])),
			function () {
			var _v1 = A2($elm$core$List$map, $author$project$Page$Question$viewCodingQuestion, model.dv);
			if (_v1.b) {
				var first = _v1.a;
				var rest = _v1.b;
				return A3($aforemny$material_components_web_elm$Material$List$list, $aforemny$material_components_web_elm$Material$List$config, first, rest);
			} else {
				var _v2 = model.a_;
				if (!_v2.$) {
					return $elm$html$Html$text('No Question yet!');
				} else {
					return A2($elm$html$Html$div, _List_Nil, _List_Nil);
				}
			}
		}(),
			function () {
			var _v3 = model.a_;
			if (!_v3.$) {
				var cid = _v3.a;
				return A2(
					$aforemny$material_components_web_elm$Material$Button$unelevated,
					A2(
						$aforemny$material_components_web_elm$Material$Button$setOnClick,
						$author$project$Msg$CRUD(
							A2(
								$author$project$Msg$CreateRandom,
								$author$project$Type$Database$CodingQuestionType,
								_List_fromArray(
									[
										function (x) {
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'coding_questionary',
												S: $author$project$Type$IO$Internal$box(x),
												d9: $author$project$Type$Database$CodingQuestionType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(cid)
											});
									}
									]))),
						A2(
							$aforemny$material_components_web_elm$Material$Button$setIcon,
							$elm$core$Maybe$Just(
								$aforemny$material_components_web_elm$Material$Button$icon('add')),
							$aforemny$material_components_web_elm$Material$Button$config)),
					'Add');
			} else {
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			}
		}()
		]);
};
var $author$project$Page$Question$viewInputTypeSelection = F2(
	function (model, _v0) {
		var id = _v0.a;
		return A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[x]));
			},
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$FormField$formField,
					A2(
						$aforemny$material_components_web_elm$Material$FormField$setOnClick,
						function () {
							var _v1 = model.ak;
							if (!_v1.$) {
								var _short = _v1.a;
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'input_type',
										S: model.S,
										d9: $author$project$Type$Database$QuestionType,
										eV: $author$project$Type$IO$Setter$StringMsg,
										fb: $author$project$Type$IO$Internal$unbox(_short)
									});
							} else {
								return $author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$InputTypeType(0),
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$QuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
											}
											])));
							}
						}(),
						A2(
							$aforemny$material_components_web_elm$Material$FormField$setFor,
							$elm$core$Maybe$Just('1'),
							A2(
								$aforemny$material_components_web_elm$Material$FormField$setLabel,
								$elm$core$Maybe$Just('Short Answer'),
								$aforemny$material_components_web_elm$Material$FormField$config))),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Radio$radio(
							A2(
								$aforemny$material_components_web_elm$Material$Radio$setOnChange,
								function () {
									var _v2 = model.ak;
									if (!_v2.$) {
										var _short = _v2.a;
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'input_type',
												S: model.S,
												d9: $author$project$Type$Database$QuestionType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(_short)
											});
									} else {
										return $author$project$Msg$CRUD(
											A2(
												$author$project$Msg$CreateRandom,
												$author$project$Type$Database$InputTypeType(0),
												_List_fromArray(
													[
														function (x) {
														return $author$project$Type$Database$TypeMatching$setField(
															{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$QuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
													}
													])));
									}
								}(),
								A2(
									$aforemny$material_components_web_elm$Material$Radio$setChecked,
									_Utils_eq(
										model.ak,
										$elm$core$Maybe$Just(id)),
									$aforemny$material_components_web_elm$Material$Radio$config)))
						])),
					A2(
					$aforemny$material_components_web_elm$Material$FormField$formField,
					A2(
						$aforemny$material_components_web_elm$Material$FormField$setOnClick,
						function () {
							var _v3 = model.ab;
							if (!_v3.$) {
								var _long = _v3.a;
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'input_type',
										S: model.S,
										d9: $author$project$Type$Database$QuestionType,
										eV: $author$project$Type$IO$Setter$StringMsg,
										fb: $author$project$Type$IO$Internal$unbox(_long)
									});
							} else {
								return $author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$InputTypeType(1),
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$QuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
											}
											])));
							}
						}(),
						A2(
							$aforemny$material_components_web_elm$Material$FormField$setFor,
							$elm$core$Maybe$Just('2'),
							A2(
								$aforemny$material_components_web_elm$Material$FormField$setLabel,
								$elm$core$Maybe$Just('Long Answer'),
								$aforemny$material_components_web_elm$Material$FormField$config))),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Radio$radio(
							A2(
								$aforemny$material_components_web_elm$Material$Radio$setOnChange,
								function () {
									var _v4 = model.ab;
									if (!_v4.$) {
										var _long = _v4.a;
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'input_type',
												S: model.S,
												d9: $author$project$Type$Database$QuestionType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(_long)
											});
									} else {
										return $author$project$Msg$CRUD(
											A2(
												$author$project$Msg$CreateRandom,
												$author$project$Type$Database$InputTypeType(1),
												_List_fromArray(
													[
														function (x) {
														return $author$project$Type$Database$TypeMatching$setField(
															{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$QuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
													}
													])));
									}
								}(),
								A2(
									$aforemny$material_components_web_elm$Material$Radio$setChecked,
									_Utils_eq(
										model.ab,
										$elm$core$Maybe$Just(id)),
									$aforemny$material_components_web_elm$Material$Radio$config)))
						])),
					A2(
					$aforemny$material_components_web_elm$Material$FormField$formField,
					A2(
						$aforemny$material_components_web_elm$Material$FormField$setOnClick,
						function () {
							var _v5 = model.aa;
							if (!_v5.$) {
								var list = _v5.a;
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'input_type',
										S: model.S,
										d9: $author$project$Type$Database$QuestionType,
										eV: $author$project$Type$IO$Setter$StringMsg,
										fb: $author$project$Type$IO$Internal$unbox(list)
									});
							} else {
								return $author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$InputTypeType(2),
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$QuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
											}
											])));
							}
						}(),
						A2(
							$aforemny$material_components_web_elm$Material$FormField$setFor,
							$elm$core$Maybe$Just('3'),
							A2(
								$aforemny$material_components_web_elm$Material$FormField$setLabel,
								$elm$core$Maybe$Just('Multiple Choice'),
								$aforemny$material_components_web_elm$Material$FormField$config))),
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Radio$radio(
							A2(
								$aforemny$material_components_web_elm$Material$Radio$setOnChange,
								function () {
									var _v6 = model.aa;
									if (!_v6.$) {
										var list = _v6.a;
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'input_type',
												S: model.S,
												d9: $author$project$Type$Database$QuestionType,
												eV: $author$project$Type$IO$Setter$StringMsg,
												fb: $author$project$Type$IO$Internal$unbox(list)
											});
									} else {
										return $author$project$Msg$CRUD(
											A2(
												$author$project$Msg$CreateRandom,
												$author$project$Type$Database$InputTypeType(2),
												_List_fromArray(
													[
														function (x) {
														return $author$project$Type$Database$TypeMatching$setField(
															{dk: 'input_type', S: model.S, d9: $author$project$Type$Database$QuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
													}
													])));
									}
								}(),
								A2(
									$aforemny$material_components_web_elm$Material$Radio$setChecked,
									_Utils_eq(
										model.aa,
										$elm$core$Maybe$Just(id)),
									$aforemny$material_components_web_elm$Material$Radio$config)))
						]))
				]));
	});
var $author$project$Page$Question$viewSettings = F4(
	function (db, id, model, _v0) {
		var itid = _v0.a;
		var mbit = _v0.b;
		var umessage = F3(
			function (attribute, setter, value) {
				return $author$project$Msg$CRUD(
					$author$project$Msg$Update(
						A2(
							$author$project$Type$IO$Setter$AttributeMsg,
							'questions',
							A2(
								$author$project$Type$IO$Setter$DictKeyMsg,
								$author$project$Type$IO$Internal$unbox(id),
								A2(
									$author$project$Type$IO$Setter$AttributeMsg,
									'value',
									A2(
										$author$project$Type$IO$Setter$AttributeMsg,
										'input_type',
										A2(
											$author$project$Type$IO$Setter$AttributeMsg,
											attribute,
											setter(value))))))));
			});
		var moreInfo = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Result$toMaybe,
				A2(
					$elm$core$Maybe$map,
					$author$project$Type$Database$InputType$input_type.h9('*'),
					mbit)));
		if (_Utils_eq(
			model.ak,
			$elm$core$Maybe$Just(itid))) {
			var _v1 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fb;
				},
				A2(
					$elm$core$Maybe$andThen,
					function (x) {
						return A2(
							$elm$core$Dict$get,
							$author$project$Type$IO$Internal$unbox(x),
							db.d5);
					},
					model.ak));
			if ((!_v1.$) && (!_v1.a.$)) {
				var _short = _v1.a.a;
				return _List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$TextField$filled(
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							function (x) {
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'label',
										S: itid,
										d9: $author$project$Type$Database$InputTypeType(0),
										eV: function (p) {
											return $author$project$Type$IO$Setter$MaybeSetMsg(
												$elm$core$Maybe$Just(
													$author$project$Type$IO$Setter$StringMsg(p)));
										},
										fb: x
									});
							},
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								_short.ea,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('Set the label'),
									$aforemny$material_components_web_elm$Material$TextField$config)))),
						$aforemny$material_components_web_elm$Material$TextField$filled(
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							function (x) {
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'placeholder',
										S: itid,
										d9: $author$project$Type$Database$InputTypeType(0),
										eV: function (p) {
											return $author$project$Type$IO$Setter$MaybeSetMsg(
												$elm$core$Maybe$Just(
													$author$project$Type$IO$Setter$StringMsg(p)));
										},
										fb: x
									});
							},
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								_short.hm,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('Set the placeholder'),
									$aforemny$material_components_web_elm$Material$TextField$config)))),
						$aforemny$material_components_web_elm$Material$TextField$filled(
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							function (x) {
								return $author$project$Type$Database$TypeMatching$setField(
									{
										dk: 'pattern',
										S: itid,
										d9: $author$project$Type$Database$InputTypeType(0),
										eV: function (p) {
											return $author$project$Type$IO$Setter$MaybeSetMsg(
												$elm$core$Maybe$Just(
													$author$project$Type$IO$Setter$StringMsg(p)));
										},
										fb: x
									});
							},
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								_short.ex,
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setLabel,
									$elm$core$Maybe$Just('Set the pattern'),
									$aforemny$material_components_web_elm$Material$TextField$config)))),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Min Length: ' + A2(
									$elm$core$Maybe$withDefault,
									'0',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, _short.bi))),
								$aforemny$material_components_web_elm$Material$Slider$slider(
								A2(
									$aforemny$material_components_web_elm$Material$Slider$setOnInput,
									function (x) {
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'minLength',
												S: itid,
												d9: $author$project$Type$Database$InputTypeType(0),
												eV: function (p) {
													return $author$project$Type$IO$Setter$MaybeSetMsg(
														$elm$core$Maybe$Just(
															$author$project$Type$IO$Setter$IntMsg(
																$elm$core$Basics$round(p))));
												},
												fb: x
											});
									},
									function (x) {
										var _v2 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _short.bi);
										if (!_v2.$) {
											var minLength = _v2.a;
											return A2($aforemny$material_components_web_elm$Material$Slider$setValue, minLength, x);
										} else {
											return x;
										}
									}($aforemny$material_components_web_elm$Material$Slider$config)))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Max Length: ' + A2(
									$elm$core$Maybe$withDefault,
									'100',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, _short.bh))),
								$aforemny$material_components_web_elm$Material$Slider$slider(
								A2(
									$aforemny$material_components_web_elm$Material$Slider$setOnInput,
									function (x) {
										return $author$project$Type$Database$TypeMatching$setField(
											{
												dk: 'maxLength',
												S: itid,
												d9: $author$project$Type$Database$InputTypeType(0),
												eV: function (p) {
													return $author$project$Type$IO$Setter$MaybeSetMsg(
														$elm$core$Maybe$Just(
															$author$project$Type$IO$Setter$IntMsg(
																$elm$core$Basics$round(p))));
												},
												fb: x
											});
									},
									function (x) {
										var _v3 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _short.bh);
										if (!_v3.$) {
											var minLength = _v3.a;
											return A2($aforemny$material_components_web_elm$Material$Slider$setValue, minLength, x);
										} else {
											return x;
										}
									}($aforemny$material_components_web_elm$Material$Slider$config)))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text('No Config found')
					]);
			}
		} else {
			if (_Utils_eq(
				model.ab,
				$elm$core$Maybe$Just(itid))) {
				var _v4 = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.fb;
					},
					A2(
						$elm$core$Maybe$andThen,
						function (x) {
							return A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(x),
								db.d5);
						},
						model.ab));
				if ((!_v4.$) && (_v4.a.$ === 1)) {
					var _long = _v4.a.a;
					return _List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TextField$filled(
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								function (x) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'label',
											S: itid,
											d9: $author$project$Type$Database$InputTypeType(0),
											eV: function (p) {
												return $author$project$Type$IO$Setter$MaybeSetMsg(
													$elm$core$Maybe$Just(
														$author$project$Type$IO$Setter$StringMsg(p)));
											},
											fb: x
										});
								},
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									_long.ea,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Set the label'),
										$aforemny$material_components_web_elm$Material$TextField$config)))),
							$aforemny$material_components_web_elm$Material$TextField$filled(
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								function (x) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'placeholder',
											S: itid,
											d9: $author$project$Type$Database$InputTypeType(0),
											eV: function (p) {
												return $author$project$Type$IO$Setter$MaybeSetMsg(
													$elm$core$Maybe$Just(
														$author$project$Type$IO$Setter$StringMsg(p)));
											},
											fb: x
										});
								},
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									_long.hm,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Set the placeholder'),
										$aforemny$material_components_web_elm$Material$TextField$config)))),
							$aforemny$material_components_web_elm$Material$TextField$filled(
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setOnInput,
								function (x) {
									return $author$project$Type$Database$TypeMatching$setField(
										{
											dk: 'pattern',
											S: itid,
											d9: $author$project$Type$Database$InputTypeType(0),
											eV: function (p) {
												return $author$project$Type$IO$Setter$MaybeSetMsg(
													$elm$core$Maybe$Just(
														$author$project$Type$IO$Setter$StringMsg(p)));
											},
											fb: x
										});
								},
								A2(
									$aforemny$material_components_web_elm$Material$TextField$setValue,
									_long.ex,
									A2(
										$aforemny$material_components_web_elm$Material$TextField$setLabel,
										$elm$core$Maybe$Just('Set the pattern'),
										$aforemny$material_components_web_elm$Material$TextField$config)))),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Min Length: ' + A2(
										$elm$core$Maybe$withDefault,
										'0',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, _long.bi))),
									$aforemny$material_components_web_elm$Material$Slider$slider(
									A2(
										$aforemny$material_components_web_elm$Material$Slider$setOnInput,
										function (x) {
											return $author$project$Type$Database$TypeMatching$setField(
												{
													dk: 'minLength',
													S: itid,
													d9: $author$project$Type$Database$InputTypeType(0),
													eV: function (p) {
														return $author$project$Type$IO$Setter$MaybeSetMsg(
															$elm$core$Maybe$Just(
																$author$project$Type$IO$Setter$IntMsg(
																	$elm$core$Basics$round(p))));
													},
													fb: x
												});
										},
										function (x) {
											var _v5 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _long.bi);
											if (!_v5.$) {
												var minLength = _v5.a;
												return A2($aforemny$material_components_web_elm$Material$Slider$setValue, minLength, x);
											} else {
												return x;
											}
										}($aforemny$material_components_web_elm$Material$Slider$config)))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Max Length: ' + A2(
										$elm$core$Maybe$withDefault,
										'100',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, _long.bh))),
									$aforemny$material_components_web_elm$Material$Slider$slider(
									A2(
										$aforemny$material_components_web_elm$Material$Slider$setOnInput,
										function (x) {
											return $author$project$Type$Database$TypeMatching$setField(
												{
													dk: 'maxLength',
													S: itid,
													d9: $author$project$Type$Database$InputTypeType(0),
													eV: function (p) {
														return $author$project$Type$IO$Setter$MaybeSetMsg(
															$elm$core$Maybe$Just(
																$author$project$Type$IO$Setter$IntMsg(
																	$elm$core$Basics$round(p))));
													},
													fb: x
												});
										},
										function (x) {
											var _v6 = A2($elm$core$Maybe$map, $elm$core$Basics$toFloat, _long.bh);
											if (!_v6.$) {
												var minLength = _v6.a;
												return A2($aforemny$material_components_web_elm$Material$Slider$setValue, minLength, x);
											} else {
												return x;
											}
										}($aforemny$material_components_web_elm$Material$Slider$config)))
								]))
						]);
				} else {
					return _List_fromArray(
						[
							$elm$html$Html$text('No Config found')
						]);
				}
			} else {
				if (_Utils_eq(
					model.aa,
					$elm$core$Maybe$Just(itid))) {
					var _v7 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fb;
						},
						A2(
							$elm$core$Maybe$andThen,
							function (x) {
								return A2(
									$elm$core$Dict$get,
									$author$project$Type$IO$Internal$unbox(x),
									db.d5);
							},
							model.aa));
					if ((!_v7.$) && (_v7.a.$ === 2)) {
						var list = _v7.a.a;
						return _List_fromArray(
							[
								$elm$html$Html$text('Boxes or Radio?'),
								A2(
								$aforemny$material_components_web_elm$Material$FormField$formField,
								A2(
									$aforemny$material_components_web_elm$Material$FormField$setLabel,
									$elm$core$Maybe$Just('Radio Button'),
									$aforemny$material_components_web_elm$Material$FormField$config),
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$Radio$radio($aforemny$material_components_web_elm$Material$Radio$config)
									])),
								A2(
								$aforemny$material_components_web_elm$Material$FormField$formField,
								A2(
									$aforemny$material_components_web_elm$Material$FormField$setLabel,
									$elm$core$Maybe$Just('Checkbox'),
									$aforemny$material_components_web_elm$Material$FormField$config),
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$Radio$radio($aforemny$material_components_web_elm$Material$Radio$config)
									]))
							]);
					} else {
						return _List_fromArray(
							[
								$elm$html$Html$text('No Config found')
							]);
					}
				} else {
					return _List_fromArray(
						[
							$elm$html$Html$text('You have not selected an Input type yet.')
						]);
				}
			}
		}
	});
var $author$project$Page$Question$view = function (_v0) {
	var model = _v0;
	var db = model.hB.u;
	var mbInfos = A2($author$project$Page$Question$relatedData, model.c.S, db);
	var moreInfos = A2(
		$elm$core$Maybe$withDefault,
		'Nothing Found',
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$toMaybe,
				$author$project$Type$Database$question.h9('*')),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.fb;
				},
				A2(
					$elm$core$Dict$get,
					$author$project$Type$IO$Internal$unbox(model.c.S),
					db.hp))));
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				return _List_fromArray(
					[
						function () {
						if (!mbInfos.$) {
							var infos = mbInfos.a;
							return A2(
								$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
								_List_fromArray(
									[$aforemny$material_components_web_elm$Material$Typography$typography]),
								_List_fromArray(
									[
										A2(
										$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_Nil,
												_Utils_ap(
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h1,
															_List_fromArray(
																[$aforemny$material_components_web_elm$Material$Typography$headline5]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Question')
																])),
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Text: ')
																])),
															$aforemny$material_components_web_elm$Material$TextField$filled(
															A2(
																$aforemny$material_components_web_elm$Material$TextField$setOnInput,
																function (x) {
																	return $author$project$Type$Database$TypeMatching$setField(
																		{dk: 'text', S: model.c.S, d9: $author$project$Type$Database$QuestionType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
																},
																A2(
																	$aforemny$material_components_web_elm$Material$TextField$setValue,
																	$elm$core$Maybe$Just(infos.hQ),
																	A2(
																		$aforemny$material_components_web_elm$Material$TextField$setLabel,
																		$elm$core$Maybe$Just('Question text'),
																		$aforemny$material_components_web_elm$Material$TextField$config))))
														]),
													A2($author$project$Page$Question$viewInputTypeSelection, model.c, infos.d4))),
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_Nil,
												A4($author$project$Page$Question$viewSettings, model.hB.u, model.c.S, model.c, infos.d4)),
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_Nil,
												$author$project$Page$Question$viewCodingQuestions(model.c))
											]))
									]));
						} else {
							return $elm$html$Html$text('got No Infos');
						}
					}()
					]);
			},
			h5: $author$project$Page$Question$toTitle(model.c),
			c5: model.hB.c5
		});
};
var $author$project$Page$Question$page = F2(
	function (session, id) {
		var model = {
			c: A2($author$project$Page$Question$init, session.u, id),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $elm$core$Basics$identity,
			ih: $author$project$Page$Question$update,
			ik: $author$project$Page$Question$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Questionary$Item = F2(
	function (id, question) {
		return {S: id, eH: question};
	});
var $author$project$Page$Questionary$Model = F6(
	function (id, questionary, focus, dnd, questions, menu) {
		return {gd: dnd, gs: focus, S: id, cp: menu, eI: questionary, hp: questions};
	});
var $author$project$Page$Questionary$init = F5(
	function (id, focus, dnd, questions, questionary) {
		return A6($author$project$Page$Questionary$Model, id, questionary, focus, dnd, questions, $elm$core$Maybe$Nothing);
	});
var $author$project$Msg$DnDEvent = function (a) {
	return {$: 25, a: a};
};
var $annaghi$dnd_list$DnDList$OnDrag = 0;
var $annaghi$dnd_list$DnDList$Rotate = 2;
var $annaghi$dnd_list$DnDList$Vertical = 2;
var $annaghi$dnd_list$DnDList$Model = $elm$core$Basics$identity;
var $annaghi$dnd_list$DnDList$GotDragElement = function (a) {
	return {$: 6, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $annaghi$dnd_list$DnDList$dragElementCommands = F2(
	function (stepMsg, state) {
		var _v0 = state.Q;
		if (_v0.$ === 1) {
			return A2(
				$elm$core$Task$attempt,
				A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$GotDragElement),
				$elm$browser$Browser$Dom$getElement(state.aq));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $annaghi$dnd_list$DnDList$GotDropElement = function (a) {
	return {$: 7, a: a};
};
var $annaghi$dnd_list$DnDList$dropElementCommands = F2(
	function (stepMsg, state) {
		return (!state.v) ? A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$GotDropElement),
			$elm$browser$Browser$Dom$getElement(state.Y)) : $elm$core$Platform$Cmd$none;
	});
var $annaghi$dnd_list$DnDList$commands = F2(
	function (stepMsg, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var state = model.a;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($annaghi$dnd_list$DnDList$dragElementCommands, stepMsg, state),
						A2($annaghi$dnd_list$DnDList$dropElementCommands, stepMsg, state)
					]));
		}
	});
var $annaghi$dnd_list$DnDList$DragStart = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $annaghi$dnd_list$Internal$Common$Utils$Position = F2(
	function (x, y) {
		return {C: x, D: y};
	});
var $annaghi$dnd_list$Internal$Common$Utils$clientX = A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float);
var $annaghi$dnd_list$Internal$Common$Utils$clientY = A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float);
var $annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates = A3($elm$json$Json$Decode$map2, $annaghi$dnd_list$Internal$Common$Utils$Position, $annaghi$dnd_list$Internal$Common$Utils$clientX, $annaghi$dnd_list$Internal$Common$Utils$clientY);
var $annaghi$dnd_list$Internal$Common$Utils$decodeMainMouseButton = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (button) {
			return (!button) ? decoder : $elm$json$Json$Decode$fail('Event is only relevant when the main mouse button was pressed.');
		},
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
};
var $annaghi$dnd_list$Internal$Common$Utils$decodeCoordinatesWithButtonCheck = $annaghi$dnd_list$Internal$Common$Utils$decodeMainMouseButton($annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates);
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $annaghi$dnd_list$DnDList$dragEvents = F3(
	function (stepMsg, dragIndex, dragElementId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'mousedown',
				A2(
					$elm$json$Json$Decode$map,
					function (msg) {
						return _Utils_Tuple2(msg, true);
					},
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeL,
							stepMsg,
							A2($annaghi$dnd_list$DnDList$DragStart, dragIndex, dragElementId)),
						$annaghi$dnd_list$Internal$Common$Utils$decodeCoordinatesWithButtonCheck)))
			]);
	});
var $annaghi$dnd_list$DnDList$DragEnter = function (a) {
	return {$: 3, a: a};
};
var $annaghi$dnd_list$DnDList$DragLeave = {$: 4};
var $annaghi$dnd_list$DnDList$DragOver = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $annaghi$dnd_list$DnDList$dropEvents = F3(
	function (stepMsg, dropIndex, dropElementId) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onMouseOver(
				stepMsg(
					A2($annaghi$dnd_list$DnDList$DragOver, dropIndex, dropElementId))),
				$elm$html$Html$Events$onMouseEnter(
				stepMsg(
					$annaghi$dnd_list$DnDList$DragEnter(dropIndex))),
				$elm$html$Html$Events$onMouseLeave(
				stepMsg($annaghi$dnd_list$DnDList$DragLeave))
			]);
	});
var $annaghi$dnd_list$Internal$Common$Utils$px = function (n) {
	return $elm$core$String$fromInt(n) + 'px';
};
var $annaghi$dnd_list$Internal$Common$Utils$translate = F2(
	function (x, y) {
		return 'translate3d(' + ($annaghi$dnd_list$Internal$Common$Utils$px(x) + (', ' + ($annaghi$dnd_list$Internal$Common$Utils$px(y) + ', 0)')));
	});
var $annaghi$dnd_list$DnDList$ghostStyles = F2(
	function (movement, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return _List_Nil;
		} else {
			var state = model.a;
			var _v2 = state.Q;
			if (!_v2.$) {
				var element = _v2.a.gk;
				var viewport = _v2.a.il;
				var transform = function () {
					switch (movement) {
						case 1:
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(((state.G.C - state.M.C) + element.C) - viewport.C),
									$elm$core$Basics$round(element.D - viewport.D)));
						case 2:
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(element.C - viewport.C),
									$elm$core$Basics$round(((state.G.D - state.M.D) + element.D) - viewport.D)));
						default:
							return A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$annaghi$dnd_list$Internal$Common$Utils$translate,
									$elm$core$Basics$round(((state.G.C - state.M.C) + element.C) - viewport.C),
									$elm$core$Basics$round(((state.G.D - state.M.D) + element.D) - viewport.D)));
					}
				}();
				var baseStyles = _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
						A2($elm$html$Html$Attributes$style, 'top', '0'),
						A2($elm$html$Html$Attributes$style, 'left', '0'),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						$annaghi$dnd_list$Internal$Common$Utils$px(
							$elm$core$Basics$round(element.dW))),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$annaghi$dnd_list$Internal$Common$Utils$px(
							$elm$core$Basics$round(element.fe))),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
					]);
				return A2($elm$core$List$cons, transform, baseStyles);
			} else {
				return _List_Nil;
			}
		}
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $annaghi$dnd_list$DnDList$info = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		function (state) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (dragElement, dropElement) {
						return {G: state.G, Q: dragElement, aq: state.aq, dH: state.dH, X: dropElement, Y: state.Y, H: state.H, M: state.M};
					}),
				state.Q,
				state.X);
		},
		model);
};
var $annaghi$dnd_list$DnDList$Drag = function (a) {
	return {$: 1, a: a};
};
var $annaghi$dnd_list$DnDList$DragEnd = {$: 5};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {ey: pids, e2: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {as: event, at: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.ey,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.at;
		var event = _v0.as;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.e2);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $annaghi$dnd_list$DnDList$subscriptions = F2(
	function (stepMsg, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$elm$browser$Browser$Events$onMouseMove(
						A2(
							$elm$json$Json$Decode$map,
							A2($elm$core$Basics$composeL, stepMsg, $annaghi$dnd_list$DnDList$Drag),
							$annaghi$dnd_list$Internal$Common$Utils$decodeCoordinates)),
						$elm$browser$Browser$Events$onMouseUp(
						$elm$json$Json$Decode$succeed(
							stepMsg($annaghi$dnd_list$DnDList$DragEnd)))
					]));
		}
	});
var $annaghi$dnd_list$Internal$Common$Operations$splitAt = F2(
	function (i, list) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, i, list),
			A2($elm$core$List$drop, i, list));
	});
var $annaghi$dnd_list$Internal$Common$Operations$afterBackward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j + 1, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, (i - j) - 1, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, end);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				head,
				_Utils_ap(middle, tail)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$afterForward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, (j - i) + 1, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, middle);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				tail,
				_Utils_ap(head, end)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$insertAfter = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$beforeBackward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i - j, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, end);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				head,
				_Utils_ap(middle, tail)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$beforeForward = F3(
	function (i, j, list) {
		var _v0 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, i, list);
		var beginning = _v0.a;
		var rest = _v0.b;
		var _v1 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, j - i, rest);
		var middle = _v1.a;
		var end = _v1.b;
		var _v2 = A2($annaghi$dnd_list$Internal$Common$Operations$splitAt, 1, middle);
		var head = _v2.a;
		var tail = _v2.b;
		return _Utils_ap(
			beginning,
			_Utils_ap(
				tail,
				_Utils_ap(head, end)));
	});
var $annaghi$dnd_list$Internal$Common$Operations$insertBefore = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$rotate = F3(
	function (dragIndex, dropIndex, list) {
		return (_Utils_cmp(dragIndex, dropIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$afterForward, dragIndex, dropIndex, list) : ((_Utils_cmp(dropIndex, dragIndex) < 0) ? A3($annaghi$dnd_list$Internal$Common$Operations$beforeBackward, dragIndex, dropIndex, list) : list);
	});
var $annaghi$dnd_list$Internal$Common$Operations$swapAt = F3(
	function (i, j, list) {
		var item_j = A2(
			$elm$core$List$take,
			1,
			A2($elm$core$List$drop, j, list));
		var item_i = A2(
			$elm$core$List$take,
			1,
			A2($elm$core$List$drop, i, list));
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return _Utils_eq(index, i) ? item_j : (_Utils_eq(index, j) ? item_i : _List_fromArray(
							[item]));
					}),
				list));
	});
var $annaghi$dnd_list$Internal$Common$Operations$swap = F3(
	function (dragIndex, dropIndex, list) {
		return (!_Utils_eq(dragIndex, dropIndex)) ? A3($annaghi$dnd_list$Internal$Common$Operations$swapAt, dragIndex, dropIndex, list) : list;
	});
var $annaghi$dnd_list$DnDList$listUpdate = F4(
	function (operation, dragIndex, dropIndex, list) {
		switch (operation) {
			case 0:
				return A3($annaghi$dnd_list$Internal$Common$Operations$insertAfter, dragIndex, dropIndex, list);
			case 1:
				return A3($annaghi$dnd_list$Internal$Common$Operations$insertBefore, dragIndex, dropIndex, list);
			case 2:
				return A3($annaghi$dnd_list$Internal$Common$Operations$rotate, dragIndex, dropIndex, list);
			case 3:
				return A3($annaghi$dnd_list$Internal$Common$Operations$swap, dragIndex, dropIndex, list);
			default:
				return list;
		}
	});
var $annaghi$dnd_list$DnDList$stateUpdate = F3(
	function (operation, dropIndex, state) {
		switch (operation) {
			case 0:
				return _Utils_update(
					state,
					{
						v: 0,
						dH: (_Utils_cmp(dropIndex, state.dH) < 0) ? (dropIndex + 1) : dropIndex
					});
			case 1:
				return _Utils_update(
					state,
					{
						v: 0,
						dH: (_Utils_cmp(state.dH, dropIndex) < 0) ? (dropIndex - 1) : dropIndex
					});
			case 2:
				return _Utils_update(
					state,
					{v: 0, dH: dropIndex});
			case 3:
				return _Utils_update(
					state,
					{v: 0, dH: dropIndex});
			default:
				return _Utils_update(
					state,
					{v: 0});
		}
	});
var $annaghi$dnd_list$DnDList$update = F4(
	function (_v0, msg, _v1, list) {
		var beforeUpdate = _v0.fF;
		var listen = _v0.gQ;
		var operation = _v0.hh;
		var model = _v1;
		switch (msg.$) {
			case 0:
				var dragIndex = msg.a;
				var dragElementId = msg.b;
				var xy = msg.c;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						{G: xy, v: 0, Q: $elm$core$Maybe$Nothing, aq: dragElementId, dH: dragIndex, X: $elm$core$Maybe$Nothing, Y: dragElementId, H: dragIndex, M: xy}),
					list);
			case 1:
				var xy = msg.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$map,
						function (state) {
							return _Utils_update(
								state,
								{G: xy, v: state.v + 1});
						},
						model),
					list);
			case 2:
				var dropIndex = msg.a;
				var dropElementId = msg.b;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$map,
						function (state) {
							return _Utils_update(
								state,
								{Y: dropElementId, H: dropIndex});
						},
						model),
					list);
			case 3:
				var dropIndex = msg.a;
				var _v3 = _Utils_Tuple2(model, listen);
				if ((!_v3.a.$) && (!_v3.b)) {
					var state = _v3.a.a;
					var _v4 = _v3.b;
					return ((state.v > 1) && (!_Utils_eq(state.dH, dropIndex))) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							A3($annaghi$dnd_list$DnDList$stateUpdate, operation, dropIndex, state)),
						A4(
							$annaghi$dnd_list$DnDList$listUpdate,
							operation,
							state.dH,
							dropIndex,
							A3(beforeUpdate, state.dH, dropIndex, list))) : _Utils_Tuple2(model, list);
				} else {
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{v: 0});
							},
							model),
						list);
				}
			case 4:
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$map,
						function (state) {
							return _Utils_update(
								state,
								{H: state.dH});
						},
						model),
					list);
			case 5:
				var _v5 = _Utils_Tuple2(model, listen);
				if ((!_v5.a.$) && (_v5.b === 1)) {
					var state = _v5.a.a;
					var _v6 = _v5.b;
					return (!_Utils_eq(state.dH, state.H)) ? _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A4(
							$annaghi$dnd_list$DnDList$listUpdate,
							operation,
							state.dH,
							state.H,
							A3(beforeUpdate, state.dH, state.H, list))) : _Utils_Tuple2($elm$core$Maybe$Nothing, list);
				} else {
					return _Utils_Tuple2($elm$core$Maybe$Nothing, list);
				}
			case 6:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, list);
				} else {
					var dragElement = msg.a.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{
										Q: $elm$core$Maybe$Just(dragElement),
										X: $elm$core$Maybe$Just(dragElement)
									});
							},
							model),
						list);
				}
			default:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, list);
				} else {
					var dropElement = msg.a.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$map,
							function (state) {
								return _Utils_update(
									state,
									{
										X: $elm$core$Maybe$Just(dropElement)
									});
							},
							model),
						list);
				}
		}
	});
var $annaghi$dnd_list$DnDList$create = F2(
	function (config, stepMsg) {
		return {
			f4: $annaghi$dnd_list$DnDList$commands(stepMsg),
			gf: $annaghi$dnd_list$DnDList$dragEvents(stepMsg),
			gj: $annaghi$dnd_list$DnDList$dropEvents(stepMsg),
			gv: $annaghi$dnd_list$DnDList$ghostStyles(config.gX),
			d2: $annaghi$dnd_list$DnDList$info,
			gV: $elm$core$Maybe$Nothing,
			e3: $annaghi$dnd_list$DnDList$subscriptions(stepMsg),
			ih: $annaghi$dnd_list$DnDList$update(config)
		};
	});
var $author$project$Viewer$system = A2(
	$annaghi$dnd_list$DnDList$create,
	{
		fF: F3(
			function (_v0, _v1, list) {
				return list;
			}),
		gQ: 0,
		gX: 2,
		hh: 2
	},
	$author$project$Msg$DnDEvent);
var $author$project$Page$Questionary$update = F2(
	function (message, _v0) {
		var model = _v0;
		var oldmodel = model.c;
		switch (message.$) {
			case 11:
				var msg = message.a;
				switch (msg.$) {
					case 0:
						var selection = msg.a;
						var oldfocus = oldmodel.gs;
						var newfocus = _Utils_update(
							oldfocus,
							{bE: selection, bz: false});
						var newmodel = _Utils_update(
							oldmodel,
							{gs: newfocus});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{c: newmodel}),
							$elm$core$Platform$Cmd$none);
					case 1:
						var msg_ = msg.a;
						if (!msg_) {
							var oldfocus = oldmodel.gs;
							var newfocus = _Utils_update(
								oldfocus,
								{bE: $elm$core$Maybe$Nothing, bz: true});
							var newmodel = _Utils_update(
								oldmodel,
								{gs: newfocus});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{c: newmodel}),
								$elm$core$Platform$Cmd$none);
						} else {
							var newmodel = _Utils_update(
								oldmodel,
								{gs: $author$project$Page$Questionary$defaultFokus});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{c: newmodel}),
								$elm$core$Platform$Cmd$none);
						}
					default:
						var id = msg.a;
						var newmodel = _Utils_update(
							oldmodel,
							{cp: id});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{c: newmodel}),
							$elm$core$Platform$Cmd$none);
				}
			case 25:
				var msg_ = message.a;
				var _v4 = A3($author$project$Viewer$system.ih, msg_, oldmodel.gd, oldmodel.hp);
				var dnd = _v4.a;
				var items = _v4.b;
				var newmodel = _Utils_update(
					oldmodel,
					{gd: dnd, hp: items});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c: newmodel}),
					$author$project$Viewer$system.f4(dnd));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Msg$QuestionNameEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$Questionary = function (a) {
	return {$: 11, a: a};
};
var $aforemny$material_components_web_elm$Material$Fab$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Fab$config = {bF: _List_Nil, b4: false, cs: false, cz: $elm$core$Maybe$Nothing, aS: true};
var $author$project$Page$Questionary$editableText = F5(
	function (active, activator, deactivator, value, callback) {
		return active ? $aforemny$material_components_web_elm$Material$TextField$outlined(
			A2(
				$aforemny$material_components_web_elm$Material$TextField$setAttributes,
				_List_fromArray(
					[$aforemny$material_components_web_elm$Material$Typography$headline5]),
				A2(
					$aforemny$material_components_web_elm$Material$TextField$setLabel,
					$elm$core$Maybe$Nothing,
					A2(
						$aforemny$material_components_web_elm$Material$TextField$setOnChange,
						deactivator,
						A2(
							$aforemny$material_components_web_elm$Material$TextField$setOnInput,
							callback,
							A2(
								$aforemny$material_components_web_elm$Material$TextField$setValue,
								$elm$core$Maybe$Just(value),
								$aforemny$material_components_web_elm$Material$TextField$config)))))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Typography$headline5,
					$elm$html$Html$Events$onClick(activator)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $aforemny$material_components_web_elm$Material$Fab$clickHandler = function (_v0) {
	var onClick = _v0.cz;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $aforemny$material_components_web_elm$Material$Fab$exitedCs = function (_v0) {
	var exited = _v0.b4;
	return exited ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-fab--exited')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Fab$iconElt = function (icon_) {
	if (!icon_.$) {
		var node = icon_.a.bk;
		var attributes = icon_.a.bM;
		var nodes = icon_.a.bl;
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				node,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('mdc-fab__icon'),
					attributes),
				nodes));
	} else {
		var node = icon_.a.bk;
		var attributes = icon_.a.bM;
		var nodes = icon_.a.bl;
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				node,
				A2(
					$elm$core$List$cons,
					$elm$svg$Svg$Attributes$class('mdc-fab__icon'),
					attributes),
				nodes));
	}
};
var $aforemny$material_components_web_elm$Material$Fab$miniCs = function (_v0) {
	var mini = _v0.cs;
	return mini ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-fab--mini')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Fab$rippleElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-fab__ripple')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Fab$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-fab'));
var $aforemny$material_components_web_elm$Material$Fab$tabIndexProp = function (tabIndex) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'tabIndex',
			$elm$json$Json$Encode$int(tabIndex)));
};
var $aforemny$material_components_web_elm$Material$Fab$touchCs = function (_v0) {
	var touch = _v0.aS;
	return touch ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-fab--touch')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Fab$touchElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-fab__touch')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Fab$fab = F2(
	function (config_, icon_) {
		var additionalAttributes = config_.bF;
		var touch = config_.aS;
		var wrapTouch = function (node) {
			return touch ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-touch-target-wrapper')
					]),
				_List_fromArray(
					[node])) : node;
		};
		return wrapTouch(
			A3(
				$elm$html$Html$node,
				'mdc-fab',
				_Utils_ap(
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$aforemny$material_components_web_elm$Material$Fab$rootCs,
								$aforemny$material_components_web_elm$Material$Fab$miniCs(config_),
								$aforemny$material_components_web_elm$Material$Fab$touchCs(config_),
								$aforemny$material_components_web_elm$Material$Fab$exitedCs(config_),
								$aforemny$material_components_web_elm$Material$Fab$clickHandler(config_),
								$aforemny$material_components_web_elm$Material$Fab$tabIndexProp(0)
							])),
					additionalAttributes),
				_Utils_ap(
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Fab$rippleElt,
							$aforemny$material_components_web_elm$Material$Fab$iconElt(icon_)
						]),
					touch ? _List_fromArray(
						[$aforemny$material_components_web_elm$Material$Fab$touchElt]) : _List_Nil)));
	});
var $aforemny$material_components_web_elm$Material$Fab$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$Fab$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$Fab$Icon(
			{bM: attributes, bk: node, bl: nodes});
	});
var $aforemny$material_components_web_elm$Material$Fab$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$Fab$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $author$project$Viewer$OrderAwareList$prePost = F2(
	function (prev, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			if (!xs.b.b) {
				var a = xs.a;
				return _List_fromArray(
					[
						_Utils_Tuple3(prev, a, $elm$core$Maybe$Nothing)
					]);
			} else {
				var a = xs.a;
				var _v1 = xs.b;
				var b = _v1.a;
				var c = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple3(
						prev,
						a,
						$elm$core$Maybe$Just(b)),
					A2(
						$author$project$Viewer$OrderAwareList$prePost,
						$elm$core$Maybe$Just(a),
						A2($elm$core$List$cons, b, c)));
			}
		}
	});
var $author$project$Viewer$OrderAwareList$orderAwareList = function (old) {
	var mapToValue = function (a) {
		if (!a.$) {
			var _v3 = a.a;
			var id = _v3.a;
			var val = _v3.b;
			return $elm$core$Maybe$Just(
				{S: id, fb: val});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var x = _v0.a;
			var _v1 = _v0.b;
			var id = _v1.a;
			var value = _v1.b;
			var y = _v0.c;
			return {
				S: id,
				cu: mapToValue(y),
				cH: mapToValue(x),
				fb: value
			};
		},
		A2($author$project$Viewer$OrderAwareList$prePost, $elm$core$Maybe$Nothing, old));
};
var $author$project$Page$Questionary$relatedData = F2(
	function (id, db) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Type$IO$Internal$unbox(id),
			db.bs);
		if (!_v0.$) {
			var timestampedQuestionary = _v0.a;
			var questions = A2(
				$elm$core$List$sortBy,
				function (_v2) {
					var y = _v2.b;
					return y.gF;
				},
				A2(
					$elm$core$List$filter,
					function (_v3) {
						var y = _v3.b;
						return _Utils_eq(y.eI, id);
					},
					A2(
						$elm$core$List$map,
						function (_v4) {
							var x = _v4.a;
							var y = _v4.b;
							return _Utils_Tuple2(
								$author$project$Type$IO$Internal$box(x),
								y.fb);
						},
						$elm$core$Dict$toList(db.hp))));
			var questionary = timestampedQuestionary.fb;
			return $elm$core$Maybe$Just(
				{
					f8: $elm$time$Time$millisToPosix(timestampedQuestionary.f8),
					a5: _Utils_Tuple2(
						timestampedQuestionary.a5,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(timestampedQuestionary.a5),
								db.c6))),
					S: id,
					co: $elm$core$List$maximum(
						A2(
							$elm$core$List$map,
							function (_v1) {
								var x = _v1.b;
								return x.gF;
							},
							questions)),
					af: questionary.af,
					hp: $author$project$Viewer$OrderAwareList$orderAwareList(questions),
					cY: _Utils_Tuple2(
						questionary.cY,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(questionary.cY),
								db.hK))),
					fa: $elm$time$Time$millisToPosix(timestampedQuestionary.gW)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $aforemny$material_components_web_elm$Material$Fab$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bF: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$Fab$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cz: $elm$core$Maybe$Just(onClick)
			});
	});
var $aforemny$material_components_web_elm$Material$LayoutGrid$span = function (n) {
	return $elm$html$Html$Attributes$class(
		'mdc-layout-grid__cell--span-' + $elm$core$String$fromInt(n));
};
var $aforemny$material_components_web_elm$Material$LayoutGrid$span12 = $aforemny$material_components_web_elm$Material$LayoutGrid$span(12);
var $aforemny$material_components_web_elm$Material$LayoutGrid$spanTablet = function (n) {
	return $elm$html$Html$Attributes$class(
		'mdc-layout-grid__cell--span-' + ($elm$core$String$fromInt(n) + '-tablet'));
};
var $aforemny$material_components_web_elm$Material$LayoutGrid$span1Tablet = $aforemny$material_components_web_elm$Material$LayoutGrid$spanTablet(1);
var $aforemny$material_components_web_elm$Material$LayoutGrid$span2Desktop = $aforemny$material_components_web_elm$Material$LayoutGrid$spanDesktop(2);
var $aforemny$material_components_web_elm$Material$LayoutGrid$span6Tablet = $aforemny$material_components_web_elm$Material$LayoutGrid$spanTablet(6);
var $author$project$Page$Questionary$toTitle = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		'Home ⧽ Questionary',
		A2(
			$elm$core$Maybe$map,
			function (x) {
				return x.fb.af;
			},
			model.eI));
};
var $aforemny$material_components_web_elm$Material$List$setTwoLine = F2(
	function (twoLine, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{c2: twoLine});
	});
var $author$project$Msg$ContextMenu = function (a) {
	return {$: 2, a: a};
};
var $aforemny$material_components_web_elm$Material$IconButton$Internal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$IconButton$config = {bF: _List_Nil, aC: false, aG: $elm$core$Maybe$Nothing, ea: $elm$core$Maybe$Nothing, cp: $elm$core$Maybe$Nothing, cz: $elm$core$Maybe$Nothing, c$: $elm$core$Maybe$Nothing};
var $aforemny$material_components_web_elm$Material$Menu$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Menu$config = {bF: _List_Nil, bo: $elm$core$Maybe$Nothing, cB: false, cJ: false};
var $aforemny$material_components_web_elm$Material$IconButton$Internal$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$IconButton$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$IconButton$Internal$Icon(
			{bM: attributes, bk: node, bl: nodes});
	});
var $aforemny$material_components_web_elm$Material$IconButton$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$IconButton$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $aforemny$material_components_web_elm$Material$IconButton$clickHandler = function (_v0) {
	var onClick = _v0.cz;
	return A2($elm$core$Maybe$map, $elm$html$Html$Events$onClick, onClick);
};
var $aforemny$material_components_web_elm$Material$IconButton$disabledAttr = function (_v0) {
	var disabled = _v0.aC;
	return $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$disabled(disabled));
};
var $aforemny$material_components_web_elm$Material$IconButton$hrefAttr = function (_v0) {
	var href = _v0.aG;
	return A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, href);
};
var $aforemny$material_components_web_elm$Material$IconButton$iconButtonCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-icon-button'));
var $aforemny$material_components_web_elm$Material$Menu$surfaceAnchor = $elm$html$Html$Attributes$class('mdc-menu-surface--anchor');
var $aforemny$material_components_web_elm$Material$IconButton$targetAttr = function (_v0) {
	var href = _v0.aG;
	var target = _v0.c$;
	return (!_Utils_eq(href, $elm$core$Maybe$Nothing)) ? A2($elm$core$Maybe$map, $elm$html$Html$Attributes$target, target) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$IconButton$iconButton = F2(
	function (config_, icon_) {
		var innerConfig = config_;
		var additionalAttributes = innerConfig.bF;
		var href = innerConfig.aG;
		var disabled = innerConfig.aC;
		var wrapMenu = function (node) {
			var _v1 = innerConfig.cp;
			if (_v1.$ === 1) {
				return node;
			} else {
				var _v2 = _v1.a;
				var menuConfig = _v2.a;
				var firstListItem = _v2.b;
				var remainingListItems = _v2.c;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Menu$surfaceAnchor]),
					_List_fromArray(
						[
							node,
							A3($aforemny$material_components_web_elm$Material$Menu$menu, menuConfig, firstListItem, remainingListItems)
						]));
			}
		};
		return wrapMenu(
			A3(
				$elm$html$Html$node,
				'mdc-icon-button',
				_List_Nil,
				_List_fromArray(
					[
						A2(
						((!_Utils_eq(href, $elm$core$Maybe$Nothing)) && (!disabled)) ? $elm$html$Html$a : $elm$html$Html$button,
						_Utils_ap(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$aforemny$material_components_web_elm$Material$IconButton$iconButtonCs,
										$aforemny$material_components_web_elm$Material$IconButton$hrefAttr(config_),
										$aforemny$material_components_web_elm$Material$IconButton$targetAttr(config_),
										$aforemny$material_components_web_elm$Material$IconButton$disabledAttr(config_),
										$aforemny$material_components_web_elm$Material$IconButton$clickHandler(config_)
									])),
							additionalAttributes),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								function () {
									if (!icon_.$) {
										var node = icon_.a.bk;
										var attributes = icon_.a.bM;
										var nodes = icon_.a.bl;
										return A2(
											node,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$class('mdc-icon-button__icon'),
												attributes),
											nodes);
									} else {
										var node = icon_.a.bk;
										var attributes = icon_.a.bM;
										var nodes = icon_.a.bl;
										return A2(
											node,
											A2(
												$elm$core$List$cons,
												$elm$svg$Svg$Attributes$class('mdc-icon-button__icon'),
												attributes),
											nodes);
									}
								}())
							]))
					])));
	});
var $aforemny$material_components_web_elm$Material$List$Item$meta = F2(
	function (additionalAttributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-deprecated-list-item__meta'),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$IconButton$setOnClick = F2(
	function (onClick, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				cz: $elm$core$Maybe$Just(onClick)
			});
	});
var $aforemny$material_components_web_elm$Material$Menu$setOnClose = F2(
	function (onClose, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				bo: $elm$core$Maybe$Just(onClose)
			});
	});
var $aforemny$material_components_web_elm$Material$Menu$setOpen = F2(
	function (open, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{cB: open});
	});
var $aforemny$material_components_web_elm$Material$List$Item$primaryTextElt = F2(
	function (additionalAttributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-deprecated-list-item__primary-text'),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$List$Item$secondaryTextElt = F2(
	function (additionalAttributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-deprecated-list-item__secondary-text'),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$List$Item$text = F2(
	function (additionalAttributes, _v0) {
		var primary = _v0.eA;
		var secondary = _v0.eR;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-deprecated-list-item__text'),
				additionalAttributes),
			_List_fromArray(
				[
					A2($aforemny$material_components_web_elm$Material$List$Item$primaryTextElt, _List_Nil, primary),
					A2($aforemny$material_components_web_elm$Material$List$Item$secondaryTextElt, _List_Nil, secondary)
				]));
	});
var $author$project$Type$Database$InputType$toString = function (kind) {
	switch (kind.$) {
		case 0:
			return 'Short Answer';
		case 1:
			return 'Long Answer';
		default:
			var singleInput = kind.a.eX;
			var choices = kind.a.ds;
			if (!singleInput) {
				return 'Multiple Choice';
			} else {
				return 'Boxes';
			}
	}
};
var $author$project$Page$Questionary$viewQuestionListItem = F3(
	function (model, db, _v0) {
		var id = _v0.S;
		var value = _v0.fb;
		var previous = _v0.cH;
		var next = _v0.cu;
		var x = 1;
		return A2(
			$aforemny$material_components_web_elm$Material$List$Item$listItem,
			$aforemny$material_components_web_elm$Material$List$Item$config,
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$List$Item$text,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2(
								$author$project$Msg$Follow,
								$author$project$Type$Database$QuestionType,
								$author$project$Type$IO$Internal$unbox(id)))
						]),
					{
						eA: _List_fromArray(
							[
								$elm$html$Html$text(value.hQ)
							]),
						eR: _List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Type$IO$Internal$unbox(value.d4),
									A2(
										$elm$core$Maybe$map,
										function (it) {
											return $author$project$Type$Database$InputType$toString(it.fb);
										},
										A2(
											$elm$core$Dict$get,
											$author$project$Type$IO$Internal$unbox(value.d4),
											db.d5))))
							])
					}),
					A2(
					$aforemny$material_components_web_elm$Material$List$Item$meta,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[$aforemny$material_components_web_elm$Material$Menu$surfaceAnchor]),
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$IconButton$iconButton,
									A2(
										$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
										$author$project$Msg$Questionary(
											$author$project$Msg$ContextMenu(
												$elm$core$Maybe$Just(
													$author$project$Type$IO$Internal$unbox(id)))),
										$aforemny$material_components_web_elm$Material$IconButton$config),
									$aforemny$material_components_web_elm$Material$IconButton$icon('more_vert'))
								])),
							A3(
							$aforemny$material_components_web_elm$Material$Menu$menu,
							A2(
								$aforemny$material_components_web_elm$Material$Menu$setOnClose,
								$author$project$Msg$Questionary(
									$author$project$Msg$ContextMenu($elm$core$Maybe$Nothing)),
								A2(
									$aforemny$material_components_web_elm$Material$Menu$setOpen,
									_Utils_eq(
										model.cp,
										$elm$core$Maybe$Just(
											$author$project$Type$IO$Internal$unbox(id))),
									$aforemny$material_components_web_elm$Material$Menu$config)),
							A2(
								$aforemny$material_components_web_elm$Material$List$Item$listItem,
								$aforemny$material_components_web_elm$Material$List$Item$config,
								_List_fromArray(
									[
										$elm$html$Html$text('Menu item')
									])),
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$List$Item$listItem,
									$aforemny$material_components_web_elm$Material$List$Item$config,
									_List_fromArray(
										[
											$elm$html$Html$text('Menu item')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Questionary$viewQuestionList = F4(
	function (model, db, infos, questions) {
		if (questions.b) {
			var first = questions.a;
			var rest = questions.b;
			return A3(
				$aforemny$material_components_web_elm$Material$List$list,
				A2($aforemny$material_components_web_elm$Material$List$setTwoLine, true, $aforemny$material_components_web_elm$Material$List$config),
				A3($author$project$Page$Questionary$viewQuestionListItem, model, db, first),
				A2(
					$elm$core$List$map,
					A2($author$project$Page$Questionary$viewQuestionListItem, model, db),
					rest));
		} else {
			return $elm$html$Html$text('NoItem');
		}
	});
var $author$project$Page$Questionary$viewStudy = F2(
	function (_v0, cur) {
		var id = _v0.a;
		var mbStudy = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Type$IO$Internal$unbox(id),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.af;
				},
				mbStudy));
	});
var $author$project$Page$Questionary$view = function (_v0) {
	var model = _v0;
	var db = model.hB.u;
	var mbInfos = A2($author$project$Page$Questionary$relatedData, model.c.S, db);
	if (!mbInfos.$) {
		var infos = mbInfos.a;
		var newMsg = $author$project$Msg$CRUD(
			A2(
				$author$project$Msg$CreateRandom,
				$author$project$Type$Database$QuestionType,
				_List_fromArray(
					[
						function (x) {
						return $author$project$Type$Database$TypeMatching$setField(
							{
								dk: 'questionary',
								S: $author$project$Type$IO$Internal$box(x),
								d9: $author$project$Type$Database$QuestionType,
								eV: $author$project$Type$IO$Setter$StringMsg,
								fb: $author$project$Type$IO$Internal$unbox(infos.S)
							});
					},
						function (x) {
						return $author$project$Type$Database$TypeMatching$setField(
							{
								dk: 'index',
								S: $author$project$Type$IO$Internal$box(x),
								d9: $author$project$Type$Database$QuestionType,
								eV: $author$project$Type$IO$Setter$IntMsg,
								fb: A2(
									$elm$core$Maybe$withDefault,
									0,
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$add(1),
										infos.co))
							});
					}
					])));
		return _Utils_update(
			$author$project$Viewer$detailsConfig,
			{
				fI: function (_v2) {
					return _List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
							_List_fromArray(
								[$aforemny$material_components_web_elm$Material$Typography$typography]),
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
									_List_Nil,
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_fromArray(
													[$aforemny$material_components_web_elm$Material$LayoutGrid$span12]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h1,
														_List_fromArray(
															[$aforemny$material_components_web_elm$Material$Typography$headline5]),
														_List_fromArray(
															[
																A5(
																$author$project$Page$Questionary$editableText,
																model.c.gs.bz,
																$author$project$Msg$Questionary(
																	$author$project$Msg$QuestionNameEdit(0)),
																function (x) {
																	return $author$project$Msg$Questionary(
																		$author$project$Msg$QuestionNameEdit(1));
																},
																infos.af,
																function (x) {
																	return $author$project$Type$Database$TypeMatching$setField(
																		{dk: 'name', S: model.c.S, d9: $author$project$Type$Database$QuestionaryType, eV: $author$project$Type$IO$Setter$StringMsg, fb: x});
																})
															])),
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																'Study: ' + A2($author$project$Page$Questionary$viewStudy, infos.cY, model.hB.c5))
															]))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_fromArray(
													[$aforemny$material_components_web_elm$Material$LayoutGrid$span12]),
												_List_fromArray(
													[
														A2(
														$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
																_List_fromArray(
																	[$aforemny$material_components_web_elm$Material$LayoutGrid$span2Desktop, $aforemny$material_components_web_elm$Material$LayoutGrid$span1Tablet]),
																_List_Nil),
																A2(
																$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
																_List_fromArray(
																	[$aforemny$material_components_web_elm$Material$LayoutGrid$span8Desktop, $aforemny$material_components_web_elm$Material$LayoutGrid$span6Tablet]),
																_List_fromArray(
																	[
																		A4($author$project$Page$Questionary$viewQuestionList, model.c, db, infos, infos.hp)
																	]))
															]))
													]))
											])))
								])),
							A2(
							$aforemny$material_components_web_elm$Material$Fab$fab,
							A2(
								$aforemny$material_components_web_elm$Material$Fab$setAttributes,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
										A2($elm$html$Html$Attributes$style, 'bottom', '2rem'),
										A2($elm$html$Html$Attributes$style, 'right', '2rem')
									]),
								A2($aforemny$material_components_web_elm$Material$Fab$setOnClick, newMsg, $aforemny$material_components_web_elm$Material$Fab$config)),
							$aforemny$material_components_web_elm$Material$Fab$icon('playlist_add'))
						]);
				},
				h5: $author$project$Page$Questionary$toTitle(model.c),
				c5: model.hB.c5
			});
	} else {
		return _Utils_update(
			$author$project$Viewer$detailsConfig,
			{
				fI: function (_v3) {
					return _List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$Typography$headline5]),
													_List_fromArray(
														[
															$elm$html$Html$text('Questionary not Found')
														]))
												]))
										]))
								]))
						]);
				},
				h5: $author$project$Page$Questionary$toTitle(model.c),
				c5: model.hB.c5
			});
	}
};
var $author$project$Page$Questionary$page = F5(
	function (session, id, focus, mbquestions, dndmodel) {
		var questionary = A2(
			$elm$core$Dict$get,
			$author$project$Type$IO$Internal$unbox(id),
			session.u.bs);
		var dbquestions = A2(
			$elm$core$List$map,
			function (_v1) {
				var a = _v1.a;
				var b = _v1.b;
				return A2($author$project$Page$Questionary$Item, a, b);
			},
			A2(
				$elm$core$List$sortBy,
				function (_v0) {
					var question = _v0.b;
					return question.fb.gF;
				},
				$elm$core$Dict$toList(
					A2(
						$elm$core$Dict$filter,
						F2(
							function (qid, question) {
								return _Utils_eq(question.fb.eI, id);
							}),
						session.u.hp))));
		var questions = A2($elm$core$Maybe$withDefault, dbquestions, mbquestions);
		var model = {
			c: A5($author$project$Page$Questionary$init, id, focus, dndmodel, questions, questionary),
			hB: session,
			e3: $author$project$Viewer$system.e3(dndmodel),
			e6: $elm$core$Basics$identity,
			ih: $author$project$Page$Questionary$update,
			ik: $author$project$Page$Questionary$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Study$Model = F2(
	function (id, nameFocus) {
		return {S: id, en: nameFocus};
	});
var $author$project$Type$Database$Aquisition$Aquisition = F2(
	function (receiver, reference) {
		return {av: receiver, aj: reference};
	});
var $author$project$Type$Database$Aquisition$Raw = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Study$SerializableStudyDatapoint = F6(
	function (event, question, answer, coding_question, coding_answer, coder) {
		return {E: answer, du: coder, dw: coding_answer, dx: coding_question, as: event, eH: question};
	});
var $author$project$Type$Database$Aquisition$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Type$Database$rows = function (old) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst($author$project$Type$IO$Internal$box),
		$elm$core$Dict$toList(old));
};
var $author$project$Type$Database$Aquisition$filterBy = F3(
	function (attr, table, old) {
		return A2(
			$elm$core$List$filter,
			function (x) {
				return _Utils_eq(
					attr(x),
					old);
			},
			$author$project$Type$Database$rows(table));
	});
var $author$project$Type$Database$Aquisition$transformAccessor = function (accessor) {
	if (accessor.$ === 1) {
		var f = accessor.a;
		return function (_v1) {
			var x = _v1.b;
			return f(x.fb);
		};
	} else {
		var f = accessor.a;
		return f;
	}
};
var $author$project$Type$Database$Aquisition$updateReciever = F2(
	function (_v0, val) {
		var receiver = _v0.av;
		var reference = _v0.aj;
		return {
			av: receiver(val),
			aj: reference
		};
	});
var $author$project$Type$Database$Aquisition$addAttrSingle = F4(
	function (attr, table, selectvalue, aquisition) {
		var selectf = $author$project$Type$Database$Aquisition$transformAccessor(selectvalue);
		var attrf = $author$project$Type$Database$Aquisition$transformAccessor(attr);
		return A2(
			$elm$core$List$map,
			$author$project$Type$Database$Aquisition$updateReciever(aquisition),
			A2(
				$elm$core$List$map,
				selectf,
				A3($author$project$Type$Database$Aquisition$filterBy, attrf, table, aquisition.aj)));
	});
var $author$project$Type$Database$Aquisition$addAttrList = F4(
	function (attr, table, selectvalue, aquisitions) {
		return A2(
			$elm$core$List$concatMap,
			A3($author$project$Type$Database$Aquisition$addAttrSingle, attr, table, selectvalue),
			aquisitions);
	});
var $author$project$Type$Database$Aquisition$add = $author$project$Type$Database$Aquisition$addAttrList;
var $author$project$Type$Database$Aquisition$aquire = function (l) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.av;
		},
		l);
};
var $author$project$Type$Database$Aquisition$end = $author$project$Type$Database$Aquisition$aquire;
var $author$project$Type$Database$Aquisition$updateReference = F2(
	function (_v0, val) {
		var receiver = _v0.av;
		var reference = _v0.aj;
		return {av: receiver, aj: val};
	});
var $author$project$Type$Database$Aquisition$moveReferenceSingle = F4(
	function (attr, table, selectvalue, aquisition) {
		var selectf = $author$project$Type$Database$Aquisition$transformAccessor(selectvalue);
		var attrf = $author$project$Type$Database$Aquisition$transformAccessor(attr);
		return A2(
			$elm$core$List$map,
			$author$project$Type$Database$Aquisition$updateReference(aquisition),
			A2(
				$elm$core$List$map,
				selectf,
				A3($author$project$Type$Database$Aquisition$filterBy, attrf, table, aquisition.aj)));
	});
var $author$project$Type$Database$Aquisition$moveReferenceList = F4(
	function (attr, table, selectvalue, aquisitions) {
		return A2(
			$elm$core$List$concatMap,
			A3($author$project$Type$Database$Aquisition$moveReferenceSingle, attr, table, selectvalue),
			aquisitions);
	});
var $author$project$Type$Database$Aquisition$move = $author$project$Type$Database$Aquisition$moveReferenceList;
var $author$project$Page$Study$serializeStudyDatapoint = function (data) {
	return A2(
		$elm$core$String$join,
		';',
		_List_fromArray(
			[data.as, data.du, data.eH, data.E, data.dx, data.dw]));
};
var $author$project$Type$Database$Aquisition$start = $author$project$Type$Database$Aquisition$addAttrSingle;
var $author$project$Page$Study$exportStudy = F2(
	function (id, db) {
		var datapoints = $author$project$Type$Database$Aquisition$end(
			A4(
				$author$project$Type$Database$Aquisition$add,
				$author$project$Type$Database$Aquisition$Raw(
					function (_v1) {
						var x = _v1.a;
						var y = _v1.b;
						return y.a5;
					}),
				db.c6,
				$author$project$Type$Database$Aquisition$Value(
					function (x) {
						return A2($elm$core$Maybe$withDefault, '', x.af);
					}),
				A4(
					$author$project$Type$Database$Aquisition$move,
					$author$project$Type$Database$Aquisition$Raw($elm$core$Tuple$first),
					db.f0,
					$author$project$Type$Database$Aquisition$Raw(
						function (_v0) {
							var x = _v0.a;
							var y = _v0.b;
							return y.a5;
						}),
					A4(
						$author$project$Type$Database$Aquisition$move,
						$author$project$Type$Database$Aquisition$Value(
							function ($) {
								return $.dx;
							}),
						db.f0,
						$author$project$Type$Database$Aquisition$Raw($elm$core$Tuple$first),
						A4(
							$author$project$Type$Database$Aquisition$add,
							$author$project$Type$Database$Aquisition$Value(
								function ($) {
									return $.dx;
								}),
							db.f0,
							$author$project$Type$Database$Aquisition$Value(
								function ($) {
									return $.fb;
								}),
							A4(
								$author$project$Type$Database$Aquisition$move,
								$author$project$Type$Database$Aquisition$Value(
									function ($) {
										return $.f1;
									}),
								db.dy,
								$author$project$Type$Database$Aquisition$Raw($elm$core$Tuple$first),
								A4(
									$author$project$Type$Database$Aquisition$add,
									$author$project$Type$Database$Aquisition$Value(
										function ($) {
											return $.f1;
										}),
									db.dy,
									$author$project$Type$Database$Aquisition$Value(
										function ($) {
											return $.hQ;
										}),
									A4(
										$author$project$Type$Database$Aquisition$move,
										$author$project$Type$Database$Aquisition$Value(
											function ($) {
												return $.eH;
											}),
										db.f2,
										$author$project$Type$Database$Aquisition$Raw($elm$core$Tuple$first),
										A4(
											$author$project$Type$Database$Aquisition$add,
											$author$project$Type$Database$Aquisition$Value(
												function ($) {
													return $.eH;
												}),
											db.bL,
											$author$project$Type$Database$Aquisition$Value(
												function ($) {
													return $.fb;
												}),
											A4(
												$author$project$Type$Database$Aquisition$move,
												$author$project$Type$Database$Aquisition$Value(
													function ($) {
														return $.eI;
													}),
												db.hp,
												$author$project$Type$Database$Aquisition$Raw($elm$core$Tuple$first),
												A4(
													$author$project$Type$Database$Aquisition$add,
													$author$project$Type$Database$Aquisition$Value(
														function ($) {
															return $.eI;
														}),
													db.hp,
													$author$project$Type$Database$Aquisition$Value(
														function ($) {
															return $.hQ;
														}),
													A4(
														$author$project$Type$Database$Aquisition$move,
														$author$project$Type$Database$Aquisition$Value(
															function ($) {
																return $.cY;
															}),
														db.bs,
														$author$project$Type$Database$Aquisition$Raw($elm$core$Tuple$first),
														A4(
															$author$project$Type$Database$Aquisition$start,
															$author$project$Type$Database$Aquisition$Value(
																function ($) {
																	return $.cY;
																}),
															db.gm,
															$author$project$Type$Database$Aquisition$Value(
																function ($) {
																	return $.af;
																}),
															A2($author$project$Type$Database$Aquisition$Aquisition, $author$project$Page$Study$SerializableStudyDatapoint, id))))))))))))));
		return A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, $author$project$Page$Study$serializeStudyDatapoint, datapoints));
	});
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Page$Study$update = F2(
	function (message, _v0) {
		var model = _v0;
		if (message.$ === 9) {
			var msg = message.a;
			if (!msg.$) {
				var msg_ = msg.a;
				if (!msg_) {
					var old_page = model.c;
					var new_page = _Utils_update(
						old_page,
						{en: true});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c: new_page}),
						$elm$core$Platform$Cmd$none);
				} else {
					var old_page = model.c;
					var new_page = _Utils_update(
						old_page,
						{en: false});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c: new_page}),
						$elm$core$Platform$Cmd$none);
				}
			} else {
				var id = msg.a;
				return _Utils_Tuple2(
					model,
					A3(
						$elm$file$File$Download$string,
						'export.csv',
						'text/csv',
						A2(
							$author$project$Page$Study$exportStudy,
							$author$project$Type$IO$Internal$box(id),
							model.hB.u)));
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Msg$ExportStudy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$Study = function (a) {
	return {$: 9, a: a};
};
var $author$project$Msg$StudyNameEdit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Study$relatedData = F2(
	function (id, db) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Type$IO$Internal$unbox(id),
			db.hK);
		if (!_v0.$) {
			var timestampedStudy = _v0.a;
			var study = timestampedStudy.fb;
			return $elm$core$Maybe$Just(
				{
					f8: $elm$time$Time$millisToPosix(timestampedStudy.f8),
					a5: _Utils_Tuple2(
						timestampedStudy.a5,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(timestampedStudy.a5),
								db.c6))),
					a7: study.a7,
					gm: A2(
						$elm$core$List$filter,
						function (_v1) {
							var y = _v1.b;
							return _Utils_eq(y.cY, id);
						},
						A2(
							$elm$core$List$map,
							function (_v2) {
								var x = _v2.a;
								var y = _v2.b;
								return _Utils_Tuple2(
									$author$project$Type$IO$Internal$box(x),
									y.fb);
							},
							$elm$core$Dict$toList(db.gm))),
					S: id,
					aH: _Utils_Tuple2(
						study.aH,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fb;
							},
							A2(
								$elm$core$Dict$get,
								$author$project$Type$IO$Internal$unbox(study.aH),
								db.c6))),
					bs: A2(
						$elm$core$List$filter,
						function (_v3) {
							var y = _v3.b;
							return _Utils_eq(y.cY, id);
						},
						A2(
							$elm$core$List$map,
							function (_v4) {
								var x = _v4.a;
								var y = _v4.b;
								return _Utils_Tuple2(
									$author$project$Type$IO$Internal$box(x),
									y.fb);
							},
							$elm$core$Dict$toList(db.bs))),
					h5: study.af,
					fa: $elm$time$Time$millisToPosix(timestampedStudy.gW)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Study$toTitle = function (_v0) {
	return 'Home ⧽ Study';
};
var $author$project$Page$Study$viewLeader = F2(
	function (_v0, cur) {
		var id = _v0.a;
		var mbLeader = _v0.b;
		return _Utils_eq(
			$elm$core$Maybe$Just(id),
			cur) ? 'You' : A2(
			$elm$core$Maybe$withDefault,
			$author$project$Type$IO$Internal$unbox(id),
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.af;
				},
				mbLeader));
	});
var $author$project$Page$Study$viewList = F3(
	function (elements, onClick, nameGetter) {
		var mlist = A2(
			$elm$core$List$map,
			function (_v1) {
				var x = _v1.a;
				var y = _v1.b;
				return A2(
					$aforemny$material_components_web_elm$Material$List$Item$listItem,
					A2(
						$aforemny$material_components_web_elm$Material$List$Item$setOnClick,
						onClick(
							$author$project$Type$IO$Internal$unbox(x)),
						$aforemny$material_components_web_elm$Material$List$Item$config),
					_List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$List$Item$graphic,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$gdamjan$elm_identicon$Identicon$identicon,
									'100%',
									$author$project$Type$IO$Internal$unbox(x))
								])),
							$elm$html$Html$text(
							nameGetter(y))
						]));
			},
			elements);
		if (mlist.b) {
			var f = mlist.a;
			var r = mlist.b;
			return A3($aforemny$material_components_web_elm$Material$List$list, $aforemny$material_components_web_elm$Material$List$config, f, r);
		} else {
			return A3(
				$aforemny$material_components_web_elm$Material$List$list,
				$aforemny$material_components_web_elm$Material$List$config,
				A2(
					$aforemny$material_components_web_elm$Material$List$Item$listItem,
					$aforemny$material_components_web_elm$Material$List$Item$config,
					_List_fromArray(
						[
							$elm$html$Html$text('Nothing here, create one?')
						])),
				_List_Nil);
		}
	});
var $author$project$Page$Study$view = function (_v0) {
	var model = _v0;
	var econf = {
		fo: $author$project$Msg$Study(
			$author$project$Msg$StudyNameEdit(0)),
		fp: model.c.en,
		fT: function (z) {
			return $author$project$Type$Database$TypeMatching$setField(
				{dk: 'name', S: model.c.S, d9: $author$project$Type$Database$StudyType, eV: $author$project$Type$IO$Setter$StringMsg, fb: z});
		},
		gb: function (_v4) {
			return $author$project$Msg$Study(
				$author$project$Msg$StudyNameEdit(1));
		}
	};
	var db = model.hB.u;
	var mbInfos = A2($author$project$Page$Study$relatedData, model.c.S, db);
	if (!mbInfos.$) {
		var infos = mbInfos.a;
		return _Utils_update(
			$author$project$Viewer$detailsConfig,
			{
				fn: _List_fromArray(
					[
						_Utils_Tuple2(
						'get_app',
						$author$project$Msg$Study(
							$author$project$Msg$ExportStudy(
								$author$project$Type$IO$Internal$unbox(infos.S))))
					]),
				fI: function (_v2) {
					return _List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
							_List_fromArray(
								[$aforemny$material_components_web_elm$Material$Typography$typography]),
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$Typography$headline5]),
													_List_fromArray(
														[
															A3($author$project$Viewer$EditableText$text, econf, _List_Nil, infos.h5)
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Description:' + infos.a7)
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															'Leader: ' + A2($author$project$Page$Study$viewLeader, infos.aH, model.hB.c5))
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$aforemny$material_components_web_elm$Material$Button$unelevated,
															A2(
																$aforemny$material_components_web_elm$Material$Button$setOnClick,
																A4(
																	$author$project$Msg$FollowSubpage,
																	$author$project$Type$Database$StudyType,
																	$author$project$Type$IO$Internal$unbox(model.c.S),
																	_List_fromArray(
																		['code']),
																	_List_Nil),
																A2(
																	$aforemny$material_components_web_elm$Material$Button$setIcon,
																	$elm$core$Maybe$Just(
																		$aforemny$material_components_web_elm$Material$Button$icon('add')),
																	$aforemny$material_components_web_elm$Material$Button$config)),
															'StartCoding')
														]))
												])),
											A2(
											$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$Typography$headline5]),
													_List_fromArray(
														[
															$elm$html$Html$text('Events')
														])),
													A3(
													$author$project$Page$Study$viewList,
													infos.gm,
													$author$project$Msg$Follow($author$project$Type$Database$EventType),
													function ($) {
														return $.af;
													}),
													A2(
													$aforemny$material_components_web_elm$Material$Button$unelevated,
													A2(
														$aforemny$material_components_web_elm$Material$Button$setOnClick,
														$author$project$Msg$CRUD(
															A2(
																$author$project$Msg$CreateRandom,
																$author$project$Type$Database$EventType,
																_List_fromArray(
																	[
																		function (x) {
																		return $author$project$Type$Database$TypeMatching$setField(
																			{
																				dk: 'study',
																				S: $author$project$Type$IO$Internal$box(x),
																				d9: $author$project$Type$Database$EventType,
																				eV: $author$project$Type$IO$Setter$StringMsg,
																				fb: $author$project$Type$IO$Internal$unbox(infos.S)
																			});
																	}
																	]))),
														A2(
															$aforemny$material_components_web_elm$Material$Button$setIcon,
															$elm$core$Maybe$Just(
																$aforemny$material_components_web_elm$Material$Button$icon('add')),
															$aforemny$material_components_web_elm$Material$Button$config)),
													'Add')
												])),
											A2(
											$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$Typography$headline5]),
													_List_fromArray(
														[
															$elm$html$Html$text('Questionnaries')
														])),
													A3(
													$author$project$Page$Study$viewList,
													infos.bs,
													$author$project$Msg$Follow($author$project$Type$Database$QuestionaryType),
													function ($) {
														return $.af;
													}),
													A2(
													$aforemny$material_components_web_elm$Material$Button$unelevated,
													A2(
														$aforemny$material_components_web_elm$Material$Button$setOnClick,
														$author$project$Msg$CRUD(
															A2(
																$author$project$Msg$CreateRandom,
																$author$project$Type$Database$QuestionaryType,
																_List_fromArray(
																	[
																		function (x) {
																		return $author$project$Type$Database$TypeMatching$setField(
																			{
																				dk: 'study',
																				S: $author$project$Type$IO$Internal$box(x),
																				d9: $author$project$Type$Database$QuestionaryType,
																				eV: $author$project$Type$IO$Setter$StringMsg,
																				fb: $author$project$Type$IO$Internal$unbox(infos.S)
																			});
																	}
																	]))),
														A2(
															$aforemny$material_components_web_elm$Material$Button$setIcon,
															$elm$core$Maybe$Just(
																$aforemny$material_components_web_elm$Material$Button$icon('add')),
															$aforemny$material_components_web_elm$Material$Button$config)),
													'Add')
												]))
										]))
								]))
						]);
				},
				h5: $author$project$Page$Study$toTitle(model.c),
				c5: model.hB.c5
			});
	} else {
		return _Utils_update(
			$author$project$Viewer$detailsConfig,
			{
				fI: function (_v3) {
					return _List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$Typography$headline5]),
													_List_fromArray(
														[
															$elm$html$Html$text('Study not Found')
														]))
												]))
										]))
								]))
						]);
				},
				h5: $author$project$Page$Study$toTitle(model.c),
				c5: model.hB.c5
			});
	}
};
var $author$project$Page$Study$page = F3(
	function (session, id, focus) {
		var model = {
			c: A2($author$project$Page$Study$Model, id, focus),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $elm$core$Basics$identity,
			ih: $author$project$Page$Study$update,
			ik: $author$project$Page$Study$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Top$Model = function (localStorageInputField) {
	return {be: localStorageInputField};
};
var $author$project$Page$Top$init = $author$project$Page$Top$Model('');
var $author$project$Ports$toLocalStorage = _Platform_outgoingPort(
	'toLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string($.ic))
				]));
	});
var $author$project$Page$Top$update = F2(
	function (message, _v0) {
		var model = _v0;
		var session = model.hB;
		if (message.$ === 5) {
			var msg = message.a;
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 1:
					var input = msg.a;
					var oldPage = model.c;
					var newPage = _Utils_update(
						oldPage,
						{be: input});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c: newPage}),
						$elm$core$Platform$Cmd$none);
				case 2:
					var oldPage = model.c;
					var newSession = session;
					var newPage = _Utils_update(
						oldPage,
						{be: ''});
					var localStorage = {ic: model.c.be};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c: newPage, hB: newSession}),
						$author$project$Ports$toLocalStorage(localStorage));
				default:
					var newSession = session;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hB: newSession}),
						$author$project$Ports$clearLocalStorage(0));
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Viewer$Internal$defaultCardConfig = {S: '', hn: $elm$core$Maybe$Nothing, h5: ''};
var $aforemny$material_components_web_elm$Material$Card$Actions = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Card$actions = function (_v0) {
	var buttons = _v0.dq;
	var icons = _v0.d1;
	return {dq: buttons, b9: false, d1: icons};
};
var $aforemny$material_components_web_elm$Material$Card$Block = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Card$block = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Typography$body2 = $elm$html$Html$Attributes$class('mdc-typography--body2');
var $aforemny$material_components_web_elm$Material$Card$Button = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Card$button = F2(
	function (_v0, label) {
		var buttonConfig = _v0;
		return A2(
			$aforemny$material_components_web_elm$Material$Button$text,
			_Utils_update(
				buttonConfig,
				{
					bF: A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('mdc-card__action'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('mdc-card__action--button'),
							buttonConfig.bF))
				}),
			label);
	});
var $aforemny$material_components_web_elm$Material$Card$actionsElt = function (content) {
	var _v0 = content.fn;
	if (!_v0.$) {
		var buttons = _v0.a.dq;
		var icons = _v0.a.d1;
		var fullBleed = _v0.a.b9;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							$elm$html$Html$Attributes$class('mdc-card__actions')),
							fullBleed ? $elm$core$Maybe$Just(
							$elm$html$Html$Attributes$class('mdc-card__actions--full-bleed')) : $elm$core$Maybe$Nothing
						])),
				$elm$core$List$concat(
					_List_fromArray(
						[
							(!$elm$core$List$isEmpty(buttons)) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mdc-card__action-buttons')
									]),
								A2(
									$elm$core$List$map,
									function (_v1) {
										var button_ = _v1;
										return button_;
									},
									buttons))
							]) : _List_Nil,
							(!$elm$core$List$isEmpty(icons)) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mdc-card__action-icons')
									]),
								A2(
									$elm$core$List$map,
									function (_v2) {
										var icon_ = _v2;
										return icon_;
									},
									icons))
							]) : _List_Nil
						])))
			]);
	} else {
		return _List_Nil;
	}
};
var $aforemny$material_components_web_elm$Material$Card$blocksElt = function (_v0) {
	var blocks = _v0.dn;
	return A2(
		$elm$core$List$map,
		function (_v1) {
			var html = _v1;
			return html;
		},
		blocks);
};
var $aforemny$material_components_web_elm$Material$Card$outlinedCs = function (_v0) {
	var outlined = _v0.cC;
	return outlined ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-card--outlined')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Card$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-card'));
var $aforemny$material_components_web_elm$Material$Card$card = F2(
	function (config_, content) {
		var additionalAttributes = config_.bF;
		return A3(
			$elm$html$Html$node,
			'mdc-card',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Card$rootCs,
							$aforemny$material_components_web_elm$Material$Card$outlinedCs(config_)
						])),
				additionalAttributes),
			$elm$core$List$concat(
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Card$blocksElt(content),
						$aforemny$material_components_web_elm$Material$Card$actionsElt(content)
					])));
	});
var $aforemny$material_components_web_elm$Material$Card$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Card$config = {bF: _List_Nil, cC: false};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $aforemny$material_components_web_elm$Material$Typography$headline6 = $elm$html$Html$Attributes$class('mdc-typography--headline6');
var $aforemny$material_components_web_elm$Material$Card$Icon = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Card$icon = F2(
	function (_v0, icon_) {
		var iconButtonConfig = _v0;
		return A2(
			$aforemny$material_components_web_elm$Material$IconButton$iconButton,
			_Utils_update(
				iconButtonConfig,
				{
					bF: A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('mdc-card__action'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('mdc-card__action--icon'),
							iconButtonConfig.bF))
				}),
			icon_);
	});
var $aforemny$material_components_web_elm$Material$Card$primaryActionCs = $elm$html$Html$Attributes$class('mdc-card__primary-action');
var $aforemny$material_components_web_elm$Material$Card$tabIndexProp = function (tabIndex) {
	return A2(
		$elm$html$Html$Attributes$property,
		'tabIndex',
		$elm$json$Json$Encode$int(tabIndex));
};
var $aforemny$material_components_web_elm$Material$Card$primaryAction = F2(
	function (additionalAttributes, blocks) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_Utils_ap(
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Card$primaryActionCs,
							$aforemny$material_components_web_elm$Material$Card$tabIndexProp(0)
						]),
					additionalAttributes),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var html = _v0;
						return html;
					},
					blocks))
			]);
	});
var $aforemny$material_components_web_elm$Material$Typography$subtitle2 = $elm$html$Html$Attributes$class('mdc-typography--subtitle2');
var $aforemny$material_components_web_elm$Material$Theme$textSecondaryOnBackground = $elm$html$Html$Attributes$class('mdc-theme--text-secondary-on-background');
var $author$project$Viewer$Internal$viewCard = function (config) {
	var primod = function (x) {
		var _v0 = config.hn;
		if (!_v0.$) {
			var pA = _v0.a;
			return A2(
				$aforemny$material_components_web_elm$Material$Card$primaryAction,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(pA)
					]),
				x);
		} else {
			return x;
		}
	};
	return A2(
		$aforemny$material_components_web_elm$Material$Card$card,
		$aforemny$material_components_web_elm$Material$Card$config,
		{
			fn: $elm$core$Maybe$Just(
				$aforemny$material_components_web_elm$Material$Card$actions(
					{
						dq: _List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Card$button, $aforemny$material_components_web_elm$Material$Button$config, 'Visit')
							]),
						d1: _List_fromArray(
							[
								A2(
								$aforemny$material_components_web_elm$Material$Card$icon,
								$aforemny$material_components_web_elm$Material$IconButton$config,
								$aforemny$material_components_web_elm$Material$IconButton$icon('favorite'))
							])
					})),
			dn: primod(
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Card$block(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'margin-left', 'auto'),
									A2($elm$html$Html$Attributes$style, 'margin-right', 'auto'),
									A2($elm$html$Html$Attributes$style, 'padding-top', '1rem'),
									A2($elm$html$Html$Attributes$style, 'width', '25%')
								]),
							_List_fromArray(
								[
									A2($gdamjan$elm_identicon$Identicon$identicon, '100%', config.S)
								]))),
						$aforemny$material_components_web_elm$Material$Card$block(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '1rem')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											$aforemny$material_components_web_elm$Material$Typography$headline6,
											A2($elm$html$Html$Attributes$style, 'margin', '0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(config.h5)
										])),
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$aforemny$material_components_web_elm$Material$Typography$subtitle2,
											$aforemny$material_components_web_elm$Material$Theme$textSecondaryOnBackground,
											A2($elm$html$Html$Attributes$style, 'margin', '0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Some interesting Subtitle')
										]))
								]))),
						$aforemny$material_components_web_elm$Material$Card$block(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '0 1rem 0.5rem 1rem'),
									$aforemny$material_components_web_elm$Material$Typography$body2,
									$aforemny$material_components_web_elm$Material$Theme$textSecondaryOnBackground
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Description')
										]))
								])))
					]))
		});
};
var $author$project$Page$Top$studyCard = F2(
	function (id, study) {
		return $author$project$Viewer$Internal$viewCard(
			_Utils_update(
				$author$project$Viewer$Internal$defaultCardConfig,
				{
					S: id,
					hn: $elm$core$Maybe$Just(
						A2($author$project$Msg$Follow, $author$project$Type$Database$StudyType, id)),
					h5: study.af
				}));
	});
var $author$project$Page$Top$studyOverview = F2(
	function (user, _v0) {
		var model = _v0;
		var db = model.hB.u;
		return A2(
			$elm$core$List$map,
			function (_v3) {
				var x = _v3.a;
				var y = _v3.b;
				return A2($author$project$Page$Top$studyCard, x, y);
			},
			A2(
				$elm$core$List$filter,
				function (_v2) {
					var x = _v2.a;
					var y = _v2.b;
					return _Utils_eq(y.aH, user);
				},
				A2(
					$elm$core$List$map,
					function (_v1) {
						var x = _v1.a;
						var y = _v1.b;
						return _Utils_Tuple2(x, y.fb);
					},
					$elm$core$Dict$toList(db.hK))));
	});
var $author$project$Page$Top$toTitle = 'Home';
var $author$project$Page$Top$view = function (_v0) {
	var model = _v0;
	var db = model.hB.u;
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				var _v2 = model.hB.c5;
				if (!_v2.$) {
					var user = _v2.a;
					var studies = A2($author$project$Page$Top$studyOverview, user, model);
					return ($elm$core$List$length(studies) > 0) ? _List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$aforemny$material_components_web_elm$Material$LayoutGrid$inner,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (x) {
											return A2(
												$aforemny$material_components_web_elm$Material$LayoutGrid$cell,
												_List_Nil,
												_List_fromArray(
													[x]));
										},
										studies))
								]))
						]) : _List_fromArray(
						[
							$elm$html$Html$text('Create'),
							A2(
							$aforemny$material_components_web_elm$Material$Button$text,
							A2(
								$aforemny$material_components_web_elm$Material$Button$setOnClick,
								$author$project$Msg$CRUD(
									A2(
										$author$project$Msg$CreateRandom,
										$author$project$Type$Database$StudyType,
										_List_fromArray(
											[
												function (x) {
												return $author$project$Type$Database$TypeMatching$setField(
													{
														dk: 'leader',
														S: $author$project$Type$IO$Internal$box(x),
														d9: $author$project$Type$Database$StudyType,
														eV: $author$project$Type$IO$Setter$StringMsg,
														fb: $author$project$Type$IO$Internal$unbox(user)
													});
											},
												$author$project$Msg$Follow($author$project$Type$Database$StudyType)
											]))),
								$aforemny$material_components_web_elm$Material$Button$config),
							'Create')
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$LayoutGrid$layoutGrid,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('ye should not get here')
								]))
						]);
				}
			},
			h5: $author$project$Page$Top$toTitle,
			id: true,
			c5: model.hB.c5
		});
};
var $author$project$Page$Top$page = function (session) {
	var model = {c: $author$project$Page$Top$init, hB: session, e3: $elm$core$Platform$Sub$none, e6: $elm$core$Basics$identity, ih: $author$project$Page$Top$update, ik: $author$project$Page$Top$view};
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Msg$User = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$User$Model = function (user_id) {
	return {ii: user_id};
};
var $author$project$Page$User$init = function (user_id) {
	return $author$project$Page$User$Model(user_id);
};
var $author$project$Page$User$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$User$toTitle = function (model) {
	return 'Page With Subpage - ' + $elm$core$String$fromInt(
		A2($elm$core$Maybe$withDefault, -1, model.ii));
};
var $author$project$Page$User$view = function (_v0) {
	var model = _v0;
	return _Utils_update(
		$author$project$Viewer$detailsConfig,
		{
			fI: function (_v1) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('elm-spa-boilerplate - Page With Subpage')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This is a page that can handle subpaths in its routing.')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'The current subpath is : /' + $elm$core$String$fromInt(
											A2($elm$core$Maybe$withDefault, -1, model.c.ii)))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The subpath could be anything, or a specific type, like a string or integer. You can have many levels of subpaths if you wanted!')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' This demo accepts a single level subpath that can be any string. For example, '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/pagewithsubpage/xyz')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('/pagewithsubpage/xyz')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/pagewithsubpage/a-wonderful-subpath')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('click here to go to a subpath')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/pagewithsubpage/i-love-elm')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('click here to go to another subpath')
											]))
									]))
							]))
					]);
			},
			h5: $author$project$Page$User$toTitle(model.c)
		});
};
var $author$project$Page$User$page = F2(
	function (session, user_id) {
		var model = {
			c: $author$project$Page$User$init(user_id),
			hB: session,
			e3: $elm$core$Platform$Sub$none,
			e6: $author$project$Msg$User,
			ih: $author$project$Page$liftupdate($author$project$Page$User$update),
			ik: $author$project$Page$User$view
		};
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Admin$Edit = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Page$Admin$Home = {$: 0};
var $author$project$Page$Admin$Query = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.am;
		var unvisited = _v0.V;
		var params = _v0.ah;
		var frag = _v0.Z;
		var value = _v0.fb;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.am;
			var unvisited = _v1.V;
			var params = _v1.ah;
			var frag = _v1.Z;
			var value = _v1.fb;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.am;
		var unvisited = _v1.V;
		var params = _v1.ah;
		var frag = _v1.Z;
		var value = _v1.fb;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.am;
		var unvisited = _v0.V;
		var params = _v0.ah;
		var frag = _v0.Z;
		var value = _v0.fb;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Page$Admin$parser = function () {
	var page2parser = function (subpage) {
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$Page$Admin$Query(subpage),
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s(
					$author$project$Type$Database$TypeMatching$toString(subpage)),
				$elm$url$Url$Parser$Query$string('q')));
	};
	var page2edit = function (subpage) {
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$Page$Admin$Edit(subpage),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s(
					$author$project$Type$Database$TypeMatching$toString(subpage)),
				$elm$url$Url$Parser$string));
	};
	return $elm$url$Url$Parser$oneOf(
		A2(
			$elm$core$List$cons,
			A2($elm$url$Url$Parser$map, $author$project$Page$Admin$Home, $elm$url$Url$Parser$top),
			_Utils_ap(
				A2($elm$core$List$map, page2parser, $author$project$Type$Database$TypeMatching$types),
				A2($elm$core$List$map, page2edit, $author$project$Type$Database$TypeMatching$types))));
}();
var $author$project$Page$Answer$Model = F3(
	function (questionary, test_subject, event) {
		return {as: event, eI: questionary, aO: test_subject};
	});
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $author$project$Page$Answer$parser = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('answer'),
	$elm$url$Url$Parser$query(
		A3(
			$elm$url$Url$Parser$Query$map2,
			F2(
				function (qid, tsid) {
					return function (eid) {
						return A2(
							$elm$core$Maybe$map,
							function (x) {
								return x(eid);
							},
							A3($elm$core$Maybe$map2, $author$project$Page$Answer$Model, qid, tsid));
					};
				}),
			$elm$url$Url$Parser$Query$string('qid'),
			$elm$url$Url$Parser$Query$string('tsid'))));
var $author$project$Main$paths = {dg: 'admin', dx: 'coding_question', as: 'event', eu: 'pageone', ev: 'pagewithsubpage', eH: 'question', eI: 'questionary', cY: 'study', id: '', c6: 'user'};
var $author$project$Main$route = F2(
	function (parser_, handler) {
		return A2($elm$url$Url$Parser$map, handler, parser_);
	});
var $author$project$Main$parser = F2(
	function (model, session) {
		return $elm$url$Url$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$author$project$Main$route,
					$elm$url$Url$Parser$top,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$Top,
						$author$project$Page$Top$page(session))),
					A2(
					$author$project$Main$route,
					$elm$url$Url$Parser$s($author$project$Main$paths.c6),
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$User,
						A2($author$project$Page$User$page, session, $elm$core$Maybe$Nothing))),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.c6),
						$elm$url$Url$Parser$int),
					function (user_id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$User,
							A2(
								$author$project$Page$User$page,
								session,
								$elm$core$Maybe$Just(user_id)));
					}),
					A2(
					$author$project$Main$route,
					$elm$url$Url$Parser$s($author$project$Main$paths.eu),
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$PageOne,
						$author$project$Page$PageOne$page(session))),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.cY),
						$elm$url$Url$Parser$string),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Study,
							A3(
								$author$project$Page$Study$page,
								session,
								$author$project$Type$IO$Internal$box(id),
								false));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.cY),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('code'))),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Code,
							A2(
								$author$project$Page$Code$page,
								session,
								$author$project$Type$IO$Internal$box(id)));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.as),
						A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Page$Answer$parser)),
					F2(
						function (eid, answer_result) {
							var _v0 = answer_result(eid);
							if (!_v0.$) {
								var amodel = _v0.a;
								return A3(
									$author$project$Main$mapPageMsg,
									model,
									$author$project$Main$Answer,
									A2($author$project$Page$Answer$page, session, amodel));
							} else {
								return A3(
									$author$project$Main$mapPageMsg,
									model,
									$author$project$Main$Event,
									A4(
										$author$project$Page$Event$page,
										session,
										0,
										$author$project$Type$IO$Internal$box(eid),
										false));
							}
						})),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.as),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('people'))),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Event,
							A4(
								$author$project$Page$Event$page,
								session,
								2,
								$author$project$Type$IO$Internal$box(id),
								false));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.as),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('settings'))),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Event,
							A4(
								$author$project$Page$Event$page,
								session,
								0,
								$author$project$Type$IO$Internal$box(id),
								false));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.as),
						$elm$url$Url$Parser$string),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Event,
							A4(
								$author$project$Page$Event$page,
								session,
								1,
								$author$project$Type$IO$Internal$box(id),
								false));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.eI),
						$elm$url$Url$Parser$string),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Questionary,
							A5(
								$author$project$Page$Questionary$page,
								session,
								$author$project$Type$IO$Internal$box(id),
								$author$project$Page$Questionary$defaultFokus,
								$elm$core$Maybe$Nothing,
								$author$project$Viewer$system.gV));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.eH),
						$elm$url$Url$Parser$string),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Question,
							A2(
								$author$project$Page$Question$page,
								session,
								$author$project$Type$IO$Internal$box(id)));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.dx),
						$elm$url$Url$Parser$string),
					function (id) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$CodingQuestion,
							A2(
								$author$project$Page$CodingQuestion$page,
								session,
								$author$project$Type$IO$Internal$box(id)));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.dg),
						$author$project$Page$Admin$parser),
					function (presult) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Admin,
							A2($author$project$Page$Admin$page, session, presult));
					}),
					A2(
					$author$project$Main$route,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s($author$project$Main$paths.ev),
						$elm$url$Url$Parser$string),
					function (subpage) {
						return A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$PageWithSubpage,
							A2($author$project$Page$PageWithSubpage$page, session, subpage));
					})
				]));
	});
var $author$project$Main$routeUrl = F2(
	function (url, model) {
		var session = $author$project$Main$extractSession(model);
		var hashUrl = _Utils_update(
			url,
			{
				aE: $elm$core$Maybe$Nothing,
				bq: A2($elm$core$Maybe$withDefault, '', url.aE)
			});
		var _v0 = A2(
			$elm$url$Url$Parser$parse,
			A2($author$project$Main$parser, model, session),
			url);
		if (!_v0.$) {
			var success = _v0.a;
			return success;
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						c: $author$project$Main$NotFound(session)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.eE;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.aE,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.eG,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.ez,
					_Utils_ap(http, url.dZ)),
				url.bq)));
};
var $author$project$Main$urlAdaptHash = function (url) {
	var mbnewUrl = $elm$url$Url$fromString(
		A3(
			$elm$core$String$replace,
			'/#/',
			'/',
			$elm$url$Url$toString(url)));
	return A2($elm$core$Maybe$withDefault, url, mbnewUrl);
};
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var localStorage = A2($elm$json$Json$Decode$decodeValue, $author$project$Type$Database$database.a6, flags.eh);
		var db = A2($elm$json$Json$Decode$decodeValue, $author$project$Type$Database$database.a6, flags.u);
		var _v0 = A2(
			$author$project$Main$routeUrl,
			$author$project$Main$urlAdaptHash(url),
			A4(
				$author$project$Main$Model,
				key,
				$author$project$Main$NotFound(
					$author$project$Session$init(flags)),
				$author$project$Viewer$header,
				$elm$core$Maybe$Nothing));
		var model = _v0.a;
		var cmds = _v0.b;
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmds,
					A2($elm$core$Task$perform, $author$project$Msg$Tick, $elm$time$Time$now)
				]));
		if (!localStorage.$) {
			return _Utils_Tuple2(model, newCmds);
		} else {
			var newmodel = model;
			return _Utils_Tuple2(
				newmodel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							newCmds,
							$author$project$Ports$clearLocalStorage(0)
						])));
		}
	});
var $author$project$Msg$OnDbChange = function (a) {
	return {$: 15, a: a};
};
var $author$project$Msg$OnLocalStorageChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$OnWindowResize = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {eD: processes, e4: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.eD;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.e4);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Ports$onDbChange = _Platform_incomingPort('onDbChange', $elm$json$Json$Decode$value);
var $author$project$Ports$onLocalStorageChange = _Platform_incomingPort('onLocalStorageChange', $elm$json$Json$Decode$value);
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Main$subscriptions = function (_v0) {
	var page = _v0.c;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				if (page.$ === 8) {
					var m = page.a;
					return A2($elm$core$Platform$Sub$map, m.e6, m.e3);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$elm$browser$Browser$Events$onResize($author$project$Msg$OnWindowResize),
				$author$project$Ports$onLocalStorageChange($author$project$Msg$OnLocalStorageChange),
				$author$project$Ports$onDbChange($author$project$Msg$OnDbChange),
				A2($elm$time$Time$every, 1000, $author$project$Msg$Tick)
			]));
};
var $author$project$Msg$SetUser = function (a) {
	return {$: 21, a: a};
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $aforemny$material_components_web_elm$Material$Snackbar$close = F2(
	function (messageId, _v0) {
		var queue = _v0;
		return _Utils_update(
			queue,
			{
				ad: function () {
					var _v1 = queue.ad;
					if (!_v1.b) {
						return _List_Nil;
					} else {
						var _v2 = _v1.a;
						var currentMessageId = _v2.a;
						var otherMessages = _v1.b;
						return _Utils_eq(currentMessageId, messageId) ? otherMessages : queue.ad;
					}
				}()
			});
	});
var $author$project$Type$Database$TypeMatching$Delete = {$: 1};
var $author$project$Type$Database$TypeMatching$delete = $author$project$Type$Database$TypeMatching$dispatchDb($author$project$Type$Database$TypeMatching$Delete);
var $elm$random$Random$Generate = $elm$core$Basics$identity;
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$random$Random$init = A2(
	$elm$core$Task$andThen,
	function (time) {
		return $elm$core$Task$succeed(
			$elm$random$Random$initialSeed(
				$elm$time$Time$posixToMillis(time)));
	},
	$elm$time$Time$now);
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return $elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _v1 = A2($elm$random$Random$step, generator, seed);
			var value = _v1.a;
			var newSeed = _v1.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2($elm$core$Platform$sendToApp, router, value));
		}
	});
var $elm$random$Random$onSelfMsg = F3(
	function (_v0, _v1, seed) {
		return $elm$core$Task$succeed(seed);
	});
var $elm$random$Random$cmdMap = F2(
	function (func, _v0) {
		var generator = _v0;
		return A2($elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager($elm$random$Random$init, $elm$random$Random$onEffects, $elm$random$Random$onSelfMsg, $elm$random$Random$cmdMap);
var $elm$random$Random$command = _Platform_leaf('Random');
var $elm$random$Random$generate = F2(
	function (tagger, generator) {
		return $elm$random$Random$command(
			A2($elm$random$Random$map, tagger, generator));
	});
var $elm_community$random_extra$Random$Extra$frequency = F2(
	function (head, pairs) {
		var total = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, $elm$core$Basics$abs, $elm$core$Tuple$first),
				A2($elm$core$List$cons, head, pairs)));
		var pick = F2(
			function (someChoices, n) {
				pick:
				while (true) {
					if (someChoices.b) {
						var _v1 = someChoices.a;
						var k = _v1.a;
						var g = _v1.b;
						var rest = someChoices.b;
						if (_Utils_cmp(n, k) < 1) {
							return g;
						} else {
							var $temp$someChoices = rest,
								$temp$n = n - k;
							someChoices = $temp$someChoices;
							n = $temp$n;
							continue pick;
						}
					} else {
						return head.b;
					}
				}
			});
		return A2(
			$elm$random$Random$andThen,
			pick(
				A2($elm$core$List$cons, head, pairs)),
			A2($elm$random$Random$float, 0, total));
	});
var $elm_community$random_extra$Random$Extra$choices = F2(
	function (hd, gens) {
		return A2(
			$elm_community$random_extra$Random$Extra$frequency,
			_Utils_Tuple2(1, hd),
			A2(
				$elm$core$List$map,
				function (g) {
					return _Utils_Tuple2(1, g);
				},
				gens));
	});
var $elm_community$random_extra$Random$Char$char = F2(
	function (start, end) {
		return A2(
			$elm$random$Random$map,
			$elm$core$Char$fromCode,
			A2($elm$random$Random$int, start, end));
	});
var $elm_community$random_extra$Random$Char$lowerCaseLatin = A2($elm_community$random_extra$Random$Char$char, 97, 122);
var $elm_community$random_extra$Random$Char$upperCaseLatin = A2($elm_community$random_extra$Random$Char$char, 65, 90);
var $elm_community$random_extra$Random$Char$latin = A2(
	$elm_community$random_extra$Random$Extra$choices,
	$elm_community$random_extra$Random$Char$lowerCaseLatin,
	_List_fromArray(
		[$elm_community$random_extra$Random$Char$upperCaseLatin]));
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $aforemny$material_components_web_elm$Material$Snackbar$inc = function (_v0) {
	var messageId = _v0;
	return messageId + 1;
};
var $aforemny$material_components_web_elm$Material$Snackbar$addMessage = F2(
	function (message_, _v0) {
		var queue = _v0;
		return _Utils_update(
			queue,
			{
				ad: _Utils_ap(
					queue.ad,
					_List_fromArray(
						[
							_Utils_Tuple2(queue.aJ, message_)
						])),
				aJ: $aforemny$material_components_web_elm$Material$Snackbar$inc(queue.aJ)
			});
	});
var $aforemny$material_components_web_elm$Material$Snackbar$Message = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$message = function (label) {
	return {
		bC: $elm$core$Maybe$Nothing,
		bD: $elm$core$Maybe$Nothing,
		ea: label,
		cm: false,
		cw: $elm$core$Maybe$Nothing,
		cx: $elm$core$Maybe$Nothing,
		cV: false,
		c0: $elm$core$Maybe$Just(5000)
	};
};
var $aforemny$material_components_web_elm$Material$Snackbar$setStacked = F2(
	function (stacked, _v0) {
		var message_ = _v0;
		return _Utils_update(
			message_,
			{cV: stacked});
	});
var $author$project$Main$reportError = F2(
	function (msg, model) {
		var oldheader = model.i;
		var message = A2(
			$aforemny$material_components_web_elm$Material$Snackbar$setStacked,
			true,
			$aforemny$material_components_web_elm$Material$Snackbar$message(msg));
		var newQueue = A2($aforemny$material_components_web_elm$Material$Snackbar$addMessage, message, oldheader.bt);
		var newheader = _Utils_update(
			oldheader,
			{bt: newQueue});
		return _Utils_update(
			model,
			{i: newheader});
	});
var $author$project$Type$Database$TypeMatching$getTimestampUpdaterMsg = F4(
	function (kind, id, attribute, time) {
		return $author$project$Msg$CRUD(
			$author$project$Msg$Update(
				A2(
					$author$project$Type$IO$Setter$AttributeMsg,
					$author$project$Type$Database$TypeMatching$toStringPlural(kind),
					A2(
						$author$project$Type$IO$Setter$DictKeyMsg,
						id,
						A2(
							$author$project$Type$IO$Setter$AttributeMsg,
							attribute,
							$author$project$Type$IO$Setter$IntMsg(
								$elm$time$Time$posixToMillis(time)))))));
	});
var $author$project$Type$Database$TypeMatching$setTimestamp = F3(
	function (kind, id, attribute) {
		return function (x) {
			return A2($elm$core$Task$perform, x, $elm$time$Time$now);
		}(
			A3($author$project$Type$Database$TypeMatching$getTimestampUpdaterMsg, kind, id, attribute));
	});
var $elm_community$random_extra$Random$String$string = F2(
	function (stringLength, charGenerator) {
		return A2(
			$elm$random$Random$map,
			$elm$core$String$fromList,
			A2($elm$random$Random$list, stringLength, charGenerator));
	});
var $author$project$Main$toHashUrl = function (url) {
	return _Utils_update(
		url,
		{
			aE: $elm$core$Maybe$Just(url.bq),
			bq: ''
		});
};
var $author$project$Page$update = F2(
	function (msg, _v0) {
		var model = _v0;
		return A2(model.ih, msg, model);
	});
var $author$project$Viewer$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_update(
					model,
					{R: true});
			case 1:
				return _Utils_update(
					model,
					{R: false});
			case 3:
				var text = msg.a;
				return _Utils_update(
					model,
					{bj: text});
			default:
				return model;
		}
	});
var $author$project$Main$updateDb = F2(
	function (db, _v0) {
		var model = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						effect,
						$author$project$Ports$toDb(
						A2($author$project$Type$IO$encode, $author$project$Type$Database$database.dM, db))
					])));
	});
var $author$project$Main$updateSession = F2(
	function (model, session) {
		var _v0 = model.c;
		switch (_v0.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$Main$NotFound(session)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var m = _v0.a;
				return A3(
					$author$project$Main$mapPageMsg,
					model,
					$author$project$Main$User,
					A2($author$project$Page$User$page, session, m.c.ii));
			case 1:
				return function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Top(x)
							}),
						y);
				}(
					$author$project$Page$Top$page(session));
			case 5:
				var m = _v0.a;
				return function (_v2) {
					var x = _v2.a;
					var y = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Admin(x)
							}),
						y);
				}(
					A2($author$project$Page$Admin$page, session, m.c.e1));
			case 3:
				return A3(
					$author$project$Main$mapPageMsg,
					model,
					$author$project$Main$PageOne,
					$author$project$Page$PageOne$page(session));
			case 4:
				var m = _v0.a;
				return A3(
					$author$project$Main$mapPageMsg,
					model,
					$author$project$Main$PageWithSubpage,
					A2($author$project$Page$PageWithSubpage$page, session, m.c.e1));
			case 6:
				var m = _v0.a;
				return function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Study(x)
							}),
						y);
				}(
					A3($author$project$Page$Study$page, session, m.c.S, m.c.en));
			case 7:
				var m = _v0.a;
				return function (_v4) {
					var x = _v4.a;
					var y = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Event(x)
							}),
						y);
				}(
					A4($author$project$Page$Event$page, session, m.c.c, m.c.S, m.c.en));
			case 8:
				var m = _v0.a;
				return function (_v5) {
					var x = _v5.a;
					var y = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Questionary(x)
							}),
						y);
				}(
					A5(
						$author$project$Page$Questionary$page,
						session,
						m.c.S,
						m.c.gs,
						$elm$core$Maybe$Just(m.c.hp),
						m.c.gd));
			case 9:
				var m = _v0.a;
				return function (_v6) {
					var x = _v6.a;
					var y = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Question(x)
							}),
						y);
				}(
					A2($author$project$Page$Question$page, session, m.c.S));
			case 10:
				var m = _v0.a;
				return function (_v7) {
					var x = _v7.a;
					var y = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$CodingQuestion(x)
							}),
						y);
				}(
					A2($author$project$Page$CodingQuestion$page, session, m.c.S));
			case 11:
				var m = _v0.a;
				return function (_v8) {
					var x = _v8.a;
					var y = _v8.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Answer(x)
							}),
						y);
				}(
					A2($author$project$Page$Answer$page, session, m.c));
			default:
				var m = _v0.a;
				return function (_v9) {
					var x = _v9.a;
					var y = _v9.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Code(x)
							}),
						y);
				}(
					A2($author$project$Page$Code$page, session, m.c.S));
		}
	});
var $author$project$Main$updateDbSession = F3(
	function (model, session, db) {
		return A2(
			$author$project$Main$updateDb,
			db,
			A2(
				$author$project$Main$updateSession,
				model,
				_Utils_update(
					session,
					{u: db})));
	});
var $author$project$Page$Admin$url = function (_v0) {
	var m = _v0;
	var model = m.c;
	var _v1 = model.e1;
	switch (_v1.$) {
		case 0:
			return '';
		case 1:
			var kind = _v1.a;
			return $author$project$Type$Database$TypeMatching$toString(kind);
		default:
			var kind = _v1.a;
			var id = _v1.b;
			return _Utils_ap(
				$author$project$Type$Database$TypeMatching$toString(kind),
				id);
	}
};
var $author$project$Main$chainableUpdate = F2(
	function (message, _v27) {
		var model = _v27.a;
		var effect = _v27.b;
		return function (_v28) {
			var x = _v28.a;
			var y = _v28.b;
			return _Utils_Tuple2(
				x,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[effect, y])));
		}(
			A2($author$project$Main$update, message, model));
	});
var $author$project$Main$chainedUpdateAll = F2(
	function (messages, _v26) {
		var model = _v26.a;
		var effect = _v26.b;
		return A3(
			$elm$core$List$foldl,
			$author$project$Main$chainableUpdate,
			_Utils_Tuple2(model, effect),
			messages);
	});
var $author$project$Main$defaultUpdate = F2(
	function (message, _v9) {
		var model = _v9.a;
		var effect = _v9.b;
		var session = $author$project$Main$extractSession(model);
		var db = session.u;
		return function (_v10) {
			var x = _v10.a;
			var y = _v10.b;
			return _Utils_Tuple2(
				x,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[effect, y])));
		}(
			function () {
				switch (message.$) {
					case 0:
						var urlRequest = message.a;
						if (!urlRequest.$) {
							var url = urlRequest.a;
							return _Utils_Tuple2(
								model,
								A2(
									$elm$browser$Browser$Navigation$pushUrl,
									model.at,
									$elm$url$Url$toString(
										$author$project$Main$toHashUrl(url))));
						} else {
							var href = urlRequest.a;
							return _Utils_Tuple2(
								model,
								$elm$browser$Browser$Navigation$load(href));
						}
					case 1:
						var url = message.a;
						return A2(
							$author$project$Main$routeUrl,
							$author$project$Main$urlAdaptHash(url),
							model);
					case 2:
						var width = message.a;
						var height = message.b;
						var windowSize = {dW: height, fe: width};
						return A2(
							$author$project$Main$updateSession,
							model,
							_Utils_update(
								session,
								{fh: windowSize}));
					case 3:
						var msg = message.a;
						var newdb = A2($elm$json$Json$Decode$decodeValue, $author$project$Type$Database$database.a6, msg);
						var newSession = function () {
							if (!newdb.$) {
								var success = newdb.a;
								return _Utils_update(
									session,
									{u: success});
							} else {
								return _Utils_update(
									session,
									{u: $author$project$Type$Database$database.dK});
							}
						}();
						return A2($author$project$Main$updateSession, model, newSession);
					case 15:
						var msg = message.a;
						var newdb = A2($elm$json$Json$Decode$decodeValue, $author$project$Type$Database$database.a6, msg);
						var newSession = function () {
							if (!newdb.$) {
								var success = newdb.a;
								return _Utils_update(
									session,
									{u: success});
							} else {
								return _Utils_update(
									session,
									{u: $author$project$Type$Database$database.dK});
							}
						}();
						return A2($author$project$Main$updateSession, model, newSession);
					case 4:
						var msg = message.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									i: A2($author$project$Viewer$update, msg, model.i)
								}),
							$elm$core$Platform$Cmd$none);
					case 14:
						var msg = message.a;
						var new_db = A2(
							$elm$core$Result$withDefault,
							session.u,
							A2($author$project$Type$Database$database.c4, msg, session.u));
						return A2(
							$author$project$Main$updateSession,
							model,
							_Utils_update(
								session,
								{u: new_db}));
					case 17:
						var msg = message.a;
						switch (msg.$) {
							case 0:
								var kind = msg.a;
								var id = msg.b;
								var callbacks = msg.c;
								var newDb = A4(
									$author$project$Type$Database$TypeMatching$new,
									$author$project$Type$IO$Internal$box(id),
									kind,
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Type$IO$Internal$box(''),
										session.c5),
									db);
								var callbacksWithId = A2(
									$elm$core$List$map,
									function (y) {
										return y(id);
									},
									callbacks);
								return A2(
									$author$project$Main$chainedUpdateAll,
									callbacksWithId,
									function (_v16) {
										var x = _v16.a;
										var y = _v16.b;
										return _Utils_Tuple2(
											x,
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														y,
														A3($author$project$Type$Database$TypeMatching$setTimestamp, kind, id, 'created')
													])));
									}(
										function () {
											switch (kind.$) {
												case 10:
													return A2(
														$author$project$Main$chainableUpdate,
														$author$project$Msg$SetUser(
															$author$project$Type$IO$Internal$box(id)),
														A3(
															$author$project$Main$updateDbSession,
															model,
															_Utils_update(
																session,
																{
																	c5: $elm$core$Maybe$Just(
																		$author$project$Type$IO$Internal$box(id))
																}),
															newDb));
												case 8:
													return A2(
														$author$project$Main$chainableUpdate,
														$author$project$Msg$CRUD(
															A2(
																$author$project$Msg$CreateRandom,
																$author$project$Type$Database$QuestionType,
																_List_fromArray(
																	[
																		function (x) {
																		return $author$project$Type$Database$TypeMatching$setField(
																			{
																				dk: 'questionary',
																				S: $author$project$Type$IO$Internal$box(x),
																				d9: $author$project$Type$Database$QuestionType,
																				eV: $author$project$Type$IO$Setter$StringMsg,
																				fb: id
																			});
																	}
																	]))),
														A3($author$project$Main$updateDbSession, model, session, newDb));
												default:
													return A3($author$project$Main$updateDbSession, model, session, newDb);
											}
										}()));
							case 1:
								var kind = msg.a;
								var callbacks = msg.b;
								return _Utils_Tuple2(
									model,
									A2(
										$elm$random$Random$generate,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Msg$CRUD,
											function (x) {
												return A3($author$project$Msg$Create, kind, x, callbacks);
											}),
										A2($elm_community$random_extra$Random$String$string, 20, $elm_community$random_extra$Random$Char$latin)));
							case 2:
								var msg_ = msg.a;
								var _v18 = A2($author$project$Type$Database$database.c4, msg_, db);
								if (_v18.$ === 1) {
									var e = _v18.a;
									var newmodel = A2(
										$author$project$Main$reportError,
										$author$project$Type$IO$Setter$errToString(e),
										model);
									return _Utils_Tuple2(newmodel, $elm$core$Platform$Cmd$none);
								} else {
									var newDb = _v18.a;
									if ((((msg_.$ === 6) && (msg_.b.$ === 12)) && (msg_.b.b.$ === 6)) && (msg_.b.b.a === 'value')) {
										var table = msg_.a;
										var _v20 = msg_.b;
										var id = _v20.a;
										var _v21 = _v20.b;
										return function (_v22) {
											var x = _v22.a;
											var y = _v22.b;
											return _Utils_Tuple2(
												x,
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															y,
															A2(
															$elm$core$Platform$Cmd$map,
															A2($elm$core$Basics$composeL, $author$project$Msg$CRUD, $author$project$Msg$Update),
															A2(
																$elm$core$Task$perform,
																function (z) {
																	return A2(
																		$author$project$Type$IO$Setter$AttributeMsg,
																		table,
																		A2(
																			$author$project$Type$IO$Setter$DictKeyMsg,
																			id,
																			A2(
																				$author$project$Type$IO$Setter$AttributeMsg,
																				'modified',
																				$author$project$Type$IO$Setter$IntMsg(
																					$elm$time$Time$posixToMillis(z)))));
																},
																$elm$time$Time$now)),
															A2(
															$elm$core$Platform$Cmd$map,
															A2($elm$core$Basics$composeL, $author$project$Msg$CRUD, $author$project$Msg$Update),
															A2(
																$elm$core$Task$perform,
																function (z) {
																	return A2(
																		$author$project$Type$IO$Setter$AttributeMsg,
																		table,
																		A2(
																			$author$project$Type$IO$Setter$DictKeyMsg,
																			id,
																			A2(
																				$author$project$Type$IO$Setter$AttributeMsg,
																				'accessed',
																				$author$project$Type$IO$Setter$IntMsg(
																					$elm$time$Time$posixToMillis(z)))));
																},
																$elm$time$Time$now))
														])));
										}(
											A3($author$project$Main$updateDbSession, model, session, newDb));
									} else {
										return A3($author$project$Main$updateDbSession, model, session, newDb);
									}
								}
							case 5:
								var kind = msg.a;
								var id = msg.b;
								return _Utils_Tuple2(
									model,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeL, $author$project$Msg$CRUD, $author$project$Msg$Update),
												A2(
													$elm$core$Task$perform,
													function (z) {
														return A2(
															$author$project$Type$IO$Setter$AttributeMsg,
															$author$project$Type$Database$TypeMatching$toStringPlural(kind),
															A2(
																$author$project$Type$IO$Setter$DictKeyMsg,
																id,
																A2(
																	$author$project$Type$IO$Setter$AttributeMsg,
																	'accessed',
																	$author$project$Type$IO$Setter$IntMsg(
																		$elm$time$Time$posixToMillis(z)))));
													},
													$elm$time$Time$now))
											])));
							case 3:
								var updates = msg.a;
								var _v23 = A3(
									$elm$core$List$foldl,
									A2($elm$core$Basics$composeL, $elm$core$Result$andThen, $author$project$Type$Database$database.c4),
									$elm$core$Result$Ok(db),
									updates);
								if (_v23.$ === 1) {
									var e = _v23.a;
									var newmodel = A2(
										$author$project$Main$reportError,
										$author$project$Type$IO$Setter$errToString(e),
										model);
									return _Utils_Tuple2(newmodel, $elm$core$Platform$Cmd$none);
								} else {
									var newDb = _v23.a;
									return A3($author$project$Main$updateDbSession, model, session, newDb);
								}
							default:
								var kind = msg.a;
								var id = msg.b;
								var newDb = A3(
									$author$project$Type$Database$TypeMatching$delete,
									$author$project$Type$IO$Internal$box(id),
									kind,
									db);
								return A3($author$project$Main$updateDbSession, model, session, newDb);
						}
					case 18:
						var msg = message.a;
						var _v24 = $author$project$Type$IO$form2update(msg);
						if (!_v24.$) {
							var dbmsg = _v24.a;
							return A2(
								$author$project$Main$update,
								$author$project$Msg$CRUD(
									$author$project$Msg$Update(dbmsg)),
								model);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 19:
						var kind = message.a;
						var id = message.b;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.at,
								'#' + A2(
									$elm$url$Url$Builder$absolute,
									_List_fromArray(
										[
											$author$project$Type$Database$TypeMatching$toString(kind),
											id
										]),
									_List_Nil)));
					case 20:
						var kind = message.a;
						var id = message.b;
						var subpages = message.c;
						var qparam = message.d;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.at,
								'#' + A2(
									$elm$url$Url$Builder$absolute,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Type$Database$TypeMatching$toString(kind),
												id
											]),
										subpages),
									qparam)));
					case 21:
						var id = message.a;
						var newSession = _Utils_update(
							session,
							{
								c5: $elm$core$Maybe$Just(id)
							});
						return function (_v25) {
							var x = _v25.a;
							var y = _v25.b;
							return _Utils_Tuple2(
								x,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											y,
											A2(
											$elm$core$Task$perform,
											function (z) {
												return $author$project$Type$Database$TypeMatching$setField(
													{
														dk: 'last_login',
														S: id,
														d9: $author$project$Type$Database$UserType,
														eV: A2($elm$core$Basics$composeL, $author$project$Type$IO$Setter$IntMsg, $elm$time$Time$posixToMillis),
														fb: z
													});
											},
											$elm$time$Time$now)
										])));
						}(
							A2($author$project$Main$updateSession, model, newSession));
					case 22:
						return _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$back, model.at, 1));
					case 23:
						var time = message.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									r: $elm$core$Maybe$Just(time)
								}),
							$elm$core$Platform$Cmd$none);
					case 24:
						var messageId = message.a;
						var oldheader = model.i;
						var newheader = _Utils_update(
							oldheader,
							{
								bt: A2($aforemny$material_components_web_elm$Material$Snackbar$close, messageId, oldheader.bt)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{i: newheader}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			}());
	});
var $author$project$Main$update = F2(
	function (message, model) {
		var _v0 = model.c;
		switch (_v0.$) {
			case 2:
				var m = _v0.a;
				if (message.$ === 6) {
					var msg = message.a;
					return A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$User,
						A2($author$project$Page$update, msg, m));
				} else {
					return A2(
						$author$project$Main$defaultUpdate,
						message,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 1:
				var m = _v0.a;
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$Top,
						A2($author$project$Page$update, message, m)));
			case 3:
				var m = _v0.a;
				if (message.$ === 8) {
					var msg = message.a;
					return A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$PageOne,
						A2($author$project$Page$update, msg, m));
				} else {
					return A2(
						$author$project$Main$defaultUpdate,
						message,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 4:
				var m = _v0.a;
				if (message.$ === 13) {
					var msg = message.a;
					return A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$PageWithSubpage,
						A2($author$project$Page$update, msg, m));
				} else {
					return A2(
						$author$project$Main$defaultUpdate,
						message,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 5:
				var m = _v0.a;
				var _v4 = A3(
					$author$project$Main$mapPageMsg,
					model,
					$author$project$Main$Admin,
					A2($author$project$Page$update, message, m));
				var newmodel = _v4.a;
				var effect = _v4.b;
				var session = $author$project$Main$extractSession(newmodel);
				_v5$2:
				while (true) {
					switch (message.$) {
						case 7:
							if (message.a.$ === 1) {
								return function (_v6) {
									var x = _v6.a;
									var y = _v6.b;
									return _Utils_Tuple2(
										x,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													y,
													$author$project$Ports$toDb(
													A2($author$project$Type$IO$encode, $author$project$Type$Database$database.dM, session.u))
												])));
								}(
									A2(
										$author$project$Main$updateSession,
										newmodel,
										$author$project$Main$extractSession(newmodel)));
							} else {
								break _v5$2;
							}
						case 16:
							var s = message.a;
							var replacer = A2(
								$elm$browser$Browser$Navigation$replaceUrl,
								model.at,
								$author$project$Page$Admin$url(m) + ('?q=' + s));
							return A2(
								$author$project$Main$defaultUpdate,
								message,
								_Utils_Tuple2(
									newmodel,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[effect, replacer]))));
						default:
							break _v5$2;
					}
				}
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					_Utils_Tuple2(newmodel, effect));
			case 6:
				var m = _v0.a;
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$Study,
						A2($author$project$Page$update, message, m)));
			case 7:
				var m = _v0.a;
				if ((message.$ === 10) && (message.a.$ === 1)) {
					var newmodel = message.a.a;
					var session = $author$project$Main$extractSession(model);
					var _v8 = A2($author$project$Page$Answer$page, session, newmodel);
					var newpage = _v8.a;
					var effect = _v8.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Main$Answer(newpage)
							}),
						effect);
				} else {
					return A2(
						$author$project$Main$defaultUpdate,
						message,
						A3(
							$author$project$Main$mapPageMsg,
							model,
							$author$project$Main$Event,
							A2($author$project$Page$update, message, m)));
				}
			case 8:
				var m = _v0.a;
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$Questionary,
						A2($author$project$Page$update, message, m)));
			case 9:
				var m = _v0.a;
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$Question,
						A2($author$project$Page$update, message, m)));
			case 10:
				var m = _v0.a;
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$CodingQuestion,
						A2($author$project$Page$update, message, m)));
			case 11:
				var m = _v0.a;
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$Answer,
						A2($author$project$Page$update, message, m)));
			case 12:
				var m = _v0.a;
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					A3(
						$author$project$Main$mapPageMsg,
						model,
						$author$project$Main$Code,
						A2($author$project$Page$update, message, m)));
			default:
				return A2(
					$author$project$Main$defaultUpdate,
					message,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Viewer$notFound = _Utils_update(
	$author$project$Viewer$detailsConfig,
	{
		fI: function (_v0) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('not-found')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '12em')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('404')
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '3.5em')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Page Not Found')
								])),
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'font-size', '1.5em')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Oops - Looks like you got lost or clicked a bad link! '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Click here ')
										])),
									$elm$html$Html$text('to go back to the home page.')
								]))
						]))
				]);
		},
		h5: 'Page Not Found'
	});
var $author$project$Msg$Back = {$: 22};
var $author$project$Msg$CloseDrawer = {$: 1};
var $author$project$Msg$OpenDrawer = {$: 0};
var $author$project$Msg$Viewer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Device$Landscape = 1;
var $author$project$Device$Portrait = 0;
var $author$project$Device$getColumns = function (pixel) {
	return (pixel < 600) ? 4 : ((pixel < 840) ? 8 : 12);
};
var $author$project$Device$Desktop = 2;
var $author$project$Device$Handset = 0;
var $author$project$Device$Tablet = 1;
var $author$project$Device$getDevice = F2(
	function (pixel, orientation) {
		if (orientation === 1) {
			return (pixel < 960) ? 0 : ((pixel < 1440) ? 1 : 2);
		} else {
			return (pixel < 600) ? 0 : ((pixel < 960) ? 1 : 2);
		}
	});
var $author$project$Device$Large = 3;
var $author$project$Device$Medium = 2;
var $author$project$Device$Small = 1;
var $author$project$Device$XLarge = 4;
var $author$project$Device$XSmall = 0;
var $author$project$Device$getWindowType = function (pixel) {
	return (pixel < 600) ? 0 : ((pixel < 1024) ? 1 : ((pixel < 1440) ? 2 : ((pixel < 1920) ? 3 : 4)));
};
var $author$project$Device$fromPixel = F2(
	function (width, height) {
		var orientation = (_Utils_cmp(height, width) > 0) ? 0 : 1;
		var dom = A2($elm$core$Basics$max, width, height);
		return {
			dA: $author$project$Device$getColumns(dom),
			dG: A2($author$project$Device$getDevice, dom, orientation),
			et: orientation,
			fi: $author$project$Device$getWindowType(dom)
		};
	});
var $author$project$Utils$genericTitle = ' - Elm SPA Boilerplate';
var $author$project$Viewer$toggleDrawer = function (drawerOpen) {
	return $author$project$Msg$Viewer(
		drawerOpen ? $author$project$Msg$CloseDrawer : $author$project$Msg$OpenDrawer);
};
var $author$project$Msg$NewUsername = function (a) {
	return {$: 3, a: a};
};
var $aforemny$material_components_web_elm$Material$Dialog$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Dialog$config = {bF: _List_Nil, gl: true, a9: false, bo: $elm$core$Maybe$Nothing, cB: false, cN: true};
var $aforemny$material_components_web_elm$Material$Dialog$closeHandler = function (_v0) {
	var onClose = _v0.bo;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('MDCDialog:close'),
			$elm$json$Json$Decode$succeed),
		onClose);
};
var $aforemny$material_components_web_elm$Material$Dialog$actionsElt = function (_v0) {
	var actions = _v0.fn;
	return $elm$core$List$isEmpty(actions) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-dialog__actions')
				]),
			actions));
};
var $aforemny$material_components_web_elm$Material$Dialog$alertDialogRoleAttr = A2($elm$html$Html$Attributes$attribute, 'role', 'alertdialog');
var $aforemny$material_components_web_elm$Material$Dialog$ariaModalAttr = A2($elm$html$Html$Attributes$attribute, 'aria-modal', 'true');
var $aforemny$material_components_web_elm$Material$Dialog$contentElt = function (_v0) {
	var content = _v0.f5;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-dialog__content')
				]),
			content));
};
var $aforemny$material_components_web_elm$Material$Dialog$dialogSurfaceCs = $elm$html$Html$Attributes$class('mdc-dialog__surface');
var $aforemny$material_components_web_elm$Material$Dialog$titleElt = function (_v0) {
	var title = _v0.h5;
	if (!title.$) {
		var title_ = title.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-dialog__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title_)
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $aforemny$material_components_web_elm$Material$Dialog$headerElt = F2(
	function (_v0, content) {
		var onClose = _v0.bo;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-dialog__header')
					]),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Dialog$titleElt(content),
							$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mdc-dialog__close'),
										A2($elm$html$Html$Attributes$style, 'position', 'relative')
									]),
								_List_fromArray(
									[
										A2(
										$aforemny$material_components_web_elm$Material$IconButton$iconButton,
										function () {
											if (!onClose.$) {
												var onClose_ = onClose.a;
												return $aforemny$material_components_web_elm$Material$IconButton$setOnClick(onClose_);
											} else {
												return $elm$core$Basics$identity;
											}
										}()($aforemny$material_components_web_elm$Material$IconButton$config),
										$aforemny$material_components_web_elm$Material$IconButton$icon('close'))
									])))
						]))));
	});
var $aforemny$material_components_web_elm$Material$Dialog$surfaceElt = F2(
	function (config__, content) {
		var config_ = config__;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$Dialog$dialogSurfaceCs, $aforemny$material_components_web_elm$Material$Dialog$alertDialogRoleAttr, $aforemny$material_components_web_elm$Material$Dialog$ariaModalAttr]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						config_.a9 ? A2($aforemny$material_components_web_elm$Material$Dialog$headerElt, config__, content) : $aforemny$material_components_web_elm$Material$Dialog$titleElt(content),
						$aforemny$material_components_web_elm$Material$Dialog$contentElt(content),
						$aforemny$material_components_web_elm$Material$Dialog$actionsElt(content)
					])));
	});
var $aforemny$material_components_web_elm$Material$Dialog$containerElt = F2(
	function (config_, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-dialog__container')
				]),
			_List_fromArray(
				[
					A2($aforemny$material_components_web_elm$Material$Dialog$surfaceElt, config_, content)
				]));
	});
var $aforemny$material_components_web_elm$Material$Dialog$fullscreenCs = function (_v0) {
	var config_ = _v0;
	return config_.a9 ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-dialog--fullscreen')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$Dialog$openProp = function (_v0) {
	var open = _v0.cB;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'open',
			$elm$json$Json$Encode$bool(open)));
};
var $aforemny$material_components_web_elm$Material$Dialog$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-dialog'));
var $aforemny$material_components_web_elm$Material$Dialog$scrimClickActionProp = function (_v0) {
	var scrimCloses = _v0.cN;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'scrimClickAction',
			$elm$json$Json$Encode$string(
				scrimCloses ? 'close' : '')));
};
var $aforemny$material_components_web_elm$Material$Dialog$scrimElt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mdc-dialog__scrim')
		]),
	_List_Nil);
var $aforemny$material_components_web_elm$Material$Dialog$generic = F2(
	function (config_, content) {
		var additionalAttributes = config_.bF;
		return A3(
			$elm$html$Html$node,
			'mdc-dialog',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Dialog$rootCs,
							$aforemny$material_components_web_elm$Material$Dialog$fullscreenCs(config_),
							$aforemny$material_components_web_elm$Material$Dialog$openProp(config_),
							$aforemny$material_components_web_elm$Material$Dialog$scrimClickActionProp(config_),
							$aforemny$material_components_web_elm$Material$Dialog$closeHandler(config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					A2($aforemny$material_components_web_elm$Material$Dialog$containerElt, config_, content),
					$aforemny$material_components_web_elm$Material$Dialog$scrimElt
				]));
	});
var $aforemny$material_components_web_elm$Material$Dialog$fullscreen = F2(
	function (_v0, _v1) {
		var config_ = _v0;
		var title = _v1.h5;
		var content = _v1.f5;
		var actions = _v1.fn;
		return A2(
			$aforemny$material_components_web_elm$Material$Dialog$generic,
			_Utils_update(
				config_,
				{a9: true}),
			{
				fn: actions,
				f5: content,
				h5: $elm$core$Maybe$Just(title)
			});
	});
var $ryannhg$date_format$DateFormat$Relative$defaultInSomeDays = function (days) {
	return (days < 2) ? 'tomorrow' : ('in ' + ($elm$core$String$fromInt(days) + ' days'));
};
var $ryannhg$date_format$DateFormat$Relative$defaultInSomeHours = function (hours) {
	return (hours < 2) ? 'in an hour' : ('in ' + ($elm$core$String$fromInt(hours) + ' hours'));
};
var $ryannhg$date_format$DateFormat$Relative$defaultInSomeMinutes = function (minutes) {
	return (minutes < 2) ? 'in a minute' : ('in ' + ($elm$core$String$fromInt(minutes) + ' minutes'));
};
var $ryannhg$date_format$DateFormat$Relative$defaultInSomeMonths = function (months) {
	return (months < 2) ? 'in a month' : ('in ' + ($elm$core$String$fromInt(months) + ' months'));
};
var $ryannhg$date_format$DateFormat$Relative$defaultInSomeSeconds = function (seconds) {
	return (seconds < 30) ? 'in a few seconds' : ('in ' + ($elm$core$String$fromInt(seconds) + ' seconds'));
};
var $ryannhg$date_format$DateFormat$Relative$defaultInSomeYears = function (years) {
	return (years < 2) ? 'in a year' : ('in ' + ($elm$core$String$fromInt(years) + ' years'));
};
var $ryannhg$date_format$DateFormat$Relative$defaultRightNow = 'right now';
var $ryannhg$date_format$DateFormat$Relative$defaultSomeDaysAgo = function (days) {
	return (days < 2) ? 'yesterday' : ($elm$core$String$fromInt(days) + ' days ago');
};
var $ryannhg$date_format$DateFormat$Relative$defaultSomeHoursAgo = function (hours) {
	return (hours < 2) ? 'an hour ago' : ($elm$core$String$fromInt(hours) + ' hours ago');
};
var $ryannhg$date_format$DateFormat$Relative$defaultSomeMinutesAgo = function (minutes) {
	return (minutes < 2) ? 'a minute ago' : ($elm$core$String$fromInt(minutes) + ' minutes ago');
};
var $ryannhg$date_format$DateFormat$Relative$defaultSomeMonthsAgo = function (months) {
	return (months < 2) ? 'last month' : ($elm$core$String$fromInt(months) + ' months ago');
};
var $ryannhg$date_format$DateFormat$Relative$defaultSomeSecondsAgo = function (seconds) {
	return (seconds < 30) ? 'just now' : ($elm$core$String$fromInt(seconds) + ' seconds ago');
};
var $ryannhg$date_format$DateFormat$Relative$defaultSomeYearsAgo = function (years) {
	return (years < 2) ? 'last year' : ($elm$core$String$fromInt(years) + ' years ago');
};
var $ryannhg$date_format$DateFormat$Relative$defaultRelativeOptions = {ce: $ryannhg$date_format$DateFormat$Relative$defaultInSomeDays, cf: $ryannhg$date_format$DateFormat$Relative$defaultInSomeHours, cg: $ryannhg$date_format$DateFormat$Relative$defaultInSomeMinutes, ch: $ryannhg$date_format$DateFormat$Relative$defaultInSomeMonths, ci: $ryannhg$date_format$DateFormat$Relative$defaultInSomeSeconds, cj: $ryannhg$date_format$DateFormat$Relative$defaultInSomeYears, cM: $ryannhg$date_format$DateFormat$Relative$defaultRightNow, cP: $ryannhg$date_format$DateFormat$Relative$defaultSomeDaysAgo, cQ: $ryannhg$date_format$DateFormat$Relative$defaultSomeHoursAgo, cR: $ryannhg$date_format$DateFormat$Relative$defaultSomeMinutesAgo, cS: $ryannhg$date_format$DateFormat$Relative$defaultSomeMonthsAgo, cT: $ryannhg$date_format$DateFormat$Relative$defaultSomeSecondsAgo, cU: $ryannhg$date_format$DateFormat$Relative$defaultSomeYearsAgo};
var $ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions = F6(
	function (seconds, minutes, hours, days, months, years) {
		return {dE: days, d_: hours, ek: minutes, em: months, eS: seconds, fk: years};
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.cW, posixMinutes) < 0) {
					return posixMinutes + era.b;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $ryannhg$date_format$DateFormat$Relative$relativeTimeWithFunctions = F3(
	function (zone, millis, functions) {
		var seconds = (millis / 1000) | 0;
		var posix = $elm$time$Time$millisToPosix(millis);
		var minutes = (seconds / 60) | 0;
		var hours = (minutes / 60) | 0;
		var days = (hours / 24) | 0;
		return (minutes < 1) ? functions.eS(
			A2($elm$time$Time$toSecond, zone, posix)) : ((hours < 1) ? functions.ek(
			A2($elm$time$Time$toMinute, zone, posix)) : ((hours < 24) ? functions.d_(
			A2($elm$time$Time$toHour, zone, posix)) : ((days < 30) ? functions.dE(days) : ((days < 365) ? functions.em((days / 30) | 0) : functions.fk((days / 365) | 0)))));
	});
var $ryannhg$date_format$DateFormat$Relative$toMilliseconds = $elm$time$Time$posixToMillis;
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $ryannhg$date_format$DateFormat$Relative$relativeTimeWithOptions = F3(
	function (options, start, end) {
		var differenceInMilliseconds = $ryannhg$date_format$DateFormat$Relative$toMilliseconds(end) - $ryannhg$date_format$DateFormat$Relative$toMilliseconds(start);
		return (!differenceInMilliseconds) ? options.cM : A3(
			$ryannhg$date_format$DateFormat$Relative$relativeTimeWithFunctions,
			$elm$time$Time$utc,
			$elm$core$Basics$abs(differenceInMilliseconds),
			(differenceInMilliseconds < 0) ? A6($ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions, options.cT, options.cR, options.cQ, options.cP, options.cS, options.cU) : A6($ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions, options.ci, options.cg, options.cf, options.ce, options.ch, options.cj));
	});
var $ryannhg$date_format$DateFormat$Relative$relativeTime = $ryannhg$date_format$DateFormat$Relative$relativeTimeWithOptions($ryannhg$date_format$DateFormat$Relative$defaultRelativeOptions);
var $aforemny$material_components_web_elm$Material$Button$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bF: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$List$Item$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bF: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$List$setAvatarList = F2(
	function (avatarList, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bN: avatarList});
	});
var $aforemny$material_components_web_elm$Material$List$setInteractive = F2(
	function (interactive, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bd: interactive});
	});
var $aforemny$material_components_web_elm$Material$Dialog$setOpen = F2(
	function (open, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{cB: open});
	});
var $aforemny$material_components_web_elm$Material$Dialog$setScrimCloses = F2(
	function (scrimCloses, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{cN: scrimCloses});
	});
var $author$project$Viewer$userIdenticonIcon = function (id) {
	return {
		bM: _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0,.1)'),
				A2($elm$html$Html$Attributes$style, 'color', '#fff')
			]),
		b1: _List_fromArray(
			[
				A2(
				$gdamjan$elm_identicon$Identicon$identicon,
				'66%',
				$author$project$Type$IO$Internal$unbox(id))
			])
	};
};
var $author$project$Viewer$userDialog = F4(
	function (open, users, new_username, time) {
		var uList = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, _v1) {
					var id = _v1.a;
					var user = _v1.b;
					return A2(
						$aforemny$material_components_web_elm$Material$List$Item$listItem,
						A2(
							$aforemny$material_components_web_elm$Material$List$Item$setAttributes,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$tabindex(0)
								]),
							A2(
								$aforemny$material_components_web_elm$Material$List$Item$setOnClick,
								$author$project$Msg$SetUser(id),
								$aforemny$material_components_web_elm$Material$List$Item$config)),
						_List_fromArray(
							[
								A2(
								$aforemny$material_components_web_elm$Material$List$Item$graphic,
								$author$project$Viewer$userIdenticonIcon(id).bM,
								$author$project$Viewer$userIdenticonIcon(id).b1),
								A2(
								$aforemny$material_components_web_elm$Material$List$Item$text,
								_List_Nil,
								{
									eA: _List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Type$IO$Internal$unbox(id),
												user.af))
										]),
									eR: _List_fromArray(
										[
											$elm$html$Html$text(
											'Last login ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													function (x) {
														return A2(
															$ryannhg$date_format$DateFormat$Relative$relativeTime,
															x,
															$elm$time$Time$millisToPosix(user.ec));
													},
													time)))
										])
								})
							]));
				}),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($author$project$Type$IO$Internal$box),
				$elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						function (_v2) {
							var b = _v2.b;
							return b.ec;
						},
						users))));
		var addUserWithName = function (username) {
			return $author$project$Msg$CRUD(
				A2(
					$author$project$Msg$CreateRandom,
					$author$project$Type$Database$UserType,
					_List_fromArray(
						[
							function (x) {
							return $author$project$Type$Database$TypeMatching$setField(
								{
									dk: 'name',
									S: $author$project$Type$IO$Internal$box(x),
									d9: $author$project$Type$Database$UserType,
									eV: A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Type$IO$Setter$MaybeSetMsg, $elm$core$Maybe$Just),
										$author$project$Type$IO$Setter$StringMsg),
									fb: username
								});
						}
						])));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Button$text,
					A2(
						$aforemny$material_components_web_elm$Material$Button$setOnClick,
						$author$project$Msg$Viewer($author$project$Msg$OpenDrawer),
						$aforemny$material_components_web_elm$Material$Button$config),
					'Login'),
					A2(
					$aforemny$material_components_web_elm$Material$Dialog$fullscreen,
					A2(
						$aforemny$material_components_web_elm$Material$Dialog$setScrimCloses,
						false,
						A2($aforemny$material_components_web_elm$Material$Dialog$setOpen, open, $aforemny$material_components_web_elm$Material$Dialog$config)),
					{
						fn: _List_fromArray(
							[
								A3(
								$aforemny$material_components_web_elm$Material$List$list,
								A2($aforemny$material_components_web_elm$Material$List$setInteractive, true, $aforemny$material_components_web_elm$Material$List$config),
								A2(
									$aforemny$material_components_web_elm$Material$List$Item$listItem,
									A2(
										$aforemny$material_components_web_elm$Material$List$Item$setAttributes,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$tabindex(0)
											]),
										$aforemny$material_components_web_elm$Material$List$Item$config),
									_List_fromArray(
										[
											$aforemny$material_components_web_elm$Material$TextField$filled(
											A2(
												$aforemny$material_components_web_elm$Material$TextField$setValue,
												$elm$core$Maybe$Just(new_username),
												A2(
													$aforemny$material_components_web_elm$Material$TextField$setOnChange,
													addUserWithName,
													A2(
														$aforemny$material_components_web_elm$Material$TextField$setLabel,
														$elm$core$Maybe$Just('Add new User'),
														A2(
															$aforemny$material_components_web_elm$Material$TextField$setOnInput,
															A2($elm$core$Basics$composeL, $author$project$Msg$Viewer, $author$project$Msg$NewUsername),
															$aforemny$material_components_web_elm$Material$TextField$config))))),
											A2(
											$aforemny$material_components_web_elm$Material$Button$unelevated,
											A2(
												$aforemny$material_components_web_elm$Material$Button$setIcon,
												$elm$core$Maybe$Just(
													$aforemny$material_components_web_elm$Material$Button$icon('add')),
												A2(
													$aforemny$material_components_web_elm$Material$Button$setAttributes,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'margin-left', '16px')
														]),
													$aforemny$material_components_web_elm$Material$Button$config)),
											'add')
										])),
								_List_Nil)
							]),
						f5: function () {
							if (uList.b) {
								var f = uList.a;
								var rest = uList.b;
								return _List_fromArray(
									[
										A3(
										$aforemny$material_components_web_elm$Material$List$list,
										A2($aforemny$material_components_web_elm$Material$List$setAvatarList, true, $aforemny$material_components_web_elm$Material$List$config),
										f,
										rest)
									]);
							} else {
								return _List_Nil;
							}
						}(),
						h5: 'Select an account'
					})
				]));
	});
var $aforemny$material_components_web_elm$Material$List$Divider$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$List$Divider$config = {bF: _List_Nil, cl: false, cD: false};
var $aforemny$material_components_web_elm$Material$Icon$icon = F2(
	function (additionalAttributes, iconName) {
		return A2(
			$elm$html$Html$i,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('material-icons'),
				additionalAttributes),
			_List_fromArray(
				[
					$elm$html$Html$text(iconName)
				]));
	});
var $aforemny$material_components_web_elm$Material$List$Item$Internal$ListItemDivider = function (a) {
	return {$: 1, a: a};
};
var $aforemny$material_components_web_elm$Material$List$Divider$insetCs = function (_v0) {
	var inset = _v0.cl;
	return inset ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list-divider--inset')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Divider$listDividerCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-list-divider'));
var $aforemny$material_components_web_elm$Material$List$Divider$paddedCs = function (_v0) {
	var padded = _v0.cD;
	return padded ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-list-divider--padded')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$List$Divider$separatorRoleAttr = $elm$core$Maybe$Just(
	A2($elm$html$Html$Attributes$attribute, 'role', 'separator'));
var $aforemny$material_components_web_elm$Material$List$Divider$listItem = function (config_) {
	var additionalAttributes = config_.bF;
	return $aforemny$material_components_web_elm$Material$List$Item$Internal$ListItemDivider(
		A2(
			$elm$html$Html$li,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$List$Divider$listDividerCs,
							$aforemny$material_components_web_elm$Material$List$Divider$separatorRoleAttr,
							$aforemny$material_components_web_elm$Material$List$Divider$insetCs(config_),
							$aforemny$material_components_web_elm$Material$List$Divider$paddedCs(config_)
						])),
				additionalAttributes),
			_List_Nil));
};
var $aforemny$material_components_web_elm$Material$List$Item$selected = 0;
var $aforemny$material_components_web_elm$Material$List$Item$setSelected = F2(
	function (selection, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{hA: selection});
	});
var $author$project$Viewer$viewDrawerContent = function (selectedIndex) {
	var listItemConfig_ = function (index) {
		return A2(
			$aforemny$material_components_web_elm$Material$List$Item$setSelected,
			_Utils_eq(index, selectedIndex) ? $elm$core$Maybe$Just($aforemny$material_components_web_elm$Material$List$Item$selected) : $elm$core$Maybe$Nothing,
			$aforemny$material_components_web_elm$Material$List$Item$config);
	};
	return A3(
		$aforemny$material_components_web_elm$Material$List$list,
		$aforemny$material_components_web_elm$Material$List$config,
		A2(
			$aforemny$material_components_web_elm$Material$List$Item$listItem,
			listItemConfig_(0),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$List$Item$graphic,
					_List_Nil,
					_List_fromArray(
						[
							A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'home')
						])),
					$elm$html$Html$text('Home')
				])),
		_List_fromArray(
			[
				A2(
				$aforemny$material_components_web_elm$Material$List$Item$listItem,
				listItemConfig_(1),
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$List$Item$graphic,
						_List_Nil,
						_List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'local_library')
							])),
						$elm$html$Html$text('Research')
					])),
				A2(
				$aforemny$material_components_web_elm$Material$List$Item$listItem,
				listItemConfig_(2),
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$List$Item$graphic,
						_List_Nil,
						_List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'ballot')
							])),
						$elm$html$Html$text('Coding')
					])),
				$aforemny$material_components_web_elm$Material$List$Divider$listItem($aforemny$material_components_web_elm$Material$List$Divider$config),
				A2(
				$aforemny$material_components_web_elm$Material$List$Item$listItem,
				listItemConfig_(4),
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$List$Item$graphic,
						_List_Nil,
						_List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'bookmark')
							])),
						$elm$html$Html$text('Family')
					])),
				A2(
				$aforemny$material_components_web_elm$Material$List$Item$listItem,
				listItemConfig_(5),
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$List$Item$graphic,
						_List_Nil,
						_List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'bookmark')
							])),
						$elm$html$Html$text('Friends')
					])),
				A2(
				$aforemny$material_components_web_elm$Material$List$Item$listItem,
				listItemConfig_(6),
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$List$Item$graphic,
						_List_Nil,
						_List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'bookmark')
							])),
						$elm$html$Html$text('Work')
					])),
				$aforemny$material_components_web_elm$Material$List$Divider$listItem($aforemny$material_components_web_elm$Material$List$Divider$config),
				A2(
				$aforemny$material_components_web_elm$Material$List$Item$listItem,
				listItemConfig_(7),
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$List$Item$graphic,
						_List_Nil,
						_List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'settings')
							])),
						$elm$html$Html$text('Settings')
					])),
				A2(
				$aforemny$material_components_web_elm$Material$List$Item$listItem,
				listItemConfig_(8),
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$List$Item$graphic,
						_List_Nil,
						_List_fromArray(
							[
								A2($aforemny$material_components_web_elm$Material$Icon$icon, _List_Nil, 'announcement')
							])),
						$elm$html$Html$text('Help & feedback')
					]))
			]));
};
var $aforemny$material_components_web_elm$Material$Drawer$Permanent$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Drawer$Permanent$config = {bF: _List_Nil};
var $aforemny$material_components_web_elm$Material$TopAppBar$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$TopAppBar$config = {bF: _List_Nil, b$: false, b5: false};
var $aforemny$material_components_web_elm$Material$Drawer$Permanent$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-drawer'));
var $aforemny$material_components_web_elm$Material$Drawer$Permanent$drawer = F2(
	function (_v0, nodes) {
		var additionalAttributes = _v0.bF;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[$aforemny$material_components_web_elm$Material$Drawer$Permanent$rootCs])),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$Prominent = 3;
var $aforemny$material_components_web_elm$Material$TopAppBar$denseCs = function (_v0) {
	var dense = _v0.b$;
	return dense ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-top-app-bar--dense')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TopAppBar$fixedCs = function (_v0) {
	var fixed = _v0.b5;
	return fixed ? $elm$core$Maybe$Just(
		$elm$html$Html$Attributes$class('mdc-top-app-bar--fixed')) : $elm$core$Maybe$Nothing;
};
var $aforemny$material_components_web_elm$Material$TopAppBar$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-top-app-bar'));
var $aforemny$material_components_web_elm$Material$TopAppBar$variantCs = function (variant) {
	switch (variant) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-top-app-bar--short'));
		case 2:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-top-app-bar--short mdc-top-app-bar--short-collapsed'));
		default:
			return $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-top-app-bar--prominent'));
	}
};
var $aforemny$material_components_web_elm$Material$TopAppBar$genericTopAppBar = F3(
	function (variant, config_, nodes) {
		var additionalAttributes = config_.bF;
		return A3(
			$elm$html$Html$node,
			'mdc-top-app-bar',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$TopAppBar$rootCs,
							$aforemny$material_components_web_elm$Material$TopAppBar$variantCs(variant),
							$aforemny$material_components_web_elm$Material$TopAppBar$denseCs(config_),
							$aforemny$material_components_web_elm$Material$TopAppBar$fixedCs(config_)
						])),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$prominent = F2(
	function (config_, nodes) {
		return A3($aforemny$material_components_web_elm$Material$TopAppBar$genericTopAppBar, 3, config_, nodes);
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$prominentFixedAdjust = $elm$html$Html$Attributes$class('mdc-top-app-bar--prominent-fixed-adjust');
var $aforemny$material_components_web_elm$Material$Drawer$Permanent$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bF: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$setDense = F2(
	function (dense, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{b$: dense});
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$setFixed = F2(
	function (fixed, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{b5: fixed});
	});
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $aforemny$material_components_web_elm$Material$Drawer$Modal$header = F2(
	function (additionalAttributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-drawer__header'),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$Drawer$Modal$subtitle = $elm$html$Html$Attributes$class('mdc-drawer__subtitle');
var $aforemny$material_components_web_elm$Material$Drawer$Modal$title = $elm$html$Html$Attributes$class('mdc-drawer__title');
var $author$project$Viewer$Internal$viewDrawer = function (config) {
	return config.dI(
		_List_fromArray(
			[
				A2(
				$aforemny$material_components_web_elm$Material$Drawer$Modal$header,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[$aforemny$material_components_web_elm$Material$Drawer$Modal$title]),
						_List_fromArray(
							[config.gi])),
						A2(
						$elm$html$Html$h6,
						_List_fromArray(
							[$aforemny$material_components_web_elm$Material$Drawer$Modal$subtitle]),
						_List_fromArray(
							[config.gh]))
					])),
				config.f5
			]));
};
var $aforemny$material_components_web_elm$Material$TopAppBar$actionItem = $elm$html$Html$Attributes$class('mdc-top-app-bar__action-item');
var $aforemny$material_components_web_elm$Material$TopAppBar$alignEnd = $elm$html$Html$Attributes$class('mdc-top-app-bar__section--align-end');
var $aforemny$material_components_web_elm$Material$TopAppBar$alignStart = $elm$html$Html$Attributes$class('mdc-top-app-bar__section--align-start');
var $aforemny$material_components_web_elm$Material$TextField$Icon$Internal$Icon = function (a) {
	return {$: 0, a: a};
};
var $aforemny$material_components_web_elm$Material$TextField$Icon$customIcon = F3(
	function (node, attributes, nodes) {
		return $aforemny$material_components_web_elm$Material$TextField$Icon$Internal$Icon(
			{bM: attributes, aC: false, bk: node, bl: nodes, es: $elm$core$Maybe$Nothing});
	});
var $aforemny$material_components_web_elm$Material$TextField$Icon$icon = function (iconName) {
	return A3(
		$aforemny$material_components_web_elm$Material$TextField$Icon$customIcon,
		$elm$html$Html$i,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('material-icons')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(iconName)
			]));
};
var $aforemny$material_components_web_elm$Material$TopAppBar$navigationIcon = $elm$html$Html$Attributes$class('mdc-top-app-bar__navigation-icon');
var $aforemny$material_components_web_elm$Material$IconButton$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bF: additionalAttributes});
	});
var $author$project$Viewer$Internal$navButton = function (config) {
	return A2(
		$aforemny$material_components_web_elm$Material$IconButton$iconButton,
		A2(
			$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
			config.ej,
			A2(
				$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
				_List_fromArray(
					[$aforemny$material_components_web_elm$Material$TopAppBar$navigationIcon]),
				$aforemny$material_components_web_elm$Material$IconButton$config)),
		$aforemny$material_components_web_elm$Material$IconButton$icon(config.d0));
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $aforemny$material_components_web_elm$Material$TopAppBar$row = F2(
	function (attributes, nodes) {
		return A2(
			$elm$html$Html$section,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-top-app-bar__row')
					]),
				attributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$section = F2(
	function (attributes, nodes) {
		return A2(
			$elm$html$Html$section,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mdc-top-app-bar__section')
					]),
				attributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$TextField$setTrailingIcon = F2(
	function (trailingIcon, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bA: trailingIcon});
	});
var $aforemny$material_components_web_elm$Material$Theme$surface = $elm$html$Html$Attributes$class('mdc-theme--surface');
var $aforemny$material_components_web_elm$Material$TopAppBar$title = $elm$html$Html$Attributes$class('mdc-top-app-bar__title');
var $author$project$Viewer$Internal$viewTopAppBar = function (config) {
	return config.e7(
		_List_fromArray(
			[
				A2(
				$aforemny$material_components_web_elm$Material$TopAppBar$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$aforemny$material_components_web_elm$Material$TopAppBar$section,
						_List_fromArray(
							[$aforemny$material_components_web_elm$Material$TopAppBar$alignStart]),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								A2($elm$html$Html$div, _List_Nil, _List_Nil),
								A2($elm$core$Maybe$map, $author$project$Viewer$Internal$navButton, config.eo)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[$aforemny$material_components_web_elm$Material$TopAppBar$title]),
								_List_fromArray(
									[
										$elm$html$Html$text(config.h5)
									]))
							])),
						A2(
						$aforemny$material_components_web_elm$Material$TopAppBar$section,
						_List_fromArray(
							[$aforemny$material_components_web_elm$Material$TopAppBar$alignEnd]),
						_Utils_ap(
							_List_fromArray(
								[
									function () {
									var _v0 = config.hz;
									if (_v0.$ === 1) {
										return A2($elm$html$Html$div, _List_Nil, _List_Nil);
									} else {
										var s = _v0.a;
										return $aforemny$material_components_web_elm$Material$TextField$filled(
											A2(
												$aforemny$material_components_web_elm$Material$TextField$setOnInput,
												s.fT,
												A2(
													$aforemny$material_components_web_elm$Material$TextField$setAttributes,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$Theme$surface]),
													A2(
														$aforemny$material_components_web_elm$Material$TextField$setValue,
														$elm$core$Maybe$Just(s.hz),
														A2(
															$aforemny$material_components_web_elm$Material$TextField$setTrailingIcon,
															$elm$core$Maybe$Just(
																$aforemny$material_components_web_elm$Material$TextField$Icon$icon('search')),
															$aforemny$material_components_web_elm$Material$TextField$config)))));
									}
								}()
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (_v1) {
										var iconName = _v1.a;
										var callback = _v1.b;
										return A2(
											$aforemny$material_components_web_elm$Material$IconButton$iconButton,
											A2(
												$aforemny$material_components_web_elm$Material$IconButton$setOnClick,
												callback,
												A2(
													$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$TopAppBar$actionItem]),
													$aforemny$material_components_web_elm$Material$IconButton$config)),
											$aforemny$material_components_web_elm$Material$IconButton$icon(iconName));
									},
									config.fn),
								_List_fromArray(
									[
										function () {
										var _v2 = config.c5;
										if (_v2.$ === 1) {
											return A2($elm$html$Html$div, _List_Nil, _List_Nil);
										} else {
											var s = _v2.a;
											return A2(
												$aforemny$material_components_web_elm$Material$IconButton$iconButton,
												A2(
													$aforemny$material_components_web_elm$Material$IconButton$setAttributes,
													_List_fromArray(
														[$aforemny$material_components_web_elm$Material$TopAppBar$actionItem]),
													$aforemny$material_components_web_elm$Material$IconButton$config),
												A3(
													$aforemny$material_components_web_elm$Material$IconButton$customIcon,
													$elm$html$Html$i,
													_List_Nil,
													_List_fromArray(
														[s])));
										}
									}()
									]))))
					]))
			]));
};
var $author$project$Viewer$Desktop$viewLandscape = function (config) {
	return _List_fromArray(
		[
			$author$project$Viewer$Internal$viewTopAppBar(
			{
				fn: config.fn,
				eo: $elm$core$Maybe$Just(
					{d0: config.g$, ej: config.g_}),
				hz: $elm$core$Maybe$Nothing,
				h5: A2($elm$core$Maybe$withDefault, 'Landscape Desktop', config.h5),
				e7: $aforemny$material_components_web_elm$Material$TopAppBar$prominent(
					A2(
						$aforemny$material_components_web_elm$Material$TopAppBar$setFixed,
						true,
						A2($aforemny$material_components_web_elm$Material$TopAppBar$setDense, false, $aforemny$material_components_web_elm$Material$TopAppBar$config))),
				c5: config.c5
			}),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$TopAppBar$prominentFixedAdjust,
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'flex-flow', 'row nowrap')
				]),
			_List_fromArray(
				[
					$author$project$Viewer$Internal$viewDrawer(
					{
						f5: config.gg,
						dI: $aforemny$material_components_web_elm$Material$Drawer$Permanent$drawer(
							A2(
								$aforemny$material_components_web_elm$Material$Drawer$Permanent$setAttributes,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'z-index', '1')
									]),
								$aforemny$material_components_web_elm$Material$Drawer$Permanent$config)),
						gh: config.gh,
						gi: $elm$html$Html$text(config.gi)
					}),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[config.fI]))
				]))
		]);
};
var $aforemny$material_components_web_elm$Material$Drawer$Modal$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Drawer$Modal$config = {bF: _List_Nil, bo: $elm$core$Maybe$Nothing, cB: false};
var $aforemny$material_components_web_elm$Material$Drawer$Modal$content = F2(
	function (attributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-drawer__content'),
				attributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$denseFixedAdjust = $elm$html$Html$Attributes$class('mdc-top-app-bar--dense-fixed-adjust');
var $aforemny$material_components_web_elm$Material$Drawer$Modal$closeHandler = function (_v0) {
	var onClose = _v0.bo;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('MDCDrawer:close'),
			$elm$json$Json$Decode$succeed),
		onClose);
};
var $aforemny$material_components_web_elm$Material$Drawer$Modal$modalCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-drawer--modal'));
var $aforemny$material_components_web_elm$Material$Drawer$Modal$openProp = function (_v0) {
	var open = _v0.cB;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'open',
			$elm$json$Json$Encode$bool(open)));
};
var $aforemny$material_components_web_elm$Material$Drawer$Modal$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-drawer'));
var $aforemny$material_components_web_elm$Material$Drawer$Modal$drawer = F2(
	function (config_, nodes) {
		var additionalAttributes = config_.bF;
		return A3(
			$elm$html$Html$node,
			'mdc-drawer',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Drawer$Modal$rootCs,
							$aforemny$material_components_web_elm$Material$Drawer$Modal$modalCs,
							$aforemny$material_components_web_elm$Material$Drawer$Modal$openProp(config_),
							$aforemny$material_components_web_elm$Material$Drawer$Modal$closeHandler(config_)
						])),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$Drawer$Modal$scrim = F2(
	function (additionalAttributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-drawer-scrim'),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$Drawer$Modal$setOnClose = F2(
	function (onClose, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				bo: $elm$core$Maybe$Just(onClose)
			});
	});
var $aforemny$material_components_web_elm$Material$Drawer$Modal$setOpen = F2(
	function (open, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{cB: open});
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$Short = 1;
var $aforemny$material_components_web_elm$Material$TopAppBar$short = F2(
	function (config_, nodes) {
		return A3($aforemny$material_components_web_elm$Material$TopAppBar$genericTopAppBar, 1, config_, nodes);
	});
var $author$project$Viewer$Handset$viewLandscape = function (config) {
	return _List_fromArray(
		[
			$author$project$Viewer$Internal$viewDrawer(
			{
				f5: config.gg,
				dI: $aforemny$material_components_web_elm$Material$Drawer$Modal$drawer(
					A2(
						$aforemny$material_components_web_elm$Material$Drawer$Modal$setOnClose,
						config.f$,
						A2($aforemny$material_components_web_elm$Material$Drawer$Modal$setOpen, config.R, $aforemny$material_components_web_elm$Material$Drawer$Modal$config))),
				gh: config.gh,
				gi: $elm$html$Html$text(config.gi)
			}),
			A2($aforemny$material_components_web_elm$Material$Drawer$Modal$scrim, _List_Nil, _List_Nil),
			A2(
			$aforemny$material_components_web_elm$Material$Drawer$Modal$content,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Viewer$Internal$viewTopAppBar(
					{
						fn: config.fn,
						eo: $elm$core$Maybe$Just(
							{d0: config.g$, ej: config.g_}),
						hz: $elm$core$Maybe$Nothing,
						h5: A2($elm$core$Maybe$withDefault, 'Landscape Handset', config.h5),
						e7: $aforemny$material_components_web_elm$Material$TopAppBar$short(
							A2(
								$aforemny$material_components_web_elm$Material$TopAppBar$setFixed,
								false,
								A2($aforemny$material_components_web_elm$Material$TopAppBar$setDense, true, $aforemny$material_components_web_elm$Material$TopAppBar$config))),
						c5: config.c5
					})
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TopAppBar$denseFixedAdjust]),
			_List_fromArray(
				[config.fI]))
		]);
};
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$config = {bF: _List_Nil, bo: $elm$core$Maybe$Nothing, cB: false};
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$content = F2(
	function (attributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-drawer__content'),
				attributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$closeHandler = function (_v0) {
	var onClose = _v0.bo;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Events$on('MDCDrawer:close'),
			$elm$json$Json$Decode$succeed),
		onClose);
};
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$dismissibleCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-drawer--dismissible'));
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$openProp = function (_v0) {
	var open = _v0.cB;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'open',
			$elm$json$Json$Encode$bool(open)));
};
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-drawer'));
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$drawer = F2(
	function (config_, nodes) {
		var additionalAttributes = config_.bF;
		return A3(
			$elm$html$Html$node,
			'mdc-drawer',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Drawer$Dismissible$rootCs,
							$aforemny$material_components_web_elm$Material$Drawer$Dismissible$dismissibleCs,
							$aforemny$material_components_web_elm$Material$Drawer$Dismissible$openProp(config_),
							$aforemny$material_components_web_elm$Material$Drawer$Dismissible$closeHandler(config_)
						])),
				additionalAttributes),
			nodes);
	});
var $aforemny$material_components_web_elm$Material$TopAppBar$Regular = 0;
var $aforemny$material_components_web_elm$Material$TopAppBar$regular = F2(
	function (config_, nodes) {
		return A3($aforemny$material_components_web_elm$Material$TopAppBar$genericTopAppBar, 0, config_, nodes);
	});
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$setAttributes = F2(
	function (additionalAttributes, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bF: additionalAttributes});
	});
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$setOnClose = F2(
	function (onClose, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{
				bo: $elm$core$Maybe$Just(onClose)
			});
	});
var $aforemny$material_components_web_elm$Material$Drawer$Dismissible$setOpen = F2(
	function (open, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{cB: open});
	});
var $author$project$Viewer$Tablet$viewLandscape = function (config) {
	return _List_fromArray(
		[
			$author$project$Viewer$Internal$viewTopAppBar(
			{
				fn: config.fn,
				eo: $elm$core$Maybe$Just(
					{d0: config.g$, ej: config.g_}),
				hz: $elm$core$Maybe$Nothing,
				h5: A2($elm$core$Maybe$withDefault, 'Landscape Tablet', config.h5),
				e7: $aforemny$material_components_web_elm$Material$TopAppBar$regular(
					A2(
						$aforemny$material_components_web_elm$Material$TopAppBar$setFixed,
						true,
						A2($aforemny$material_components_web_elm$Material$TopAppBar$setDense, true, $aforemny$material_components_web_elm$Material$TopAppBar$config))),
				c5: config.c5
			}),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TopAppBar$denseFixedAdjust]),
			_List_fromArray(
				[
					$author$project$Viewer$Internal$viewDrawer(
					{
						f5: config.gg,
						dI: $aforemny$material_components_web_elm$Material$Drawer$Dismissible$drawer(
							A2(
								$aforemny$material_components_web_elm$Material$Drawer$Dismissible$setAttributes,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'z-index', '1')
									]),
								A2(
									$aforemny$material_components_web_elm$Material$Drawer$Dismissible$setOnClose,
									config.f$,
									A2($aforemny$material_components_web_elm$Material$Drawer$Dismissible$setOpen, config.R, $aforemny$material_components_web_elm$Material$Drawer$Dismissible$config)))),
						gh: config.gh,
						gi: $elm$html$Html$text(config.gi)
					}),
					A2(
					$aforemny$material_components_web_elm$Material$Drawer$Dismissible$content,
					_List_Nil,
					_List_fromArray(
						[config.fI]))
				]))
		]);
};
var $aforemny$material_components_web_elm$Material$Drawer$Permanent$content = F2(
	function (attributes, nodes) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('mdc-drawer__content'),
				attributes),
			nodes);
	});
var $author$project$Viewer$Desktop$viewPortrait = function (config) {
	return _List_fromArray(
		[
			$author$project$Viewer$Internal$viewTopAppBar(
			{
				fn: config.fn,
				eo: $elm$core$Maybe$Just(
					{d0: config.g$, ej: config.g_}),
				hz: $elm$core$Maybe$Nothing,
				h5: A2($elm$core$Maybe$withDefault, 'Portrait Desktop', config.h5),
				e7: $aforemny$material_components_web_elm$Material$TopAppBar$prominent(
					A2(
						$aforemny$material_components_web_elm$Material$TopAppBar$setFixed,
						true,
						A2($aforemny$material_components_web_elm$Material$TopAppBar$setDense, false, $aforemny$material_components_web_elm$Material$TopAppBar$config))),
				c5: config.c5
			}),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TopAppBar$prominentFixedAdjust]),
			_List_fromArray(
				[
					$author$project$Viewer$Internal$viewDrawer(
					{
						f5: config.gg,
						dI: $aforemny$material_components_web_elm$Material$Drawer$Permanent$drawer(
							A2(
								$aforemny$material_components_web_elm$Material$Drawer$Permanent$setAttributes,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'z-index', '1')
									]),
								$aforemny$material_components_web_elm$Material$Drawer$Permanent$config)),
						gh: config.gh,
						gi: $elm$html$Html$text(config.gi)
					})
				])),
			A2(
			$aforemny$material_components_web_elm$Material$Drawer$Permanent$content,
			_List_Nil,
			_List_fromArray(
				[config.fI]))
		]);
};
var $author$project$Viewer$Handset$viewPortrait = function (config) {
	return config.R ? _List_fromArray(
		[
			$author$project$Viewer$Internal$viewTopAppBar(
			{
				fn: config.fn,
				eo: $elm$core$Maybe$Just(
					{d0: 'arrow_back', ej: config.f$}),
				hz: $elm$core$Maybe$Nothing,
				h5: config.gi,
				e7: $aforemny$material_components_web_elm$Material$TopAppBar$short(
					A2(
						$aforemny$material_components_web_elm$Material$TopAppBar$setFixed,
						false,
						A2($aforemny$material_components_web_elm$Material$TopAppBar$setDense, true, $aforemny$material_components_web_elm$Material$TopAppBar$config))),
				c5: config.c5
			}),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TopAppBar$denseFixedAdjust]),
			_List_fromArray(
				[
					A3(
					$aforemny$material_components_web_elm$Material$List$list,
					$aforemny$material_components_web_elm$Material$List$config,
					A2(
						$aforemny$material_components_web_elm$Material$List$Item$listItem,
						$aforemny$material_components_web_elm$Material$List$Item$config,
						_List_fromArray(
							[
								$elm$html$Html$text('Line item')
							])),
					_List_fromArray(
						[
							A2(
							$aforemny$material_components_web_elm$Material$List$Item$listItem,
							$aforemny$material_components_web_elm$Material$List$Item$config,
							_List_fromArray(
								[
									$elm$html$Html$text('Line item')
								]))
						]))
				]))
		]) : _List_fromArray(
		[
			$author$project$Viewer$Internal$viewTopAppBar(
			{
				fn: config.fn,
				eo: $elm$core$Maybe$Just(
					{d0: config.g$, ej: config.g_}),
				hz: $elm$core$Maybe$Nothing,
				h5: A2($elm$core$Maybe$withDefault, 'Portrait Handset', config.h5),
				e7: $aforemny$material_components_web_elm$Material$TopAppBar$short(
					A2(
						$aforemny$material_components_web_elm$Material$TopAppBar$setFixed,
						false,
						A2($aforemny$material_components_web_elm$Material$TopAppBar$setDense, true, $aforemny$material_components_web_elm$Material$TopAppBar$config))),
				c5: config.c5
			}),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TopAppBar$denseFixedAdjust]),
			_List_fromArray(
				[config.fI]))
		]);
};
var $aforemny$material_components_web_elm$Material$TopAppBar$fixedAdjust = $elm$html$Html$Attributes$class('mdc-top-app-bar--fixed-adjust');
var $author$project$Viewer$Tablet$viewPortrait = function (config) {
	return _List_fromArray(
		[
			$author$project$Viewer$Internal$viewDrawer(
			{
				f5: config.gg,
				dI: $aforemny$material_components_web_elm$Material$Drawer$Modal$drawer(
					A2(
						$aforemny$material_components_web_elm$Material$Drawer$Modal$setOnClose,
						config.f$,
						A2($aforemny$material_components_web_elm$Material$Drawer$Modal$setOpen, config.R, $aforemny$material_components_web_elm$Material$Drawer$Modal$config))),
				gh: config.gh,
				gi: $elm$html$Html$text(config.gi)
			}),
			A2($aforemny$material_components_web_elm$Material$Drawer$Modal$scrim, _List_Nil, _List_Nil),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Viewer$Internal$viewTopAppBar(
					{
						fn: config.fn,
						eo: $elm$core$Maybe$Just(
							{d0: config.g$, ej: config.g_}),
						hz: $elm$core$Maybe$Nothing,
						h5: A2($elm$core$Maybe$withDefault, 'Portrait Tablet', config.h5),
						e7: $aforemny$material_components_web_elm$Material$TopAppBar$regular(
							A2(
								$aforemny$material_components_web_elm$Material$TopAppBar$setFixed,
								true,
								A2($aforemny$material_components_web_elm$Material$TopAppBar$setDense, true, $aforemny$material_components_web_elm$Material$TopAppBar$config))),
						c5: config.c5
					})
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$TopAppBar$fixedAdjust]),
			_List_fromArray(
				[config.fI]))
		]);
};
var $author$project$Msg$SnackbarClosed = function (a) {
	return {$: 24, a: a};
};
var $aforemny$material_components_web_elm$Material$Snackbar$Config = $elm$core$Basics$identity;
var $aforemny$material_components_web_elm$Material$Snackbar$config = function (_v0) {
	var onClosed = _v0.g9;
	return {bF: _List_Nil, bP: false, g9: onClosed};
};
var $aforemny$material_components_web_elm$Material$Snackbar$setCloseOnEscape = F2(
	function (closeOnEscape, _v0) {
		var config_ = _v0;
		return _Utils_update(
			config_,
			{bP: closeOnEscape});
	});
var $aforemny$material_components_web_elm$Material$Snackbar$closeOnEscapeProp = function (_v0) {
	var closeOnEscape = _v0.bP;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'closeOnEscape',
			$elm$json$Json$Encode$bool(closeOnEscape)));
};
var $aforemny$material_components_web_elm$Material$Snackbar$closedHandler = F2(
	function (messageId, _v0) {
		var onClosed = _v0.g9;
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$Events$on,
				'MDCSnackbar:closed',
				$elm$json$Json$Decode$succeed(
					onClosed(messageId))));
	});
var $aforemny$material_components_web_elm$Material$Snackbar$leadingCs = function (message_) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var leading = _v0.cm;
			return leading ? $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-snackbar--leading')) : $elm$core$Maybe$Nothing;
		},
		message_);
};
var $aforemny$material_components_web_elm$Material$Snackbar$messageIdProp = function (_v0) {
	var messageId = _v0;
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'messageId',
			$elm$json$Json$Encode$int(messageId)));
};
var $aforemny$material_components_web_elm$Material$Snackbar$rootCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-snackbar'));
var $aforemny$material_components_web_elm$Material$Snackbar$stackedCs = function (message_) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var stacked = _v0.cV;
			return stacked ? $elm$core$Maybe$Just(
				$elm$html$Html$Attributes$class('mdc-snackbar--stacked')) : $elm$core$Maybe$Nothing;
		},
		message_);
};
var $aforemny$material_components_web_elm$Material$Snackbar$actionButtonClickHandler = F2(
	function (messageId, _v0) {
		var onActionButtonClick = _v0.cw;
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$Events$onClick,
				$elm$core$Basics$apR(messageId)),
			onActionButtonClick);
	});
var $aforemny$material_components_web_elm$Material$Snackbar$actionButtonCs = $elm$core$Maybe$Just(
	$elm$html$Html$Attributes$class('mdc-button mdc-snackbar__action'));
var $aforemny$material_components_web_elm$Material$Snackbar$actionButtonElt = F2(
	function (messageId, message_) {
		var actionButton = message_.bC;
		return A2(
			$elm$core$Maybe$map,
			function (actionButtonLabel) {
				return A2(
					$elm$html$Html$button,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$aforemny$material_components_web_elm$Material$Snackbar$actionButtonCs,
								A2($aforemny$material_components_web_elm$Material$Snackbar$actionButtonClickHandler, messageId, message_)
							])),
					_List_fromArray(
						[
							$elm$html$Html$text(actionButtonLabel)
						]));
			},
			actionButton);
	});
var $aforemny$material_components_web_elm$Material$Snackbar$actionIconClickHandler = F2(
	function (messageId, _v0) {
		var onActionIconClick = _v0.cx;
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$Events$onClick,
				$elm$core$Basics$apR(messageId)),
			onActionIconClick);
	});
var $aforemny$material_components_web_elm$Material$Snackbar$actionIconElt = F2(
	function (messageId, message_) {
		var actionIcon = message_.bD;
		if (!actionIcon.$) {
			if (!actionIcon.a.$) {
				var node = actionIcon.a.a.bk;
				var attributes = actionIcon.a.a.bM;
				var nodes = actionIcon.a.a.bl;
				return $elm$core$Maybe$Just(
					A2(
						node,
						_Utils_ap(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										$elm$html$Html$Attributes$class('mdc-icon-button')),
										$elm$core$Maybe$Just(
										$elm$html$Html$Attributes$class('mdc-snackbar__dismiss')),
										A2($aforemny$material_components_web_elm$Material$Snackbar$actionIconClickHandler, messageId, message_)
									])),
							attributes),
						nodes));
			} else {
				var node = actionIcon.a.a.bk;
				var attributes = actionIcon.a.a.bM;
				var nodes = actionIcon.a.a.bl;
				return $elm$core$Maybe$Just(
					A2(
						node,
						_Utils_ap(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										$elm$svg$Svg$Attributes$class('mdc-icon-button')),
										$elm$core$Maybe$Just(
										$elm$svg$Svg$Attributes$class('mdc-snackbar__dismiss')),
										A2($aforemny$material_components_web_elm$Material$Snackbar$actionIconClickHandler, messageId, message_)
									])),
							attributes),
						nodes));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $aforemny$material_components_web_elm$Material$Snackbar$actionsElt = F2(
	function (messageId, message_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-snackbar__actions')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($aforemny$material_components_web_elm$Material$Snackbar$actionButtonElt, messageId, message_),
						A2($aforemny$material_components_web_elm$Material$Snackbar$actionIconElt, messageId, message_)
					])));
	});
var $aforemny$material_components_web_elm$Material$Snackbar$ariaPoliteLiveAttr = A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite');
var $aforemny$material_components_web_elm$Material$Snackbar$ariaStatusRoleAttr = A2($elm$html$Html$Attributes$attribute, 'aria-role', 'status');
var $aforemny$material_components_web_elm$Material$Snackbar$labelElt = function (_v0) {
	var label = _v0.ea;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mdc-snackbar__label'),
				$aforemny$material_components_web_elm$Material$Snackbar$ariaStatusRoleAttr,
				$aforemny$material_components_web_elm$Material$Snackbar$ariaPoliteLiveAttr
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $aforemny$material_components_web_elm$Material$Snackbar$surfaceElt = F2(
	function (messageId, message_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mdc-snackbar__surface')
				]),
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Snackbar$labelElt(message_),
					A2($aforemny$material_components_web_elm$Material$Snackbar$actionsElt, messageId, message_)
				]));
	});
var $aforemny$material_components_web_elm$Material$Snackbar$timeoutMsProp = function (message_) {
	var indefiniteTimeout = -1;
	var normalizedTimeoutMs = A2(
		$elm$core$Maybe$withDefault,
		indefiniteTimeout,
		A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var timeoutMs = _v0.c0;
				return A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$clamp, 4000, 10000),
					timeoutMs);
			},
			message_));
	return $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$property,
			'timeoutMs',
			$elm$json$Json$Encode$int(normalizedTimeoutMs)));
};
var $aforemny$material_components_web_elm$Material$Snackbar$snackbar = F2(
	function (config_, queue) {
		var additionalAttributes = config_.bF;
		var messages = queue.ad;
		var nextMessageId = queue.aJ;
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(-1, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$mapSecond($elm$core$Maybe$Just),
				$elm$core$List$head(messages)));
		var currentMessageId = _v0.a;
		var currentMessage = _v0.b;
		return A3(
			$elm$html$Html$node,
			'mdc-snackbar',
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Snackbar$rootCs,
							$aforemny$material_components_web_elm$Material$Snackbar$closeOnEscapeProp(config_),
							$aforemny$material_components_web_elm$Material$Snackbar$leadingCs(currentMessage),
							$aforemny$material_components_web_elm$Material$Snackbar$stackedCs(currentMessage),
							$aforemny$material_components_web_elm$Material$Snackbar$messageIdProp(currentMessageId),
							$aforemny$material_components_web_elm$Material$Snackbar$timeoutMsProp(currentMessage),
							A2($aforemny$material_components_web_elm$Material$Snackbar$closedHandler, currentMessageId, config_)
						])),
				additionalAttributes),
			_List_fromArray(
				[
					A2(
					$aforemny$material_components_web_elm$Material$Snackbar$surfaceElt,
					currentMessageId,
					A2(
						$elm$core$Maybe$withDefault,
						$aforemny$material_components_web_elm$Material$Snackbar$message(''),
						currentMessage))
				]));
	});
var $author$project$Viewer$viewSnackbar = function (h) {
	return A2(
		$aforemny$material_components_web_elm$Material$Snackbar$snackbar,
		A2(
			$aforemny$material_components_web_elm$Material$Snackbar$setCloseOnEscape,
			true,
			$aforemny$material_components_web_elm$Material$Snackbar$config(
				{g9: $author$project$Msg$SnackbarClosed})),
		h.bt);
};
var $author$project$Viewer$view = F5(
	function (session, msg, details, h, time) {
		return {
			fI: A2(
				$elm$core$List$cons,
				$author$project$Viewer$viewSnackbar(h),
				function () {
					var device = A2($author$project$Device$fromPixel, session.fh.fe, session.fh.dW);
					var _v0 = session.c5;
					if (!_v0.$) {
						var userid = _v0.a;
						var username = A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.af;
							},
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.fb;
								},
								A2(
									$elm$core$Dict$get,
									$author$project$Type$IO$Internal$unbox(userid),
									session.u.c6)));
						return function () {
							var _v1 = _Utils_Tuple2(device.dG, device.et);
							if (!_v1.b) {
								switch (_v1.a) {
									case 2:
										var _v2 = _v1.a;
										var _v3 = _v1.b;
										return $author$project$Viewer$Desktop$viewPortrait;
									case 0:
										var _v6 = _v1.a;
										var _v7 = _v1.b;
										return $author$project$Viewer$Handset$viewPortrait;
									default:
										var _v10 = _v1.a;
										var _v11 = _v1.b;
										return $author$project$Viewer$Tablet$viewPortrait;
								}
							} else {
								switch (_v1.a) {
									case 2:
										var _v4 = _v1.a;
										var _v5 = _v1.b;
										return $author$project$Viewer$Desktop$viewLandscape;
									case 0:
										var _v8 = _v1.a;
										var _v9 = _v1.b;
										return $author$project$Viewer$Handset$viewLandscape;
									default:
										var _v12 = _v1.a;
										var _v13 = _v1.b;
										return $author$project$Viewer$Tablet$viewLandscape;
								}
							}
						}()(
							{
								fn: details.fn,
								fI: A2(
									$elm$html$Html$div,
									_List_Nil,
									details.fI(time)),
								f$: $author$project$Msg$Viewer($author$project$Msg$CloseDrawer),
								gg: $author$project$Viewer$viewDrawerContent(0),
								R: h.R,
								gh: $elm$html$Html$text(
									'ID: ' + $author$project$Type$IO$Internal$unbox(userid)),
								gi: A2($elm$core$Maybe$withDefault, 'User', username),
								g_: details.id ? $author$project$Viewer$toggleDrawer(h.R) : $author$project$Msg$Back,
								g$: details.id ? 'menu' : 'arrow_back',
								hg: $author$project$Msg$Viewer($author$project$Msg$OpenDrawer),
								h5: $elm$core$Maybe$Just(details.h5),
								c5: A2(
									$elm$core$Maybe$map,
									function (x) {
										return A2(
											$gdamjan$elm_identicon$Identicon$identicon,
											'100%',
											$author$project$Type$IO$Internal$unbox(x));
									},
									session.c5)
							});
					} else {
						return _List_fromArray(
							[
								A4(
								$author$project$Viewer$userDialog,
								true,
								A2(
									$elm$core$List$map,
									function (_v14) {
										var x = _v14.a;
										var y = _v14.b;
										return _Utils_Tuple2(x, y.fb);
									},
									$elm$core$Dict$toList(session.u.c6)),
								h.bj,
								time)
							]);
					}
				}()),
			h5: _Utils_ap(details.h5, $author$project$Utils$genericTitle)
		};
	});
var $author$project$Page$view = F2(
	function (_v0, header) {
		var model = _v0;
		return A4(
			$author$project$Viewer$view,
			model.hB,
			model.e6,
			model.ik(model),
			header);
	});
var $author$project$Main$view = function (model) {
	var session = $author$project$Main$extractSession(model);
	var _v0 = model.c;
	switch (_v0.$) {
		case 0:
			return A5($author$project$Viewer$view, session, $elm$core$Basics$never, $author$project$Viewer$notFound, $author$project$Viewer$header, model.r);
		case 2:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 5:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 1:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 3:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 4:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 6:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 7:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 8:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 9:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 10:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		case 11:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
		default:
			var m = _v0.a;
			return A3($author$project$Page$view, m, model.i, model.r);
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{gG: $author$project$Main$init, he: $author$project$Msg$UrlChanged, hf: $author$project$Msg$LinkClicked, e3: $author$project$Main$subscriptions, ih: $author$project$Main$update, ik: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (windowSize) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (timeAppStarted) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (localStorage) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (db) {
									return $elm$json$Json$Decode$succeed(
										{u: db, eh: localStorage, h4: timeAppStarted, fh: windowSize});
								},
								A2($elm$json$Json$Decode$field, 'db', $elm$json$Json$Decode$value));
						},
						A2($elm$json$Json$Decode$field, 'localStorage', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'timeAppStarted', $elm$json$Json$Decode$int));
		},
		A2(
			$elm$json$Json$Decode$field,
			'windowSize',
			A2(
				$elm$json$Json$Decode$andThen,
				function (width) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (height) {
							return $elm$json$Json$Decode$succeed(
								{dW: height, fe: width});
						},
						A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int)))))(0)}});}(this));